export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: ISODate; output: ISODate; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: ISODateTime; output: ISODateTime; }
  /** Represents non-fractional signed whole numeric values. The value may exceed the size of a 32-bit integer, but should be in MIN_SAFE_INTEGER..MAX_SAFE_INTEGER range. */
  SafeInt: { input: number; output: number; }
};

export enum AccessLevelEnum {
  BASIC = 'BASIC',
  FULL = 'FULL',
  NO_ACCESS = 'NO_ACCESS',
  VIEW = 'VIEW'
}

export type Account = {
  accountNumberType: Maybe<VendorAccountNumberTypeEnum>;
  accountType: AccountTypeEnum;
  accountingAccount: Maybe<AccountingAccount>;
  bankAddress: Maybe<Address>;
  bankConnection: Maybe<BankLink>;
  bankName: Maybe<Scalars['String']['output']>;
  beneficiaryFirstName: Maybe<Scalars['String']['output']>;
  beneficiaryLastName: Maybe<Scalars['String']['output']>;
  beneficiaryName: Maybe<Scalars['String']['output']>;
  bicSwift: Maybe<Scalars['String']['output']>;
  /** Blocked for use by Settle; cannot be unarchived or used for payments */
  blocked: Scalars['Boolean']['output'];
  /** If the account has a recent error of 'R29 Corporate Customer Advises Not Authorized' */
  chargesNotAuthorized: Scalars['Boolean']['output'];
  currency: Maybe<Scalars['String']['output']>;
  destinationCountry: Scalars['String']['output'];
  /** @deprecated Use bankConnection instead */
  finicityConnection: Maybe<FinicityLink>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lockbox: Maybe<Scalars['Boolean']['output']>;
  mask: Maybe<Scalars['String']['output']>;
  microdepositsPaymentMethod: Maybe<MicrodepositsPaymentMethodEnum>;
  microdepositsStatus: Maybe<MicrodepositsStatusEnum>;
  missingRequiredDetails: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  numOutstandingInvoices: Scalars['Int']['output'];
  /** Account ability to process future ACH payments through the system */
  paymentsProcessingAvailable: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use bankConnection instead */
  plaidItem: Maybe<PlaidLink>;
  preferredPayingAccount: Scalars['Boolean']['output'];
  preferredReceivingAccount: Scalars['Boolean']['output'];
  /** If the account has a successful charge */
  successChargesExists: Scalars['Boolean']['output'];
  suggestedAccountingAccount: Maybe<AccountingAccount>;
  supportedPaymentTypes: Array<PaymentMethodEnum>;
  transactable: Scalars['Boolean']['output'];
  verificationSource: Maybe<VerificationSourceEnum>;
  wireFields: Maybe<Array<InternationalWireFieldsDataFieldValueType>>;
};

export enum AccountConnectionStatusEnum {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  NOT_SET = 'NOT_SET'
}

export type AccountInputObject = {
  accountNumber: Scalars['String']['input'];
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  bankAddress?: InputMaybe<AddressInputObject>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  beneficiaryFirstName?: InputMaybe<Scalars['String']['input']>;
  beneficiaryLastName?: InputMaybe<Scalars['String']['input']>;
  beneficiaryName?: InputMaybe<Scalars['String']['input']>;
  bicSwift?: InputMaybe<Scalars['String']['input']>;
  cnaps?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  destinationCountry: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  taxpayerId?: InputMaybe<Scalars['String']['input']>;
  wireFields?: InputMaybe<Array<InternationalWireFieldsDataFieldInputObject>>;
  wireRoutingNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum AccountTypeEnum {
  PAYING = 'PAYING',
  PAYING_AND_RECEIVING = 'PAYING_AND_RECEIVING',
  RECEIVING = 'RECEIVING'
}

export type AccountantDashboard = {
  /** @deprecated Use firmDisplayName and firmCompanyName */
  accountingFirmName: Scalars['String']['output'];
  clients: Array<BusinessClient>;
  firmCompanyName: Scalars['String']['output'];
  firmDisplayName: Scalars['String']['output'];
  teamMembers: Array<TeamMember>;
};

export type AccountingAccount = {
  accountSubType: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  children: Array<AccountingAccount>;
  classification: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  number: Maybe<Scalars['String']['output']>;
};

export enum AccountingBillingModelTypeEnum {
  AGGREGATED = 'AGGREGATED',
  HYBRID = 'HYBRID',
  INDIVIDUAL = 'INDIVIDUAL'
}

export type AccountingCategory = {
  categories: Array<AccountingDictionary>;
  categoryType: AccountingCategoryTypeEnum;
  label: Scalars['String']['output'];
  showOnTxn: Scalars['Boolean']['output'];
  showOnTxnLine: Scalars['Boolean']['output'];
};

export type AccountingCategoryType = {
  id: Scalars['ID']['output'];
};

export enum AccountingCategoryTypeEnum {
  CLASS = 'CLASS',
  DEPARTMENT = 'DEPARTMENT',
  LOCATION = 'LOCATION',
  TRACKING_CATEGORY_ONE = 'TRACKING_CATEGORY_ONE',
  TRACKING_CATEGORY_TWO = 'TRACKING_CATEGORY_TWO'
}

export enum AccountingConnectionStatusEnum {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  NOT_SET = 'NOT_SET'
}

export type AccountingCounters = {
  excludedFromSync: CountersBySyncObject;
  recentlySynced: CountersBySyncObject;
  syncErrors: CountersBySyncObject;
  waitingForSync: CountersBySyncObject;
};

export type AccountingDictionary = {
  children: Array<AccountingDictionary>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Autogenerated return type of AccountingImportStateChanged. */
export type AccountingImportStateChangedPayload = {
  importType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  statusMessage: Maybe<Scalars['String']['output']>;
};

export enum AccountingPermissionsEnum {
  ACCOUNTING_LINK = 'ACCOUNTING_LINK',
  ACCOUNTING_SYNC = 'ACCOUNTING_SYNC',
  ACCOUNTING_SYNC_STATE = 'ACCOUNTING_SYNC_STATE',
  ACCOUNTING_UNIMPORTED_PURCHASE_ORDERS = 'ACCOUNTING_UNIMPORTED_PURCHASE_ORDERS',
  ACCOUNTING_UNLINK = 'ACCOUNTING_UNLINK',
  ACCOUNTING_UNPAID_BILLS = 'ACCOUNTING_UNPAID_BILLS',
  ACCOUNTING_UPDATE_PREFERENCES = 'ACCOUNTING_UPDATE_PREFERENCES'
}

export enum AccountingQuickBooksItemTypeEnum {
  CATEGORY = 'CATEGORY',
  INVENTORY = 'INVENTORY',
  NONINVENTORY = 'NONINVENTORY',
  SERVICE = 'SERVICE'
}

export type AccountingState = {
  accountingProvider: Maybe<ProviderEnum>;
  accounts: Array<AccountingAccount>;
  bankAccounts: Array<AccountingAccount>;
  categoryClasses: Maybe<AccountingCategory>;
  categoryDepartments: Maybe<AccountingCategory>;
  categoryLocations: Maybe<AccountingCategory>;
  categoryTrackingCategoryOne: Maybe<AccountingCategory>;
  categoryTrackingCategoryTwo: Maybe<AccountingCategory>;
  cogsAccounts: Array<AccountingAccount>;
  creditCardAccounts: Array<AccountingAccount>;
  customersAndProjects: Maybe<AccountingTrackableEntityType>;
  expenseAccounts: Array<AccountingAccount>;
  filteredAccounts: Array<AccountingAccount>;
  liabilityAccounts: Array<AccountingAccount>;
  name: Scalars['String']['output'];
};

export type AccountingSummary = {
  status: AccountingConnectionStatusEnum;
  syncErrorCount: Scalars['Int']['output'];
};

/** Autogenerated return type of AccountingSyncStateChanged. */
export type AccountingSyncStateChangedPayload = {
  connected: Scalars['Boolean']['output'];
  platform: ProviderEnum;
  syncScheduledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  syncStartedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  syncState: SyncStateEnum;
  syncedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type AccountingTrackableEntityType = {
  showOnTxnLine: Scalars['Boolean']['output'];
  values: Array<AccountingDictionary>;
};

export type AccountsReceivableNotificationSettings = {
  paymentCanceledEmail: Scalars['Boolean']['output'];
  paymentLandedInAccountEmail: Scalars['Boolean']['output'];
  paymentOnItsWayEmail: Scalars['Boolean']['output'];
  paymentScheduledEmail: Scalars['Boolean']['output'];
};

export type AccountsReceivableNotificationSettingsInputObject = {
  paymentCanceledEmail?: InputMaybe<Scalars['Boolean']['input']>;
  paymentLandedInAccountEmail?: InputMaybe<Scalars['Boolean']['input']>;
  paymentOnItsWayEmail?: InputMaybe<Scalars['Boolean']['input']>;
  paymentScheduledEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountsSummary = {
  status: AccountConnectionStatusEnum;
  unmappedCount: Scalars['Int']['output'];
};

export type Action = {
  allowed: Scalars['Boolean']['output'];
  errorReasons: Array<Scalars['String']['output']>;
};

export type ActivatePhoneFactorResponse = {
  recoveryCodes: Array<Scalars['String']['output']>;
};

export type ActivateTotpResponse = {
  recoveryCodes: Array<Scalars['String']['output']>;
};

export type AdditionalExpense = {
  allocationModel: Maybe<AdditionalExpenseAllocationModelEnum>;
  cost: Maybe<Money>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayOnPdf: Scalars['Boolean']['output'];
  expenseType: Maybe<AdditionalExpenseTypeEnum>;
  id: Scalars['ID']['output'];
  invoiceLineItem: Maybe<InvoiceLineItem>;
  name: Maybe<Scalars['String']['output']>;
  position: Maybe<Scalars['Int']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  totalCost: Maybe<Money>;
};

export enum AdditionalExpenseAllocationModelEnum {
  NONE = 'NONE',
  QUANTITY = 'QUANTITY',
  VALUE = 'VALUE',
  VOLUME = 'VOLUME',
  WEIGHT = 'WEIGHT'
}

export type AdditionalExpenseInputObject = {
  allocationModel?: InputMaybe<AdditionalExpenseAllocationModelEnum>;
  costCents?: InputMaybe<Scalars['Float']['input']>;
  displayOnPdf?: InputMaybe<Scalars['Boolean']['input']>;
  expenseType?: InputMaybe<AdditionalExpenseTypeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export enum AdditionalExpenseTypeEnum {
  INVENTORY = 'INVENTORY',
  OTHER = 'OTHER',
  PRODUCTION_COST = 'PRODUCTION_COST',
  SHIPPING = 'SHIPPING',
  SURCHARGE = 'SURCHARGE',
  TARIFF = 'TARIFF'
}

export type Address = {
  additionalAddressLines: Maybe<Array<Scalars['String']['output']>>;
  addressLine: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  complete: Scalars['Boolean']['output'];
  country: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  oneLineFormatted: Scalars['String']['output'];
  postalCode: Maybe<Scalars['String']['output']>;
  secondaryAddressLine: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  unitNumber: Maybe<Scalars['String']['output']>;
};

export type AddressInputObject = {
  additionalAddressLines?: InputMaybe<Array<Scalars['String']['input']>>;
  addressLine?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  secondaryAddressLine?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AddressOcr = {
  addressLine: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  rawAddress: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
};

export type AddressValidation = {
  /** Returns true if the address is a Commercial Mail Receiving Agency (UPS Store, Mailboxes Etc., PMB), false otherwise (including international addresses). May make a network request to validate the address */
  cmra: Scalars['Boolean']['output'];
  /** Returns true if the address matches a known registered-agent address, false otherwise (including international addresses). */
  knownRegisteredAgent: Scalars['Boolean']['output'];
  /** Returns true if the address is a PO box, false otherwise. */
  poBox: Scalars['Boolean']['output'];
  /** Returns true if the address is completely verified, false otherwise. May make a network request to validate the address */
  valid: Scalars['Boolean']['output'];
};

export type Agreement = {
  byteSize: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export enum AiFeedbackCategoryEnum {
  FUNCTIONALITY_BROKEN = 'FUNCTIONALITY_BROKEN',
  NOT_WHAT_LOOKING_FOR = 'NOT_WHAT_LOOKING_FOR',
  OTHER = 'OTHER',
  WRONG_DATA = 'WRONG_DATA'
}

export enum AiRequestStatusEnum {
  COMPLETED = 'COMPLETED',
  CONFIRMATION_NEEDED = 'CONFIRMATION_NEEDED'
}

export type AiResponsePayload = {
  /** The ID of the conversation */
  conversationId: Scalars['String']['output'];
  /** The status of the request */
  requestStatus: AiRequestStatusEnum;
  /** The AI's response text */
  responseText: Scalars['String']['output'];
};

export type Allocation = {
  actions: TransferActions;
  amount: Maybe<Money>;
  exchangeFeeAmount: Maybe<Money>;
  exchangeRate: Maybe<Scalars['String']['output']>;
  financingOptions: FinancingOptions;
  id: Scalars['ID']['output'];
  includedInConsolidatedPayment: Scalars['Boolean']['output'];
  invoice: Maybe<Invoice>;
  isCashAdvance: Scalars['Boolean']['output'];
  isExtendedPaymentTerm: Scalars['Boolean']['output'];
  /** Returns true when the allocation matches applied filter. Eg. when splitted invoice has 2 allocations: PENDING and SCHEDULED, and filter by PENDING status applied, PENDING allocation will have the field value 'true' and SCHEDULED allocation - 'false'. */
  matchesFilter: Scalars['Boolean']['output'];
  payment: Maybe<Payment>;
  /** Error code for Inactive Payment */
  paymentErrorCode: Maybe<Scalars['String']['output']>;
  /** Error message for Inactive Payment */
  paymentErrorMessage: Maybe<Scalars['String']['output']>;
  reconciliationItems: Array<ReconciliationItem>;
  status: InvoiceStatusEnum;
  statuses: Array<InvoiceStatusEnum>;
  totalUsdAmount: Maybe<Money>;
  usdAmount: Maybe<Money>;
};

export type AmortizedLoan = {
  /** Annual percentage rate (APR) for the loan */
  apr: Scalars['Float']['output'];
  /** The current installment (last failed, next scheduled or the last one); a window during which nothing is due is skipped */
  currentInstallment: AmortizedLoanInstallment;
  /** Planned or actual installments schedule */
  installments: Array<AmortizedLoanInstallment>;
  /** Sum of interest accrued */
  interest: Money;
  /** Nominal annualized rate at which interest accrues */
  interestRate: Scalars['Float']['output'];
  /** Number of days in each regular period; an upfront window has its own length */
  periodDays: Scalars['Int']['output'];
  /** Percentage of principal charged as interest each regular period; an upfront window has its own rate */
  periodRate: Scalars['Float']['output'];
  /** Number of periods ending with installment payment */
  periods: Scalars['Int']['output'];
  /** Sum of principal repayments */
  principal: Money;
  /** Number of periods that charge an amount; a window during which nothing is due is not one */
  repaymentCount: Scalars['Int']['output'];
  /** Sum of all installment payments */
  total: Money;
  /** Sum of days in all periods */
  totalDays: Scalars['Int']['output'];
  /** Leading window at its own rate before the regular periods, when the terms carry one */
  upfrontWindow: Maybe<UpfrontWindow>;
};

export type AmortizedLoanEarlyRepaymentPreview = {
  /** Current amortized loan schedule */
  current: AmortizedLoan;
  /** Expected amortized loan schedule */
  expected: AmortizedLoan;
};

export type AmortizedLoanInstallment = {
  /** Installment payment date */
  date: Scalars['ISO8601Date']['output'];
  /** Marks the late-payment interest line */
  defaultInterest: Scalars['Boolean']['output'];
  /** Full description of installment (eg. "Installment 1", "Installment 2", ..., "Early repayment") */
  description: Scalars['String']['output'];
  /** Marks installment which is an early repayment */
  earlyRepayment: Scalars['Boolean']['output'];
  /** Interest included into installment amount */
  interest: Money;
  /** Number of the installment */
  number: Scalars['Int']['output'];
  /** Percentage of the outstanding balance charged this period as interest */
  periodRate: Scalars['Float']['output'];
  /** Principal repayment included in installment amount */
  principal: Money;
  reconciliationItem: Maybe<ReconciliationItem>;
  /** Status of the installment */
  status: AmortizedLoanInstallmentStatusEnum;
  /** Installment amount */
  total: Money;
};

export enum AmortizedLoanInstallmentStatusEnum {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SCHEDULED = 'SCHEDULED'
}

export enum ApAgingBucketEnum {
  BUCKET_1_TO_30 = 'BUCKET_1_TO_30',
  BUCKET_31_TO_60 = 'BUCKET_31_TO_60',
  BUCKET_61_TO_90 = 'BUCKET_61_TO_90',
  BUCKET_91_PLUS = 'BUCKET_91_PLUS',
  BUCKET_CURRENT = 'BUCKET_CURRENT'
}

export type ApAgingBucketSummary = {
  dayRange: ApAgingBucketEnum;
  endDate: Maybe<Scalars['ISO8601Date']['output']>;
  otherVendors: Array<LocalBusiness>;
  otherVendorsAmount: Maybe<Money>;
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
  totalAmount: Money;
  vendorAmounts: Array<VendorAmount>;
};

export type ApplicableVendorCredit = {
  applied: Scalars['Boolean']['output'];
  appliedAmount: Money;
  autoFillAmount: Money;
  availableAmount: Money;
  canApply: Scalars['Boolean']['output'];
  invoice: Invoice;
  reason: Maybe<Scalars['String']['output']>;
  vendorCredit: VendorCredit;
};

export enum ApplicationThemeEnum {
  ESCALON = 'ESCALON',
  SETTLE = 'SETTLE'
}

export type Approval = {
  requestedAt: Scalars['ISO8601DateTime']['output'];
  requestingUser: Maybe<ApproverV2>;
  rule: Maybe<Rule>;
  status: Maybe<ApprovalStatusEnumV2>;
  steps: Maybe<Array<ApprovalStep>>;
};

export type ApprovalRequest = {
  approvingUser: ApproverV2;
  autoApproved: Scalars['Boolean']['output'];
  decisionMadeAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  note: Maybe<Scalars['String']['output']>;
  overriddenBy: Maybe<ApproverV2>;
  status: ApprovalRequestStatusEnum;
};

export enum ApprovalRequestStatusEnum {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED',
  STAGED = 'STAGED'
}

export enum ApprovalStatusEnumV2 {
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED'
}

export type ApprovalStep = {
  approvalRequests: Maybe<Array<ApprovalRequest>>;
  approvalType: RuleActionConditionEnum;
  approvedOrRejectedOn: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: ApprovalStepStatusEnum;
  stepNumber: Scalars['Int']['output'];
};

export enum ApprovalStepStatusEnum {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED',
  STAGED = 'STAGED'
}

export type Approver = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ApproverV2 = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum AssemblyTypeEnum {
  KIT_TO_ORDER = 'KIT_TO_ORDER',
  KIT_TO_STOCK = 'KIT_TO_STOCK',
  PRODUCTION = 'PRODUCTION'
}

export type AttachedDocumentTemplate = {
  actions: AttachedDocumentTemplateActions;
  appliedToPurchaseOrders: Scalars['Boolean']['output'];
  appliedToWorkOrders: Scalars['Boolean']['output'];
  attachment: Attachment;
  id: Scalars['ID']['output'];
  localBusinesses: Array<LocalBusiness>;
  templateScope: AttachedDocumentTemplateScopeEnum;
};

export type AttachedDocumentTemplateActions = {
  delete: Action;
  update: Action;
};

export enum AttachedDocumentTemplateScopeEnum {
  ALL = 'ALL',
  BY_LOCAL_BUSINESS = 'BY_LOCAL_BUSINESS'
}

export type AttachedReport = {
  byteSize: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type Attachment = {
  attachedDocumentTemplate: Maybe<AttachedDocumentTemplate>;
  byteSize: Scalars['Int']['output'];
  category: Maybe<AttachmentCategoryEnum>;
  contentType: Scalars['String']['output'];
  conversionPending: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBySettle: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  originalByteSize: Scalars['Int']['output'];
  originalContentType: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  originalType: Maybe<Scalars['String']['output']>;
  originalUrl: Scalars['String']['output'];
  preview: Maybe<AttachmentPreview>;
  previewStatus: AttachmentPreviewStatusEnum;
  requiresAuthentication: Scalars['Boolean']['output'];
  sourceAttachedDocumentTemplate: Maybe<AttachedDocumentTemplate>;
  target: Maybe<AttachmentTargetType>;
  /** @deprecated Use target field instead */
  targetId: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use target field instead */
  targetType: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  uploadedBy: Maybe<TeamMember>;
  url: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export enum AttachmentCategoryEnum {
  CREDIT_LIMIT_REQUEST = 'CREDIT_LIMIT_REQUEST',
  INVOICE = 'INVOICE',
  LEGAL_AGREEMENT = 'LEGAL_AGREEMENT',
  MASKED_W8_OR_W9 = 'MASKED_W8_OR_W9',
  OTHER = 'OTHER',
  OUTBOUND_ORDER = 'OUTBOUND_ORDER',
  PAYMENT_ORDER = 'PAYMENT_ORDER',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  QUOTE = 'QUOTE',
  RECEIPT = 'RECEIPT',
  RECEIVABLE = 'RECEIVABLE',
  SETTLE_INBOX = 'SETTLE_INBOX',
  SPECIFICATION = 'SPECIFICATION',
  VENDOR = 'VENDOR',
  VENDOR_CREDIT = 'VENDOR_CREDIT',
  W8_OR_W9 = 'W8_OR_W9',
  WORK_ORDER = 'WORK_ORDER'
}

export enum AttachmentDocumentTemplatePermissionsEnum {
  CREATE_ATTACHED_DOCUMENT_TEMPLATE = 'CREATE_ATTACHED_DOCUMENT_TEMPLATE',
  DELETE_ATTACHED_DOCUMENT_TEMPLATE = 'DELETE_ATTACHED_DOCUMENT_TEMPLATE',
  UPDATE_ATTACHED_DOCUMENT_TEMPLATE = 'UPDATE_ATTACHED_DOCUMENT_TEMPLATE'
}

export type AttachmentPreview = {
  x1: Maybe<Scalars['String']['output']>;
  x2: Maybe<Scalars['String']['output']>;
  x3: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of AttachmentPreviewStatusChanged. */
export type AttachmentPreviewStatusChangedPayload = {
  id: Scalars['ID']['output'];
  preview: Maybe<AttachmentPreview>;
  previewStatus: AttachmentPreviewStatusEnum;
};

export enum AttachmentPreviewStatusEnum {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  NOT_STARTED = 'NOT_STARTED',
  STARTED = 'STARTED'
}

export type AttachmentTargetType = Business | Invoice | LocalBusiness | OutboundOrder | PurchaseOrder | Receipt | Receivable | SettleInboxAttachment | VendorCredit | WorkOrder;

export type AuditTrailEvents = Comment | TimelineEventV2;

export enum AuthProviderTypeEnum {
  GOOGLE = 'GOOGLE'
}

export type AuthResponse = {
  availableMethods: Maybe<Array<MfaMethod>>;
  deviceToken: Maybe<Scalars['String']['output']>;
  mfaChallengeGrant: Maybe<Scalars['String']['output']>;
  mfaSetupRequired: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use signInIssueMfaChallengeV2 */
  mfaToken: Maybe<Scalars['ID']['output']>;
  mfaVerificationRequired: Scalars['Boolean']['output'];
  profile: Maybe<Profile>;
  recoveryCodes: Maybe<Array<Scalars['String']['output']>>;
  token: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use signInIssueMfaChallengeV2 */
  totpSetupInfo: Maybe<TotpSetupInfo>;
};

export type AuthorizationPaginated = {
  data: Array<MarketingVirtualCardAuthorization>;
  pagination: Pagination;
};

export enum BalancePaymentStatusEnum {
  DELINQUENT = 'DELINQUENT',
  PAID = 'PAID',
  WAITING = 'WAITING'
}

export type BalanceSheet = {
  cashAdvanceAvailableCents: Scalars['Int']['output'];
  cashAdvanceLiabilityCents: Scalars['Int']['output'];
  cashAdvanceSubLimitCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  totalAvailableCents: Scalars['Int']['output'];
  totalLiabilityCents: Scalars['Int']['output'];
  totalLimitCents: Scalars['Int']['output'];
  workingCapitalAvailableCents: Scalars['Int']['output'];
  workingCapitalLiabilityCents: Scalars['Int']['output'];
  workingCapitalSubLimitCents: Scalars['Int']['output'];
};

export type BankAccountInfo = {
  accountName: Maybe<Scalars['String']['output']>;
  accountNumber: Scalars['String']['output'];
  accountNumberLast4: Scalars['String']['output'];
  accountNumberType: VendorAccountNumberTypeEnum;
  bankName: Maybe<Scalars['String']['output']>;
  destinationCountry: Maybe<Scalars['String']['output']>;
  routingNumber: Scalars['String']['output'];
  routingNumberType: RoutingNumberTypeEnum;
};

export enum BankAccountsPermissionsEnum {
  ACCOUNT = 'ACCOUNT',
  ACCOUNTS = 'ACCOUNTS',
  LINK_FINICITY = 'LINK_FINICITY',
  LINK_PLAID = 'LINK_PLAID',
  UPDATE_ACCOUNT = 'UPDATE_ACCOUNT'
}

/** Common fields of bank account links */
export type BankLink = {
  deleted: Scalars['Boolean']['output'];
  fixAvailable: Maybe<BankLinkFixEnum>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum BankLinkFixEnum {
  FIX_FLOW = 'FIX_FLOW',
  RELINK = 'RELINK'
}

export type Banner = {
  allowedDismissalDurationsDays: Maybe<Array<Scalars['Int']['output']>>;
  allowsIndefiniteDismissal: Scalars['Boolean']['output'];
  button: Maybe<BannerButton>;
  category: Maybe<BannerCategoryEnum>;
  dismissible: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  severity: BannerSeverityEnum;
};

export enum BannerActionEnum {
  ADD_BENEFICIAL_OWNER = 'ADD_BENEFICIAL_OWNER',
  CHANGE_BILLING_METHOD = 'CHANGE_BILLING_METHOD',
  CHOOSE_PLAN = 'CHOOSE_PLAN',
  CONFIRM_SHOPIFY_PLAN = 'CONFIRM_SHOPIFY_PLAN',
  DASHBOARD_TO_DO_LIST = 'DASHBOARD_TO_DO_LIST',
  EDIT_BANK_ACCOUNTS = 'EDIT_BANK_ACCOUNTS',
  EDIT_INTEGRATIONS = 'EDIT_INTEGRATIONS',
  EDIT_INTERNATIONAL_RECEIVING_BANK_ACCOUNT = 'EDIT_INTERNATIONAL_RECEIVING_BANK_ACCOUNT',
  EDIT_SYNC_PREFERENCES = 'EDIT_SYNC_PREFERENCES',
  FINICITY_FIX_FLOW = 'FINICITY_FIX_FLOW',
  HELP_CENTER = 'HELP_CENTER',
  INTEGRATION_SETTINGS = 'INTEGRATION_SETTINGS',
  INVITE_CUSTOMERS = 'INVITE_CUSTOMERS',
  LINK_UNVERIFIED_BANK_ACCOUNT = 'LINK_UNVERIFIED_BANK_ACCOUNT',
  MERGE_CATALOG_ITEMS = 'MERGE_CATALOG_ITEMS',
  MERGE_LOCATIONS = 'MERGE_LOCATIONS',
  PLAID_FIX_FLOW = 'PLAID_FIX_FLOW',
  PROVIDE_BUSINESS_INFO = 'PROVIDE_BUSINESS_INFO',
  REACTIVATE_ACCOUNT = 'REACTIVATE_ACCOUNT',
  RETRY_FAILED_REPAYMENTS = 'RETRY_FAILED_REPAYMENTS',
  SECURITY_SETTINGS = 'SECURITY_SETTINGS',
  SHOPIFY_SYNC_SETTINGS = 'SHOPIFY_SYNC_SETTINGS',
  UPLOAD_W8_W9 = 'UPLOAD_W8_W9',
  VERIFY_BANK_ACCOUNT = 'VERIFY_BANK_ACCOUNT'
}

export type BannerActionParams = {
  accountId: Maybe<Scalars['Int']['output']>;
  connectionId: Maybe<Scalars['Int']['output']>;
  shopifyPlanConfirmationUrl: Maybe<Scalars['String']['output']>;
};

export type BannerButton = {
  action: Maybe<BannerActionEnum>;
  actionParams: Maybe<BannerActionParams>;
  text: Scalars['String']['output'];
};

export enum BannerCategoryEnum {
  ACCOUNTING_SOFTWARE = 'ACCOUNTING_SOFTWARE',
  BANK_ACCOUNTS = 'BANK_ACCOUNTS',
  BANK_ACCOUNTS_INTEGRATION = 'BANK_ACCOUNTS_INTEGRATION',
  BILLING = 'BILLING',
  COMPLIANCE = 'COMPLIANCE',
  INVENTORY = 'INVENTORY',
  MARKETNG = 'MARKETNG',
  ONBOARDING = 'ONBOARDING',
  RISK = 'RISK',
  SECURITY = 'SECURITY'
}

export enum BannerSeverityEnum {
  ERROR = 'ERROR',
  INFO = 'INFO',
  SUGGESTION = 'SUGGESTION',
  WARNING = 'WARNING'
}

export type Banners = {
  banners: Array<Banner>;
};

export type BaseExternalPayableLineItemInputObject = {
  accountingAccountId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryClassId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryDepartmentId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryLocationId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryOneId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryTwoId?: InputMaybe<Scalars['ID']['input']>;
  catalogItemId?: InputMaybe<Scalars['ID']['input']>;
  quickbooksCategoryId?: InputMaybe<Scalars['ID']['input']>;
  quickbooksClassId?: InputMaybe<Scalars['ID']['input']>;
  trackingCategoryOneId?: InputMaybe<Scalars['ID']['input']>;
  trackingCategoryTwoId?: InputMaybe<Scalars['ID']['input']>;
  xeroCategoryId?: InputMaybe<Scalars['ID']['input']>;
};

export type BatchLandedCostProfitability = {
  catalogItemVariation: CatalogItemVariation;
  estimatedDaysInInventory: Maybe<Scalars['Int']['output']>;
  fractionalLandedCost: Maybe<InfinitePrecisionMoney>;
  margin: Maybe<InfinitePrecisionMoney>;
  marginPercentage: Maybe<Scalars['Float']['output']>;
  orderDocument: Maybe<OrderDocument>;
  quantity: Maybe<Scalars['Float']['output']>;
  totalFractionalLandedCost: Maybe<InfinitePrecisionMoney>;
  totalMargin: Maybe<InfinitePrecisionMoney>;
};

export type BeneficialOwner = {
  createdAt: Scalars['ISO8601Date']['output'];
  createdBy: Scalars['String']['output'];
  /** Type of beneficial owner (business or individual) */
  entityType: Maybe<BeneficialOwnerEntityType>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** ID of the parent beneficial owner, if applicable */
  parentBeneficialOwnerId: Maybe<Scalars['Int']['output']>;
  significantControl: Scalars['Boolean']['output'];
  status: BeneficialOwnerStatusEnum;
};

/** Type of beneficial owner entity */
export enum BeneficialOwnerEntityType {
  /** Business beneficial owner */
  business = 'business',
  /** Individual beneficial owner */
  individual = 'individual'
}

export type BeneficialOwnerIndividualInputType = {
  dataFields: DataFieldsInput;
  /** ISO alpha-2 nationality / citizenship country. Distinct from residence (address country); drives which national ID format applies during screening. */
  nationalityCountryCode?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the parent BusinessOwner. */
  parentBeneficialOwnerId?: InputMaybe<Scalars['Int']['input']>;
  significantControl?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BeneficialOwnerStatusEnum {
  APPROVED = 'APPROVED',
  CREATED = 'CREATED',
  DECLINED = 'DECLINED',
  FLAGGED = 'FLAGGED',
  IN_PROGRESS = 'IN_PROGRESS',
  REMOVED = 'REMOVED'
}

/** Autogenerated return type of BeneficialOwnersApprove. */
export type BeneficialOwnersApprovePayload = {
  success: Scalars['Boolean']['output'];
};

export type BeneficialOwnersDataFields = {
  communication: Maybe<BeneficialOwnersSectionFields>;
  countrySpecific: Maybe<BeneficialOwnersSectionFields>;
  driverLicence: Maybe<BeneficialOwnersSectionFields>;
  location: Maybe<BeneficialOwnersSectionFields>;
  nationalIds: Maybe<BeneficialOwnersSectionFields>;
  passport: Maybe<BeneficialOwnersSectionFields>;
  personInfo: Maybe<BeneficialOwnersSectionFields>;
};

/** Autogenerated return type of BeneficialOwnersDecline. */
export type BeneficialOwnersDeclinePayload = {
  success: Scalars['Boolean']['output'];
};

export type BeneficialOwnersFieldDescription = {
  description: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  nestedIn: Maybe<Scalars['String']['output']>;
  propertyKey: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type BeneficialOwnersSectionFields = {
  fields: Maybe<Array<BeneficialOwnersFieldDescription>>;
  required: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of BeneficialOwnersStartReview. */
export type BeneficialOwnersStartReviewPayload = {
  success: Scalars['Boolean']['output'];
};

export type BillingCouponType = {
  active: Scalars['Boolean']['output'];
  amountOff: Maybe<Money>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  termsLink: Scalars['String']['output'];
};

export type BillingDiscountType = {
  activatedAt: Scalars['ISO8601DateTime']['output'];
  active: Scalars['Boolean']['output'];
  coupon: BillingCouponType;
  expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  promotionCode: Maybe<BillingPromotionCodeType>;
};

export type BillingDowngradeDetailsType = {
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BillingExtendedDowngradeDetailsType = {
  featureGroupTitle: Scalars['String']['output'];
  features: Array<BillingDowngradeDetailsType>;
};

export type BillingInvoiceLineItemType = {
  lineItemPriceType: Maybe<BillingPriceTypeEnum>;
  perUnitAmount: Maybe<Money>;
  periodEnd: Scalars['ISO8601DateTime']['output'];
  periodStart: Scalars['ISO8601DateTime']['output'];
  quantity: Scalars['Int']['output'];
  /** The name of the SaaS plan associated with the line item */
  saasPlanName: Maybe<Scalars['String']['output']>;
  totalAmount: Money;
};

export enum BillingInvoiceStatusEnum {
  DRAFT = 'DRAFT',
  OPEN = 'OPEN',
  PAID = 'PAID',
  VOID = 'VOID'
}

export type BillingInvoiceTax = {
  amount: Money;
  taxType: Maybe<BillingTaxTypeEnum>;
};

export type BillingInvoiceType = {
  /** Paid amount */
  amount: Money;
  billingInvoiceLineItems: Array<BillingInvoiceLineItemType>;
  billingInvoiceTaxes: Maybe<Array<BillingInvoiceTax>>;
  billingMethod: Maybe<BillingMethod>;
  billingPaymentStatus: Maybe<BillingPaymentStatusEnum>;
  billingStatementAvailable: Scalars['Boolean']['output'];
  date: Scalars['ISO8601DateTime']['output'];
  /** The total amount of discounts */
  discountAmount: Maybe<Money>;
  discountCouponName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  periodEnd: Scalars['ISO8601DateTime']['output'];
  periodStart: Scalars['ISO8601DateTime']['output'];
  planName: Maybe<Scalars['String']['output']>;
  status: BillingInvoiceStatusEnum;
  /** The total amount before discounts */
  subtotalAmount: Maybe<Money>;
};

export type BillingInvoicesType = {
  data: Array<BillingInvoiceType>;
  pagination: Pagination;
};

export type BillingLimitType = {
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BillingMethod = {
  default: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  source: BillingMethodSource;
};

export type BillingMethodSource = Account | PaymentCard;

export enum BillingPaymentStatusEnum {
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
  INITIATED = 'INITIATED',
  PAID = 'PAID',
  REFUNDED = 'REFUNDED',
  RETRY_INITIATED = 'RETRY_INITIATED'
}

export type BillingPlanChangeResponseType = {
  confirmationUrl: Maybe<Scalars['String']['output']>;
  subscription: BillingSubscriptionType;
};

export type BillingPlanFeatures = {
  billingVersion: BillingVersionsEnum;
  feature: BillingPlanFeaturesEnumV2;
  supportedByPlan: Scalars['Boolean']['output'];
  usageData: BillingPlanUsageData;
};

export enum BillingPlanFeaturesEnumV2 {
  ACCOUNTING_SOFTWARE = 'ACCOUNTING_SOFTWARE',
  ADHOC_INVOICE_APPROVALS = 'ADHOC_INVOICE_APPROVALS',
  ADVANCED_AND_CUSTOM_USER_ROLES = 'ADVANCED_AND_CUSTOM_USER_ROLES',
  AI_ASSISTANT = 'AI_ASSISTANT',
  APPROVALS = 'APPROVALS',
  APPROVAL_WORKFLOW_RULES = 'APPROVAL_WORKFLOW_RULES',
  BASIC_USER_ROLES = 'BASIC_USER_ROLES',
  BATCH_LANDED_COSTS = 'BATCH_LANDED_COSTS',
  BATCH_PAYMENTS = 'BATCH_PAYMENTS',
  BULK_PAYMENTS = 'BULK_PAYMENTS',
  CASH_FLOW_CHART = 'CASH_FLOW_CHART',
  CASH_FLOW_FORECASTING = 'CASH_FLOW_FORECASTING',
  CASH_OUTFLOWS = 'CASH_OUTFLOWS',
  CATALOG = 'CATALOG',
  COMMENTING = 'COMMENTING',
  CUSTOM_ROLES = 'CUSTOM_ROLES',
  END_OF_MONTH_INVENTORY_REPORT = 'END_OF_MONTH_INVENTORY_REPORT',
  GRN = 'GRN',
  INBOX = 'INBOX',
  INVENTORY_FORECASTING = 'INVENTORY_FORECASTING',
  INVENTORY_TRANSFERS = 'INVENTORY_TRANSFERS',
  INVOICE_LESS_PAYMENTS = 'INVOICE_LESS_PAYMENTS',
  ITEMIZED_ACCOUNTING = 'ITEMIZED_ACCOUNTING',
  LANDED_COSTS = 'LANDED_COSTS',
  LOCATIONS = 'LOCATIONS',
  MILESTONES = 'MILESTONES',
  OCR = 'OCR',
  PREMIUM_CUSTOMER_SUPPORT = 'PREMIUM_CUSTOMER_SUPPORT',
  PRODUCT_COST = 'PRODUCT_COST',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  PURCHASE_ORDERS = 'PURCHASE_ORDERS',
  PURCHASE_ORDER_DEPOSITS = 'PURCHASE_ORDER_DEPOSITS',
  PURCHASE_ORDER_MANAGEMENT = 'PURCHASE_ORDER_MANAGEMENT',
  PURCHASING_SUITE = 'PURCHASING_SUITE',
  SALES_INTEGRATION = 'SALES_INTEGRATION',
  SALES_ORDERS = 'SALES_ORDERS',
  SEATS = 'SEATS',
  SEATS_AVAILABLE = 'SEATS_AVAILABLE',
  SETTLE_INBOX = 'SETTLE_INBOX',
  SHIPMENTS = 'SHIPMENTS',
  SPLIT_PAY_AND_VENDOR_CREDITS = 'SPLIT_PAY_AND_VENDOR_CREDITS',
  STANDARD_PAYMENTS = 'STANDARD_PAYMENTS',
  THREE_WAY_MATCH = 'THREE_WAY_MATCH',
  TRANSACTIONS = 'TRANSACTIONS',
  TWO_WAY_SYNC = 'TWO_WAY_SYNC',
  VENDOR_MANAGEMENT = 'VENDOR_MANAGEMENT',
  VENDOR_W9_AND_1099 = 'VENDOR_W9_AND_1099',
  VENDOR_W9_STORAGE_AND_1099 = 'VENDOR_W9_STORAGE_AND_1099',
  VOLUME_BASED_COSTS = 'VOLUME_BASED_COSTS',
  WAREHOUSE_INTEGRATION = 'WAREHOUSE_INTEGRATION',
  WORK_ORDERS = 'WORK_ORDERS'
}

export enum BillingPlanPermissionsEnum {
  BILLING_PLANS = 'BILLING_PLANS',
  CHANGE_BILLING_PLAN = 'CHANGE_BILLING_PLAN'
}

export type BillingPlanType = {
  accountingBillingModelType: Maybe<AccountingBillingModelTypeEnum>;
  basePlanType: Maybe<BillingPlanTypeEnum>;
  billingVersion: BillingVersionsEnum;
  description: Maybe<Scalars['String']['output']>;
  displayFeatures: Array<Scalars['String']['output']>;
  features: Array<BillingPlanFeaturesEnumV2>;
  featuresWithLimits: Array<BillingPlanFeatures>;
  id: Scalars['ID']['output'];
  limits: Array<BillingLimitType>;
  name: Scalars['String']['output'];
  originalSaasFeePerMonth: Maybe<Money>;
  planPaidBy: Maybe<PayerEnum>;
  saasFeePerMonth: Maybe<Money>;
  transactionFeesPaidBy: Maybe<PayerEnum>;
  transfersPrices: Maybe<BillingPricingType>;
  type: BillingPlanTypeEnum;
};

export enum BillingPlanTypeEnum {
  ACCELERATE = 'ACCELERATE',
  ACCOUNTING_ACCELERATE = 'ACCOUNTING_ACCELERATE',
  ACCOUNTING_BASIC = 'ACCOUNTING_BASIC',
  ACCOUNTING_BILL_PAY = 'ACCOUNTING_BILL_PAY',
  ACCOUNTING_ELEVATE = 'ACCOUNTING_ELEVATE',
  ACCOUNTING_FIRM = 'ACCOUNTING_FIRM',
  ACCOUNTING_FIRM_V3 = 'ACCOUNTING_FIRM_V3',
  ACCOUNTING_LAUNCH = 'ACCOUNTING_LAUNCH',
  ACCOUNTING_PLUS = 'ACCOUNTING_PLUS',
  ACCOUNTING_WORKING_CAPITAL = 'ACCOUNTING_WORKING_CAPITAL',
  AUTOMATE = 'AUTOMATE',
  BASIC = 'BASIC',
  CUSTOM = 'CUSTOM',
  ELEVATE = 'ELEVATE',
  FREE = 'FREE',
  LAUNCH = 'LAUNCH',
  OPTIMIZE = 'OPTIMIZE',
  PLUS = 'PLUS',
  SAVE = 'SAVE',
  WORKING_CAPITAL = 'WORKING_CAPITAL'
}

export type BillingPlanUpgrade = {
  amount: Money;
  currentPeriodStart: Scalars['ISO8601Date']['output'];
  prorated: Scalars['Boolean']['output'];
};

export type BillingPlanUsageData = {
  currentUsage: Maybe<Scalars['Int']['output']>;
  limitReached: Maybe<Scalars['Boolean']['output']>;
  usageLimit: Maybe<Scalars['Int']['output']>;
};

export type BillingPriceType = {
  name: Scalars['String']['output'];
  originalUnitAmount: Maybe<Money>;
  type: Scalars['String']['output'];
  unitAmount: Money;
};

export enum BillingPriceTypeEnum {
  ACH_TRANSFER = 'ACH_TRANSFER',
  CHARGE_TRANSFER_FAIL = 'CHARGE_TRANSFER_FAIL',
  DOMESTIC_WIRE_TRANSFER = 'DOMESTIC_WIRE_TRANSFER',
  INTERNATIONAL_WIRE_TRANSFER = 'INTERNATIONAL_WIRE_TRANSFER',
  PAPER_CHECK_TRANSFER = 'PAPER_CHECK_TRANSFER',
  SAAS = 'SAAS',
  SAME_DAY_ACH_TRANSFER = 'SAME_DAY_ACH_TRANSFER'
}

export type BillingPricingType = {
  achTransfer: BillingPriceType;
  chargeTransferFail: BillingPriceType;
  domesticWireTransfer: BillingPriceType;
  internationalWireTransfer: BillingPriceType;
  paperCheckTransfer: BillingPriceType;
  sameDayAchTransfer: BillingPriceType;
};

export type BillingPromotionCodeType = {
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  coupon: BillingCouponType;
  id: Scalars['ID']['output'];
};

export enum BillingProviderEnum {
  SETTLE = 'SETTLE',
  SHOPIFY = 'SHOPIFY',
  STRIPE = 'STRIPE'
}

export enum BillingSubscriptionStatusEnum {
  ACTIVE = 'ACTIVE',
  CANCELLATION_INITIATED = 'CANCELLATION_INITIATED',
  CANCELLED = 'CANCELLED',
  FROZEN = 'FROZEN'
}

export type BillingSubscriptionType = {
  cancelAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  cancelledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  currentPeriodEnd: Scalars['ISO8601DateTime']['output'];
  currentPeriodStart: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  plan: BillingPlanType;
  provider: BillingProviderEnum;
  status: BillingSubscriptionStatusEnum;
  transfersPrices: Maybe<BillingPricingType>;
};

export enum BillingTaxTypeEnum {
  SALES_TAX = 'SALES_TAX'
}

export enum BillingVersionsEnum {
  V2 = 'V2',
  V3 = 'V3'
}

export type BillsSummary = {
  inboxCount: Scalars['Int']['output'];
  rejectedCount: Scalars['Int']['output'];
};

export type Blob = {
  byteSize: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type BlockLocalBusinessPayments = {
  reason: BlockLocalBusinessPaymentsReasonEnum;
};

export enum BlockLocalBusinessPaymentsReasonEnum {
  PUBLIC_BUSINESS_MATCH_AVAILABLE = 'PUBLIC_BUSINESS_MATCH_AVAILABLE'
}

export type BlockPayments = {
  reason: ReasonEnum;
};

export type BomLineItem = {
  bomMaterial: Maybe<BomMaterial>;
  catalogItemVariation: Maybe<CatalogItemVariation>;
  id: Scalars['ID']['output'];
  quantity: Maybe<Scalars['Float']['output']>;
  softDeletedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  unitOfMeasure: Maybe<Scalars['String']['output']>;
};

export type BomMaterial = {
  defaultCatalogItemVariation: Maybe<CatalogItemVariation>;
  defaultQuantity: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BomTableRowType = {
  catalogItemVariation: Maybe<CatalogItemVariation>;
  name: Maybe<Scalars['String']['output']>;
  quantityPerUnit: Maybe<Scalars['Float']['output']>;
  totalQuantity: Maybe<Scalars['Float']['output']>;
  type: Maybe<Scalars['String']['output']>;
  /** The unit cost for this BOM component based on business costing method */
  unitAmount: Maybe<InfinitePrecisionMoney>;
  unitOfMeasure: Maybe<Scalars['String']['output']>;
};

export type BulkPayBase = {
  invoice: Maybe<Invoice>;
  message: Maybe<Scalars['String']['output']>;
  payment: Maybe<Payment>;
  success: Scalars['Boolean']['output'];
};

export type BulkPayInputObjectV2 = {
  amount?: InputMaybe<MoneyInputObject>;
  invoiceId: Scalars['ID']['input'];
  toAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type BulletEpt = {
  /** Annual percentage rate (APR) for the loan */
  apr: Scalars['Float']['output'];
  /** Planned or actual charges schedule */
  charges: Array<BulletEptCharge>;
  /** The current installment (last failed, next scheduled or the last one); a window during which nothing is due is skipped */
  currentCharge: Maybe<BulletEptCharge>;
  /** Whether taking this term on an existing payment needs a signed extension agreement first */
  extensionAgreementRequired: Scalars['Boolean']['output'];
  /** Sum of interest accrued */
  interest: Money;
  /** Nominal annualized rate at which interest accrues */
  interestRate: Scalars['Float']['output'];
  /** Number of days in each regular period; an upfront window has its own length */
  periodDays: Scalars['Int']['output'];
  /** Percentage of principal charged as interest each regular period; an upfront window has its own rate */
  periodRate: Scalars['Float']['output'];
  /** Number of periods ending with installment payment */
  periods: Scalars['Int']['output'];
  /** Sum of principal repayments */
  principal: Money;
  /** Number of periods that charge an amount; a window during which nothing is due is not one */
  repaymentCount: Scalars['Int']['output'];
  /** Whether or not this EPT schedule is active on the payment */
  selected: Scalars['Boolean']['output'];
  /** Sum of all installment payments */
  total: Money;
  /** Sum of days in all periods */
  totalDays: Scalars['Int']['output'];
  /** Leading window at its own rate before the regular periods, when the terms carry one */
  upfrontWindow: Maybe<UpfrontWindow>;
};

export type BulletEptCharge = {
  /** Installment payment date */
  date: Scalars['ISO8601Date']['output'];
  /** Marks the late-payment interest line */
  defaultInterest: Scalars['Boolean']['output'];
  /** Full description of charge */
  description: Scalars['String']['output'];
  /** Marks charge which is an early repayment */
  earlyRepayment: Scalars['Boolean']['output'];
  /** Interest included into installment amount */
  interest: Money;
  /** Number of the installment */
  number: Scalars['Int']['output'];
  /** Percentage of principal charged each period as interest */
  periodRate: Scalars['Float']['output'];
  /** Principal repayment included in installment amount */
  principal: Money;
  reconciliationItem: Maybe<ReconciliationItem>;
  /** Status of the installment */
  status: AmortizedLoanInstallmentStatusEnum;
  /** Installment amount */
  total: Money;
};

export type BulletEptEarlyRepaymentPreview = {
  /** Current bullet ept schedule */
  current: BulletEpt;
  /** Expected bullet ept schedule */
  expected: BulletEpt;
};

/** The document a borrower signs before an extension of a bullet EPT applies */
export type BulletEptExtensionAgreement = {
  /** The signed copy once signed, otherwise the copy to review */
  document: Agreement;
  /** Pass to signBulletEptExtensionAgreement and changeBulletEptTermLength */
  id: Scalars['ID']['output'];
  signed: Scalars['Boolean']['output'];
};

export type Business = {
  actions: BusinessActions;
  address: Maybe<Address>;
  /** Returns true when the business has amortized terms configured, general or vendor-scoped */
  amortizationAvailable: Scalars['Boolean']['output'];
  appliedForFinancing: Scalars['Boolean']['output'];
  attachmentTemplates: Array<AttachedDocumentTemplate>;
  balanceSheet: Maybe<BalanceSheet>;
  billPayFromPayer: Scalars['Boolean']['output'];
  billPayToVendor: Scalars['Boolean']['output'];
  blockFinancedPayments: Maybe<BlockPayments>;
  blockPayments: Maybe<BlockPayments>;
  /** @deprecated Always true. Stop branching on it and select nothing in its place. */
  bulletExtendedTermFeatureEnabled: Scalars['Boolean']['output'];
  businessStructure: Maybe<BusinessStructureEnum>;
  businessStructureTaxClassification: Maybe<BusinessStructureTaxClassificationEnum>;
  /** Cash Advance EPT/BEPT and AEPT feature enables */
  cashAdvanceFinancingAvailability: CashAdvanceFinancingAvailability;
  cashManagerInflowIntegration: Maybe<CashManagerIntegration>;
  companyName: Maybe<Scalars['String']['output']>;
  connectedToCin7: Scalars['Boolean']['output'];
  counters: Counters;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Credit limit status of current business */
  creditLimitStatus: Maybe<BusinessCreditLimitStatusEnum>;
  creditLimitUpsizeRequestAvailable: Scalars['Boolean']['output'];
  current: Scalars['Boolean']['output'];
  demoAvailable: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  doingBusinessAsNames: Maybe<Array<Scalars['String']['output']>>;
  email: Maybe<Scalars['String']['output']>;
  eptFromPayer: Scalars['Boolean']['output'];
  eptMetrics: Maybe<EptMetrics>;
  eptToVendor: Scalars['Boolean']['output'];
  estimatedCreditEligibility: Maybe<Money>;
  exemptFatcaReportingCode: Maybe<Scalars['String']['output']>;
  exemptPayeeCode: Maybe<Scalars['String']['output']>;
  finaloopLinked: Scalars['Boolean']['output'];
  /** Smallest amount that can be financed */
  financingMinimumAmount: Money;
  financingNudgeBanner: Maybe<FinancingNudgeBanner>;
  firstName: Maybe<Scalars['String']['output']>;
  hasAmortizedPayments: Scalars['Boolean']['output'];
  hasBeptPayments: Scalars['Boolean']['output'];
  hasCashAdvancePayments: Scalars['Boolean']['output'];
  hasEptPayments: Scalars['Boolean']['output'];
  hasRefunds: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  industry: Maybe<BusinessIndustryEnum>;
  inputStateOfFormation: Maybe<Scalars['String']['output']>;
  internalEmail: Maybe<Scalars['String']['output']>;
  is1099Eligible: Maybe<Scalars['Boolean']['output']>;
  kybStatus: KybStatusEnum;
  lastName: Maybe<Scalars['String']['output']>;
  lendingLicense: Maybe<LendingLicenseEnum>;
  lockboxEnabled: Maybe<Scalars['Boolean']['output']>;
  logo: Maybe<Blob>;
  mailingAddress: Maybe<Address>;
  marketingVirtualCardDefaultRepaymentPercent: Scalars['Float']['output'];
  marketingVirtualCardEnabled: Scalars['Boolean']['output'];
  /** Largest amount a single consolidated financed payment can cover */
  maxConsolidatedFinancingAmount: Money;
  mcc: Maybe<Scalars['String']['output']>;
  mdrReady: Scalars['Boolean']['output'];
  mfaEnforcementLevel: Maybe<MfaEnforcementLevelEnum>;
  netsuiteLinked: Scalars['Boolean']['output'];
  netsuiteState: Maybe<NetsuiteState>;
  officialName: Scalars['String']['output'];
  onboardingStatus: Maybe<OnboardingStatusEnum>;
  partnerPricingEnabled: Scalars['Boolean']['output'];
  /** Payment dialog configuration for current business */
  paymentOptions: PaymentOptions;
  phone: Maybe<Phone>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  plaidLinked: Scalars['Boolean']['output'];
  preferredPayingAccount: Maybe<Account>;
  preferredReceivingAccount: Maybe<Account>;
  pusherChannelId: Scalars['String']['output'];
  quickBooksLinked: Scalars['Boolean']['output'];
  quickBooksState: Maybe<QuickBooksState>;
  receivablesEnabled: Scalars['Boolean']['output'];
  /** @deprecated Use preferredReceivingAccount instead */
  receivingAccount: Maybe<LocalBusinessAccount>;
  requiresCaLendingTransitionAcknowledgment: Scalars['Boolean']['output'];
  roles: Array<BusinessRoleEnum>;
  /** @deprecated Not needed by FE */
  rulesCount: Scalars['Int']['output'];
  shopifyLead: Scalars['Boolean']['output'];
  showBillsPromoSignup: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated banner deprecated */
  showStatusesRenamingBanner: Scalars['Boolean']['output'];
  signupInterests: Maybe<Array<SignupInterestsEnum>>;
  stateOfFormation: Maybe<Scalars['String']['output']>;
  subscription: Maybe<BillingSubscriptionType>;
  taxpayerId: Maybe<Scalars['String']['output']>;
  underwritingStatus: BusinessUnderwritingStatusEnum;
  usersRequiringMfaCount: Scalars['Int']['output'];
  /** W9 form document uploaded by the current business */
  w9Form: Maybe<Attachment>;
  website: Maybe<Scalars['String']['output']>;
  xeroLinked: Scalars['Boolean']['output'];
};

export type BusinessActions = {
  creditLimitUpsizeRequest: Action;
  editDetails: Action;
  exportCashFlowReport: Action;
  submitTaxForm: Action;
};

export type BusinessBeneficialOwnerInput = {
  address: AddressInputObject;
  countryOfFormation?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  /** The ID of the parent BusinessOwner. */
  parentBeneficialOwnerId?: InputMaybe<Scalars['Int']['input']>;
  stateOfFormation?: InputMaybe<Scalars['String']['input']>;
  taxpayerId: Scalars['String']['input'];
};

export type BusinessClient = {
  business: PublicBusiness;
  teamMemberships: Array<UserClient>;
};

export enum BusinessComplianceStatusEnum {
  AWAITING_INFO = 'AWAITING_INFO',
  IN_REVIEW = 'IN_REVIEW',
  REJECTED = 'REJECTED',
  VERIFIED = 'VERIFIED'
}

export type BusinessCostingMethod = {
  costingMethod: CostingMethodEnum;
  effectiveAt: Scalars['ISO8601Date']['output'];
  modifiedBy: Maybe<Scalars['ID']['output']>;
  nextScheduled: Maybe<BusinessCostingMethod>;
};

export enum BusinessCreditLimitStatusEnum {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED'
}

export enum BusinessDetailsPermissionsEnum {
  ADD_BENEFICIAL_OWNERS = 'ADD_BENEFICIAL_OWNERS',
  UPDATE_BUSINESS_DETAILS = 'UPDATE_BUSINESS_DETAILS',
  VIEW_BENEFICIAL_OWNERS = 'VIEW_BENEFICIAL_OWNERS',
  VIEW_BUSINESS_DETAILS = 'VIEW_BUSINESS_DETAILS'
}

export type BusinessFeaturesActions = {
  updateBillApprovalOverride: Action;
  updateBillApprovalOverrideReasonRequired: Action;
  updateBillAutoItemization: Action;
  updateCostingMethod: Action;
  updatePaymentApprovalOverride: Action;
  updatePaymentApprovalOverrideReasonRequired: Action;
  updatePaymentHoldRelease: Action;
  updatePaymentW8OrW9MissingHold: Action;
  updatePurchaseOrderApprovalOverride: Action;
  updatePurchaseOrderApprovalOverrideReasonRequired: Action;
  updatePurchaseOrderAutoItemization: Action;
  updateVendorDunning: Action;
};

export type BusinessFeaturesInputObject = {
  billApprovalOverride?: InputMaybe<Scalars['Boolean']['input']>;
  billApprovalOverrideReasonRequired?: InputMaybe<Scalars['Boolean']['input']>;
  billAutoItemization?: InputMaybe<Scalars['Boolean']['input']>;
  costingMethod?: InputMaybe<CostingMethodEnum>;
  paymentApprovalOverride?: InputMaybe<Scalars['Boolean']['input']>;
  paymentApprovalOverrideReasonRequired?: InputMaybe<Scalars['Boolean']['input']>;
  paymentHoldRelease?: InputMaybe<Scalars['Boolean']['input']>;
  paymentW8OrW9MissingHold?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseOrderApprovalOverride?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseOrderApprovalOverrideReasonRequired?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseOrderAutoItemization?: InputMaybe<Scalars['Boolean']['input']>;
  receivableInvoiceAutoItemization?: InputMaybe<Scalars['Boolean']['input']>;
  vendorDunning?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BusinessFeaturesPermissionsEnum {
  UPDATE_BILL_AUTO_ITEMIZATION = 'UPDATE_BILL_AUTO_ITEMIZATION',
  UPDATE_COSTING_METHOD_SELECTION = 'UPDATE_COSTING_METHOD_SELECTION',
  UPDATE_PAYMENT_HOLD_RELEASE = 'UPDATE_PAYMENT_HOLD_RELEASE',
  UPDATE_PAYMENT_W8_OR_W9_MISSING_HOLD = 'UPDATE_PAYMENT_W8_OR_W9_MISSING_HOLD',
  UPDATE_PURCHASE_ORDER_AUTO_ITEMIZATION = 'UPDATE_PURCHASE_ORDER_AUTO_ITEMIZATION',
  UPDATE_RECEIVABLE_INVOICE_AUTO_ITEMIZATION = 'UPDATE_RECEIVABLE_INVOICE_AUTO_ITEMIZATION',
  UPDATE_VENDOR_DUNNING = 'UPDATE_VENDOR_DUNNING',
  VIEW_COSTING_METHOD_SELECTION = 'VIEW_COSTING_METHOD_SELECTION'
}

export type BusinessFeaturesType = {
  actions: BusinessFeaturesActions;
  billApprovalOverride: Scalars['Boolean']['output'];
  billApprovalOverrideReasonRequired: Scalars['Boolean']['output'];
  billAutoItemization: Scalars['Boolean']['output'];
  costingMethod: CostingMethodEnum;
  costingMethodV2: BusinessCostingMethod;
  paymentApprovalOverride: Scalars['Boolean']['output'];
  paymentApprovalOverrideReasonRequired: Scalars['Boolean']['output'];
  paymentHoldRelease: Scalars['Boolean']['output'];
  paymentW8OrW9MissingHold: Scalars['Boolean']['output'];
  purchaseOrderApprovalOverride: Scalars['Boolean']['output'];
  purchaseOrderApprovalOverrideReasonRequired: Scalars['Boolean']['output'];
  purchaseOrderAutoItemization: Scalars['Boolean']['output'];
  receivableInvoiceAutoItemization: Scalars['Boolean']['output'];
  vendorDunning: Scalars['Boolean']['output'];
};

export enum BusinessIndustryEnum {
  ACCESSORIES = 'ACCESSORIES',
  ACCOUNTING = 'ACCOUNTING',
  BABY_KIDS = 'BABY_KIDS',
  BEAUTY = 'BEAUTY',
  CLOTHING_APPAREL = 'CLOTHING_APPAREL',
  CONSTRUCTION = 'CONSTRUCTION',
  ELECTRONICS = 'ELECTRONICS',
  FINANCIAL_SERVICES = 'FINANCIAL_SERVICES',
  FOOD_BEVERAGE = 'FOOD_BEVERAGE',
  FURNITURE = 'FURNITURE',
  HEALTH_WELLNESS = 'HEALTH_WELLNESS',
  HOME_KITCHEN = 'HOME_KITCHEN',
  JEWELERY = 'JEWELERY',
  LAW_OFFICES = 'LAW_OFFICES',
  MARKETING = 'MARKETING',
  OTHER = 'OTHER',
  PET_PRODUCTS = 'PET_PRODUCTS',
  REAL_ESTATE = 'REAL_ESTATE',
  RESTAURANT_HOSPITALITY = 'RESTAURANT_HOSPITALITY',
  SERVICES = 'SERVICES',
  SPORTS = 'SPORTS',
  TOYS = 'TOYS',
  VIRTUAL_SERVICES = 'VIRTUAL_SERVICES'
}

export type BusinessMatch = {
  id: Scalars['ID']['output'];
  localBusiness: LocalBusiness;
  matchedEntity: PublicBusiness;
  matchedOn: Array<Scalars['String']['output']>;
  status: BusinessMatchStatusEnum;
};

export enum BusinessMatchStatusEnum {
  MERGED = 'MERGED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export enum BusinessRoleEnum {
  ACCOUNTING_FIRM = 'ACCOUNTING_FIRM',
  PAYER = 'PAYER',
  VENDOR = 'VENDOR'
}

export enum BusinessStructureEnum {
  BUSINESS_GENERAL = 'BUSINESS_GENERAL',
  C_CORPORATION = 'C_CORPORATION',
  INDIVIDUAL = 'INDIVIDUAL',
  LIMITED_PARTNERSHIP = 'LIMITED_PARTNERSHIP',
  LLC = 'LLC',
  NON_PROFIT = 'NON_PROFIT',
  OTHER_BUSINESS = 'OTHER_BUSINESS',
  PARTNERSHIP = 'PARTNERSHIP',
  SOLE_PROP = 'SOLE_PROP',
  S_CORPORATION = 'S_CORPORATION'
}

export enum BusinessStructureTaxClassificationEnum {
  C_CORPORATION = 'C_CORPORATION',
  PARTNERSHIP = 'PARTNERSHIP',
  SOLE_PROP = 'SOLE_PROP',
  S_CORPORATION = 'S_CORPORATION'
}

export enum BusinessTraitsEnum {
  ACCOUNTING_FIRM = 'ACCOUNTING_FIRM',
  BILLING_PLAN_ACCELERATE = 'BILLING_PLAN_ACCELERATE',
  BILLING_PLAN_ELEVATE = 'BILLING_PLAN_ELEVATE',
  BILLING_PLAN_LAUNCH = 'BILLING_PLAN_LAUNCH',
  BILLING_PLAN_WC = 'BILLING_PLAN_WC',
  DORMANT = 'DORMANT',
  INDIVIDUAL = 'INDIVIDUAL',
  IS_1099_ELIGIBLE = 'IS_1099_ELIGIBLE',
  MFA_ENFORCEMENT_ALL = 'MFA_ENFORCEMENT_ALL',
  MICRO_DEPOSITS_SENT = 'MICRO_DEPOSITS_SENT',
  MICRO_DEPOSITS_WAITING = 'MICRO_DEPOSITS_WAITING',
  MIDDESK_VERIFIED = 'MIDDESK_VERIFIED',
  PAYER = 'PAYER',
  SOLE_PROP = 'SOLE_PROP',
  UNDERWRITTEN = 'UNDERWRITTEN',
  VENDOR = 'VENDOR',
  VERIFICATION_FILLED = 'VERIFICATION_FILLED',
  VERIFIED = 'VERIFIED',
  VERIFIED_INTERNATIONAL = 'VERIFIED_INTERNATIONAL',
  VERIFIED_WITHOUT_RECEIVING_ACCOUNT = 'VERIFIED_WITHOUT_RECEIVING_ACCOUNT',
  WITH_ACCOUNT_BILLING_METHOD = 'WITH_ACCOUNT_BILLING_METHOD',
  WITH_AMORTIZATION = 'WITH_AMORTIZATION',
  WITH_CARD_BILLING_METHOD = 'WITH_CARD_BILLING_METHOD',
  WITH_CLIENT = 'WITH_CLIENT',
  WITH_EPT_LIMIT = 'WITH_EPT_LIMIT',
  WITH_FRAUD_APPROVAL = 'WITH_FRAUD_APPROVAL',
  WITH_PAYEE_AGENT_DISCLOSURE = 'WITH_PAYEE_AGENT_DISCLOSURE',
  WITH_QUICK_BOOKS = 'WITH_QUICK_BOOKS',
  WITH_UBO = 'WITH_UBO',
  WITH_W9_FORM = 'WITH_W9_FORM',
  WITH_ZERO_EPT_LIMIT = 'WITH_ZERO_EPT_LIMIT'
}

export enum BusinessTypeEnum {
  ACCOUNTING_PARTNER = 'ACCOUNTING_PARTNER',
  PAYER = 'PAYER'
}

export enum BusinessUnderwritingStatusEnum {
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  MISSING_BANK_ACCOUNT = 'MISSING_BANK_ACCOUNT',
  PENDING = 'PENDING'
}

export type CashAdvanceFinancingAvailability = {
  amortizationAvailable: Scalars['Boolean']['output'];
  eptAvailable: Scalars['Boolean']['output'];
};

export type CashAdvancePaymentInputObject = {
  amount: MoneyInputObject;
  receivingAccountId: Scalars['ID']['input'];
  repaymentAccountId: Scalars['ID']['input'];
};

export type CashManagerIntegration = {
  connectionType: ConnectionTypeEnum;
  finishOnboardingUrl: Maybe<Scalars['String']['output']>;
  stripeOnboardingStatus: StripeOnboardingStatusEnum;
};

export type CashOutflow = {
  endDate: Scalars['ISO8601Date']['output'];
  eptPayments: Money;
  failed: Money;
  fees: Money;
  nonfinancedPayments: Money;
  pendingApproval: Money;
  purchaseOrderExpectedPayments: Money;
  startDate: Scalars['ISO8601Date']['output'];
  total: Money;
  undefinedDate: Scalars['Boolean']['output'];
  unscheduled: Money;
};

export type CatalogItem = {
  accountingCategoryClass: Maybe<AccountingDictionary>;
  accountingCategoryDepartment: Maybe<AccountingDictionary>;
  accountingCategoryLocation: Maybe<AccountingDictionary>;
  accountingSyncEvents: Maybe<Array<SyncEvent>>;
  accountingType: Maybe<AccountingQuickBooksItemTypeEnum>;
  accountingUrl: Maybe<Scalars['String']['output']>;
  actions: CatalogItemActions;
  amount: Maybe<Money>;
  archived: Scalars['Boolean']['output'];
  assemblyType: Maybe<AssemblyTypeEnum>;
  barcodes: Array<CatalogItemBarcodeType>;
  /** @deprecated Use CatalogItemVariation.baseline_cost instead */
  baselineCost: Maybe<InfinitePrecisionMoney>;
  bomLineItems: Array<BomLineItem>;
  bomMaterials: Array<BomMaterial>;
  category: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  defaultVariation: Maybe<CatalogItemVariation>;
  description: Maybe<Scalars['String']['output']>;
  expenseAccountingAccount: Maybe<AccountingAccount>;
  fractionalAmount: Maybe<InfinitePrecisionMoney>;
  hasDefaultVariation: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Blob>;
  imageUrl: Maybe<Scalars['String']['output']>;
  itemCode: Maybe<Scalars['String']['output']>;
  labels: Array<Label>;
  lastTimelineEvent: TimelineEventV2;
  name: Maybe<Scalars['String']['output']>;
  note: Maybe<Scalars['String']['output']>;
  physicalAttributes: Maybe<PhysicalAttributes>;
  primarySku: Maybe<Scalars['String']['output']>;
  properties: Array<CatalogItemProperty>;
  purchaseDetails: Maybe<Array<PurchaseDetailsType>>;
  quantity: Maybe<Scalars['Int']['output']>;
  salesDetails: Array<SalesDetailType>;
  shopifyImageUrl: Maybe<Scalars['String']['output']>;
  shopifyUrl: Maybe<Scalars['String']['output']>;
  showSyncHistory: Maybe<Scalars['Boolean']['output']>;
  syncError: Maybe<SyncError>;
  syncObjectStatus: Maybe<SyncObjectStatus>;
  timelineEvents: Array<TimelineEventV2>;
  unitOfMeasure: Maybe<Scalars['String']['output']>;
  variations: Array<CatalogItemVariation>;
  vendorLocalBusiness: Maybe<LocalBusiness>;
};

export type CatalogItemActions = {
  delete: Action;
  editBaseData: Action;
  updateVendor: Action;
};

export enum CatalogItemBarcodeSourceEnum {
  MANUAL = 'MANUAL',
  TRACKSTAR = 'TRACKSTAR'
}

export type CatalogItemBarcodeType = {
  integrationName: Maybe<Scalars['String']['output']>;
  source: CatalogItemBarcodeSourceEnum;
  value: Scalars['String']['output'];
};

export type CatalogItemBatchLandedCostDetails = {
  availableQuantity: Maybe<Scalars['Float']['output']>;
  batchLandedCost: Maybe<InfinitePrecisionMoney>;
  changeDirection: CatalogItemsLandedCostChangeDirectionEnum;
  date: Maybe<Scalars['ISO8601Date']['output']>;
  receipt: Maybe<Receipt>;
  receivedQuantity: Maybe<Scalars['Float']['output']>;
  unitCost: Maybe<InfinitePrecisionMoney>;
};

export type CatalogItemBulkInputObject = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  dimensionsUnitOfMeasure?: InputMaybe<DimensionsUnitEnum>;
  height?: InputMaybe<Scalars['Float']['input']>;
  imageSignedId?: InputMaybe<Scalars['ID']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  vendorLocalBusinessId?: InputMaybe<Scalars['ID']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnitOfMeasure?: InputMaybe<WeightUnitEnum>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CatalogItemInputObject = {
  accountingCategoryClassId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryDepartmentId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryLocationId?: InputMaybe<Scalars['ID']['input']>;
  amount?: InputMaybe<MoneyInputObject>;
  assemblyType?: InputMaybe<AssemblyTypeEnum>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  baselineCost?: InputMaybe<FractionalMoneyInputObject>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionsUnitOfMeasure?: InputMaybe<DimensionsUnitEnum>;
  expenseAccountingAccountId?: InputMaybe<Scalars['ID']['input']>;
  fractionalAmount?: InputMaybe<FractionalMoneyInputObject>;
  height?: InputMaybe<Scalars['Float']['input']>;
  imageSignedId?: InputMaybe<Scalars['ID']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  primarySku?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  vendorLocalBusinessId?: InputMaybe<Scalars['ID']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnitOfMeasure?: InputMaybe<WeightUnitEnum>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CatalogItemLandedCostDetails = {
  changeDirection: CatalogItemsLandedCostChangeDirectionEnum;
  date: Maybe<Scalars['ISO8601Date']['output']>;
  fractionalLandedCost: Maybe<InfinitePrecisionMoney>;
  orderDocument: Maybe<OrderDocument>;
  /** @deprecated This will be replaced by order_document */
  purchaseOrder: PurchaseOrder;
  quantity: Maybe<Scalars['Float']['output']>;
  wacChangeDirection: CatalogItemsLandedCostChangeDirectionEnum;
  weightedAverageCost: Maybe<InfinitePrecisionMoney>;
};

export type CatalogItemMergeSuggestion = {
  catalogItemVariation: CatalogItemVariation;
  id: Scalars['ID']['output'];
};

export type CatalogItemProperty = {
  archived: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  values: Array<CatalogItemPropertyValue>;
};

export type CatalogItemPropertyInputObject = {
  name: Scalars['String']['input'];
  values: Array<CatalogItemPropertyValuesInputObject>;
};

export type CatalogItemPropertyValue = {
  archived: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type CatalogItemPropertyValuesInputObject = {
  id?: InputMaybe<Scalars['ID']['input']>;
  value: Scalars['String']['input'];
};

export enum CatalogItemSalesDataSourceEnum {
  ACCOUNTING_PLATFORM = 'ACCOUNTING_PLATFORM',
  MANUAL = 'MANUAL',
  SHOPIFY = 'SHOPIFY'
}

/** Catalog item with semantic search similarity */
export type CatalogItemSemanticSearchResult = {
  catalogItem: CatalogItem;
  /** Cosine similarity (0.0 to 1.0, higher is more similar) */
  similarity: Scalars['Float']['output'];
};

export type CatalogItemUnion = CatalogItem | CatalogItemVariation;

export type CatalogItemVariation = {
  actions: CatalogItemActions;
  amount: Maybe<Money>;
  archived: Scalars['Boolean']['output'];
  assemblyType: Maybe<AssemblyTypeEnum>;
  barcodes: Array<CatalogItemBarcodeType>;
  baselineCost: Maybe<InfinitePrecisionMoney>;
  bomLineItems: Array<BomLineItem>;
  bomReviewed: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  fractionalAmount: Maybe<InfinitePrecisionMoney>;
  id: Scalars['ID']['output'];
  image: Maybe<Blob>;
  imageUrl: Maybe<Scalars['String']['output']>;
  isDefaultVariation: Scalars['Boolean']['output'];
  itemCode: Maybe<Scalars['String']['output']>;
  labels: Array<Label>;
  landedCost: Maybe<InfinitePrecisionMoney>;
  lastTimelineEvent: TimelineEventV2;
  name: Maybe<Scalars['String']['output']>;
  note: Maybe<Scalars['String']['output']>;
  parentCatalogItem: Maybe<CatalogItem>;
  physicalAttributes: Maybe<PhysicalAttributes>;
  primarySku: Maybe<Scalars['String']['output']>;
  productFamilyCatalogItem: CatalogItem;
  propertyValues: Array<CatalogItemPropertyValue>;
  purchaseDetails: Maybe<Array<PurchaseDetailsType>>;
  quantity: Maybe<Scalars['Int']['output']>;
  salesDetails: Array<SalesDetailType>;
  shopifyImageUrl: Maybe<Scalars['String']['output']>;
  shopifyUrl: Maybe<Scalars['String']['output']>;
  shortName: Maybe<Scalars['String']['output']>;
  timelineEvents: Array<TimelineEventV2>;
  unitOfMeasure: Maybe<Scalars['String']['output']>;
};

export type CatalogItemVariationInputObject = {
  amount?: InputMaybe<MoneyInputObject>;
  assemblyType?: InputMaybe<AssemblyTypeEnum>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  baselineCost?: InputMaybe<FractionalMoneyInputObject>;
  dimensionsUnitOfMeasure?: InputMaybe<DimensionsUnitEnum>;
  fractionalAmount?: InputMaybe<FractionalMoneyInputObject>;
  height?: InputMaybe<Scalars['Float']['input']>;
  imageSignedId?: InputMaybe<Scalars['ID']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  primarySku?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnitOfMeasure?: InputMaybe<WeightUnitEnum>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CatalogItemVariations = {
  data: Array<CatalogItemVariation>;
  pagination: Pagination;
};

export enum CatalogItemVariationsArchivedStatusEnum {
  ACTIVE = 'ACTIVE',
  ACTIVE_AND_ARCHIVED = 'ACTIVE_AND_ARCHIVED',
  ARCHIVED = 'ARCHIVED'
}

export type CatalogItemVariationsFilteringInputObject = {
  archivedStatus?: InputMaybe<CatalogItemVariationsArchivedStatusEnum>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  idsToExclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeProductFamilyCatalogItems?: InputMaybe<Scalars['Boolean']['input']>;
  inventoryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  labelOperator?: InputMaybe<LabelOperatorEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  withValidBom?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CatalogItemVariationsSortableFieldEnum {
  NAME = 'NAME',
  PRIMARY_SKU = 'PRIMARY_SKU'
}

export enum CatalogItemVariationsSortingDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type CatalogItemVariationsSortingInputObject = {
  direction: CatalogItemVariationsSortingDirectionEnum;
  field: CatalogItemVariationsSortableFieldEnum;
};

export type CatalogItems = {
  data: Array<CatalogItem>;
  pagination: Pagination;
};

export enum CatalogItemsArchivedStatusEnum {
  ACTIVE = 'ACTIVE',
  ACTIVE_AND_ARCHIVED = 'ACTIVE_AND_ARCHIVED',
  ARCHIVED = 'ARCHIVED'
}

export type CatalogItemsFilteringInputObject = {
  accountingAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  archivedStatus?: InputMaybe<CatalogItemsArchivedStatusEnum>;
  category?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  inventoryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  labelIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  labelOperator?: InputMaybe<LabelOperatorEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  vendorLocalBusinessId?: InputMaybe<Scalars['ID']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
  withSyncError?: InputMaybe<Scalars['Boolean']['input']>;
  withoutLandedCost?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CatalogItemsLandedCostChangeDirectionEnum {
  DECREASE = 'DECREASE',
  INCREASE = 'INCREASE',
  NO_CHANGE = 'NO_CHANGE'
}

export type CatalogItemsSalesDetailInputObject = {
  sku?: InputMaybe<Scalars['String']['input']>;
};

export enum CatalogPermissionsEnum {
  UPDATE_CATALOG_ITEM_LABELS = 'UPDATE_CATALOG_ITEM_LABELS'
}

export enum CategoryEnum {
  AP_AGING_CSV = 'AP_AGING_CSV',
  EXORT_AP_AGING_SUMMARY_CSV = 'EXORT_AP_AGING_SUMMARY_CSV',
  EXPORT_1099_CSV = 'EXPORT_1099_CSV',
  EXPORT_AP_AGING_DETAILS_CSV = 'EXPORT_AP_AGING_DETAILS_CSV',
  EXPORT_CASH_OUTFLOW = 'EXPORT_CASH_OUTFLOW',
  EXPORT_EXTENDED_PAYMENT_TERM_AGREEMENTS = 'EXPORT_EXTENDED_PAYMENT_TERM_AGREEMENTS',
  EXPORT_FACTORING_AGREEMENTS = 'EXPORT_FACTORING_AGREEMENTS',
  EXPORT_HISTORICAL_1099_CSV = 'EXPORT_HISTORICAL_1099_CSV',
  EXPORT_HOLDING_ACCOUNT_TRANSACTIONS = 'EXPORT_HOLDING_ACCOUNT_TRANSACTIONS',
  EXPORT_INVOICES_TO_CSV = 'EXPORT_INVOICES_TO_CSV',
  EXPORT_MVC_TRANSACTIONS_TO_CSV = 'EXPORT_MVC_TRANSACTIONS_TO_CSV',
  EXPORT_MY_INVOICES_TO_CSV = 'EXPORT_MY_INVOICES_TO_CSV',
  EXPORT_OUTSTANDING_LOANS = 'EXPORT_OUTSTANDING_LOANS',
  EXPORT_OWED_TO_SETTLE = 'EXPORT_OWED_TO_SETTLE',
  EXPORT_PAYEE_AGENT_DISCLOSURES = 'EXPORT_PAYEE_AGENT_DISCLOSURES',
  EXPORT_PAYMENT_CONFIRMATIONS = 'EXPORT_PAYMENT_CONFIRMATIONS',
  EXPORT_PRODUCT_COST = 'EXPORT_PRODUCT_COST',
  EXPORT_PURCHASE_ORDER = 'EXPORT_PURCHASE_ORDER',
  EXPORT_PURCHASE_ORDER_WITH_LINE_ITEMS = 'EXPORT_PURCHASE_ORDER_WITH_LINE_ITEMS',
  EXPORT_RECEIVABLES_TO_CSV = 'EXPORT_RECEIVABLES_TO_CSV',
  EXPORT_RECONCILIATION_ITEMS_TO_CSV = 'EXPORT_RECONCILIATION_ITEMS_TO_CSV',
  EXPORT_VENDORS = 'EXPORT_VENDORS',
  EXPORT_VENDOR_PAYMENT_CONFIRMATIONS = 'EXPORT_VENDOR_PAYMENT_CONFIRMATIONS'
}

export type ChatFeedback = {
  /** Categories of feedback for negative ratings */
  categories: Maybe<Array<AiFeedbackCategoryEnum>>;
  /** The ID of the conversation */
  conversationId: Scalars['String']['output'];
  /** Whether the feedback is positive (true) or negative (false) */
  rating: Scalars['Boolean']['output'];
};

export type ClientApplication = {
  integration: OauthClientIntegrationEnum;
  name: Scalars['String']['output'];
};

export type ClientBillingDashboardType = {
  clientsBillingSummary: Array<ClientBillingSummaryType>;
  firmPlan: BillingPlanType;
  pagination: Pagination;
};

export type ClientBillingInvoiceType = {
  /** Paid amount */
  amount: Money;
  billingInvoiceLineItems: Array<BillingInvoiceLineItemType>;
  billingInvoiceTaxes: Maybe<Array<BillingInvoiceTax>>;
  billingMethod: Maybe<BillingMethod>;
  billingPaymentStatus: Maybe<BillingPaymentStatusEnum>;
  billingStatementAvailable: Scalars['Boolean']['output'];
  /** Amount to charge from the client */
  clientAmount: Maybe<Money>;
  date: Scalars['ISO8601DateTime']['output'];
  /** The total amount of discounts */
  discountAmount: Maybe<Money>;
  discountCouponName: Maybe<Scalars['String']['output']>;
  /** Amount to charge from the firm */
  firmAmount: Maybe<Money>;
  id: Maybe<Scalars['ID']['output']>;
  periodEnd: Scalars['ISO8601DateTime']['output'];
  periodStart: Scalars['ISO8601DateTime']['output'];
  planName: Maybe<Scalars['String']['output']>;
  status: BillingInvoiceStatusEnum;
  /** The total amount before discounts */
  subtotalAmount: Maybe<Money>;
};

export type ClientBillingInvoicesType = {
  data: Array<ClientBillingInvoiceType>;
  pagination: Pagination;
};

export type ClientBillingSummaryType = {
  billingPaymentsValid: Scalars['Boolean']['output'];
  clientBusiness: Business;
  clientUpcomingBillingInvoice: Maybe<ClientBillingInvoiceType>;
  historicalBillingInvoicesExists: Scalars['Boolean']['output'];
};

export type ClientManagerAssignmentInputObject = {
  role?: InputMaybe<MembershipRolesEnum>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type ClientManagerDashboard = {
  data: Array<ClientSummary>;
  pagination: Pagination;
};

export enum ClientManagerPermissionsEnum {
  CLIENT_MANAGER_TEAM_MEMBERS = 'CLIENT_MANAGER_TEAM_MEMBERS',
  MANAGE_CLIENTS = 'MANAGE_CLIENTS',
  MANAGE_CLIENT_MANAGER_TEAM_MEMBERS = 'MANAGE_CLIENT_MANAGER_TEAM_MEMBERS'
}

export type ClientSummary = {
  accounting: AccountingSummary;
  accounts: AccountsSummary;
  bills: BillsSummary;
  complianceStatus: Maybe<BusinessComplianceStatusEnum>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payments: PaymentsSummary;
  status: ClientSummaryStatusEnum;
  /** @deprecated Use teamMemberships instead */
  teamMembers: Array<TeamMember>;
  teamMemberships: Array<Membership>;
};

export enum ClientSummaryStatusEnum {
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  NO_ACTION_REQUIRED = 'NO_ACTION_REQUIRED'
}

/** Fetches referrer link data for a given user/business pair */
export type CodeTypeV2 = {
  referralCode: Scalars['String']['output'];
  referralCount: Scalars['Int']['output'];
  referrerPromotionAmount: Money;
};

export type Comment = {
  /** HTML string containing the comment */
  body: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdBy: Maybe<TeamMember>;
  createdById: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  read: Maybe<Scalars['Boolean']['output']>;
};

export type CommentInputObject = {
  /** HTML string containing the comment */
  body: Scalars['String']['input'];
  /** array of user IDs mentioned in the comment */
  mentions: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of CompleteJourneyStep. */
export type CompleteJourneyStepPayload = {
  success: Scalars['Boolean']['output'];
};

export type ConnectUrl = {
  disabled: Scalars['Boolean']['output'];
  disabledReason: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export enum ConnectionTypeEnum {
  INFLOW = 'INFLOW'
}

export type ConsolidatePaymentDueDateForGroupInputObject = {
  groupId: Scalars['ID']['input'];
  invoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ConsolidatePaymentPreliminaryGroupRequestInputObject = {
  excluded?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId: Scalars['ID']['input'];
};

export type ConsolidatedPaymentGroupWithDueDateType = {
  earliestDueDate: Scalars['ISO8601Date']['output'];
  groupId: Scalars['ID']['output'];
  invoices: Array<Invoice>;
  overdue: Scalars['Boolean']['output'];
};

export type ConsolidatedPaymentGroupWithProcessDateType = {
  groupId: Scalars['ID']['output'];
  overdue: Scalars['Boolean']['output'];
  processDate: Scalars['ISO8601Date']['output'];
};

export type ConsolidatedPaymentInputObject = {
  members: Array<ConsolidatedPaymentMemberInputObject>;
};

export type ConsolidatedPaymentMemberInputObject = {
  amount: MoneyInputObject;
  invoiceId: Scalars['ID']['input'];
};

export type ConsolidatedPaymentType = {
  errorMessage: Maybe<Scalars['String']['output']>;
  invoices: Array<Invoice>;
  payment: Maybe<Payment>;
  success: Scalars['Boolean']['output'];
};

export type ContactDetails = {
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  operationsEmail: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  showOnAttachment: Scalars['Boolean']['output'];
  target: ContactDetailsTarget;
};

export type ContactDetailsInputObject = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operationsEmail?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  showOnAttachment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactDetailsTarget = LocalBusiness | Location | OutboundOrder | PurchaseOrder | ReceivableInvoice | WorkOrder;

export enum ContactDetailsTargetTypeEnum {
  INVOICE = 'INVOICE',
  LOCAL_BUSINESS = 'LOCAL_BUSINESS',
  LOCATION = 'LOCATION',
  OUTBOUND_ORDER = 'OUTBOUND_ORDER',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  WORK_ORDER = 'WORK_ORDER'
}

export type CostTierInputObject = {
  cost: FractionalMoneyInputObject;
  id?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
  quantity: Scalars['Float']['input'];
};

export type CostTierType = {
  cost: InfinitePrecisionMoney;
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  quantity: Scalars['Float']['output'];
};

export enum CostingMethodEnum {
  BATCH_LANDED_COST = 'BATCH_LANDED_COST',
  WEIGHTED_AVERAGE_COST = 'WEIGHTED_AVERAGE_COST'
}

export type Counters = {
  all: Scalars['Int']['output'];
  allBySource: CountersBySource;
  allInboxMessages: Scalars['Int']['output'];
  allUnread: Scalars['Int']['output'];
  archived: Scalars['Int']['output'];
  archivedInboxMessages: Scalars['Int']['output'];
  draftReceivables: Scalars['Int']['output'];
  failedReconciliationItems: Scalars['Int']['output'];
  /** @deprecated Use receivableInvoices instead */
  myInvoices: Scalars['Int']['output'];
  paid: Scalars['Int']['output'];
  paidReceivables: Scalars['Int']['output'];
  /** @deprecated Use unscheduled field instead */
  pending: Scalars['Int']['output'];
  receivableInvoices: Scalars['Int']['output'];
  receivables: Scalars['Int']['output'];
  reconciliationItemsInReview: Scalars['Int']['output'];
  reconciliationItemsOnHold: Scalars['Int']['output'];
  scheduled: Scalars['Int']['output'];
  scheduledReceivables: Scalars['Int']['output'];
  scheduledReconciliationItems: Scalars['Int']['output'];
  unreadBySource: CountersBySource;
  unreadInboxMessages: Scalars['Int']['output'];
  unscheduled: Scalars['Int']['output'];
  unscheduledReceivables: Scalars['Int']['output'];
  vmcUnpaid: Scalars['Int']['output'];
};

export type CountersBySource = {
  email: Scalars['Int']['output'];
  eptFee: Scalars['Int']['output'];
  quickbooksImport: Scalars['Int']['output'];
  uploaded: Scalars['Int']['output'];
  vmc: Scalars['Int']['output'];
  vmcFee: Scalars['Int']['output'];
  xeroImport: Scalars['Int']['output'];
};

export type CountersBySyncObject = {
  catalogItems: Scalars['Int']['output'];
  invoices: Scalars['Int']['output'];
  payments: Scalars['Int']['output'];
  purchaseOrders: Scalars['Int']['output'];
  vendorCredits: Scalars['Int']['output'];
};

/** Autogenerated return type of CountersChanged. */
export type CountersChangedPayload = {
  counters: Counters;
};

export type Country = {
  accountNumberType: VendorAccountNumberTypeEnum;
  code: Scalars['String']['output'];
  domestic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phoneNumberCode: Maybe<Scalars['String']['output']>;
  smsMfaSupported: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CreateBusiness. */
export type CreateBusinessPayload = {
  businessId: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
};

/** Autogenerated return type of CreateDocumentRequestItem. */
export type CreateDocumentRequestItemPayload = {
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CreateInvitationLink. */
export type CreateInvitationLinkPayload = {
  invitationLink: Scalars['String']['output'];
};

/** Autogenerated return type of CreateInvitation. */
export type CreateInvitationPayload = {
  invitationUrl: Scalars['String']['output'];
};

/** Autogenerated return type of CreateOrderDocumentFromExternalGrn. */
export type CreateOrderDocumentFromExternalGrnPayload = {
  success: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOrderDocumentInputObject = {
  linkableOrderDocumentId: Scalars['ID']['input'];
  orderDocumentType: OrderDocumentTypeEnum;
};

export type CreatePayableInvoiceResponse = {
  invoice: Invoice;
  settleInboxMessage: SettleInboxMessage;
};

export type CreatePhoneFactorResponse = {
  mfaToken: Scalars['ID']['output'];
  phoneFactorChallengeInfo: PhoneFactorChallengeInfo;
};

export type CreateReceivableInvoiceResponse = {
  invoice: ReceivableInvoice;
  settleInboxMessage: SettleInboxMessage;
};

export type CreateTotpResponse = {
  mfaToken: Scalars['ID']['output'];
  totpSetupInfo: TotpSetupInfo;
};

/** Autogenerated return type of CreateUser. */
export type CreateUserPayload = {
  token: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
};

export type CreateVendorCreditResponseType = {
  settleInboxMessage: SettleInboxMessage;
  vendorCredit: VendorCredit;
};

/** Autogenerated return type of CreateW9Link. */
export type CreateW9LinkPayload = {
  link: Scalars['String']['output'];
};

export type CreateW9ResponseType = {
  settleInboxMessage: SettleInboxMessage;
  w9Form: Attachment;
};

export type CreatedDocument = Attachment | Invoice | ReceivableInvoice | VendorCredit;

export type CreditOffer = {
  acceptedByCustomer: Maybe<Scalars['String']['output']>;
  acceptedByCustomerAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  cashAdvanceSubLimitCents: Scalars['Int']['output'];
  creditLimitCents: Scalars['Int']['output'];
  eptDetails: Array<CreditOfferEptDetail>;
  id: Scalars['ID']['output'];
  period: Maybe<Scalars['ISO8601Date']['output']>;
  sentToCustomerAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  sentToCustomerBy: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type CreditOfferEptDetail = {
  eptType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  numberOfPeriods: Scalars['Int']['output'];
  periodLength: Scalars['Int']['output'];
  periodRate: Scalars['Float']['output'];
};

/** Autogenerated return type of CsvImportChanged. */
export type CsvImportChangedPayload = {
  failedRows: Scalars['Int']['output'];
  filename: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importId: Scalars['Int']['output'];
  importType: CsvImportType;
  processedRows: Scalars['Int']['output'];
  rowsCreated: Scalars['Int']['output'];
  rowsFailed: Scalars['Int']['output'];
  rowsProcessedWithError: Scalars['Int']['output'];
  rowsSkipped: Scalars['Int']['output'];
  rowsUpdated: Scalars['Int']['output'];
  status: CsvImportStatusEnum;
  successfulRows: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
};

/** Status of a CSV Import, includes filename and other details */
export type CsvImportStatus = {
  filename: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Import ID assigned by CSVBox */
  importId: Maybe<Scalars['Int']['output']>;
  /** Number of rows successfully created (new rows only) */
  rowsCreated: Scalars['Int']['output'];
  /** Number of rows that failed to import */
  rowsFailed: Scalars['Int']['output'];
  /** Number of rows that were imported with error during processing */
  rowsProcessedWithError: Scalars['Int']['output'];
  /** Number of rows that were skipped (already exist) */
  rowsSkipped: Scalars['Int']['output'];
  /** Number of rows that were updated (already existed) */
  rowsUpdated: Scalars['Int']['output'];
  status: Maybe<CsvImportStatusEnum>;
  type: Maybe<CsvImportType>;
};

export enum CsvImportStatusEnum {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PARTIALLY_COMPLETED = 'PARTIALLY_COMPLETED',
  PROCESSING = 'PROCESSING'
}

export enum CsvImportType {
  CATALOGS = 'CATALOGS',
  LOCATIONS = 'LOCATIONS',
  MILESTONES = 'MILESTONES',
  PURCHASE_ORDERS = 'PURCHASE_ORDERS',
  SHIPMENTS = 'SHIPMENTS',
  VENDORS = 'VENDORS'
}

export type Currency = {
  decimalMark: Scalars['String']['output'];
  exponent: Scalars['Int']['output'];
  isoCode: Scalars['String']['output'];
  minUsdAmount: Maybe<Money>;
  subunitToUnit: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
  thousandsSeparator: Scalars['String']['output'];
};

export type Dashboard = {
  actionableItems: DashboardActionableItemConnection;
  bankAccounts: Maybe<Array<DashboardBankAccount>>;
  paid: Maybe<DashboardPaid>;
  scheduledAndProcessing: Maybe<DashboardScheduledAndProcessing>;
  toDos: Array<JourneyStep>;
  totalOwe: Maybe<DashboardTotalOwe>;
  unscheduled: Maybe<DashboardUnscheduled>;
  virtualMarketingCard: Maybe<DashboardVirtualMarketingCard>;
};


export type DashboardactionableItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardActionableItem = {
  invoice: Maybe<Invoice>;
  invoiceReasons: Array<TransferActionableItem>;
  purchaseOrder: Maybe<PurchaseOrder>;
  purchaseOrderReasons: Array<DashboardActionableItemReasonEnum>;
  receivable: Maybe<Receivable>;
  receivableReason: Maybe<DashboardActionableItemReasonEnum>;
};

/** The connection type for DashboardActionableItem. */
export type DashboardActionableItemConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<DashboardActionableItemEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<DashboardActionableItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DashboardActionableItemEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<DashboardActionableItem>;
};

export enum DashboardActionableItemReasonEnum {
  A2X_REMINDER = 'A2X_REMINDER',
  AT_RISK_PAYMENT = 'AT_RISK_PAYMENT',
  EPT_EXTENSION_AVAILABLE = 'EPT_EXTENSION_AVAILABLE',
  FAILED_INVOICE = 'FAILED_INVOICE',
  FAILED_PAYMENT = 'FAILED_PAYMENT',
  NEEDS_REVIEW_SALES_CHANNEL_CONFIGURATIONS = 'NEEDS_REVIEW_SALES_CHANNEL_CONFIGURATIONS',
  OVERDUE_OPEN_BILL = 'OVERDUE_OPEN_BILL',
  PENDING_APPROVAL_BILL = 'PENDING_APPROVAL_BILL',
  PENDING_APPROVAL_PAYMENT = 'PENDING_APPROVAL_PAYMENT',
  PENDING_APPROVAL_PURCHASE_ORDER = 'PENDING_APPROVAL_PURCHASE_ORDER',
  PENDING_INVOICE = 'PENDING_INVOICE',
  READY_TO_EXTEND_PAYMENT = 'READY_TO_EXTEND_PAYMENT',
  RECEIVABLE_APPROVED = 'RECEIVABLE_APPROVED',
  RECEIVABLE_DEBIT_REQUESTED = 'RECEIVABLE_DEBIT_REQUESTED',
  REJECTED_BILL = 'REJECTED_BILL',
  REJECTED_PAYMENT = 'REJECTED_PAYMENT',
  UNKNOWN = 'UNKNOWN',
  UNLINKED_CATALOG_ITEMS = 'UNLINKED_CATALOG_ITEMS',
  UNLINKED_LOCATIONS = 'UNLINKED_LOCATIONS',
  UNPROCESSABLE_ACCOUNTS_PAYMENTS = 'UNPROCESSABLE_ACCOUNTS_PAYMENTS',
  VENDOR_W8_OR_W9_FORM_REQUIRED = 'VENDOR_W8_OR_W9_FORM_REQUIRED',
  WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
  WAITING_FOR_INVOICE_APPROVAL = 'WAITING_FOR_INVOICE_APPROVAL'
}

export type DashboardBankAccount = {
  balance: Maybe<Money>;
  id: Scalars['String']['output'];
  maskedNumber: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  scheduledAndProcessing: DashboardGroupedAmounts;
};

export type DashboardGroupedAmounts = {
  sevenDays: Money;
  thirtyDays: Money;
};

export type DashboardPaid = {
  payerToSettle: DashboardGroupedAmounts;
  payerToVendors: DashboardGroupedAmounts;
  payerToVendorsAndSettle: DashboardGroupedAmounts;
  total: Money;
};

export enum DashboardPermissionsEnum {
  DASHBOARD_WIDGETS = 'DASHBOARD_WIDGETS',
  FULL_TODO_LIST = 'FULL_TODO_LIST'
}

export type DashboardScheduledAndProcessing = {
  payerToSettle: DashboardGroupedAmounts;
  payerToVendors: DashboardGroupedAmounts;
  payerToVendorsAndSettle: DashboardGroupedAmounts;
  total: Money;
};

export type DashboardTotalOwe = {
  scheduledAndProcessing: Money;
  total: Money;
  unscheduled: Money;
};

export type DashboardUnscheduled = {
  failed: Money;
  overdue: Money;
  payerToVendors: DashboardGroupedAmounts;
  total: Money;
};

export type DashboardVirtualMarketingCard = {
  availableCredit: Money;
  creditLimit: Money;
  currentPeriod: Money;
  previousUnpaid: Money;
};

export type DataFieldsInput = {
  communication?: InputMaybe<Array<SectionFieldsInput>>;
  countrySpecific?: InputMaybe<Array<SectionFieldsInput>>;
  driverLicence?: InputMaybe<Array<SectionFieldsInput>>;
  location?: InputMaybe<Array<SectionFieldsInput>>;
  nationalIds?: InputMaybe<Array<SectionFieldsInput>>;
  passport?: InputMaybe<Array<SectionFieldsInput>>;
  personInfo?: InputMaybe<Array<SectionFieldsInput>>;
};

export enum DateFilterPresetEnum {
  AFTER_TODAY = 'AFTER_TODAY',
  ALL_DATES = 'ALL_DATES',
  BEFORE_TODAY = 'BEFORE_TODAY',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_YEAR = 'LAST_YEAR',
  NEXT_7_DAYS = 'NEXT_7_DAYS',
  NEXT_30_DAYS = 'NEXT_30_DAYS',
  NOT_SET = 'NOT_SET',
  THIS_MONTH = 'THIS_MONTH',
  THIS_QUARTER = 'THIS_QUARTER',
  THIS_YEAR = 'THIS_YEAR'
}

export type DateFilteringInputObject = {
  from?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Use presetEnum instead */
  preset?: InputMaybe<Scalars['String']['input']>;
  presetEnum?: InputMaybe<DateFilterPresetEnum>;
  to?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type DefaultInterestAccrualDay = {
  amount: InfinitePrecisionMoney;
  date: Scalars['ISO8601Date']['output'];
  waived: Scalars['Boolean']['output'];
};

export type DefaultInterestDetails = {
  accrualDays: Array<DefaultInterestAccrualDay>;
  buildingSince: Scalars['ISO8601Date']['output'];
  collectionDate: Maybe<Scalars['ISO8601Date']['output']>;
  dailyAmount: InfinitePrecisionMoney;
  daysLate: Scalars['Int']['output'];
  mainReconciliationItem: ReconciliationItem;
  relatedReconciliationItems: Array<ReconciliationItem>;
};

export type DefaultInterestSummary = {
  accrualRate: Scalars['String']['output'];
  accruingTotal: Money;
  asOfDate: Scalars['ISO8601Date']['output'];
  dailyTotal: Money;
};

export enum DeferralPeriodEnum {
  DAYS_03 = 'DAYS_03',
  DAYS_07 = 'DAYS_07',
  DAYS_15 = 'DAYS_15',
  DAYS_30 = 'DAYS_30',
  DAYS_45 = 'DAYS_45',
  DAYS_60 = 'DAYS_60',
  MAXIMUM_ALLOWED_DAYS = 'MAXIMUM_ALLOWED_DAYS'
}

export type DeferralsRequestsInputObject = {
  explanation?: InputMaybe<Scalars['String']['input']>;
  reconciliationItemsData: Array<DeferralsRequestsItemsInputObject>;
};

export type DeferralsRequestsItemsInputObject = {
  reconciliationItemId: Scalars['ID']['input'];
  requestedDeferralLength: DeferralPeriodEnum;
};

export type DeleteCommentPayload = {
  success: Scalars['Boolean']['output'];
};

export type DeletePayload = {
  deletedIds: Array<Scalars['ID']['output']>;
};

export type DeleteRoleResponse = {
  deletedRole: UserRole;
  teamMembers: Maybe<TeamMembers>;
};

export enum DimensionsUnitEnum {
  CM = 'CM',
  FEET = 'FEET',
  INCHES = 'INCHES',
  METERS = 'METERS'
}

export type Disclosures = {
  payeeAgentDisclosure: Scalars['String']['output'];
};

export enum DiscrepancyDocumentEnum {
  INVOICE = 'INVOICE',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  RECEIPT = 'RECEIPT'
}

export enum DiscrepancyFieldEnum {
  PRICE = 'PRICE',
  QUANTITY = 'QUANTITY',
  TOTAL = 'TOTAL'
}

export type DiscrepancyRule = {
  id: Scalars['ID']['output'];
  thresholds: Array<DiscrepancyThreshold>;
  vendorLocalBusiness: Maybe<LocalBusiness>;
};

export enum DiscrepancyRulePermissionsEnum {
  CREATE_DISCREPANCY_RULE = 'CREATE_DISCREPANCY_RULE',
  DELETE_DISCREPANCY_RULE = 'DELETE_DISCREPANCY_RULE',
  UPDATE_DISCREPANCY_RULE = 'UPDATE_DISCREPANCY_RULE',
  VIEW_DISCREPANCY_RULES = 'VIEW_DISCREPANCY_RULES'
}

export type DiscrepancyThreshold = {
  field: DiscrepancyFieldEnum;
  id: Scalars['ID']['output'];
  sourceDocumentType: DiscrepancyDocumentEnum;
  targetDocumentType: DiscrepancyDocumentEnum;
  threshold: Maybe<Scalars['Float']['output']>;
};

export type DiscrepancyThresholdInputObject = {
  field: DiscrepancyFieldEnum;
  id?: InputMaybe<Scalars['ID']['input']>;
  sourceDocumentType: DiscrepancyDocumentEnum;
  targetDocumentType: DiscrepancyDocumentEnum;
  threshold?: InputMaybe<Scalars['Float']['input']>;
};

export type DismissedBanner = {
  bannerId: Scalars['String']['output'];
  dismissedUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated return type of DocumentAttachmentUpdated. */
export type DocumentAttachmentUpdatedPayload = {
  byteSize: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  targetId: Scalars['ID']['output'];
  targetType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum DocumentCategoryEnum {
  ARTICLES_OF_INCORPORATION = 'ARTICLES_OF_INCORPORATION',
  BALANCE_SHEET = 'BALANCE_SHEET',
  BANK_STATEMENT = 'BANK_STATEMENT',
  BUSINESS_TAX_RETURN = 'BUSINESS_TAX_RETURN',
  DBA_CERTIFICATION_ASSUMED_NAME_CERTIFICATION = 'DBA_CERTIFICATION_ASSUMED_NAME_CERTIFICATION',
  ID_CARD = 'ID_CARD',
  LOAN_AGREEMENT = 'LOAN_AGREEMENT',
  OPERATING_AGREEMENT_CORORATE_BYLAWS = 'OPERATING_AGREEMENT_CORORATE_BYLAWS',
  PASSPORT = 'PASSPORT',
  PROFIT_AND_LOSS = 'PROFIT_AND_LOSS',
  PROOF_OF_SOS_FILING = 'PROOF_OF_SOS_FILING',
  REVENUE_FORECAST = 'REVENUE_FORECAST',
  SS4 = 'SS4',
  SSN9_DOCUMENT = 'SSN9_DOCUMENT'
}

export type DocumentDisplaySettings = {
  wrapLineItemsContent: Scalars['Boolean']['output'];
};

export type DocumentDisplaySettingsInputObject = {
  wrapLineItemsContent?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DocumentOcrChangeFieldEnum {
  AMOUNT = 'AMOUNT',
  DUE_DATE = 'DUE_DATE',
  ISSUE_DATE = 'ISSUE_DATE',
  LINE_ITEMS = 'LINE_ITEMS',
  NUMBER = 'NUMBER',
  PURCHASE_ORDER_NUMBER = 'PURCHASE_ORDER_NUMBER',
  TAX_PERCENTAGE = 'TAX_PERCENTAGE',
  VENDOR = 'VENDOR'
}

export enum DocumentOcrChangeKindEnum {
  FILL = 'FILL',
  OVERWRITE = 'OVERWRITE'
}

/** Autogenerated return type of DocumentOcrCompleted. */
export type DocumentOcrCompletedPayload = {
  awaitingReview: Scalars['Boolean']['output'];
  document: OcrDocument;
  documentId: Scalars['ID']['output'];
  documentType: DocumentOcrDocumentTypeEnum;
  failureReason: Maybe<DocumentOcrFailureReason>;
  status: Maybe<DocumentOcrStatusEnum>;
  success: Scalars['Boolean']['output'];
};

export enum DocumentOcrDocumentTypeEnum {
  INVOICE = 'INVOICE',
  PURCHASE_ORDER = 'PURCHASE_ORDER'
}

export enum DocumentOcrFailureReason {
  BAD_DOCUMENT = 'BAD_DOCUMENT',
  DIMENSIONS_TOO_SMALL = 'DIMENSIONS_TOO_SMALL',
  ENCRYPTED = 'ENCRYPTED',
  FILE_TOO_LARGE = 'FILE_TOO_LARGE',
  NETWORK_ERROR = 'NETWORK_ERROR'
}

export type DocumentOcrStatus = {
  failureReason: Maybe<DocumentOcrFailureReason>;
  status: Maybe<DocumentOcrStatusEnum>;
};

export enum DocumentOcrStatusEnum {
  ABORTED = 'ABORTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export type DocumentPendingOcrChange = {
  currentValue: Maybe<Scalars['String']['output']>;
  field: DocumentOcrChangeFieldEnum;
  kind: DocumentOcrChangeKindEnum;
  proposedValue: Scalars['String']['output'];
};

export type DocumentPendingOcrChanges = {
  changes: Array<DocumentPendingOcrChange>;
  ocrRecordId: Scalars['ID']['output'];
  vendorMismatchName: Maybe<Scalars['String']['output']>;
};

export type DocumentReference = {
  document: Maybe<LinkedDocument>;
  documentType: DocumentReferenceTypeEnum;
  id: Scalars['ID']['output'];
  linkedDocuments: Array<LinkedDocument>;
  number: Maybe<Scalars['String']['output']>;
};

export type DocumentReferenceCreateInputObject = {
  documentType: DocumentReferenceTypeEnum;
  number: Scalars['String']['input'];
};

export enum DocumentReferenceTypeEnum {
  INVOICE = 'INVOICE',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  RECEIPT = 'RECEIPT'
}

export type DocumentReferenceUpdateInputObject = {
  number?: InputMaybe<Scalars['String']['input']>;
};

export enum DocumentRequestedPeriod {
  MOST_RECENT_MONTH = 'MOST_RECENT_MONTH',
  PREVIOUS_THREE_YEARS = 'PREVIOUS_THREE_YEARS',
  PREVIOUS_YEAR = 'PREVIOUS_YEAR'
}

export enum DocumentTypeEnum {
  ARTICLES_OF_INCORPORATION = 'ARTICLES_OF_INCORPORATION',
  BALANCE_SHEET = 'BALANCE_SHEET',
  BANK_STATEMENT = 'BANK_STATEMENT',
  BUSINESS_TAX_RETURN = 'BUSINESS_TAX_RETURN',
  DBA_CERTIFICATION_ASSUMED_NAME_CERTIFICATION = 'DBA_CERTIFICATION_ASSUMED_NAME_CERTIFICATION',
  ID_CARD = 'ID_CARD',
  LOAN_AGREEMENT = 'LOAN_AGREEMENT',
  OPERATING_AGREEMENT_CORORATE_BYLAWS = 'OPERATING_AGREEMENT_CORORATE_BYLAWS',
  PASSPORT = 'PASSPORT',
  PROFIT_AND_LOSS = 'PROFIT_AND_LOSS',
  PROOF_OF_SOS_FILING = 'PROOF_OF_SOS_FILING',
  REVENUE_FORECAST = 'REVENUE_FORECAST',
  SS4 = 'SS4',
  SSN9_DOCUMENT = 'SSN9_DOCUMENT'
}

export type DocumentsMatchingData = {
  discrepancies: LinkedDocumentDiscrepancies;
  invoicesLinesTotal: LineItemsMatchingTotal;
  matchedLines: Array<MatchedLine>;
  matchingDocuments: Array<LinkedDocument>;
  purchaseOrdersLinesTotal: LineItemsMatchingTotal;
  receiptsLinesTotal: LineItemsMatchingTotal;
  unmatchedBillLines: Array<LineItemDetails>;
  /** @deprecated Use unmatchedBillLines and unmatchedPurchaseOrderLines instead */
  unmatchedLines: Array<UnmatchedLine>;
  unmatchedPurchaseOrderLines: Array<LineItemDetails>;
  unmatchedReceiptLines: Array<LineItemDetails>;
};

export type EmailOptOut = {
  email: Scalars['String']['output'];
  emailAction: Scalars['String']['output'];
};

export enum EmailTypeEnum {
  GOOGLE = 'GOOGLE',
  INVALID = 'INVALID',
  UNKNOWN = 'UNKNOWN'
}

export enum EptFilterEnum {
  FILTER_AMRT = 'FILTER_AMRT',
  FILTER_AMRT30 = 'FILTER_AMRT30',
  FILTER_AMRT60 = 'FILTER_AMRT60',
  FILTER_AMRT75 = 'FILTER_AMRT75',
  FILTER_AMRT90 = 'FILTER_AMRT90',
  FILTER_AMRT120 = 'FILTER_AMRT120',
  FILTER_AMRT150 = 'FILTER_AMRT150',
  FILTER_AMRT165 = 'FILTER_AMRT165',
  FILTER_AMRT180 = 'FILTER_AMRT180',
  FILTER_AMRT180PLUS = 'FILTER_AMRT180PLUS',
  FILTER_EPT = 'FILTER_EPT',
  FILTER_EPT30 = 'FILTER_EPT30',
  FILTER_EPT60 = 'FILTER_EPT60',
  FILTER_EPT75 = 'FILTER_EPT75',
  FILTER_EPT90 = 'FILTER_EPT90',
  FILTER_EPT120 = 'FILTER_EPT120',
  FILTER_EPT120PLUS = 'FILTER_EPT120PLUS'
}

export type EptMetricVendorTotal = {
  paid: Scalars['Int']['output'];
  unpaid: Scalars['Int']['output'];
};

export type EptMetrics = {
  cashAdvance: EptMetricVendorTotal;
  days30: EptMetricVendorTotal;
  days30Amortized: EptMetricVendorTotal;
  days60: EptMetricVendorTotal;
  days60Amortized: EptMetricVendorTotal;
  days75: EptMetricVendorTotal;
  days75Amortized: EptMetricVendorTotal;
  days90: EptMetricVendorTotal;
  days90Amortized: EptMetricVendorTotal;
  days120: EptMetricVendorTotal;
  days120Amortized: EptMetricVendorTotal;
  days120Plus: EptMetricVendorTotal;
  days150Amortized: EptMetricVendorTotal;
  days165Amortized: EptMetricVendorTotal;
  days180Amortized: EptMetricVendorTotal;
  days180PlusAmortized: EptMetricVendorTotal;
};

export type ExchangeFeeData = {
  exchangeFeeAmount: Maybe<Money>;
  exchangeRate: Maybe<Scalars['String']['output']>;
  totalUsdAmount: Money;
  usdAmount: Money;
};

export enum ExclusiveGroupEnum {
  ADD_FIRST_CATALOG_ITEM = 'ADD_FIRST_CATALOG_ITEM'
}

export type ExternalApprovalRequest = {
  businessName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  requestType: ExternalApprovalRequestTypeEnum;
  requesterName: Scalars['String']['output'];
  status: ExternalApprovalRequestStatusEnum;
  targetName: Scalars['String']['output'];
};

export enum ExternalApprovalRequestStatusEnum {
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  PENDING = 'PENDING',
  REVOKED = 'REVOKED'
}

export enum ExternalApprovalRequestTypeEnum {
  DOCUMENT_ACKNOWLEDGEMENT = 'DOCUMENT_ACKNOWLEDGEMENT'
}

export type ExternalItem = {
  children: Array<ExternalItem>;
  name: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  url: Maybe<Scalars['String']['output']>;
};

export type ExternalPaymentInputObject = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  amount: MoneyInputObject;
  excludeFromSync?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  localBusinessId?: InputMaybe<Scalars['ID']['input']>;
  orderDocumentId?: InputMaybe<Scalars['ID']['input']>;
  paidAt: Scalars['ISO8601Date']['input'];
  paymentDescription?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethodEnum;
  suggestedPaymentId?: InputMaybe<Scalars['ID']['input']>;
  usdAmountCents?: InputMaybe<Scalars['SafeInt']['input']>;
};

export enum FailedEntityTypeEnum {
  INVOICE = 'INVOICE',
  PAYMENT = 'PAYMENT'
}

export type FinaloopAccount = {
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FinaloopState = {
  accounts: Array<FinaloopAccount>;
  connected: Scalars['Boolean']['output'];
  filteredAccounts: Array<FinaloopAccount>;
  name: Scalars['String']['output'];
  pullFinancials: Scalars['Boolean']['output'];
};

export type FinancingNudgeBanner = {
  qboBillsToNudge: Array<Scalars['ID']['output']>;
  settleInvoicesToNudge: Scalars['Int']['output'];
};

export type FinancingOptions = {
  /** Details of amortized loan offer when it's available */
  amortizedOffer: Maybe<AmortizedLoan>;
  /** Details of EPT offers when EPT is available */
  bulletEptOffers: Maybe<Array<BulletEpt>>;
  /** Details of EPT offers when EPT is available */
  eptOffers: Maybe<Array<InvoiceExtendedPaymentTermOffer>>;
  /** Estimated range of payment arrival to vendor */
  etaRange: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  /** Why financing is unavailable, null when any offer is available */
  financingUnavailableReason: Maybe<FinancingUnavailableReasonEnum>;
  /** Planned date of initiating payment to vendor */
  vendorPaymentDate: Maybe<Scalars['ISO8601Date']['output']>;
};

export enum FinancingUnavailableReasonEnum {
  BELOW_MINIMUM = 'BELOW_MINIMUM',
  CREDIT_SUSPENDED = 'CREDIT_SUSPENDED',
  MISSING_BANK_ACCOUNT = 'MISSING_BANK_ACCOUNT',
  NEVER_APPLIED = 'NEVER_APPLIED',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  OVER_CAPACITY = 'OVER_CAPACITY',
  UNDERWRITING_DENIED = 'UNDERWRITING_DENIED',
  UNDERWRITING_PENDING = 'UNDERWRITING_PENDING'
}

export type FinicityLink = BankLink & {
  deleted: Scalars['Boolean']['output'];
  fixAvailable: Maybe<BankLinkFixEnum>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Common fields of onboarding flows */
export type FlowInterface = {
  currentStep: Maybe<StepEnum>;
  flowType: FlowTypeEnum;
  id: Scalars['ID']['output'];
  orderedSteps: Array<StepEnum>;
};

export enum FlowTypeEnum {
  LANDED_COSTS = 'LANDED_COSTS'
}

/** Union of onboarding flow types */
export type FlowUnion = LandedCostsOnboardingFlow;

export type FractionalMoneyInputObject = {
  cents: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
};

/** Autogenerated return type of FraudBusinessReviewApprove. */
export type FraudBusinessReviewApprovePayload = {
  success: Scalars['Boolean']['output'];
};

export type FullRepaymentBalance = {
  defaultInterest: Money;
  defaultInterestAsOfDate: Maybe<Scalars['ISO8601Date']['output']>;
  interest: Money;
  principal: Money;
  total: Money;
};

export type Holiday = {
  date: Scalars['ISO8601Date']['output'];
  name: Scalars['String']['output'];
};

export enum IconEnum {
  ADDED_TO_PAYABLES = 'ADDED_TO_PAYABLES',
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  GENERIC = 'GENERIC',
  LIGHTNING = 'LIGHTNING',
  MERGE = 'MERGE',
  ON_APPROVAL = 'ON_APPROVAL',
  PAID = 'PAID',
  RECEIVED = 'RECEIVED',
  REJECTED = 'REJECTED',
  SCHEDULED = 'SCHEDULED',
  SENT = 'SENT'
}

export type InboundExternalPaymentInputObject = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  amount: MoneyInputObject;
  invoiceId: Scalars['ID']['input'];
  paidAt: Scalars['ISO8601Date']['input'];
  paymentDescription?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethodEnum;
  usdAmountCents?: InputMaybe<Scalars['SafeInt']['input']>;
};

export type InfinitePrecisionMoney = {
  cents: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  currencySymbol: Scalars['String']['output'];
  formatted: Scalars['String']['output'];
  formattedNoCents: Scalars['String']['output'];
  subunitToUnit: Scalars['Int']['output'];
};

export type InformationRequest = {
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  informationType: InformationRequestTypeEnum;
  localBusiness: PublicLocalBusiness;
  requestedAt: Scalars['ISO8601DateTime']['output'];
  status: InformationRequestStatusEnum;
  verifyBusinessLink: Maybe<Scalars['String']['output']>;
};

export enum InformationRequestStatusEnum {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  REQUESTED = 'REQUESTED'
}

export enum InformationRequestTypeEnum {
  W8_OR_W9 = 'W8_OR_W9'
}

export type Integration = NetsuiteState | QuickBooksState | XeroState;

export enum IntegrationSourceEnum {
  QUICKBOOKS = 'QUICKBOOKS',
  SHOPIFY = 'SHOPIFY',
  TRACKSTAR = 'TRACKSTAR'
}

export enum IntegrationSourceTypeEnum {
  ACCOUNTING = 'ACCOUNTING',
  LOCATIONS = 'LOCATIONS',
  SALES = 'SALES'
}

export type IntegrationsState = {
  a2x: IntegrationsStateInfo;
};

export type IntegrationsStateInfo = {
  connected: Scalars['Boolean']['output'];
};

export type InternationalWireFieldsDataFieldInputObject = {
  id?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InternationalWireFieldsDataFieldType = {
  country: Scalars['String']['output'];
  currency: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  length: Maybe<Scalars['Int']['output']>;
  propertyKey: InternationalWirePropertyKeyTypeEnum;
  regex: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  targetType: InternationalWireTargetTypeEnum;
};

export type InternationalWireFieldsDataFieldValueType = {
  id: Scalars['ID']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export enum InternationalWirePropertyKeyTypeEnum {
  BANK_NAME = 'BANK_NAME',
  CNAPS = 'CNAPS',
  LOCAL_BANK_CODE = 'LOCAL_BANK_CODE',
  PHONE_NUMBER = 'PHONE_NUMBER',
  TAXPAYER_ID = 'TAXPAYER_ID'
}

export enum InternationalWireTargetTypeEnum {
  ACCOUNT = 'ACCOUNT',
  PAYMENT = 'PAYMENT'
}

export type InventoryConnector = {
  redirectUri: Scalars['String']['output'];
};

export enum InventoryPermissionsEnum {
  CREATE_CATALOG_ITEM = 'CREATE_CATALOG_ITEM',
  CREATE_LOCATION = 'CREATE_LOCATION',
  DELETE_CATALOG_ITEM = 'DELETE_CATALOG_ITEM',
  DELETE_LOCATION = 'DELETE_LOCATION',
  EDIT_CATALOG_SYNC_CENTER = 'EDIT_CATALOG_SYNC_CENTER',
  EDIT_INVENTORY_BALANCE = 'EDIT_INVENTORY_BALANCE',
  LINK_ECOMMERCE_SERVICE = 'LINK_ECOMMERCE_SERVICE',
  UPDATE_CATALOG_ITEM = 'UPDATE_CATALOG_ITEM',
  UPDATE_LOCATION = 'UPDATE_LOCATION',
  VIEW_CATALOG_SYNC_CENTER = 'VIEW_CATALOG_SYNC_CENTER'
}

export enum InventoryTransferPermissionsEnum {
  CREATE_INVENTORY_TRANSFER = 'CREATE_INVENTORY_TRANSFER',
  UPDATE_INVENTORY_TRANSFER = 'UPDATE_INVENTORY_TRANSFER',
  UPDATE_INVENTORY_TRANSFER_ARCHIVED = 'UPDATE_INVENTORY_TRANSFER_ARCHIVED',
  VIEW_INVENTORY_TRANSFER = 'VIEW_INVENTORY_TRANSFER'
}

export type Invitation = {
  businessName: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  existingUser: Maybe<Profile>;
  id: Scalars['ID']['output'];
  occupation: Maybe<Scalars['String']['output']>;
  role: Maybe<MembershipRolesEnum>;
  userRole: Maybe<UserRole>;
};

/** Autogenerated return type of InvitePayer. */
export type InvitePayerPayload = {
  localBusiness: Maybe<LocalBusiness>;
};

/** Autogenerated return type of InviteVendor. */
export type InviteVendorPayload = {
  invoice: Maybe<Invoice>;
  localBusiness: Maybe<LocalBusiness>;
};

export type Invoice = {
  /** @deprecated Use pay_from_account field instead */
  account: Maybe<Account>;
  accountingCategoryClassId: Maybe<Scalars['ID']['output']>;
  accountingCategoryDepartmentId: Maybe<Scalars['ID']['output']>;
  accountingCategoryLocationId: Maybe<Scalars['ID']['output']>;
  accountingMemo: Maybe<Scalars['String']['output']>;
  accountingSyncEvents: Maybe<Array<SyncEvent>>;
  accountingUrl: Maybe<Scalars['String']['output']>;
  actions: InvoiceActions;
  allocations: Maybe<Array<Allocation>>;
  allowAccountChange: Scalars['Boolean']['output'];
  allowPaymentCardMethod: Maybe<Scalars['Boolean']['output']>;
  allowVendorChange: Scalars['Boolean']['output'];
  amount: Maybe<Money>;
  applicableVendorCredits: Array<ApplicableVendorCredit>;
  approval: Maybe<Approval>;
  archived: Scalars['Boolean']['output'];
  associatedVendorCredits: Array<VendorCredit>;
  attachments: Array<Attachment>;
  auditTrailEvents: Array<AuditTrailEvents>;
  balanceDue: Maybe<Money>;
  balanceDueToSettle: Maybe<Money>;
  billInCin7: Scalars['Boolean']['output'];
  cancelledAllocations: Maybe<Array<Allocation>>;
  cin7BillUrl: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdForPayment: Maybe<Payment>;
  /** @deprecated Use vendorCurrency.isoCode instead */
  currency: Maybe<Scalars['String']['output']>;
  deletable: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  discrepancyAmount: Maybe<Money>;
  documentDisplaySettings: DocumentDisplaySettings;
  dueDate: Maybe<Scalars['ISO8601Date']['output']>;
  dueDays: Maybe<Scalars['Int']['output']>;
  dueToVendorAmount: Maybe<Money>;
  externalReconciliationItems: Maybe<Array<ReconciliationItem>>;
  failedPayments: Array<Payment>;
  /** Total of all fee associated with EPT agreements accepted by customer for the invoice. */
  feeAmount: Maybe<Money>;
  friendlyId: Scalars['String']['output'];
  hasAccessToView: Scalars['Boolean']['output'];
  hasUnprocessedTransfers: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoiceErrorMessages: Maybe<Array<InvoiceErrorMessage>>;
  isExtendedPaymentTermFeeInvoice: Scalars['Boolean']['output'];
  isExtendedPaymentTermInvoice: Scalars['Boolean']['output'];
  isMarketingVirtualCardAggregatedInvoice: Scalars['Boolean']['output'];
  isMarketingVirtualCardFeeInvoice: Scalars['Boolean']['output'];
  isRelatedPaymentsExists: Scalars['Boolean']['output'];
  issueDate: Maybe<Scalars['ISO8601Date']['output']>;
  labels: Array<Label>;
  lastAttached: Maybe<Attachment>;
  liabilityAmount: Money;
  liabilityUsdAmount: Money;
  lineItems: Array<InvoiceLineItem>;
  lineItemsMatchOcr: Scalars['Boolean']['output'];
  lineItemsTotalAmount: Money;
  linkedDocuments: Array<LinkedDocument>;
  markedAsPaid: Scalars['Boolean']['output'];
  markedAsPaidBy: Maybe<Approver>;
  markedAsPaidFromAccount: Maybe<Account>;
  /** Date the 'mark invoice paid' action was taken */
  markedAsPaidOn: Maybe<Scalars['ISO8601Date']['output']>;
  marketingVirtualCardInvoice: Maybe<InvoiceMarketingVirtualCard>;
  memo: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['String']['output']>;
  ocrStatus: DocumentOcrStatus;
  paidOn: Maybe<Scalars['ISO8601Date']['output']>;
  paidWithMethod: Maybe<PaymentMethodEnum>;
  paperCheck: Scalars['Boolean']['output'];
  paperCheckDetails: Maybe<PaperCheckDetails>;
  payFromAccount: Maybe<Account>;
  payToAccount: Maybe<LocalBusinessAccount>;
  payWithLink: Scalars['Boolean']['output'];
  payableActionIndicator: Maybe<PayableActionIndicatorEnum>;
  payerBusiness: Maybe<PublicBusiness>;
  payerLocalBusiness: Maybe<LocalBusiness>;
  payerTaxpayerId: Maybe<Scalars['String']['output']>;
  paymentAccountingAccount: Maybe<AccountingAccount>;
  paymentAccountingAccountId: Maybe<Scalars['ID']['output']>;
  paymentCard: Maybe<PaymentCard>;
  paymentDescription: Maybe<Scalars['String']['output']>;
  paymentLinkUrl: Maybe<Scalars['String']['output']>;
  paymentTermDays: Maybe<Scalars['Int']['output']>;
  payments: Array<Payment>;
  paymentsTotalAmount: Money;
  payoutReconciliationItems: Maybe<Array<ReconciliationItem>>;
  pendingOcrChanges: Maybe<DocumentPendingOcrChanges>;
  /** Only query for this field for single invoices. Querying at volume may introduce high latency */
  possibleDuplicates: Array<Invoice>;
  purposeCode: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  recommendedAccount: Maybe<Account>;
  recommendedAccountWarning: Maybe<Scalars['String']['output']>;
  recommendedPaymentMethod: Maybe<PaymentMethodEnum>;
  relatedInvoices: Array<Invoice>;
  selectedForFinancing: Scalars['Boolean']['output'];
  settleInboxMessage: Maybe<SettleInboxMessage>;
  shippingVendors: Array<LocalBusiness>;
  showDiscrepancyAlert: Scalars['Boolean']['output'];
  showSyncHistory: Maybe<Scalars['Boolean']['output']>;
  signedDocuments: Array<SignedDocument>;
  source: Maybe<InvoiceSourceEnum>;
  status: InvoiceStatusEnum;
  /** @deprecated Use statusesForBadge */
  statuses: Array<InvoiceStatusEnum>;
  statusesForBadge: Array<InvoiceStatusEnum>;
  syncCurrency: Maybe<Scalars['String']['output']>;
  syncError: Maybe<SyncError>;
  syncObjectStatus: Maybe<SyncObjectStatus>;
  syncPossible: Maybe<Scalars['Boolean']['output']>;
  timelineEvents: Maybe<Array<TimelineEvent>>;
  totalUsdAmount: Maybe<Money>;
  unscheduledAmount: Maybe<Money>;
  uploadedByCurrentBusiness: Scalars['Boolean']['output'];
  /** @deprecated Use pay_to_account field instead */
  vendorAccount: Maybe<LocalBusinessAccount>;
  vendorAmount: Maybe<Money>;
  vendorBusiness: Maybe<PublicBusiness>;
  vendorCreditApplications: Array<VendorCreditApplication>;
  vendorCreditAppliedTotal: Money;
  vendorCurrency: Maybe<Currency>;
  vendorInvited: Scalars['Boolean']['output'];
  vendorLocalBusiness: Maybe<LocalBusiness>;
  vendorReceivedAmount: Money;
};

export type InvoiceActions = {
  addNewPayment: Action;
  applyVendorCredit: Action;
  bulkPay: Action;
  cancelApprovalRequest: Action;
  cancelVendorFinancing: Action;
  createExternalInboundPayment: Action;
  createExternalPayment: Action;
  createLinkedPurchaseOrder: Action;
  createLinkedReceipt: Action;
  financeInvoice: Action;
  markPaid: Action;
  markUnpaid: Action;
  overrideApproval: Action;
  partialPayment: Action;
  requestRuleBasedApproval: Action;
  sendInvoice: Action;
  updateAmount: Action;
  updateArchived: Action;
  updateCurrency: Action;
  updateVendor: Action;
  updateVendorAccount: Action;
};

export type InvoiceAddressValidationType = {
  addressValidation: AddressValidation;
  invoice: Invoice;
};

export type InvoiceAmountFilteringInputObject = {
  from?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export enum InvoiceArchivedStatusEnum {
  ACTIVE_AND_ARCHIVED = 'ACTIVE_AND_ARCHIVED',
  ACTIVE_ONLY = 'ACTIVE_ONLY',
  ARCHIVED_ONLY = 'ARCHIVED_ONLY'
}

export type InvoiceDateFilteringOption = {
  code: Maybe<Scalars['String']['output']>;
  empty: Scalars['Boolean']['output'];
  from: Maybe<Scalars['ISO8601Date']['output']>;
  name: Maybe<Scalars['String']['output']>;
  to: Maybe<Scalars['ISO8601Date']['output']>;
};

export type InvoiceDateFilteringOptions = {
  field: InvoiceSortableFieldEnum;
  presets: Array<InvoiceDateFilteringOption>;
};

export type InvoiceErrorMessage = {
  code: Maybe<Scalars['String']['output']>;
  failedEntityType: FailedEntityTypeEnum;
  message: Maybe<Scalars['String']['output']>;
};

export enum InvoiceEventTypeEnum {
  APPLIED_VENDOR_CREDITS_CLOSED = 'APPLIED_VENDOR_CREDITS_CLOSED',
  APPLIED_VENDOR_CREDITS_REOPENED = 'APPLIED_VENDOR_CREDITS_REOPENED',
  APPLIED_VENDOR_CREDITS_UPDATED = 'APPLIED_VENDOR_CREDITS_UPDATED',
  COLLECTION_EMAIL_SENT = 'COLLECTION_EMAIL_SENT',
  DEFAULT_INTEREST_ACCRUAL_RESUMED = 'DEFAULT_INTEREST_ACCRUAL_RESUMED',
  DEFAULT_INTEREST_ACCRUAL_STARTED = 'DEFAULT_INTEREST_ACCRUAL_STARTED',
  DEFAULT_INTEREST_COLLECTION_CANCELED = 'DEFAULT_INTEREST_COLLECTION_CANCELED',
  DEFAULT_INTEREST_COLLECTION_SCHEDULED = 'DEFAULT_INTEREST_COLLECTION_SCHEDULED',
  DEFAULT_INTEREST_WAIVED_BY_SETTLE = 'DEFAULT_INTEREST_WAIVED_BY_SETTLE',
  DEFAULT_INTEREST_WAIVED_WITHIN_GRACE = 'DEFAULT_INTEREST_WAIVED_WITHIN_GRACE',
  EPT_AGREEMENT_SIGNED = 'EPT_AGREEMENT_SIGNED',
  EPT_TERMS_CHANGED = 'EPT_TERMS_CHANGED',
  INVOICE_APPROVAL_CANCELLED = 'INVOICE_APPROVAL_CANCELLED',
  INVOICE_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT = 'INVOICE_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT',
  INVOICE_APPROVAL_CANCELLED_PLAN_CHANGE = 'INVOICE_APPROVAL_CANCELLED_PLAN_CHANGE',
  INVOICE_APPROVAL_OVERRIDE_APPROVED = 'INVOICE_APPROVAL_OVERRIDE_APPROVED',
  INVOICE_APPROVAL_OVERRIDE_REJECTED = 'INVOICE_APPROVAL_OVERRIDE_REJECTED',
  INVOICE_APPROVAL_REQUESTED = 'INVOICE_APPROVAL_REQUESTED',
  INVOICE_APPROVED = 'INVOICE_APPROVED',
  INVOICE_ARCHIVED = 'INVOICE_ARCHIVED',
  INVOICE_AUTO_APPROVED = 'INVOICE_AUTO_APPROVED',
  INVOICE_CREATED_BY_EMAIL = 'INVOICE_CREATED_BY_EMAIL',
  INVOICE_CREATED_BY_IMPORT = 'INVOICE_CREATED_BY_IMPORT',
  INVOICE_CREATED_BY_USER = 'INVOICE_CREATED_BY_USER',
  INVOICE_CREATED_BY_VENDOR = 'INVOICE_CREATED_BY_VENDOR',
  INVOICE_CREATED_FROM_SETTLE_INBOX = 'INVOICE_CREATED_FROM_SETTLE_INBOX',
  INVOICE_MARKED_AS_PAID = 'INVOICE_MARKED_AS_PAID',
  INVOICE_MARKED_AS_UNPAID = 'INVOICE_MARKED_AS_UNPAID',
  INVOICE_RECEIVED_IN_SETTLE_INBOX = 'INVOICE_RECEIVED_IN_SETTLE_INBOX',
  INVOICE_REJECTED = 'INVOICE_REJECTED',
  INVOICE_SENT = 'INVOICE_SENT',
  INVOICE_VIEWED_BY_PAYER = 'INVOICE_VIEWED_BY_PAYER',
  PAYMENT_APPROVAL_CANCELLED = 'PAYMENT_APPROVAL_CANCELLED',
  PAYMENT_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT = 'PAYMENT_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT',
  PAYMENT_APPROVAL_CANCELLED_PLAN_CHANGE = 'PAYMENT_APPROVAL_CANCELLED_PLAN_CHANGE',
  PAYMENT_APPROVAL_OVERRIDE_APPROVED = 'PAYMENT_APPROVAL_OVERRIDE_APPROVED',
  PAYMENT_APPROVAL_OVERRIDE_REJECTED = 'PAYMENT_APPROVAL_OVERRIDE_REJECTED',
  PAYMENT_APPROVAL_REQUESTED = 'PAYMENT_APPROVAL_REQUESTED',
  PAYMENT_APPROVED = 'PAYMENT_APPROVED',
  PAYMENT_AUTO_APPROVED = 'PAYMENT_AUTO_APPROVED',
  PAYMENT_CANCELLED = 'PAYMENT_CANCELLED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_FROM_PAYER_PAID = 'PAYMENT_FROM_PAYER_PAID',
  PAYMENT_FROM_PAYER_PROCESSED = 'PAYMENT_FROM_PAYER_PROCESSED',
  PAYMENT_FULLY_REVERSED = 'PAYMENT_FULLY_REVERSED',
  PAYMENT_ON_HOLD = 'PAYMENT_ON_HOLD',
  PAYMENT_PAID_EXTERNALLY = 'PAYMENT_PAID_EXTERNALLY',
  PAYMENT_PARTIALLY_REPAID_EARLY = 'PAYMENT_PARTIALLY_REPAID_EARLY',
  PAYMENT_REFUND_COMPLETED = 'PAYMENT_REFUND_COMPLETED',
  PAYMENT_REFUND_INITIATED = 'PAYMENT_REFUND_INITIATED',
  PAYMENT_REJECTED = 'PAYMENT_REJECTED',
  PAYMENT_RELEASED = 'PAYMENT_RELEASED',
  PAYMENT_REPAID_EARLY = 'PAYMENT_REPAID_EARLY',
  PAYMENT_RESCHEDULED = 'PAYMENT_RESCHEDULED',
  PAYMENT_RETRIED = 'PAYMENT_RETRIED',
  PAYMENT_SCHEDULED = 'PAYMENT_SCHEDULED',
  PAYMENT_TO_VENDOR_PAID = 'PAYMENT_TO_VENDOR_PAID',
  PAYMENT_TO_VENDOR_PAPER_CHECK_CASHED = 'PAYMENT_TO_VENDOR_PAPER_CHECK_CASHED',
  PAYMENT_TO_VENDOR_PROCESSED = 'PAYMENT_TO_VENDOR_PROCESSED',
  RECEIVABLE_CREATED_FROM_SETTLE_INBOX = 'RECEIVABLE_CREATED_FROM_SETTLE_INBOX',
  RECEIVABLE_PURCHASED = 'RECEIVABLE_PURCHASED',
  RECEIVABLE_PURCHASE_CANCELED = 'RECEIVABLE_PURCHASE_CANCELED',
  SWITCH_TO_PRO = 'SWITCH_TO_PRO',
  VENDOR_CREDIT_ADDED = 'VENDOR_CREDIT_ADDED',
  VENDOR_CREDIT_APPLIED = 'VENDOR_CREDIT_APPLIED',
  VENDOR_CREDIT_CLOSED = 'VENDOR_CREDIT_CLOSED',
  VENDOR_CREDIT_CREATED = 'VENDOR_CREDIT_CREATED',
  VENDOR_CREDIT_DELETED = 'VENDOR_CREDIT_DELETED',
  VENDOR_CREDIT_REOPENED = 'VENDOR_CREDIT_REOPENED',
  VENDOR_CREDIT_UNAPPLIED = 'VENDOR_CREDIT_UNAPPLIED',
  W8_OR_W9_EMAIL_REQUEST_SENT = 'W8_OR_W9_EMAIL_REQUEST_SENT',
  W8_OR_W9_SUBMITTED = 'W8_OR_W9_SUBMITTED'
}

export type InvoiceExtendedPaymentTermConfirmation = {
  additionalDays: Scalars['Int']['output'];
  agreement: SignedDocument;
  dueDate: Scalars['ISO8601Date']['output'];
  feeAmount: Money;
  feeInvoice: Maybe<Invoice>;
  feePaymentDate: Scalars['ISO8601Date']['output'];
  feePercent: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  payerPaymentDate: Scalars['ISO8601Date']['output'];
};

export type InvoiceExtendedPaymentTermOffer = {
  additionalDays: Scalars['Int']['output'];
  feeAmount: Maybe<Money>;
  feeAmountWithRepayments: Maybe<Money>;
  feeInvoice: Maybe<Invoice>;
  feePaymentDate: Scalars['ISO8601Date']['output'];
  feePercent: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  payerPaymentDate: Maybe<Scalars['ISO8601Date']['output']>;
  status: OfferStatusEnum;
};

export type InvoiceFilteringOptions = {
  createdAt: Array<InvoiceDateFilteringOption>;
  dates: Array<InvoiceDateFilteringOptions>;
  dueDate: Array<InvoiceDateFilteringOption>;
  epts: Maybe<Array<EptFilterEnum>>;
  issueDate: Array<InvoiceDateFilteringOption>;
  scheduledDate: Array<InvoiceDateFilteringOption>;
};

export type InvoiceInputObject = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountingAccountId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryClassId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryDepartmentId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryLocationId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentDisplaySettings?: InputMaybe<DocumentDisplaySettingsInputObject>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  issueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  payerLocalBusinessId?: InputMaybe<Scalars['ID']['input']>;
  payerTaxpayerId?: InputMaybe<Scalars['String']['input']>;
  paymentCardId?: InputMaybe<Scalars['ID']['input']>;
  purposeCode?: InputMaybe<Scalars['String']['input']>;
  quickBooksAccountId?: InputMaybe<Scalars['ID']['input']>;
  quickBooksClassId?: InputMaybe<Scalars['ID']['input']>;
  quickBooksLocationId?: InputMaybe<Scalars['ID']['input']>;
  quickBooksMemo?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  shippingVendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  trackingCategoryOneId?: InputMaybe<Scalars['ID']['input']>;
  trackingCategoryTwoId?: InputMaybe<Scalars['ID']['input']>;
  vendorAccountId?: InputMaybe<Scalars['ID']['input']>;
  vendorLocalBusinessId?: InputMaybe<Scalars['ID']['input']>;
  xeroAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type InvoiceLineItem = {
  accountingAccount: Maybe<AccountingAccount>;
  accountingAccountId: Maybe<Scalars['ID']['output']>;
  accountingCategoryClass: Maybe<AccountingDictionary>;
  accountingCategoryClassId: Maybe<Scalars['ID']['output']>;
  accountingCategoryDepartment: Maybe<AccountingDictionary>;
  accountingCategoryDepartmentId: Maybe<Scalars['ID']['output']>;
  accountingCategoryLocation: Maybe<AccountingDictionary>;
  accountingCategoryLocationId: Maybe<Scalars['ID']['output']>;
  accountingCategoryOneId: Maybe<Scalars['ID']['output']>;
  accountingCategoryTwoId: Maybe<Scalars['ID']['output']>;
  accountingCustomerOrProject: Maybe<AccountingDictionary>;
  amount: Money;
  catalogItemVariation: Maybe<CatalogItemVariation>;
  description: Maybe<Scalars['String']['output']>;
  fractionalUnitAmount: InfinitePrecisionMoney;
  hasSimilarCatalogItem: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoice: Maybe<Invoice>;
  linkedAdditionalExpenses: Array<AdditionalExpense>;
  manuallyCreated: Scalars['Boolean']['output'];
  position: Maybe<Scalars['Int']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  trackingCategoryOne: Maybe<AccountingDictionary>;
  trackingCategoryOneId: Maybe<Scalars['ID']['output']>;
  trackingCategoryTwo: Maybe<AccountingDictionary>;
  trackingCategoryTwoId: Maybe<Scalars['ID']['output']>;
  unitAmount: Maybe<Money>;
  unitOfMeasure: Maybe<Scalars['String']['output']>;
};

export type InvoiceLineItemDetailsInputObject = {
  amountCents: Scalars['SafeInt']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitAmountCents?: InputMaybe<Scalars['Int']['input']>;
};

export type InvoiceLineItemInputObject = {
  accountingAccountId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryClassId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryDepartmentId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryLocationId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryOneId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryTwoId?: InputMaybe<Scalars['ID']['input']>;
  accountingCustomerOrProjectId?: InputMaybe<Scalars['ID']['input']>;
  catalogItemVariationId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fractionalUnitAmountCents?: InputMaybe<Scalars['Float']['input']>;
  manuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Float']['input'];
  trackingCategoryOneId?: InputMaybe<Scalars['ID']['input']>;
  trackingCategoryTwoId?: InputMaybe<Scalars['ID']['input']>;
  unitAmountCents?: InputMaybe<Scalars['Int']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceMarketingVirtualCard = {
  fromDate: Scalars['ISO8601Date']['output'];
  toDate: Scalars['ISO8601Date']['output'];
};

export type InvoiceOcr = {
  ocrRecordLineItems: Array<InvoiceOcrLineItem>;
  payerAddress: Maybe<AddressOcr>;
  payerEmail: Maybe<Scalars['String']['output']>;
  payerName: Maybe<Scalars['String']['output']>;
  routingNumberValidation: Maybe<RoutingNumberValidation>;
  vendorAccountNumber: Maybe<Scalars['String']['output']>;
  vendorAddress: Maybe<AddressOcr>;
  vendorEmail: Maybe<Scalars['String']['output']>;
  vendorIban: Maybe<Scalars['String']['output']>;
  vendorName: Maybe<Scalars['String']['output']>;
  vendorPhone: Maybe<Scalars['String']['output']>;
  vendorRoutingNumber: Maybe<Scalars['String']['output']>;
  vendorSwift: Maybe<Scalars['String']['output']>;
};

export type InvoiceOcrLineItem = {
  amount: Maybe<Money>;
  id: Scalars['ID']['output'];
  matchingCatalogItem: Maybe<CatalogItem>;
  productName: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  sku: Maybe<Scalars['String']['output']>;
  unitAmount: Maybe<Money>;
};

export type InvoicePayableDataInputObject = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountingMemo?: InputMaybe<Scalars['String']['input']>;
  paperCheck?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  quickBooksLocationId?: InputMaybe<Scalars['ID']['input']>;
  quickBooksMemo?: InputMaybe<Scalars['String']['input']>;
};

export enum InvoiceSortableFieldEnum {
  AMOUNT = 'AMOUNT',
  AMOUNT_CURRENCY = 'AMOUNT_CURRENCY',
  CREATED_AT = 'CREATED_AT',
  DUE_DATE = 'DUE_DATE',
  FEE_AMOUNT = 'FEE_AMOUNT',
  INVOICE_NUMBER = 'INVOICE_NUMBER',
  ISSUE_DATE = 'ISSUE_DATE',
  LABELS = 'LABELS',
  NEAREST_INSTALLMENT_AMOUNT = 'NEAREST_INSTALLMENT_AMOUNT',
  NEAREST_PAYER_PAYMENT_DATE = 'NEAREST_PAYER_PAYMENT_DATE',
  NEAREST_VENDOR_PAYMENT_DATE = 'NEAREST_VENDOR_PAYMENT_DATE',
  PAYMENT_METHOD = 'PAYMENT_METHOD',
  SCHEDULED_DATE = 'SCHEDULED_DATE',
  STATUS = 'STATUS',
  TERMS = 'TERMS',
  TOTAL_USD_AMOUNT = 'TOTAL_USD_AMOUNT',
  VENDOR_NAME = 'VENDOR_NAME'
}

export enum InvoiceSortingDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type InvoiceSortingInputObject = {
  direction: InvoiceSortingDirectionEnum;
  field: InvoiceSortableFieldEnum;
};

export enum InvoiceSourceEnum {
  ADDED_WITHOUT_ATTACHMENT = 'ADDED_WITHOUT_ATTACHMENT',
  CREATED = 'CREATED',
  EMAIL = 'EMAIL',
  EPT_FEE = 'EPT_FEE',
  FROM_REFERENCE = 'FROM_REFERENCE',
  NETSUITE_IMPORT = 'NETSUITE_IMPORT',
  QUICKBOOKS_IMPORT = 'QUICKBOOKS_IMPORT',
  UPLOADED = 'UPLOADED',
  VMC = 'VMC',
  VMC_FEE = 'VMC_FEE',
  XERO_IMPORT = 'XERO_IMPORT'
}

export type InvoiceStatusCounts = {
  approvalRequested: Scalars['Int']['output'];
  approved: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  error: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  onHold: Scalars['Int']['output'];
  paid: Scalars['Int']['output'];
  partiallyRepaid: Scalars['Int']['output'];
  paymentPlan: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  scheduled: Scalars['Int']['output'];
  splitted: Scalars['Int']['output'];
  unscheduled: Scalars['Int']['output'];
  vendorPartiallyPaid: Scalars['Int']['output'];
  voided: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
};

export enum InvoiceStatusEnum {
  APPROVAL_REQUESTED = 'APPROVAL_REQUESTED',
  APPROVED = 'APPROVED',
  DRAFT = 'DRAFT',
  ERROR = 'ERROR',
  FAILED = 'FAILED',
  ON_HOLD = 'ON_HOLD',
  PAID = 'PAID',
  PARTIALLY_REPAID = 'PARTIALLY_REPAID',
  PAYMENT_PLAN = 'PAYMENT_PLAN',
  PROCESSED = 'PROCESSED',
  REJECTED = 'REJECTED',
  SCHEDULED = 'SCHEDULED',
  SPLITTED = 'SPLITTED',
  UNSCHEDULED = 'UNSCHEDULED',
  VENDOR_PARTIALLY_PAID = 'VENDOR_PARTIALLY_PAID',
  VOIDED = 'VOIDED',
  WAITING = 'WAITING'
}

export type InvoiceSuggestedVendorAccount = {
  routingNumberValidation: Maybe<RoutingNumberValidation>;
  type: Maybe<SuggestedVendorAccountTypeEnum>;
  vendorAccountNumber: Maybe<Scalars['String']['output']>;
  vendorIban: Maybe<Scalars['String']['output']>;
  vendorRoutingNumber: Maybe<Scalars['String']['output']>;
  vendorSwift: Maybe<Scalars['String']['output']>;
};

export type Invoices = {
  data: Array<Invoice>;
  pagination: Pagination;
};

export enum InvoicesEptReasonEnum {
  CREDIT_LIMIT = 'CREDIT_LIMIT',
  THRESHOLD = 'THRESHOLD'
}

export type InvoicesFilteringInputObject = {
  accountingAccountIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  accountingCategoryClassIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  accountingCategoryDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  accountingCategoryLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  accountingCategoryOneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  accountingCategoryTwoIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  amountCents?: InputMaybe<InvoiceAmountFilteringInputObject>;
  amountCurrencies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approverIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  archivedStatus?: InputMaybe<InvoiceArchivedStatusEnum>;
  confirmationNumber?: InputMaybe<Scalars['String']['input']>;
  confirmationNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<DateFilteringInputObject>;
  dueDate?: InputMaybe<DateFilteringInputObject>;
  epts?: InputMaybe<Array<InputMaybe<EptFilterEnum>>>;
  invoiceOrPaymentApproverIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  issueDate?: InputMaybe<DateFilteringInputObject>;
  labelIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  labelOperator?: InputMaybe<LabelOperatorEnum>;
  number?: InputMaybe<Scalars['String']['input']>;
  payerName?: InputMaybe<Scalars['String']['input']>;
  paymentApproverIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentFriendlyId?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<Array<InputMaybe<PaymentMethodEnum>>>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  quickbooksClassIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  quickbooksLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledDate?: InputMaybe<DateFilteringInputObject>;
  search?: InputMaybe<Scalars['String']['input']>;
  selectedForFinancing?: InputMaybe<Scalars['Boolean']['input']>;
  sources?: InputMaybe<Array<InvoiceSourceEnum>>;
  sourcesV2?: InputMaybe<Array<InvoiceSourceEnum>>;
  statuses?: InputMaybe<Array<InvoiceStatusEnum>>;
  vendorLocalBusinessIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
  withSyncError?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum InvoicesPermissionsEnum {
  ATTACH_INVOICE_DOCUMENT = 'ATTACH_INVOICE_DOCUMENT',
  CANCEL_INVOICE_APPROVAL_REQUEST = 'CANCEL_INVOICE_APPROVAL_REQUEST',
  CREATE_PAYABLE_INVOICE = 'CREATE_PAYABLE_INVOICE',
  CREATE_RECEIVABLE_INVOICE = 'CREATE_RECEIVABLE_INVOICE',
  DELETE_INVOICES = 'DELETE_INVOICES',
  DELETE_INVOICE_ATTACHMENT = 'DELETE_INVOICE_ATTACHMENT',
  INVOICE_STATUS_COUNTS = 'INVOICE_STATUS_COUNTS',
  MARK_INVOICE_PAID = 'MARK_INVOICE_PAID',
  MARK_INVOICE_UNPAID = 'MARK_INVOICE_UNPAID',
  NOTIFY_EPT_REQUEST = 'NOTIFY_EPT_REQUEST',
  NOTIFY_WRONG_INVOICE = 'NOTIFY_WRONG_INVOICE',
  REQUEST_INVOICE_APPROVAL = 'REQUEST_INVOICE_APPROVAL',
  SPLIT_TRANSFERS = 'SPLIT_TRANSFERS',
  UPDATE_INVOICE = 'UPDATE_INVOICE',
  UPDATE_INVOICE_ARCHIVED = 'UPDATE_INVOICE_ARCHIVED',
  UPDATE_INVOICE_EXTERNAL_ATTRIBUTES = 'UPDATE_INVOICE_EXTERNAL_ATTRIBUTES',
  UPDATE_INVOICE_LABELS = 'UPDATE_INVOICE_LABELS',
  UPDATE_INVOICE_PAYABLE_DATA = 'UPDATE_INVOICE_PAYABLE_DATA',
  UPDATE_TRANSFER = 'UPDATE_TRANSFER'
}

export type Journey = {
  activatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  active: Scalars['Boolean']['output'];
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: JourneyStatus;
  steps: Array<JourneyStep>;
  type: JourneyEnum;
};

/** Autogenerated return type of JourneyChanged. */
export type JourneyChangedPayload = {
  eventType: Scalars['String']['output'];
  journey: Journey;
};

export enum JourneyEnum {
  ACTIVATE_BUSINESS = 'ACTIVATE_BUSINESS',
  LENDING = 'LENDING',
  PAYER = 'PAYER',
  PURCHASING = 'PURCHASING',
  SYNC_INVENTORY = 'SYNC_INVENTORY'
}

export enum JourneyStatus {
  COMPLETE = 'COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type JourneyStep = {
  exclusiveGroup: Maybe<ExclusiveGroupEnum>;
  optional: Scalars['Boolean']['output'];
  relatedObjectData: Maybe<JourneyStepRelatedObject>;
  status: JourneyStepStatus;
  type: JourneyStepEnum;
  userCanCompleteStep: Scalars['Boolean']['output'];
};

export enum JourneyStepEnum {
  ADD_BENEFICIAL_OWNERS = 'ADD_BENEFICIAL_OWNERS',
  COMPLETE_BUSINESS_DETAILS = 'COMPLETE_BUSINESS_DETAILS',
  CONFIGURE_ACCOUNTING = 'CONFIGURE_ACCOUNTING',
  CONNECT_ACCOUNTING = 'CONNECT_ACCOUNTING',
  CONNECT_BANK_ACCOUNT = 'CONNECT_BANK_ACCOUNT',
  CONNECT_SHOPIFY = 'CONNECT_SHOPIFY',
  CREATE_CATALOG_ITEM = 'CREATE_CATALOG_ITEM',
  CREATE_CATALOG_ITEM_VIA_CSV_UPLOAD = 'CREATE_CATALOG_ITEM_VIA_CSV_UPLOAD',
  CREATE_OR_UPLOAD_PURCHASE_ORDER = 'CREATE_OR_UPLOAD_PURCHASE_ORDER',
  DOCUMENT_OR_DATA_REQUEST = 'DOCUMENT_OR_DATA_REQUEST',
  ORG_MFA_SETUP = 'ORG_MFA_SETUP',
  SCHEDULE_BILL_PAYMENT = 'SCHEDULE_BILL_PAYMENT'
}

export type JourneyStepRelatedObject = {
  dataRequestId: Maybe<Scalars['ID']['output']>;
  documentType: Maybe<DocumentTypeEnum>;
  documentUploadRequestId: Maybe<Scalars['ID']['output']>;
  dueDate: Maybe<Scalars['ISO8601Date']['output']>;
  latestAccountingDate: Maybe<Scalars['ISO8601Date']['output']>;
  manuallyTriggered: Maybe<Scalars['Boolean']['output']>;
  requestedPeriod: Maybe<DocumentRequestedPeriod>;
  requiredForUnderwriting: Maybe<Scalars['Boolean']['output']>;
  resubmissionReasons: Maybe<Array<Scalars['String']['output']>>;
  resubmissionRequired: Maybe<Scalars['Boolean']['output']>;
  targetDescription: Maybe<Scalars['String']['output']>;
};

export enum JourneyStepStatus {
  COMPLETE = 'COMPLETE',
  TO_DO = 'TO_DO'
}

export type KybDataField = {
  description: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  propertyKey: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type KybDataFieldInput = {
  intValue?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export type KybDataRequest = {
  dataFields: Maybe<Array<KybDataField>>;
  dataRequestId: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type KybDataRequestInput = {
  dataFieldInputs: Array<KybDataFieldInput>;
  dataRequestId: Scalars['ID']['input'];
};

export enum KybStatusEnum {
  /** Awaiting approval by Settle */
  AWAITING_OPS_APPROVAL = 'AWAITING_OPS_APPROVAL',
  /** Blocked by Settle */
  BLOCKED = 'BLOCKED',
  /** Business marked as dormant due to inactivity */
  DORMANT = 'DORMANT',
  /** Awaiting beneficial owner information */
  NEED_BENEFICIAL_OWNER = 'NEED_BENEFICIAL_OWNER',
  /** Awaiting business details */
  NEED_BUSINESS_INFO = 'NEED_BUSINESS_INFO',
  /** Awaiting significant control designation */
  NEED_SIGNIFICANT_CONTROL = 'NEED_SIGNIFICANT_CONTROL',
  /** Approved by Settle */
  VERIFIED = 'VERIFIED'
}

export type Label = {
  actions: LabelActions;
  /** HEX representation of a color (e.g. #RRGGBB) */
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LabelActions = {
  update: Action;
};

export enum LabelContextEnum {
  CATALOG = 'CATALOG'
}

export type LabelInputObject = {
  /** HEX representation of a color (e.g. #RRGGBB) */
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum LabelOperatorEnum {
  ALL_OF = 'ALL_OF',
  ANY_OF = 'ANY_OF'
}

export type LabelsFilteringInputObject = {
  context?: InputMaybe<LabelContextEnum>;
};

export type LandedCostsOnboardingFlow = FlowInterface & {
  currentStep: Maybe<StepEnum>;
  flowType: FlowTypeEnum;
  id: Scalars['ID']['output'];
  orderedSteps: Array<StepEnum>;
};

/** Onboarding product item */
export type LandedCostsProduct = {
  /** Shopify id that we use as our external id */
  externalId: Scalars['String']['output'];
  /** Landed cost set by customer */
  landedCost: InfinitePrecisionMoney;
  /** Shopify id for the product */
  parentExternalId: Maybe<Scalars['String']['output']>;
  /** Title of the product */
  parentTitle: Maybe<Scalars['String']['output']>;
  /** Sku of the variant, or product if there are no variants */
  sku: Maybe<Scalars['String']['output']>;
  /** Title of the variant (e.g. small, 20oz, etc) */
  title: Scalars['String']['output'];
};

/** Product selected in onboarding flow */
export type LandedCostsProductInputObject = {
  /** Shopify id that we use as our external id */
  externalId: Scalars['String']['input'];
  /** Landed cost set by customer */
  landedCost: FractionalMoneyInputObject;
  /** Shopify id for the product */
  parentExternalId?: InputMaybe<Scalars['String']['input']>;
  /** Title of the product */
  parentTitle?: InputMaybe<Scalars['String']['input']>;
  /** Variant sku */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Title of the variant (e.g. small, 20oz, etc) */
  title: Scalars['String']['input'];
};

export enum LendingLicenseEnum {
  CA = 'CA',
  NY = 'NY'
}

export type LineItemDetails = {
  /** catalog item of the line. always present for matched lines(and variations), can be null for unmatched lines (categories) */
  catalogItem: Maybe<CatalogItem>;
  /** null for lines with children, not null if it's a variation */
  catalogItemVariation: Maybe<CatalogItemVariation>;
  /** linked document: bill/PO */
  document: LinkedDocument;
  /** id of the line item (either bill or PO) */
  id: Scalars['ID']['output'];
  /** name of the item */
  itemName: Maybe<Scalars['String']['output']>;
  /** number of line in document it comes from */
  lineNumber: Scalars['Int']['output'];
  /** we should show a warning (price mismatch) */
  priceConflict: Maybe<Scalars['Boolean']['output']>;
  /** if the discrepancy falls within a rule threshold */
  priceConflictWithinThreshold: Maybe<Scalars['Boolean']['output']>;
  /** which thresholds the price discrepancy is within */
  priceDiscrepancyThresholdsTriggered: Maybe<Array<DiscrepancyThreshold>>;
  quantity: Scalars['Float']['output'];
  /** we should show a warning (quantity mismatch) */
  quantityConflict: Maybe<Scalars['Boolean']['output']>;
  /** if the discrepancy falls within a rule threshold */
  quantityConflictWithinThreshold: Maybe<Scalars['Boolean']['output']>;
  /** which thresholds the quantity discrepancy is within */
  quantityDiscrepancyThresholdsTriggered: Maybe<Array<DiscrepancyThreshold>>;
  total: InfinitePrecisionMoney;
  /** we should show a warning (total mismatch) */
  totalConflict: Maybe<Scalars['Boolean']['output']>;
  unitAmount: InfinitePrecisionMoney;
  /** unit of measure */
  unitOfMeasure: Maybe<Scalars['String']['output']>;
};

export type LineItemsMatchingTotal = {
  /** total amount of all matched lines in the view */
  totalMatchedAmount: InfinitePrecisionMoney;
  /** number of matched catalog items (groups) and categories */
  totalMatchedLines: Scalars['Int']['output'];
  /** total quantity of matched lines in the view */
  totalMatchedQuantity: Scalars['Int']['output'];
  /** total amount of all unmatched lines in the view */
  totalUnmatchedAmount: InfinitePrecisionMoney;
  /** number of unmatched catalog items (groups) and categories */
  totalUnmatchedLines: Scalars['Int']['output'];
  /** total quantity of unmatched lines in the view */
  totalUnmatchedQuantity: Scalars['Int']['output'];
};

export type LinkableCatalogItem = {
  catalogItemMergeSuggestion: Maybe<CatalogItemMergeSuggestion>;
  catalogItemVariation: Maybe<CatalogItemVariation>;
  externalItem: Maybe<ExternalItem>;
  externalName: Maybe<Scalars['String']['output']>;
  externalSku: Scalars['String']['output'];
  externalUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integrationSource: IntegrationSourceEnum;
  integrationSourceName: Maybe<Scalars['String']['output']>;
  integrationSourceType: IntegrationSourceTypeEnum;
  /** @deprecated Please use stateV2 instead */
  state: LinkableCatalogItemStateEnum;
  stateV2: LinkableStateEnum;
};

export enum LinkableCatalogItemStateEnum {
  ARCHIVED = 'ARCHIVED',
  LINKED = 'LINKED',
  UNLINKED = 'UNLINKED'
}

export type LinkableCatalogItemsFilteringInputObject = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Please use state_v2 instead */
  state?: InputMaybe<LinkableCatalogItemStateEnum>;
  stateV2?: InputMaybe<LinkableStateEnum>;
};

export type LinkableLocation = {
  externalName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integrationSource: IntegrationSourceEnum;
  mergeSuggestion: Maybe<Location>;
  state: LinkableStateEnum;
};

export type LinkableLocationsFilteringInputObject = {
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  state?: InputMaybe<LinkableStateEnum>;
};

export enum LinkableStateEnum {
  ARCHIVED = 'ARCHIVED',
  LINKED = 'LINKED',
  UNLINKED = 'UNLINKED'
}

export type LinkedDocument = DocumentReference | Invoice | PurchaseOrder | Receipt | WorkOrder;

export type LinkedDocumentDiscrepancies = {
  discrepanciesOutsideThresholdCount: Scalars['Int']['output'];
  discrepanciesWithinThresholdCount: Scalars['Int']['output'];
  discrepancyRulesApplied: Scalars['Boolean']['output'];
  fullyMatchedCount: Scalars['Int']['output'];
  matchedWithDiscrepanciesCount: Scalars['Int']['output'];
  partiallyMatchedCount: Scalars['Int']['output'];
  totalDiscrepanciesCount: Scalars['Int']['output'];
  unmatchedCount: Scalars['Int']['output'];
};

export type LocalBusiness = {
  accounts: Array<LocalBusinessAccount>;
  actions: LocalBusinessActions;
  address: Maybe<Address>;
  addressForPaperCheck: Maybe<Address>;
  allowsPaperCheck: Scalars['Boolean']['output'];
  availableVendorCreditAmount: Maybe<Money>;
  bankVerified: Scalars['Boolean']['output'];
  blockPayments: Maybe<BlockLocalBusinessPayments>;
  business: Maybe<PublicBusiness>;
  businessName: Maybe<Scalars['String']['output']>;
  businessStructure: Maybe<BusinessStructureEnum>;
  /** @deprecated Use suggestedBusinessMatches instead */
  canMergeWithPublicBusiness: Scalars['Boolean']['output'];
  contactDetails: Maybe<ContactDetails>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Maybe<Scalars['String']['output']>;
  customerNumber: Maybe<Scalars['String']['output']>;
  defaultBeneficiaryFirstName: Maybe<Scalars['String']['output']>;
  defaultBeneficiaryLastName: Maybe<Scalars['String']['output']>;
  defaultBeneficiaryName: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  factoringEmail: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importedEmails: Array<Scalars['String']['output']>;
  invited: Scalars['Boolean']['output'];
  invitedAsPayer: Scalars['Boolean']['output'];
  invitedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  invoicesStatistics: LocalBusinessStatusesCountType;
  is1099Eligible: Maybe<Scalars['Boolean']['output']>;
  labels: Array<Label>;
  lastName: Maybe<Scalars['String']['output']>;
  manufacturingLocation: Maybe<Location>;
  /** Returns true when the there is a W9 form uploaded by the verified businessand it should not be accessible to the creator business */
  maskW9Form: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  notificationsEmail: Maybe<Scalars['String']['output']>;
  numBills: Scalars['Int']['output'];
  numPayments: Scalars['Int']['output'];
  officialName: Maybe<Scalars['String']['output']>;
  operationsAddress: Maybe<Address>;
  /** non-w9 documents */
  otherAttachments: Array<Attachment>;
  paymentReference: Maybe<Scalars['String']['output']>;
  paymentsForewarnings: Array<WarningMessage>;
  /** @deprecated Use suggestedBusinessMatches instead */
  publicBusinessMatch: Maybe<PublicBusiness>;
  registeredAddress: Maybe<Address>;
  registeredBusinessName: Maybe<Scalars['String']['output']>;
  registeredBusinessStructure: Maybe<BusinessStructureEnum>;
  registeredIs1099Eligible: Maybe<Scalars['Boolean']['output']>;
  registeredTaxpayerId: Maybe<Scalars['String']['output']>;
  registeredWebsite: Maybe<Scalars['String']['output']>;
  shipmentLocations: Array<LocalBusinessShipmentLocation>;
  /** Returns true when missing W9 form message should be shown to the creator business */
  showW9MissingMessage: Scalars['Boolean']['output'];
  suggestedBusinessMatches: Array<BusinessMatch>;
  taxpayerId: Maybe<Scalars['String']['output']>;
  trackRequiredTaxForm: Scalars['Boolean']['output'];
  useOperationsAddressOnDocuments: Scalars['Boolean']['output'];
  vendorCredits: Array<VendorCredit>;
  /** @deprecated Use vendorTerm instead */
  vendorPaymentTerms: Array<VendorPaymentTerm>;
  vendorTerm: Maybe<VendorTerms>;
  /** W9 form uploaded by the verified business */
  verifiedW9Form: Maybe<Attachment>;
  visible: Scalars['Boolean']['output'];
  /** W9 form uploaded for the local business */
  w9Form: Maybe<Attachment>;
  w9Request: Maybe<InformationRequest>;
};

export type LocalBusinessAccount = {
  accountNumber: Maybe<Scalars['String']['output']>;
  accountNumberType: Maybe<VendorAccountNumberTypeEnum>;
  archived: Scalars['Boolean']['output'];
  bankAddress: Maybe<Address>;
  bankName: Maybe<Scalars['String']['output']>;
  beneficiaryFirstName: Maybe<Scalars['String']['output']>;
  beneficiaryLastName: Maybe<Scalars['String']['output']>;
  beneficiaryName: Maybe<Scalars['String']['output']>;
  bicSwift: Maybe<Scalars['String']['output']>;
  cnaps: Maybe<Scalars['String']['output']>;
  copyOfVerifiedAccount: Scalars['Boolean']['output'];
  currency: Maybe<Scalars['String']['output']>;
  deletable: Scalars['Boolean']['output'];
  destinationCountry: Scalars['String']['output'];
  editable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastUsedInvoice: Maybe<Invoice>;
  lastUsedOn: Maybe<Scalars['ISO8601Date']['output']>;
  mask: Scalars['String']['output'];
  /** True if this account is missing wire fields and has a complete local copy */
  missingWireFieldsProvidedByLocalCopy: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  ownedByPayer: Scalars['Boolean']['output'];
  /** Account ability to process future ACH payments through the system */
  paymentsProcessingAvailable: Maybe<Scalars['Boolean']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  preferredReceivingAccount: Scalars['Boolean']['output'];
  routingNumber: Maybe<Scalars['String']['output']>;
  routingNumberValidation: Maybe<RoutingNumberValidation>;
  /** True if at least one wire to this account has been paid out successfully */
  successfulWirePayoutExists: Scalars['Boolean']['output'];
  supportedPaymentTypes: Array<PaymentMethodEnum>;
  taxpayerId: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
  wireFields: Maybe<Array<InternationalWireFieldsDataFieldValueType>>;
  wireRoutingNumber: Maybe<Scalars['String']['output']>;
  wireRoutingNumberValidation: Maybe<RoutingNumberValidation>;
};

export type LocalBusinessAccountInputObject = {
  accountNumber: Scalars['String']['input'];
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  bankAddress?: InputMaybe<AddressInputObject>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  beneficiaryFirstName?: InputMaybe<Scalars['String']['input']>;
  beneficiaryLastName?: InputMaybe<Scalars['String']['input']>;
  beneficiaryName?: InputMaybe<Scalars['String']['input']>;
  bicSwift?: InputMaybe<Scalars['String']['input']>;
  cnaps?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  destinationCountry: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  taxpayerId?: InputMaybe<Scalars['String']['input']>;
  wireFields?: InputMaybe<Array<InternationalWireFieldsDataFieldInputObject>>;
  wireRoutingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type LocalBusinessActions = {
  delete: Action;
  deleteW9: Action;
};

export type LocalBusinessEmailInputObject = {
  email: Scalars['String']['input'];
  localBusinessId: Scalars['ID']['input'];
};

export type LocalBusinessInputObject = {
  address?: InputMaybe<AddressInputObject>;
  addressForPaperCheck?: InputMaybe<AddressInputObject>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessStructure?: InputMaybe<BusinessStructureEnum>;
  contactDetails?: InputMaybe<ContactDetailsInputObject>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  factoringEmail?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  initialRole?: InputMaybe<LocalBusinessRoleEnum>;
  is1099Eligible?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationsEmail?: InputMaybe<Scalars['String']['input']>;
  operationsAddress?: InputMaybe<AddressInputObject>;
  paymentReference?: InputMaybe<Scalars['String']['input']>;
  taxpayerId?: InputMaybe<Scalars['String']['input']>;
  trackRequiredTaxForm?: InputMaybe<Scalars['Boolean']['input']>;
  useOperationsAddressOnDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  /** (Deprecated) Use `vendorTerms` instead */
  vendorPaymentTerms?: InputMaybe<Array<VendorPaymentTermInputObject>>;
  vendorTerm?: InputMaybe<VendorTermInputObject>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalBusinessPublicInputObject = {
  businessStructure?: InputMaybe<BusinessStructureEnum>;
  currency?: InputMaybe<Scalars['String']['input']>;
  initialRole?: InputMaybe<LocalBusinessRoleEnum>;
  is1099Eligible?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notificationsEmail?: InputMaybe<Scalars['String']['input']>;
  trackRequiredTaxForm?: InputMaybe<Scalars['Boolean']['input']>;
  /** (Deprecated) Use `vendorTerms` instead */
  vendorPaymentTerms?: InputMaybe<Array<VendorPaymentTermInputObject>>;
  vendorTerm?: InputMaybe<VendorTermInputObject>;
};

export enum LocalBusinessRoleEnum {
  PAYER = 'PAYER',
  VENDOR = 'VENDOR'
}

export type LocalBusinessShipmentLocation = {
  address: Address;
  id: Scalars['ID']['output'];
  localBusiness: LocalBusiness;
  name: Maybe<Scalars['String']['output']>;
};

export type LocalBusinessShipmentLocationInputObject = {
  addressAttributes?: InputMaybe<AddressInputObject>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum LocalBusinessSortableFieldEnum {
  LABELS = 'LABELS',
  NAME = 'NAME'
}

export enum LocalBusinessSortingDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type LocalBusinessSortingInputObject = {
  direction: LocalBusinessSortingDirectionEnum;
  field: LocalBusinessSortableFieldEnum;
};

export type LocalBusinessStatusesCountType = {
  all: Scalars['Int']['output'];
  lastInvoiceDate: Maybe<Scalars['ISO8601Date']['output']>;
  lastInvoiceTotal: Maybe<Money>;
  paid: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  scheduled: Scalars['Int']['output'];
  totalAll: Money;
  totalPaid: Money;
  totalPending: Money;
  totalScheduled: Money;
};

export type LocalBusinesses = {
  data: Array<LocalBusiness>;
  hasDeleted: Scalars['Boolean']['output'];
  pagination: Pagination;
};

export enum LocalBusinessesPermissionsEnum {
  ACCEPT_BUSINESS_MATCH = 'ACCEPT_BUSINESS_MATCH',
  CREATE_FROM_PUBLIC_BUSINESS = 'CREATE_FROM_PUBLIC_BUSINESS',
  CREATE_LOCAL_BUSINESS = 'CREATE_LOCAL_BUSINESS',
  CREATE_LOCAL_BUSINESS_ACCOUNT = 'CREATE_LOCAL_BUSINESS_ACCOUNT',
  CREATE_LOCAL_BUSINESS_ATTACHMENT = 'CREATE_LOCAL_BUSINESS_ATTACHMENT',
  DELETE_LOCAL_BUSINESSES = 'DELETE_LOCAL_BUSINESSES',
  DELETE_LOCAL_BUSINESS_ACCOUNT = 'DELETE_LOCAL_BUSINESS_ACCOUNT',
  DELETE_LOCAL_BUSINESS_ATTACHMENT = 'DELETE_LOCAL_BUSINESS_ATTACHMENT',
  INVITE_PAYER = 'INVITE_PAYER',
  INVITE_VENDOR = 'INVITE_VENDOR',
  MERGE_WITH_PUBLIC_BUSINESS = 'MERGE_WITH_PUBLIC_BUSINESS',
  REJECT_ALL_BUSINESS_MATCHES = 'REJECT_ALL_BUSINESS_MATCHES',
  RESTORE_LOCAL_BUSINESS = 'RESTORE_LOCAL_BUSINESS',
  SYNC_WITH_PUBLIC_BUSINESS = 'SYNC_WITH_PUBLIC_BUSINESS',
  UPDATE_LOCAL_BUSINESS = 'UPDATE_LOCAL_BUSINESS',
  UPDATE_LOCAL_BUSINESS_ACCOUNT = 'UPDATE_LOCAL_BUSINESS_ACCOUNT',
  UPDATE_LOCAL_BUSINESS_ATTACHMENT = 'UPDATE_LOCAL_BUSINESS_ATTACHMENT',
  UPDATE_LOCAL_BUSINESS_LABELS = 'UPDATE_LOCAL_BUSINESS_LABELS'
}

export type Location = {
  address: Maybe<Address>;
  archived: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  companyName: Maybe<Scalars['String']['output']>;
  contactDetails: Maybe<ContactDetails>;
  deleted: Scalars['Boolean']['output'];
  group: Maybe<LocationGroupTypeEnum>;
  id: Scalars['ID']['output'];
  initialSource: LocationSourceTypeEnum;
  /** @deprecated Always returns null; no integration inventory timestamp is tracked on Location */
  integrationInventoryUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  localBusiness: Maybe<LocalBusiness>;
  locationPageUrl: Maybe<Scalars['String']['output']>;
  locationType: Maybe<LocationTypeEnum>;
  lotSnapshots: Array<LotSnapshot>;
  name: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  operationsAddress: Maybe<Address>;
  source: LocationSourceTypeEnum;
};

export enum LocationArchivedStatusEnum {
  ACTIVE_AND_ARCHIVED = 'ACTIVE_AND_ARCHIVED',
  ACTIVE_ONLY = 'ACTIVE_ONLY',
  ARCHIVED_ONLY = 'ARCHIVED_ONLY'
}

export type LocationFilter = {
  archivedStatus?: InputMaybe<LocationArchivedStatusEnum>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationType?: InputMaybe<LocationTypeEnum>;
};

export enum LocationGroupTypeEnum {
  FBA = 'FBA'
}

export type LocationInputObject = {
  address?: InputMaybe<AddressInputObject>;
  code?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<LocationTypeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  operationsAddress?: InputMaybe<AddressInputObject>;
};

export enum LocationSourceTypeEnum {
  MANUAL = 'MANUAL',
  NETSUITE = 'NETSUITE',
  QUICK_BOOKS = 'QUICK_BOOKS',
  SHOPIFY = 'SHOPIFY',
  WMS = 'WMS'
}

export enum LocationTypeEnum {
  CORPORATE = 'CORPORATE',
  DISTRIBUTION_CENTER = 'DISTRIBUTION_CENTER',
  MANUFACTURING = 'MANUFACTURING',
  RETAIL_STORE = 'RETAIL_STORE',
  WAREHOUSE = 'WAREHOUSE'
}

/** Stores the UTMs to use for the referral */
export type LongLinkUtms = {
  utmCampaign: Maybe<Scalars['String']['output']>;
  utmContent: Maybe<Scalars['String']['output']>;
  utmMedium: Maybe<Scalars['String']['output']>;
  utmSource: Maybe<Scalars['String']['output']>;
};

export type Lot = {
  code: Scalars['String']['output'];
  expirationDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  lotSnapshots: Array<LotSnapshot>;
  note: Maybe<Scalars['String']['output']>;
};

export type LotInputObject = {
  expirationDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type LotSnapshot = {
  available: Maybe<Scalars['Float']['output']>;
  catalogItem: CatalogItem;
  catalogItemVariation: CatalogItemVariation;
  id: Scalars['ID']['output'];
  incoming: Maybe<Scalars['Float']['output']>;
  location: Maybe<Location>;
  lot: Lot;
  onhand: Maybe<Scalars['Float']['output']>;
  reserved: Maybe<Scalars['Float']['output']>;
  snapshotDate: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type MarketingVirtualCard = {
  account: Account;
  accountingAccount: Maybe<AccountingAccount>;
  accountingAccountId: Maybe<Scalars['ID']['output']>;
  accountingCategoryClassId: Maybe<Scalars['ID']['output']>;
  accountingCategoryLocationId: Maybe<Scalars['ID']['output']>;
  accountingMemo: Maybe<Scalars['String']['output']>;
  availableCredit: Money;
  balance: Money;
  cardNumberLast4: Scalars['String']['output'];
  currentPeriodAmount: Money;
  deletable: Scalars['Boolean']['output'];
  expirationMonth: Scalars['Int']['output'];
  expirationYear: Scalars['Int']['output'];
  feeAccountingAccount: Maybe<AccountingAccount>;
  feeAccountingAccountId: Maybe<Scalars['ID']['output']>;
  feeAccountingCategoryClassId: Maybe<Scalars['ID']['output']>;
  feeAccountingCategoryLocationId: Maybe<Scalars['ID']['output']>;
  feeAccountingMemo: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  limit: Money;
  name: Scalars['String']['output'];
  paymentSystem: Scalars['String']['output'];
  pendingAuthorizationsAmount: Money;
  postalCode: Scalars['String']['output'];
  previousUnpaidAmount: Money;
  repaymentPercent: Scalars['Float']['output'];
  repaymentPeriod: MarketingVirtualCardRepaymentPeriodEnum;
  terms: Scalars['String']['output'];
  useSameExpanseDetailsForFee: Scalars['Boolean']['output'];
};

export type MarketingVirtualCardAuthorization = {
  amount: Money;
  createdAt: Scalars['ISO8601Date']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: MarketingVirtualCardAuthorizationStatusEnum;
};

export enum MarketingVirtualCardAuthorizationStatusEnum {
  CLOSED = 'CLOSED',
  PENDING = 'PENDING',
  REVERSED = 'REVERSED'
}

export type MarketingVirtualCardInputObject = {
  accountId: Scalars['ID']['input'];
  accountingAccountId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryClassId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryLocationId?: InputMaybe<Scalars['ID']['input']>;
  accountingMemo?: InputMaybe<Scalars['String']['input']>;
  feeAccountingAccountId?: InputMaybe<Scalars['ID']['input']>;
  feeAccountingCategoryClassId?: InputMaybe<Scalars['ID']['input']>;
  feeAccountingCategoryLocationId?: InputMaybe<Scalars['ID']['input']>;
  feeAccountingMemo?: InputMaybe<Scalars['String']['input']>;
  feeQuickBooksAccountId?: InputMaybe<Scalars['ID']['input']>;
  feeQuickBooksClassId?: InputMaybe<Scalars['ID']['input']>;
  feeQuickBooksLocationId?: InputMaybe<Scalars['ID']['input']>;
  feeQuickBooksMemo?: InputMaybe<Scalars['String']['input']>;
  feeXeroAccountId?: InputMaybe<Scalars['ID']['input']>;
  quickBooksAccountId?: InputMaybe<Scalars['ID']['input']>;
  quickBooksClassId?: InputMaybe<Scalars['ID']['input']>;
  quickBooksLocationId?: InputMaybe<Scalars['ID']['input']>;
  quickBooksMemo?: InputMaybe<Scalars['String']['input']>;
  repaymentPeriod: MarketingVirtualCardRepaymentPeriodEnum;
  useSameExpanseDetailsForFee?: InputMaybe<Scalars['Boolean']['input']>;
  xeroAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export enum MarketingVirtualCardRepaymentPeriodEnum {
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export type MarketingVirtualCardSecure = {
  data: Maybe<MarketingVirtualCardSecureData>;
  reauthenticationRequired: Scalars['Boolean']['output'];
};

export type MarketingVirtualCardSecureData = {
  cvc: Scalars['String']['output'];
  expirationMonth: Scalars['Int']['output'];
  expirationYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export type MarketingVirtualCardTransaction = {
  amount: Money;
  createdAt: Scalars['ISO8601Date']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: MarketingVirtualCardTransactionStatusEnum;
};

export enum MarketingVirtualCardTransactionStatusEnum {
  COMPLETED = 'COMPLETED',
  REFUNDED = 'REFUNDED',
  UNDEFINED = 'UNDEFINED'
}

export type MatchedCatalogItemInputObject = {
  catalogItemId: Scalars['ID']['input'];
  linkableCatalogItemId: Scalars['ID']['input'];
};

export type MatchedLine = {
  /** child lines (variations) */
  children: Array<MatchedLine>;
  /** data for rendering Bill columns */
  invoiceLine: Array<LineItemDetails>;
  /** data for rendering PO columns */
  purchaseOrderLine: Array<LineItemDetails>;
  /** data for rendering Receipt columns */
  receiptLine: Array<LineItemDetails>;
};

export type MatchedLocationInputObject = {
  linkableLocationId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};

export type Membership = {
  /** Should only return null if the membership is deactivated. A null response is not expected in frontend flows. */
  business: Maybe<Business>;
  externalBusiness: Maybe<PublicBusiness>;
  id: Scalars['ID']['output'];
  lastTosAccepted: Maybe<Scalars['ISO8601Date']['output']>;
  role: MembershipRolesEnum;
  roleAccountingAccounts: Maybe<Array<AccountingAccount>>;
  user: Profile;
  userRole: UserRole;
};

export enum MembershipRolesEnum {
  ADMIN = 'ADMIN',
  APPROVER = 'APPROVER',
  CLERK = 'CLERK',
  CLIENT_MANAGER_ADMIN = 'CLIENT_MANAGER_ADMIN',
  CLIENT_MANAGER_TEAM_MEMBER = 'CLIENT_MANAGER_TEAM_MEMBER',
  CUSTOM = 'CUSTOM',
  PAYER = 'PAYER',
  PROCUREMENT = 'PROCUREMENT',
  REGULAR = 'REGULAR',
  VIEWER = 'VIEWER'
}

export type Message = {
  message: Scalars['String']['output'];
};

export type MetabaseEmbedToken = {
  expiresAt: Scalars['ISO8601DateTime']['output'];
  token: Scalars['String']['output'];
};

export type MfaChallenge = PhoneFactorChallenge | TotpChallenge;

export enum MfaEnforcementLevelEnum {
  ADMINS_AND_PAYERS = 'ADMINS_AND_PAYERS',
  ALL = 'ALL'
}

export enum MfaMethod {
  PHONE = 'PHONE',
  TOTP = 'TOTP'
}

export enum MicrodepositsPaymentMethodEnum {
  ACH = 'ACH',
  RTP = 'RTP'
}

export enum MicrodepositsStatusEnum {
  PENDING = 'PENDING',
  VERIFIABLE = 'VERIFIABLE'
}

/** Search results from Middesk Name/State Search API */
export type MiddeskSearch = {
  maxAttemptsReached: Scalars['Boolean']['output'];
  providedInputMatched: Scalars['Boolean']['output'];
  suggestions: Array<MiddeskSearchSuggestion>;
};

/** Middesk search result schema */
export type MiddeskSearchSuggestion = {
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type Milestone = {
  actualDate: Maybe<Scalars['ISO8601Date']['output']>;
  contractedDate: Maybe<Scalars['ISO8601Date']['output']>;
  delayDays: Maybe<Scalars['SafeInt']['output']>;
  externallyConfirmed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  orderingDocument: OrderDocument;
  shipment: Maybe<Shipment>;
  type: MilestoneTypeEnum;
};

export type MilestoneInputObject = {
  actualDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  contractedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export enum MilestoneTypeEnum {
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  ARRIVED = 'ARRIVED',
  CARGO_READY = 'CARGO_READY',
  COMPLETED = 'COMPLETED',
  ISSUED = 'ISSUED',
  PRODUCTION_STARTED = 'PRODUCTION_STARTED',
  SHIPPED = 'SHIPPED'
}

export type Money = {
  cents: Scalars['SafeInt']['output'];
  currency: Scalars['String']['output'];
  currencySymbol: Scalars['String']['output'];
  formatted: Scalars['String']['output'];
  formattedNoCents: Scalars['String']['output'];
  subunitToUnit: Scalars['Int']['output'];
};

export type MoneyInputObject = {
  cents: Scalars['SafeInt']['input'];
  currency: Scalars['String']['input'];
};

export type Mutation = {
  abortDocumentOcr: Maybe<OcrDocument>;
  acceptBusinessMatch: Maybe<LocalBusiness>;
  acceptCreditOffer: Maybe<CreditOffer>;
  acceptInvitation: Maybe<AuthResponse>;
  acceptInvitationAuthenticated: Maybe<Business>;
  /** Create a new TosAcceptance entry for current user/business membership with specified version. */
  acceptTos: Maybe<Membership>;
  acceptVendorInvitation: Maybe<AuthResponse>;
  acceptVendorInvitationAuthenticated: Maybe<Business>;
  activateJourney: Maybe<Journey>;
  activatePhoneFactor: Maybe<ActivatePhoneFactorResponse>;
  activateRuleV2: Maybe<Rule>;
  activateTeamMember: Maybe<TeamMember>;
  activateTotpV2: Maybe<ActivateTotpResponse>;
  addCatalogItemsLabels: Maybe<Array<CatalogItem>>;
  addInvoicesLabels: Maybe<Array<Invoice>>;
  addJourneyV2: Maybe<Array<Journey>>;
  addLocalBusinessesLabels: Maybe<Array<LocalBusiness>>;
  addProductsForLandedCosts: Maybe<Array<LandedCostsProduct>>;
  addPurchaseOrdersLabels: Maybe<Array<PurchaseOrder>>;
  addTeamMemberToClient: Maybe<Scalars['Boolean']['output']>;
  addVendorCredit: Maybe<VendorCredit>;
  allocatePaymentToInvoice: Maybe<Payment>;
  /** @deprecated Use repayEarlyV2 instead */
  amortizedRepayEarly: Maybe<Payment>;
  applyAttachmentTemplateToPurchaseOrder: Maybe<PurchaseOrder>;
  applyAttachmentTemplateToWorkOrder: Maybe<WorkOrder>;
  applyDocumentOcrChanges: Maybe<OcrDocument>;
  applyPromotionCode: Maybe<BillingPromotionCodeType>;
  applyPromotionCodeV2: Maybe<BillingDiscountType>;
  approveInvoiceApprovalRequest: Maybe<Invoice>;
  approvePayment: Maybe<Payment>;
  approvePurchaseOrderApprovalRequest: Maybe<PurchaseOrder>;
  approveReceivableDebit: Maybe<Receivable>;
  archiveCatalogItemProperty: Maybe<CatalogItem>;
  archiveCatalogItemPropertyTemplate: Maybe<CatalogItemProperty>;
  /** @deprecated Use updateLocationArchived instead */
  archiveLocation: Maybe<Location>;
  archiveShipment: Maybe<OrderDocument>;
  archiveUnlinkedCatalogItem: Maybe<Array<LinkableCatalogItem>>;
  archiveUnlinkedLocation: Maybe<Array<LinkableLocation>>;
  /** Upload an additional document to existing invoice */
  attachInvoiceDocument: Maybe<Invoice>;
  attachLocalBusinessDocument: Maybe<Attachment>;
  attachOutboundOrderDocument: Maybe<OutboundOrder>;
  attachPurchaseOrderDocument: Maybe<PurchaseOrder>;
  attachReceiptDocument: Maybe<Receipt>;
  attachVendorCreditDocument: Maybe<VendorCredit>;
  attachW9: Maybe<LocalBusiness>;
  attachWorkOrderDocument: Maybe<WorkOrder>;
  authProviderAcceptInvitation: Maybe<AuthResponse>;
  authProviderAcceptVendorInvitation: Maybe<AuthResponse>;
  authProviderSignIn: Maybe<AuthResponse>;
  authProviderSignUp: Maybe<AuthResponse>;
  batchUpdateManualSalesDetails: CatalogItemUnion;
  bulkPayAsapV2: Maybe<Array<BulkPayBase>>;
  bulkPayOnDateV2: Maybe<Array<BulkPayBase>>;
  bulkPayOnDueDateV2: Maybe<Array<BulkPayBase>>;
  bulkPayToArriveOnDueDate: Maybe<Array<BulkPayBase>>;
  bulkUpdateCatalogItem: Maybe<Array<CatalogItem>>;
  bulkUpdateCatalogItemVariations: Maybe<Array<CatalogItemVariation>>;
  cancelDocumentRequestSteps: Maybe<Array<Journey>>;
  cancelInvoiceApprovalRequest: Maybe<Invoice>;
  cancelJourneyStep: Maybe<Array<Journey>>;
  cancelPurchaseOrderApprovalRequest: Maybe<PurchaseOrder>;
  cancelSubscription: Maybe<Business>;
  cancelVendorFinancing: Maybe<ReceivableInvoice>;
  changeBillingPlan: Maybe<BillingPlanChangeResponseType>;
  changeBulletEptTermLength: Maybe<Payment>;
  changeClientBillingPlan: Maybe<Message>;
  changePayFromAccountRecurrentPayments: Maybe<RecurrentPaymentsSchedule>;
  changePayToAccountRecurrentPayments: Maybe<RecurrentPaymentsSchedule>;
  checkAllocationAllowed: Maybe<Action>;
  clearPayerInvoice: Maybe<Invoice>;
  confirmReceiving: Maybe<OrderDocument>;
  convertVendorIntoPayer: Maybe<Business>;
  copyOrUpdateLocalBusinessAccount: Maybe<LocalBusinessAccount>;
  createAccount: Maybe<Account>;
  createAmortizedLoanPaymentV2: Maybe<Payment>;
  createAttachment: Maybe<Attachment>;
  createAttachmentTemplate: Maybe<AttachedDocumentTemplate>;
  createBeneficialOwnersV2: Maybe<Array<BeneficialOwner>>;
  createBillingMethod: Maybe<BillingMethod>;
  createBomMaterial: Maybe<CatalogItem>;
  createBulletEptExtensionAgreement: Maybe<BulletEptExtensionAgreement>;
  createBulletEptPayment: Maybe<Payment>;
  createBusiness: Maybe<Business>;
  createByNumberPurchaseOrder: Maybe<PurchaseOrder>;
  createCashAdvanceAmortizedLoanPayment: Maybe<Payment>;
  createCashAdvanceBulletEptPayment: Maybe<Payment>;
  createCashAdvanceEptPayment: Maybe<Payment>;
  createCashAdvancePreliminaryAmortizedLoanAgreement: Maybe<Agreement>;
  createCashAdvancePreliminaryBulletEptAgreement: Maybe<Agreement>;
  createCashAdvancePreliminaryEptAgreement: Maybe<Agreement>;
  createCatalogItem: Maybe<CatalogItem>;
  createCatalogItemFromExternalSource: Maybe<Array<LinkableCatalogItem>>;
  createCatalogItemProperty: Maybe<CatalogItem>;
  createCatalogItemPropertyTemplate: Maybe<CatalogItemProperty>;
  createClientBusiness: Maybe<Business>;
  createComment: Maybe<Comment>;
  createConsolidatedAmortizedLoanPayment: Maybe<Payment>;
  createConsolidatedBulletEptPayment: Maybe<Payment>;
  createConsolidatedPayments: Maybe<Array<ConsolidatedPaymentType>>;
  createCreditLimitUpsizeRequest: Maybe<Business>;
  createCustomBomLineItem: Maybe<CatalogItemVariation>;
  createCustomOutboundOrder: Maybe<OutboundOrder>;
  createCustomPurchaseOrder: Maybe<PurchaseOrder>;
  createDeferralRequest: Maybe<Message>;
  createDiscrepancyRule: Maybe<DiscrepancyRule>;
  createDocumentFromReference: Maybe<LinkedDocument>;
  createDocumentReference: Maybe<LinkedDocument>;
  createEmailOptOut: Maybe<EmailOptOut>;
  createExtendedTermPaymentV2: Maybe<Payment>;
  createExternalInboundPayment: Maybe<Payment>;
  createExternalPayment: Maybe<Payment>;
  createFactoringAgreement: Maybe<Agreement>;
  createFromPublicBusiness: Maybe<LocalBusiness>;
  createInvitation: Maybe<CreateInvitationPayload>;
  createInvoiceLineItem: Maybe<Invoice>;
  createInvoiceLineItems: Maybe<Invoice>;
  createInvoicePaymentsForecast: Maybe<ReceivableInvoice>;
  createLabel: Maybe<Label>;
  createLocalBusiness: Maybe<LocalBusiness>;
  createLocalBusinessAccount: Maybe<LocalBusinessAccount>;
  createLocalBusinessForOutboundOrder: Maybe<LocalBusiness>;
  createLocalBusinessShipmentLocation: Maybe<LocalBusinessShipmentLocation>;
  createLocation: Maybe<Location>;
  createLocationFromLinkable: Maybe<Array<LinkableLocation>>;
  createLocationFromLocalBusiness: Maybe<Location>;
  createLocationFromPublicBusiness: Maybe<Location>;
  createManualSalesDetail: Maybe<Array<SalesDetailType>>;
  /** @deprecated Deprecated feature, will be removed after FE cleanup */
  createMarketingVirtualCard: Maybe<MarketingVirtualCard>;
  /** @deprecated Trackstar GRN sync center has been removed */
  createOrderDocumentFromExternalGrn: Maybe<CreateOrderDocumentFromExternalGrnPayload>;
  createOutboundOrderLineItem: Maybe<OutboundOrder>;
  createPayable: Maybe<Invoice>;
  createPayableFromDataAccessToken: Maybe<Invoice>;
  createPayableFromPurchaseOrder: Maybe<Invoice>;
  createPayableFromSettleInbox: Maybe<CreatePayableInvoiceResponse>;
  createPayerInvitation: Maybe<PayerInvitationV2>;
  createPaymentScheduledConfirmation: Maybe<Blob>;
  createPaymentV2: Maybe<Payment>;
  createPaymentsForecast: Maybe<PurchaseOrder>;
  createPhoneFactor: Maybe<CreatePhoneFactorResponse>;
  /** Generates preview or signed agreement for amortized loans in Payments UX 3.0 */
  createPreliminaryAmortizedLoanAgreementV2: Maybe<Agreement>;
  createPreliminaryBulletEptAgreement: Maybe<Agreement>;
  createPreliminaryConsolidatedAmortizedLoanAgreement: Maybe<Agreement>;
  createPreliminaryConsolidatedBulletEptAgreement: Maybe<Agreement>;
  createPreliminaryEptAgreementV2: Maybe<Agreement>;
  createPurchaseDetails: Maybe<Array<PurchaseDetailsType>>;
  createPurchaseOrder: Maybe<PurchaseOrder>;
  createPurchaseOrderAdditionalExpense: Maybe<PurchaseOrder>;
  createPurchaseOrderAmortizedLoanPayment: Maybe<Payment>;
  createPurchaseOrderBulletEptPayment: Maybe<Payment>;
  createPurchaseOrderLineItem: Maybe<PurchaseOrder>;
  createPurchaseOrderLineItems: Maybe<PurchaseOrder>;
  createPurchaseOrderLineItemsGroup: Maybe<PurchaseOrder>;
  createPurchaseOrderPreliminaryAmortizedLoanAgreement: Maybe<Agreement>;
  createPurchaseOrderPreliminaryBulletEptAgreement: Maybe<Agreement>;
  createReceipt: Maybe<Receipt>;
  createReceiptLineItem: Maybe<Receipt>;
  createReceivable: Maybe<Receivable>;
  createReceivableFromSettleInbox: Maybe<CreateReceivableInvoiceResponse>;
  createReceivableInvoice: Maybe<ReceivableInvoice>;
  createReceivableInvoiceFromOutboundOrder: Maybe<ReceivableInvoice>;
  createReceivableInvoiceLineItem: Maybe<ReceivableInvoice>;
  createReceivableInvoices: Array<ReceivableInvoice>;
  createRecurrentPaymentsSchedule: Maybe<RecurrentPaymentsSchedule>;
  createReportSchedule: Maybe<ReportSchedule>;
  createRole: Maybe<UserRole>;
  createRule: Maybe<Rule>;
  createSalesChannel: Maybe<OutboundOrderChannel>;
  createShipment: Maybe<OrderDocument>;
  createShopifyConnector: Maybe<InventoryConnector>;
  createStandalonePayment: Maybe<Payment>;
  createTotp: Maybe<CreateTotpResponse>;
  createUploadedDocument: Maybe<UploadedDocument>;
  createVendorCredit: Maybe<VendorCredit>;
  createVendorCreditFromSettleInbox: Maybe<CreateVendorCreditResponseType>;
  createVendorInvitationLink: Maybe<CreateInvitationLinkPayload>;
  createVendorLeadTime: Maybe<VendorLeadTime>;
  /** @deprecated Use createPaymentsForecast instead */
  createVendorTerm: Maybe<VendorTerms>;
  createVendorTermOption: Maybe<VendorTermOption>;
  createW9FromSettleInbox: Maybe<CreateW9ResponseType>;
  createW9RequestLink: Maybe<CreateW9LinkPayload>;
  createWorkOrder: Maybe<WorkOrder>;
  createWorkOrderAdditionalExpense: Maybe<WorkOrder>;
  createWorkOrderLineItem: Maybe<WorkOrder>;
  deactivateRule: Maybe<Message>;
  deactivateRuleV2: Maybe<Rule>;
  declineTermExtensions: Maybe<Message>;
  deleteAttachment: Maybe<DeletePayload>;
  deleteAttachmentTemplate: Maybe<DeletePayload>;
  deleteBillingMethod: Maybe<BillingMethod>;
  deleteBom: Maybe<CatalogItem>;
  deleteBomLineItem: Maybe<BomLineItem>;
  deleteBomMaterial: Maybe<CatalogItem>;
  deleteBusinessLogo: Maybe<Business>;
  /** Clear out all instances of W9 forms attached to the business. Require BusinessDetailsPermissionsEnum::UPDATE_BUSINESS_DETAILS permission */
  deleteBusinessW9: Maybe<Business>;
  deleteComment: Maybe<DeleteCommentPayload>;
  deleteDiscrepancyRule: Maybe<Scalars['Boolean']['output']>;
  deleteInvoiceAttachment: Maybe<Invoice>;
  deleteInvoiceLineItems: Maybe<Invoice>;
  deleteInvoicePaymentsForecast: Maybe<ReceivableInvoice>;
  deleteInvoices: Maybe<DeletePayload>;
  deleteLabels: Maybe<Message>;
  deleteLocalBusinessAccount: Maybe<Message>;
  deleteLocalBusinessShipmentLocation: Maybe<LocalBusinessShipmentLocation>;
  deleteLocalBusinesses: Maybe<Message>;
  deleteLocationsPermanently: Maybe<DeletePayload>;
  deleteManualSalesDetails: Array<SalesDetailType>;
  /** @deprecated Deprecated feature, will be removed after FE cleanup */
  deleteMarketingVirtualCard: Maybe<Message>;
  deleteOutboundOrder: Maybe<OutboundOrder>;
  deleteOutboundOrderLineItems: Maybe<OutboundOrder>;
  deletePaymentsForecast: Maybe<PurchaseOrder>;
  deletePurchaseDetails: Maybe<DeletePayload>;
  deletePurchaseOrderAdditionalExpense: Maybe<PurchaseOrder>;
  deletePurchaseOrderLineItems: Maybe<PurchaseOrder>;
  deletePurchaseOrderLineItemsGroups: Maybe<PurchaseOrder>;
  deletePurchaseOrdersPermanently: Maybe<DeletePayload>;
  deleteReceiptLineItems: Maybe<Receipt>;
  deleteReceiptsPermanently: Maybe<DeletePayload>;
  deleteReceivable: Maybe<DeletePayload>;
  deleteReceivableInvoiceLineItems: Maybe<ReceivableInvoice>;
  deleteReportSchedule: Scalars['Boolean']['output'];
  deleteRoleV2: Maybe<DeleteRoleResponse>;
  deleteRule: Maybe<Message>;
  deleteSettleInboxMessages: Maybe<DeletePayload>;
  deleteTeamMember: Maybe<Message>;
  deleteVendorCredit: Maybe<DeletePayload>;
  deleteVendorLeadTime: Maybe<DeletePayload>;
  deleteVendorTermOption: Maybe<DeletePayload>;
  deleteW9: Maybe<LocalBusiness>;
  deleteWorkOrderAdditionalExpense: Maybe<WorkOrder>;
  deleteWorkOrderLineItem: Maybe<WorkOrder>;
  deleteWorkOrdersPermanently: Maybe<DeletePayload>;
  disablePhoneFactor: Maybe<Scalars['Boolean']['output']>;
  disablePhoneFactorWithRecoveryCode: Maybe<Scalars['Boolean']['output']>;
  disableTotp: Maybe<Scalars['Boolean']['output']>;
  disableTotpWithRecoveryCode: Maybe<Scalars['Boolean']['output']>;
  discardDocumentOcrChanges: Maybe<OcrDocument>;
  dismissBanner: Maybe<DismissedBanner>;
  dismissSuggestedPayment: Maybe<SuggestedPayment>;
  downloadBillingStatement: Maybe<Blob>;
  downloadClientBillingStatement: Maybe<Blob>;
  downloadClientUpcomingBillingStatement: Maybe<Blob>;
  downloadClientsBillingStatement: Maybe<Blob>;
  downloadOutboundOrderPackingSlip: Maybe<Blob>;
  downloadUpcomingBillingStatement: Maybe<Blob>;
  duplicateInvoice: Maybe<ReceivableInvoice>;
  duplicatePurchaseOrder: Maybe<PurchaseOrder>;
  excludeFromSync: Maybe<Array<SyncObject>>;
  export1099Csv: Maybe<Report>;
  exportApAgingDetails: Maybe<Report>;
  exportApAgingSummary: Maybe<Report>;
  exportCashOutflow: Maybe<Report>;
  exportFactoringAgreements: Maybe<Report>;
  exportInvoicesV2: Maybe<Report>;
  exportLockboxTransactions: Maybe<Report>;
  /** @deprecated Deprecated feature, will be removed after FE cleanup */
  exportMvcTransactions: Maybe<Report>;
  exportMyInvoices: Maybe<Report>;
  exportOutstandingLoans: Maybe<Report>;
  exportOwedToSettle: Maybe<Report>;
  exportPaymentConfirmationsV2: Maybe<Report>;
  exportProductCost: Maybe<Report>;
  exportPurchaseOrders: Maybe<Report>;
  exportPurchaseOrdersWithLineItems: Maybe<Report>;
  exportReceivables: Maybe<Report>;
  exportReconciliationItems: Maybe<Report>;
  exportSignedDocumentsV2: Maybe<Report>;
  exportVendorPaymentConfirmations: Maybe<Report>;
  exportVendors: Maybe<Report>;
  extendPaymentTerm: Maybe<Message>;
  financeInvoice: Maybe<ReceivableInvoice>;
  importBills: Maybe<Array<Invoice>>;
  importHistoricalBills: Maybe<Scalars['Boolean']['output']>;
  importPurchaseOrders: Maybe<Scalars['Boolean']['output']>;
  initiateVerification: Maybe<Account>;
  invitePayer: Maybe<InvitePayerPayload>;
  inviteTeamMember: Maybe<Invitation>;
  inviteVendor: Maybe<InviteVendorPayload>;
  invoicePreview: Maybe<ReceivableInvoice>;
  issueMfaChallengeV2: Maybe<MfaChallenge>;
  itemizeInvoice: Maybe<Invoice>;
  itemizePurchaseOrder: Maybe<PurchaseOrder>;
  linkAuthProvider: Maybe<AuthResponse>;
  linkDocuments: Array<LinkedDocument>;
  linkFinaloop: Maybe<FinaloopState>;
  linkFinicity: Maybe<Array<Account>>;
  linkNetsuite: Maybe<NetsuiteState>;
  linkPaymentToOrderDocument: Maybe<OrderDocument>;
  linkPlaid: Maybe<Array<Account>>;
  linkPurchaseOrderAdditionalExpenseToInvoiceItem: Maybe<PurchaseOrder>;
  linkQuickBooks: Maybe<QuickBooksState>;
  linkShopify: Maybe<ShopifyState>;
  linkWorkOrderAdditionalExpenseToInvoiceItem: Maybe<WorkOrder>;
  linkXero: Maybe<XeroState>;
  manageAssignments: Maybe<Scalars['Boolean']['output']>;
  markAsFixed: Maybe<Array<SyncError>>;
  markBomsAsReviewed: Maybe<Array<CatalogItemVariation>>;
  markCommentsRead: Maybe<Array<Comment>>;
  markInvoicePaid: Maybe<Invoice>;
  markInvoiceUnpaid: Maybe<Invoice>;
  markReceivableInvoicePaid: Maybe<ReceivableInvoice>;
  markReceivableInvoiceSent: Maybe<ReceivableInvoice>;
  mergeUnlinkedCatalogItem: Maybe<Array<LinkableCatalogItem>>;
  mergeUnlinkedLocation: Maybe<Array<LinkableLocation>>;
  mergeWithPublicBusiness: Maybe<LocalBusiness>;
  migrateBusinessAccount: Maybe<Account>;
  /** @deprecated Use changeBillingPlan instead */
  newChangeBillingPlan: Maybe<Message>;
  newPasswordRequest: Maybe<Message>;
  notifyDormantReactivation: Maybe<Message>;
  notifyEptRequest: Maybe<Message>;
  notifyWrongInvoice: Maybe<Message>;
  openPurchaseOrder: Maybe<PurchaseOrder>;
  passwordUpdate: Maybe<Scalars['Boolean']['output']>;
  payNowPayment: Maybe<Payment>;
  previewInvoice: Maybe<Blob>;
  previewReceipt: Maybe<Receipt>;
  processChatMessageFeedback: ChatFeedback;
  processKybDataRequest: Maybe<KybDataRequest>;
  processNaturalLanguageMutation: AiResponsePayload;
  publicApproveExternalRequest: Maybe<ExternalApprovalRequest>;
  publicDeleteLocalBusinessW9: Maybe<PublicLocalBusiness>;
  publicRevokeExternalRequest: Maybe<ExternalApprovalRequest>;
  publicUpdateLocalBusiness: Maybe<PublicLocalBusiness>;
  publicUploadLocalBusinessW9: Maybe<PublicLocalBusiness>;
  purchaseOrderPreview: Maybe<PurchaseOrder>;
  reactivateDormantBusiness: Maybe<Business>;
  reactivateSubscription: Maybe<Business>;
  rejectAllBusinessMatch: Maybe<LocalBusiness>;
  rejectInvoiceApprovalRequest: Maybe<Invoice>;
  rejectPayment: Maybe<Payment>;
  rejectPurchaseOrderApprovalRequest: Maybe<PurchaseOrder>;
  releasePayment: Maybe<Payment>;
  releasePayments: Maybe<Array<Payment>>;
  removeCatalogItemsLabels: Maybe<Array<CatalogItem>>;
  removeInvoicesLabels: Maybe<Array<Invoice>>;
  removeLocalBusinessesLabels: Maybe<Array<LocalBusiness>>;
  removePurchaseOrdersLabels: Maybe<Array<PurchaseOrder>>;
  /** @deprecated Use deletePaymentsForecast instead */
  removeVendorTerm: Maybe<VendorTerms>;
  repayEarlyV2: Maybe<Payment>;
  reportLinkPlaidFailed: Maybe<Message>;
  requestBillingInvoice: Maybe<Blob>;
  requestClientBillingInvoice: Maybe<Blob>;
  requestCustomBillingPlan: Maybe<Message>;
  requestCustomReport: Maybe<Message>;
  requestInvoiceApproval: Maybe<Array<Invoice>>;
  requestPurchaseOrderApproval: Maybe<Array<PurchaseOrder>>;
  requestPurchaseOrderRuleBasedApproval: Maybe<PurchaseOrder>;
  requestReceivableFactoring: Maybe<Receivable>;
  requestRuleBasedApproval: Maybe<Invoice>;
  reschedulePayment: Maybe<Payment>;
  resendPhoneFactorCode: Maybe<ResendPhoneFactorCodeResponse>;
  resetMicrodeposits: Maybe<Business>;
  resolveSuggestedPayment: Maybe<SuggestedPayment>;
  restoreBomLineItem: Maybe<BomLineItem>;
  restoreCatalogItemImages: Maybe<Array<CatalogItem>>;
  restoreCatalogItemVariationImages: Maybe<Array<CatalogItemVariation>>;
  restoreLocalBusiness: Maybe<LocalBusiness>;
  restoreLocalBusinesses: Maybe<Array<LocalBusiness>>;
  restorePaymentDate: Maybe<Payment>;
  retryFailedBillingPayments: Maybe<Message>;
  retryPaymentV2: Maybe<Payment>;
  revokeInvitation: Maybe<Message>;
  revokePayment: Maybe<Payment>;
  revokeReceivableFactoring: Maybe<Receivable>;
  revokeRecurrentPayments: Maybe<RecurrentPaymentsSchedule>;
  scheduleReceivableFactoring: Maybe<Receivable>;
  sendInvoice: Maybe<ReceivableInvoice>;
  sendPurchaseOrderEmail: Maybe<PurchaseOrder>;
  sendW9RequestEmail: Maybe<Array<LocalBusiness>>;
  sendWorkOrder: Maybe<WorkOrder>;
  setBillingMethodDefault: Maybe<BillingMethod>;
  setDesiredWorkingCapital: Maybe<Business>;
  setMfaEnforcementLevel: Maybe<Business>;
  /** Attempts to set the next step for the onboarding flow and advances the state */
  setNextStep: Maybe<FlowUnion>;
  /** Attempts to set the previous step for the onboarding flow */
  setPreviousStep: Maybe<FlowUnion>;
  setRoleV2: Maybe<Array<Membership>>;
  setVendorManufacturingLocation: Maybe<Location>;
  setupCashManagerInflowIntegration: Maybe<CashManagerIntegration>;
  signBulletEptExtensionAgreement: Maybe<BulletEptExtensionAgreement>;
  signIn: Maybe<AuthResponse>;
  signInByToken: Maybe<AuthResponse>;
  signInIssueMfaChallengeV2: Maybe<MfaChallenge>;
  signInResendPhoneFactorCode: Maybe<ResendPhoneFactorCodeResponse>;
  signInWithPhoneFactor: Maybe<AuthResponse>;
  signInWithPhoneFactorRecoveryCode: Maybe<AuthResponse>;
  signInWithTotp: Maybe<AuthResponse>;
  signInWithTotpRecoveryCode: Maybe<AuthResponse>;
  signOut: Maybe<Scalars['Boolean']['output']>;
  signUp: Maybe<AuthResponse>;
  skipMfaSetup: Maybe<SkipMfaSetupPayload>;
  submitSurvey: Maybe<SubmitSubscriptionSurveyResponseType>;
  syncNetsuite: Maybe<NetsuiteState>;
  syncQuickBooks: Maybe<QuickBooksState>;
  syncReceivableInvoiceWithOutboundOrder: Maybe<ReceivableInvoice>;
  syncWithPublicBusiness: Maybe<LocalBusiness>;
  syncXero: Maybe<XeroState>;
  testAutoEptSet: Maybe<Message>;
  testBeneficialOwnersApprove: Maybe<BeneficialOwnersApprovePayload>;
  testBeneficialOwnersDecline: Maybe<BeneficialOwnersDeclinePayload>;
  testBeneficialOwnersStartReview: Maybe<BeneficialOwnersStartReviewPayload>;
  testCancelSubscription: Maybe<Business>;
  testCompleteJourneyStep: Maybe<CompleteJourneyStepPayload>;
  testCreateBusiness: Maybe<CreateBusinessPayload>;
  testCreateDocumentRequestItem: Maybe<CreateDocumentRequestItemPayload>;
  testCreateUser: Maybe<CreateUserPayload>;
  testFraudBusinessReviewApprove: Maybe<FraudBusinessReviewApprovePayload>;
  testLinkPlaid: Maybe<Array<Account>>;
  testMicroDepositsCompleted: Maybe<Account>;
  testPayVendor: Maybe<Payment>;
  testPayerKycOverride: Maybe<Business>;
  testPaymentPaid: Maybe<Payment>;
  testPaymentProcessed: Maybe<Payment>;
  testSeedPendingOcrReview: Maybe<SeedPendingOcrReviewPayload>;
  testSeedSettleInboxMessages: Maybe<SeedSettleInboxMessagesPayload>;
  testSendPayment: Maybe<Payment>;
  testSendReportSchedule: Scalars['Boolean']['output'];
  testSetCatalogItemShopifyImages: Maybe<Array<CatalogItem>>;
  testSetCatalogItemVariationShopifyImages: Maybe<Array<CatalogItemVariation>>;
  testSetupQuickBooksAccountingState: Maybe<SetupQuickBooksAccountingStatePayload>;
  testTriggerAccountingImportStateChanged: Maybe<Scalars['Boolean']['output']>;
  testVendorFinancingCreditLimit: Maybe<Business>;
  triggerDocumentOcr: Maybe<OcrDocument>;
  unapplyVendorCredit: Maybe<Invoice>;
  unlinkDocuments: Array<LinkedDocument>;
  unlinkFinaloop: Maybe<FinaloopState>;
  unlinkFinicity: Maybe<Array<Account>>;
  unlinkNetsuite: Maybe<NetsuiteState>;
  unlinkPaymentFromOrderDocument: Maybe<OrderDocument>;
  unlinkPlaid: Maybe<Array<Account>>;
  unlinkQuickBooks: Maybe<QuickBooksState>;
  unlinkShopify: Maybe<ShopifyState>;
  unlinkXero: Maybe<XeroState>;
  updateAccount: Maybe<Account>;
  updateAccountingAutoImport: Maybe<Integration>;
  updateAccountingDetailsRecurrentPayments: Maybe<RecurrentPaymentsSchedule>;
  updateAppliedVendorCredits: Maybe<Invoice>;
  updateAttachment: Maybe<Attachment>;
  updateAttachmentTemplate: Maybe<AttachedDocumentTemplate>;
  updateBomLineItem: Maybe<BomLineItem>;
  updateBomMaterial: Maybe<CatalogItem>;
  updateBusinessDetails: Maybe<Business>;
  updateBusinessFeatures: Maybe<BusinessFeaturesType>;
  updateBusinessLogo: Maybe<Business>;
  updateBusinessMailingAddress: Maybe<Business>;
  /** Set new W9 form to the business. Require BusinessDetailsPermissionsEnum::UPDATE_BUSINESS_DETAILS permission */
  updateBusinessW9: Maybe<Business>;
  /** @deprecated Use updatePaymentReceivingAccount mutation instead. */
  updateCashAdvancePaymentReceivingAccount: Maybe<Payment>;
  updateCatalogItem: Maybe<CatalogItem>;
  updateCatalogItemProperty: Maybe<CatalogItem>;
  updateCatalogItemPropertyTemplate: Maybe<CatalogItemProperty>;
  updateCatalogItemVariation: Maybe<CatalogItemVariation>;
  updateCatalogItemsArchived: Maybe<Array<CatalogItem>>;
  /** @deprecated Use updatePaymentsForecast instead */
  updateDefaultVendorTerms: Maybe<VendorTerms>;
  updateDiscrepancyRule: Maybe<DiscrepancyRule>;
  updateDocumentReference: Maybe<DocumentReference>;
  updateFinaloopPreferences: Maybe<FinaloopState>;
  updateInternationalDetailsRecurrentPayments: Maybe<RecurrentPaymentsSchedule>;
  updateInvoice: Maybe<Invoice>;
  updateInvoiceAmount: Maybe<Invoice>;
  updateInvoiceExternalAttributes: Maybe<Invoice>;
  updateInvoiceLineItem: Maybe<Invoice>;
  updateInvoicePayableData: Maybe<Invoice>;
  updateInvoicePaymentsForecast: Maybe<ReceivableInvoice>;
  updateInvoicesRead: Maybe<Array<Invoice>>;
  updateLabel: Maybe<Label>;
  updateLocalBusiness: Maybe<LocalBusiness>;
  updateLocalBusinessAccount: Maybe<LocalBusinessAccount>;
  updateLocalBusinessShipmentLocation: Maybe<LocalBusinessShipmentLocation>;
  updateLocalBusinessVisibility: Maybe<LocalBusiness>;
  updateLocation: Maybe<Location>;
  updateLocationArchived: Maybe<Array<Location>>;
  updateLot: Maybe<Lot>;
  /** @deprecated Deprecated feature, will be removed after FE cleanup */
  updateMarketingVirtualCard: Maybe<Message>;
  updateMilestone: Maybe<OrderDocument>;
  updateNetsuitePreferences: Maybe<NetsuiteState>;
  updateNotificationSettings: Maybe<NotificationSettings>;
  updateOrderDocumentLineItemsFromShipments: Maybe<OrderDocument>;
  updateOutboundOrder: Maybe<OutboundOrder>;
  updateOutboundOrderFulfillment: Maybe<OutboundOrderFulfillment>;
  updateOutboundOrderLineItem: Maybe<OutboundOrder>;
  updateOutboundOrdersArchived: Maybe<Array<OutboundOrder>>;
  updatePayablesArchived: Maybe<Array<Invoice>>;
  updatePayerInvitation: Maybe<PayerInvitationV2>;
  updatePaymentAccount: Maybe<Payment>;
  updatePaymentAccountingDetails: Maybe<PaymentAccountingDetailsType>;
  updatePaymentInternationalDetails: Maybe<Payment>;
  updatePaymentMethod: Maybe<Payment>;
  updatePaymentReceivingAccount: Maybe<Payment>;
  updatePaymentsForecast: Maybe<PurchaseOrder>;
  updatePreferredAccounts: Maybe<Business>;
  updatePurchaseDetails: Maybe<Array<PurchaseDetailsType>>;
  updatePurchaseOrder: Maybe<PurchaseOrder>;
  updatePurchaseOrderAdditionalExpense: Maybe<PurchaseOrder>;
  updatePurchaseOrderDiscount: Maybe<PurchaseOrder>;
  updatePurchaseOrderLineItem: Maybe<PurchaseOrder>;
  updatePurchaseOrderLineItemsGroup: Maybe<PurchaseOrder>;
  updatePurchaseOrderLineItemsGroupRow: Maybe<PurchaseOrder>;
  updatePurchaseOrdersArchived: Maybe<Array<PurchaseOrder>>;
  updateQuickBooksPreferences: Maybe<QuickBooksState>;
  updateReceipt: Maybe<Receipt>;
  updateReceiptLineItem: Maybe<Receipt>;
  updateReceiptsArchived: Maybe<Array<Receipt>>;
  updateReceivable: Maybe<Receivable>;
  updateReceivableInvoice: Maybe<ReceivableInvoice>;
  updateReceivableInvoiceDiscount: Maybe<ReceivableInvoice>;
  updateReceivableInvoiceLineItem: Maybe<ReceivableInvoice>;
  updateReceivableInvoiceLineItems: Maybe<ReceivableInvoice>;
  updateReceivablesArchived: Maybe<Array<ReceivableInvoice>>;
  updateReportSchedule: Maybe<ReportSchedule>;
  updateRole: Maybe<UserRole>;
  updateRule: Maybe<Rule>;
  updateSalesChannel: Maybe<OutboundOrderChannel>;
  updateSalesChannelConfigurationStates: Maybe<Array<SalesChannelConfiguration>>;
  updateSettleInboxMessagesArchived: Maybe<Array<SettleInboxMessage>>;
  updateSettleInboxMessagesRead: Maybe<Array<SettleInboxMessage>>;
  updateShipment: Maybe<OrderDocument>;
  /** @deprecated Use upsertShipmentLineItems instead */
  updateShipmentLineItems: Maybe<Array<Shipment>>;
  updateShopifyExportLandedCosts: Maybe<ShopifyState>;
  updateShopifyExportableLocations: Maybe<ShopifyState>;
  updateShopifyIntegrationFeature: Maybe<ShopifyIntegrationFeature>;
  updateUserDetails: Maybe<Profile>;
  updateVendorCredit: Maybe<VendorCredit>;
  updateVendorLeadTime: Maybe<VendorLeadTime>;
  /** @deprecated Use updatePaymentsForecast instead */
  updateVendorTerm: Maybe<PurchaseOrder>;
  updateWorkOrder: Maybe<WorkOrder>;
  updateWorkOrderAdditionalExpense: Maybe<WorkOrder>;
  updateWorkOrderLineItem: Maybe<WorkOrder>;
  updateWorkOrdersArchived: Maybe<Array<WorkOrder>>;
  updateXeroPreferences: Maybe<XeroState>;
  upsertAutopayableConfig: Maybe<SettleInboxAutopayableConfigType>;
  upsertContactDetails: Maybe<ContactDetails>;
  upsertShipmentLineItems: Maybe<Array<Shipment>>;
  validateInternationalWireField: Maybe<RoutingNumberValidation>;
  validateRoutingNumber: Maybe<RoutingNumberValidation>;
  verificationConfirm: Maybe<Profile>;
  verificationRequest: Maybe<Message>;
  verifyAccount: Maybe<Business>;
  viewInvoiceV2: Maybe<Invoice>;
  viewPublicInvoiceV2: Maybe<Invoice>;
  workOrderPreview: Maybe<WorkOrder>;
};


export type MutationabortDocumentOcrArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationacceptBusinessMatchArgs = {
  businessMatchId: Scalars['ID']['input'];
};


export type MutationacceptCreditOfferArgs = {
  creditOfferId: Scalars['ID']['input'];
};


export type MutationacceptInvitationArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  invitationToken: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationacceptInvitationAuthenticatedArgs = {
  invitationToken: Scalars['String']['input'];
};


export type MutationacceptTosArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  effectiveDate: Scalars['ISO8601Date']['input'];
};


export type MutationacceptVendorInvitationArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  invitationToken: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationacceptVendorInvitationAuthenticatedArgs = {
  firstName: Scalars['String']['input'];
  invitationToken: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


export type MutationactivateJourneyArgs = {
  journeyType: JourneyEnum;
};


export type MutationactivatePhoneFactorArgs = {
  code: Scalars['String']['input'];
  mfaToken: Scalars['String']['input'];
};


export type MutationactivateRuleV2Args = {
  ruleId: Scalars['ID']['input'];
};


export type MutationactivateTeamMemberArgs = {
  teamMemberId: Scalars['ID']['input'];
};


export type MutationactivateTotpV2Args = {
  mfaToken: Scalars['String']['input'];
  totpCode: Scalars['String']['input'];
};


export type MutationaddCatalogItemsLabelsArgs = {
  catalogItemIds: Array<Scalars['ID']['input']>;
  labelIds: Array<Scalars['ID']['input']>;
};


export type MutationaddInvoicesLabelsArgs = {
  invoiceIds: Array<Scalars['ID']['input']>;
  labelIds: Array<Scalars['ID']['input']>;
};


export type MutationaddJourneyV2Args = {
  journeyType?: InputMaybe<JourneyEnum>;
  journeyTypes?: InputMaybe<Array<JourneyEnum>>;
};


export type MutationaddLocalBusinessesLabelsArgs = {
  labelIds: Array<Scalars['ID']['input']>;
  localBusinessIds: Array<Scalars['ID']['input']>;
};


export type MutationaddProductsForLandedCostsArgs = {
  items: Array<LandedCostsProductInputObject>;
};


export type MutationaddPurchaseOrdersLabelsArgs = {
  labelIds: Array<Scalars['ID']['input']>;
  purchaseOrderIds: Array<Scalars['ID']['input']>;
};


export type MutationaddTeamMemberToClientArgs = {
  clientBusinessId: Scalars['ID']['input'];
  role?: InputMaybe<MembershipRolesEnum>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  teamMemberId: Scalars['ID']['input'];
};


export type MutationaddVendorCreditArgs = {
  vendorCreditId: Scalars['ID']['input'];
};


export type MutationallocatePaymentToInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
};


export type MutationamortizedRepayEarlyArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationapplyAttachmentTemplateToPurchaseOrderArgs = {
  attachedDocumentTemplateId: Scalars['ID']['input'];
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationapplyAttachmentTemplateToWorkOrderArgs = {
  attachedDocumentTemplateId: Scalars['ID']['input'];
  workOrderId: Scalars['ID']['input'];
};


export type MutationapplyDocumentOcrChangesArgs = {
  documentId: Scalars['ID']['input'];
  fields: Array<DocumentOcrChangeFieldEnum>;
  ocrRecordId: Scalars['ID']['input'];
};


export type MutationapplyPromotionCodeArgs = {
  billingPromotionCodeId: Scalars['ID']['input'];
};


export type MutationapplyPromotionCodeV2Args = {
  billingPromotionCodeId: Scalars['ID']['input'];
};


export type MutationapproveInvoiceApprovalRequestArgs = {
  approvalNote?: InputMaybe<Scalars['String']['input']>;
  approvalOverrideSteps?: InputMaybe<Array<OverrideStepInput>>;
  invoiceId: Scalars['ID']['input'];
};


export type MutationapprovePaymentArgs = {
  approvalNote?: InputMaybe<Scalars['String']['input']>;
  approvalOverrideSteps?: InputMaybe<Array<OverrideStepInput>>;
  paymentId: Scalars['ID']['input'];
};


export type MutationapprovePurchaseOrderApprovalRequestArgs = {
  approvalNote?: InputMaybe<Scalars['String']['input']>;
  approvalOverrideSteps?: InputMaybe<Array<OverrideStepInput>>;
  id: Scalars['ID']['input'];
};


export type MutationapproveReceivableDebitArgs = {
  receivableId: Scalars['ID']['input'];
};


export type MutationarchiveCatalogItemPropertyArgs = {
  propertyId: Scalars['ID']['input'];
};


export type MutationarchiveCatalogItemPropertyTemplateArgs = {
  propertyId: Scalars['ID']['input'];
};


export type MutationarchiveLocationArgs = {
  locationId: Scalars['ID']['input'];
};


export type MutationarchiveShipmentArgs = {
  shipmentId: Scalars['ID']['input'];
};


export type MutationarchiveUnlinkedCatalogItemArgs = {
  linkableCatalogItemIds: Array<Scalars['ID']['input']>;
};


export type MutationarchiveUnlinkedLocationArgs = {
  linkableLocationIds: Array<Scalars['ID']['input']>;
};


export type MutationattachInvoiceDocumentArgs = {
  category?: InputMaybe<AttachmentCategoryEnum>;
  invoiceId: Scalars['ID']['input'];
  uploadSignedId: Scalars['ID']['input'];
};


export type MutationattachLocalBusinessDocumentArgs = {
  category: AttachmentCategoryEnum;
  localBusinessId: Scalars['ID']['input'];
  uploadSignedId: Scalars['ID']['input'];
};


export type MutationattachOutboundOrderDocumentArgs = {
  category?: InputMaybe<AttachmentCategoryEnum>;
  outboundOrderId: Scalars['ID']['input'];
  uploadSignedId: Scalars['ID']['input'];
};


export type MutationattachPurchaseOrderDocumentArgs = {
  category?: InputMaybe<AttachmentCategoryEnum>;
  purchaseOrderId: Scalars['ID']['input'];
  uploadSignedId: Scalars['ID']['input'];
};


export type MutationattachReceiptDocumentArgs = {
  category?: InputMaybe<AttachmentCategoryEnum>;
  receiptId: Scalars['ID']['input'];
  uploadSignedId: Scalars['ID']['input'];
};


export type MutationattachVendorCreditDocumentArgs = {
  uploadSignedId: Scalars['ID']['input'];
  vendorCreditId: Scalars['ID']['input'];
};


export type MutationattachW9Args = {
  attachedDocumentId: Scalars['ID']['input'];
  localBusinessId: Scalars['ID']['input'];
};


export type MutationattachWorkOrderDocumentArgs = {
  category?: InputMaybe<AttachmentCategoryEnum>;
  uploadSignedId: Scalars['ID']['input'];
  workOrderId: Scalars['ID']['input'];
};


export type MutationauthProviderAcceptInvitationArgs = {
  data: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  invitationToken: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  provider: AuthProviderTypeEnum;
};


export type MutationauthProviderAcceptVendorInvitationArgs = {
  data: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  invitationToken: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  provider: AuthProviderTypeEnum;
};


export type MutationauthProviderSignInArgs = {
  data: Scalars['String']['input'];
  provider: AuthProviderTypeEnum;
};


export type MutationauthProviderSignUpArgs = {
  businessStructure?: InputMaybe<BusinessStructureEnum>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  invitationCode: Scalars['String']['input'];
  is1099Eligible?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  partnerDataAccessToken?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  provider: AuthProviderTypeEnum;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationbatchUpdateManualSalesDetailsArgs = {
  catalogItemId: Scalars['ID']['input'];
  salesDetailIdsToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
  skusToAdd?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationbulkPayAsapV2Args = {
  fromAccountId: Scalars['ID']['input'];
  invoices: Array<BulkPayInputObjectV2>;
  paymentMethod: PaymentMethodEnum;
};


export type MutationbulkPayOnDateV2Args = {
  fromAccountId: Scalars['ID']['input'];
  invoices: Array<BulkPayInputObjectV2>;
  paymentMethod: PaymentMethodEnum;
  processDate: Scalars['ISO8601Date']['input'];
};


export type MutationbulkPayOnDueDateV2Args = {
  fromAccountId: Scalars['ID']['input'];
  invoices: Array<BulkPayInputObjectV2>;
  paymentMethod: PaymentMethodEnum;
};


export type MutationbulkPayToArriveOnDueDateArgs = {
  fromAccountId: Scalars['ID']['input'];
  invoices: Array<BulkPayInputObjectV2>;
  paymentMethod: PaymentMethodEnum;
};


export type MutationbulkUpdateCatalogItemArgs = {
  attributes: CatalogItemBulkInputObject;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationbulkUpdateCatalogItemVariationsArgs = {
  attributes: CatalogItemVariationInputObject;
  variationIds: Array<Scalars['ID']['input']>;
};


export type MutationcancelDocumentRequestStepsArgs = {
  documentTypes: Array<DocumentTypeEnum>;
  replacementStepType?: InputMaybe<JourneyStepEnum>;
};


export type MutationcancelInvoiceApprovalRequestArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationcancelJourneyStepArgs = {
  stepType: JourneyStepEnum;
};


export type MutationcancelPurchaseOrderApprovalRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationcancelVendorFinancingArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationchangeBillingPlanArgs = {
  billingPlanId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationchangeBulletEptTermLengthArgs = {
  extensionAgreementId?: InputMaybe<Scalars['ID']['input']>;
  paymentId: Scalars['ID']['input'];
  periods: Scalars['Int']['input'];
};


export type MutationchangeClientBillingPlanArgs = {
  billingPlanId: Scalars['ID']['input'];
  businessId: Scalars['ID']['input'];
};


export type MutationchangePayFromAccountRecurrentPaymentsArgs = {
  payFromAccountId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};


export type MutationchangePayToAccountRecurrentPaymentsArgs = {
  payToAccountId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};


export type MutationcheckAllocationAllowedArgs = {
  invoiceId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
};


export type MutationclearPayerInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationconfirmReceivingArgs = {
  shipmentId: Scalars['ID']['input'];
};


export type MutationcopyOrUpdateLocalBusinessAccountArgs = {
  accountId: Scalars['ID']['input'];
  currency: Scalars['String']['input'];
  migrateInvoices: Scalars['Boolean']['input'];
  wireFields: Array<InternationalWireFieldsDataFieldInputObject>;
};


export type MutationcreateAccountArgs = {
  attributes: AccountInputObject;
  receiving?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationcreateAmortizedLoanPaymentV2Args = {
  caLendingTransitionAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  data: PaymentInputObject;
  invoiceId: Scalars['ID']['input'];
};


export type MutationcreateAttachmentArgs = {
  category: AttachmentCategoryEnum;
  uploadSignedId: Scalars['ID']['input'];
};


export type MutationcreateAttachmentTemplateArgs = {
  appliedToPurchaseOrders?: InputMaybe<Scalars['Boolean']['input']>;
  appliedToWorkOrders?: InputMaybe<Scalars['Boolean']['input']>;
  category: AttachmentCategoryEnum;
  uploadSignedId: Scalars['ID']['input'];
};


export type MutationcreateBeneficialOwnersV2Args = {
  businessBeneficialOwners?: InputMaybe<Array<BusinessBeneficialOwnerInput>>;
  individualBeneficialOwners?: InputMaybe<Array<BeneficialOwnerIndividualInputType>>;
};


export type MutationcreateBillingMethodArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  stripeCardToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateBomMaterialArgs = {
  catalogItemId: Scalars['ID']['input'];
  defaultCatalogItemVariationId?: InputMaybe<Scalars['ID']['input']>;
  defaultQuantity?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};


export type MutationcreateBulletEptExtensionAgreementArgs = {
  paymentId: Scalars['ID']['input'];
  periods: Scalars['Int']['input'];
};


export type MutationcreateBulletEptPaymentArgs = {
  caLendingTransitionAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  data: PaymentInputObject;
  invoiceId: Scalars['ID']['input'];
  periods: Scalars['Int']['input'];
};


export type MutationcreateBusinessArgs = {
  businessStructure: BusinessStructureEnum;
  firstName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<BusinessIndustryEnum>;
  interestedIn?: InputMaybe<Array<SignupInterestsEnum>>;
  is1099Eligible?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateByNumberPurchaseOrderArgs = {
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateCashAdvanceAmortizedLoanPaymentArgs = {
  data: CashAdvancePaymentInputObject;
};


export type MutationcreateCashAdvanceBulletEptPaymentArgs = {
  data: CashAdvancePaymentInputObject;
  periods: Scalars['Int']['input'];
};


export type MutationcreateCashAdvanceEptPaymentArgs = {
  data: CashAdvancePaymentInputObject;
  offerIds: Array<Scalars['ID']['input']>;
};


export type MutationcreateCashAdvancePreliminaryAmortizedLoanAgreementArgs = {
  amount: MoneyInputObject;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationcreateCashAdvancePreliminaryBulletEptAgreementArgs = {
  amount: MoneyInputObject;
  periods: Scalars['Int']['input'];
  signed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationcreateCashAdvancePreliminaryEptAgreementArgs = {
  amount: MoneyInputObject;
  offerIds: Array<Scalars['ID']['input']>;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationcreateCatalogItemArgs = {
  attributes: CatalogItemInputObject;
};


export type MutationcreateCatalogItemFromExternalSourceArgs = {
  linkableCatalogItemIds: Array<Scalars['ID']['input']>;
};


export type MutationcreateCatalogItemPropertyArgs = {
  attributes?: InputMaybe<CatalogItemPropertyInputObject>;
  catalogItemId: Scalars['ID']['input'];
  templateId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationcreateCatalogItemPropertyTemplateArgs = {
  attributes: CatalogItemPropertyInputObject;
};


export type MutationcreateClientBusinessArgs = {
  businessStructure: BusinessStructureEnum;
  firstName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<BusinessIndustryEnum>;
  interestedIn?: InputMaybe<Array<SignupInterestsEnum>>;
  is1099Eligible?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateCommentArgs = {
  attributes: CommentInputObject;
  entityId: Scalars['ID']['input'];
};


export type MutationcreateConsolidatedAmortizedLoanPaymentArgs = {
  caLendingTransitionAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  data: PaymentInputObject;
  members: Array<ConsolidatedPaymentMemberInputObject>;
};


export type MutationcreateConsolidatedBulletEptPaymentArgs = {
  caLendingTransitionAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  data: PaymentInputObject;
  members: Array<ConsolidatedPaymentMemberInputObject>;
  periods: Scalars['Int']['input'];
};


export type MutationcreateConsolidatedPaymentsArgs = {
  fromAccountId: Scalars['ID']['input'];
  onDueDates?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod: PaymentMethodEnum;
  paymentsData: Array<ConsolidatedPaymentInputObject>;
  processDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  toArriveOnDueDate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationcreateCreditLimitUpsizeRequestArgs = {
  amount?: InputMaybe<MoneyInputObject>;
  explanation: Scalars['String']['input'];
  uploadSignedIds: Array<Scalars['ID']['input']>;
};


export type MutationcreateCustomBomLineItemArgs = {
  catalogItemVariationId: Scalars['ID']['input'];
  lineItemVariationId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationcreateCustomOutboundOrderArgs = {
  attributes: OutboundOrdersInputObject;
};


export type MutationcreateCustomPurchaseOrderArgs = {
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationcreateDeferralRequestArgs = {
  data: DeferralsRequestsInputObject;
};


export type MutationcreateDiscrepancyRuleArgs = {
  thresholds: Array<DiscrepancyThresholdInputObject>;
  vendorLocalBusinessId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationcreateDocumentFromReferenceArgs = {
  documentReferenceId: Scalars['ID']['input'];
};


export type MutationcreateDocumentReferenceArgs = {
  documentReferenceData: DocumentReferenceCreateInputObject;
  sourceDocumentId: Scalars['ID']['input'];
};


export type MutationcreateEmailOptOutArgs = {
  optOutToken: Scalars['String']['input'];
};


export type MutationcreateExtendedTermPaymentV2Args = {
  data: PaymentInputObject;
  invoiceId: Scalars['ID']['input'];
  offerIds: Array<Scalars['ID']['input']>;
};


export type MutationcreateExternalInboundPaymentArgs = {
  data: InboundExternalPaymentInputObject;
};


export type MutationcreateExternalPaymentArgs = {
  accountingData?: InputMaybe<PaymentAccountingDetailsInputObject>;
  data: ExternalPaymentInputObject;
};


export type MutationcreateFactoringAgreementArgs = {
  invoiceId: Scalars['ID']['input'];
  signed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationcreateFromPublicBusinessArgs = {
  attributes: LocalBusinessPublicInputObject;
  catalogItemId?: InputMaybe<Scalars['ID']['input']>;
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  publicBusinessId: Scalars['ID']['input'];
  purchaseOrderId?: InputMaybe<Scalars['ID']['input']>;
  receiptId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationcreateInvoiceLineItemArgs = {
  attributes: InvoiceLineItemInputObject;
  invoiceId: Scalars['ID']['input'];
};


export type MutationcreateInvoiceLineItemsArgs = {
  attributes: Array<InvoiceLineItemInputObject>;
  invoiceId: Scalars['ID']['input'];
};


export type MutationcreateInvoicePaymentsForecastArgs = {
  data: PaymentsForecastTableInputObject;
  invoiceId: Scalars['ID']['input'];
};


export type MutationcreateLabelArgs = {
  attributes: LabelInputObject;
};


export type MutationcreateLocalBusinessArgs = {
  accountAttributes?: InputMaybe<LocalBusinessAccountInputObject>;
  attributes: LocalBusinessInputObject;
  catalogItemId?: InputMaybe<Scalars['ID']['input']>;
  customMessage?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  purchaseOrderId?: InputMaybe<Scalars['ID']['input']>;
  receiptId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationcreateLocalBusinessAccountArgs = {
  attributes: LocalBusinessAccountInputObject;
  localBusinessId: Scalars['ID']['input'];
};


export type MutationcreateLocalBusinessForOutboundOrderArgs = {
  attributes: LocalBusinessInputObject;
  outboundOrderId: Scalars['ID']['input'];
};


export type MutationcreateLocalBusinessShipmentLocationArgs = {
  attributes: LocalBusinessShipmentLocationInputObject;
  localBusinessId: Scalars['ID']['input'];
};


export type MutationcreateLocationArgs = {
  attributes: LocationInputObject;
};


export type MutationcreateLocationFromLinkableArgs = {
  linkableLocationIds: Array<Scalars['ID']['input']>;
};


export type MutationcreateLocationFromLocalBusinessArgs = {
  inventoryTransferReceivingId?: InputMaybe<Scalars['ID']['input']>;
  inventoryTransferSendingId?: InputMaybe<Scalars['ID']['input']>;
  localBusinessId: Scalars['ID']['input'];
  purchaseOrderId?: InputMaybe<Scalars['ID']['input']>;
  receiptId?: InputMaybe<Scalars['ID']['input']>;
  shipmentId?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationcreateLocationFromPublicBusinessArgs = {
  attributes: LocalBusinessPublicInputObject;
  inventoryTransferReceivingId?: InputMaybe<Scalars['ID']['input']>;
  inventoryTransferSendingId?: InputMaybe<Scalars['ID']['input']>;
  publicBusinessId: Scalars['ID']['input'];
  purchaseOrderId?: InputMaybe<Scalars['ID']['input']>;
  receiptId?: InputMaybe<Scalars['ID']['input']>;
  shipmentId?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationcreateManualSalesDetailArgs = {
  attributes: CatalogItemsSalesDetailInputObject;
  catalogItemId: Scalars['ID']['input'];
};


export type MutationcreateMarketingVirtualCardArgs = {
  data?: InputMaybe<MarketingVirtualCardInputObject>;
};


export type MutationcreateOrderDocumentFromExternalGrnArgs = {
  attributes: Array<CreateOrderDocumentInputObject>;
};


export type MutationcreateOutboundOrderLineItemArgs = {
  attributes?: InputMaybe<OutboundOrderLineItemInputObject>;
  outboundOrderId: Scalars['ID']['input'];
};


export type MutationcreatePayableArgs = {
  asyncProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderId?: InputMaybe<Scalars['ID']['input']>;
  receiptId?: InputMaybe<Scalars['ID']['input']>;
  uploadSignedId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationcreatePayableFromDataAccessTokenArgs = {
  partnerDataAccessToken: Scalars['String']['input'];
};


export type MutationcreatePayableFromPurchaseOrderArgs = {
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationcreatePayableFromSettleInboxArgs = {
  attributes: PayableInvoiceInputObject;
  settleInboxAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  settleInboxAttachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  settleInboxMessageId: Scalars['ID']['input'];
};


export type MutationcreatePayerInvitationArgs = {
  accountingFirmId?: InputMaybe<Scalars['ID']['input']>;
  billingPromotionCodeId?: InputMaybe<Scalars['ID']['input']>;
  businessType?: InputMaybe<BusinessTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  interestedIn: Array<SignupInterestsEnum>;
  partnerDataAccessToken?: InputMaybe<Scalars['String']['input']>;
  partnerSource?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  shopifyOauthArguments?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreatePaymentScheduledConfirmationArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationcreatePaymentV2Args = {
  data: PaymentInputObject;
  invoiceId: Scalars['ID']['input'];
};


export type MutationcreatePaymentsForecastArgs = {
  data: PaymentsForecastTableInputObject;
  purchaseOrderId: Scalars['ID']['input'];
  updateDefault?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationcreatePhoneFactorArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationcreatePreliminaryAmortizedLoanAgreementV2Args = {
  amount: MoneyInputObject;
  invoiceId: Scalars['ID']['input'];
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  vendorPaymentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type MutationcreatePreliminaryBulletEptAgreementArgs = {
  amount: MoneyInputObject;
  invoiceId: Scalars['ID']['input'];
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  periods: Scalars['Int']['input'];
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  vendorPaymentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type MutationcreatePreliminaryConsolidatedAmortizedLoanAgreementArgs = {
  members: Array<ConsolidatedPaymentMemberInputObject>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  vendorPaymentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type MutationcreatePreliminaryConsolidatedBulletEptAgreementArgs = {
  members: Array<ConsolidatedPaymentMemberInputObject>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  periods: Scalars['Int']['input'];
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  vendorPaymentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type MutationcreatePreliminaryEptAgreementV2Args = {
  amount: MoneyInputObject;
  invoiceId: Scalars['ID']['input'];
  offerIds: Array<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  vendorPaymentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type MutationcreatePurchaseDetailsArgs = {
  attributes: PurchaseDetailsInputObject;
  catalogItemId: Scalars['ID']['input'];
};


export type MutationcreatePurchaseOrderArgs = {
  asyncProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  uploadSignedId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationcreatePurchaseOrderAdditionalExpenseArgs = {
  attributes?: InputMaybe<AdditionalExpenseInputObject>;
  invoiceLineItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationcreatePurchaseOrderAmortizedLoanPaymentArgs = {
  data: PurchaseOrderPaymentInputObject;
};


export type MutationcreatePurchaseOrderBulletEptPaymentArgs = {
  data: PurchaseOrderPaymentInputObject;
  periods: Scalars['Int']['input'];
};


export type MutationcreatePurchaseOrderLineItemArgs = {
  attributes: PurchaseOrderLineItemInputObject;
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationcreatePurchaseOrderLineItemsArgs = {
  attributes: Array<PurchaseOrderLineItemInputObject>;
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationcreatePurchaseOrderLineItemsGroupArgs = {
  attributes: PurchaseOrderLineItemsGroupInputObject;
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationcreatePurchaseOrderPreliminaryAmortizedLoanAgreementArgs = {
  data: PurchaseOrderPreliminaryAgreementInput;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationcreatePurchaseOrderPreliminaryBulletEptAgreementArgs = {
  data: PurchaseOrderPreliminaryAgreementInput;
  periods: Scalars['Int']['input'];
  signed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationcreateReceiptArgs = {
  attributes?: InputMaybe<ReceiptCreateInputObject>;
};


export type MutationcreateReceiptLineItemArgs = {
  attributes: ReceiptLineItemInputObject;
  receiptId: Scalars['ID']['input'];
};


export type MutationcreateReceivableArgs = {
  uploadSignedId: Scalars['ID']['input'];
};


export type MutationcreateReceivableFromSettleInboxArgs = {
  settleInboxAttachmentId: Scalars['ID']['input'];
  settleInboxMessageId: Scalars['ID']['input'];
};


export type MutationcreateReceivableInvoiceFromOutboundOrderArgs = {
  outboundOrderId: Scalars['ID']['input'];
};


export type MutationcreateReceivableInvoiceLineItemArgs = {
  attributes: ReceivableInvoiceLineItemInputObject;
  invoiceId: Scalars['ID']['input'];
};


export type MutationcreateReceivableInvoicesArgs = {
  uploadSignedIds: Array<Scalars['ID']['input']>;
};


export type MutationcreateRecurrentPaymentsScheduleArgs = {
  scheduleData: RecurrentPaymentsScheduleInputObject;
};


export type MutationcreateReportScheduleArgs = {
  input: ReportScheduleInput;
};


export type MutationcreateRoleArgs = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  permissionSets: Array<PermissionSetInputObject>;
};


export type MutationcreateRuleArgs = {
  actions?: InputMaybe<Array<RuleActionInputObject>>;
  conditions?: InputMaybe<Array<RuleConditionInputObject>>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  targetType?: InputMaybe<RuleTypeEnum>;
};


export type MutationcreateSalesChannelArgs = {
  attributes: SalesChannelInputObject;
};


export type MutationcreateShipmentArgs = {
  attributes?: InputMaybe<ShipmentInputObject>;
  orderingDocumentId: Scalars['ID']['input'];
};


export type MutationcreateShopifyConnectorArgs = {
  shopifyOauthArguments?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateStandalonePaymentArgs = {
  data: StandalonePaymentInputObject;
};


export type MutationcreateUploadedDocumentArgs = {
  documentRequestId: Scalars['ID']['input'];
  uploadSignedIds: Array<Scalars['ID']['input']>;
};


export type MutationcreateVendorCreditArgs = {
  uploadSignedId?: InputMaybe<Scalars['ID']['input']>;
  vendorLocalBusinessId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationcreateVendorCreditFromSettleInboxArgs = {
  settleInboxAttachmentId: Scalars['ID']['input'];
  settleInboxMessageId: Scalars['ID']['input'];
};


export type MutationcreateVendorInvitationLinkArgs = {
  localBusinessId: Scalars['ID']['input'];
};


export type MutationcreateVendorLeadTimeArgs = {
  vendorLeadTime: VendorLeadTimeInputObject;
};


export type MutationcreateVendorTermArgs = {
  purchaseOrderId: Scalars['ID']['input'];
  vendorTerm: VendorTermInputObject;
};


export type MutationcreateVendorTermOptionArgs = {
  vendorTermOption: VendorTermOptionInputObject;
};


export type MutationcreateW9FromSettleInboxArgs = {
  settleInboxAttachmentId: Scalars['ID']['input'];
  settleInboxMessageId: Scalars['ID']['input'];
  vendorLocalBusinessId: Scalars['ID']['input'];
};


export type MutationcreateW9RequestLinkArgs = {
  localBusinessId: Scalars['ID']['input'];
};


export type MutationcreateWorkOrderArgs = {
  data?: InputMaybe<WorkOrderInputObject>;
};


export type MutationcreateWorkOrderAdditionalExpenseArgs = {
  attributes?: InputMaybe<AdditionalExpenseInputObject>;
  invoiceLineItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workOrderId: Scalars['ID']['input'];
};


export type MutationcreateWorkOrderLineItemArgs = {
  data?: InputMaybe<WorkOrderLineItemInputObject>;
  workOrderId: Scalars['ID']['input'];
};


export type MutationdeactivateRuleArgs = {
  ruleId: Scalars['ID']['input'];
};


export type MutationdeactivateRuleV2Args = {
  ruleId: Scalars['ID']['input'];
};


export type MutationdeclineTermExtensionsArgs = {
  offerIds: Array<Scalars['ID']['input']>;
  paymentId: Scalars['ID']['input'];
};


export type MutationdeleteAttachmentArgs = {
  attachmentId: Scalars['ID']['input'];
};


export type MutationdeleteAttachmentTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteBillingMethodArgs = {
  billingMethodId: Scalars['ID']['input'];
};


export type MutationdeleteBomArgs = {
  catalogItemId: Scalars['ID']['input'];
};


export type MutationdeleteBomLineItemArgs = {
  lineItemId: Scalars['ID']['input'];
};


export type MutationdeleteBomMaterialArgs = {
  materialId: Scalars['ID']['input'];
};


export type MutationdeleteCommentArgs = {
  commentId: Scalars['ID']['input'];
};


export type MutationdeleteDiscrepancyRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteInvoiceAttachmentArgs = {
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  invoiceId: Scalars['ID']['input'];
};


export type MutationdeleteInvoiceLineItemsArgs = {
  invoiceLineItemIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteInvoicePaymentsForecastArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationdeleteInvoicesArgs = {
  invoiceIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteLabelsArgs = {
  labelIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteLocalBusinessAccountArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationdeleteLocalBusinessShipmentLocationArgs = {
  shipmentLocationId: Scalars['ID']['input'];
};


export type MutationdeleteLocalBusinessesArgs = {
  localBusinessIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteLocationsPermanentlyArgs = {
  locationIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteManualSalesDetailsArgs = {
  catalogItemId: Scalars['ID']['input'];
  salesDetailIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteOutboundOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteOutboundOrderLineItemsArgs = {
  outboundOrderLineItemIds: Array<Scalars['ID']['input']>;
};


export type MutationdeletePaymentsForecastArgs = {
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationdeletePurchaseDetailsArgs = {
  purchaseDetailsIds: Array<Scalars['ID']['input']>;
};


export type MutationdeletePurchaseOrderAdditionalExpenseArgs = {
  expenseId: Scalars['ID']['input'];
};


export type MutationdeletePurchaseOrderLineItemsArgs = {
  purchaseOrderLineItemIds: Array<Scalars['ID']['input']>;
};


export type MutationdeletePurchaseOrderLineItemsGroupsArgs = {
  purchaseOrderLineItemGroupIds: Array<Scalars['ID']['input']>;
};


export type MutationdeletePurchaseOrdersPermanentlyArgs = {
  purchaseOrderIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteReceiptLineItemsArgs = {
  receiptLineItemIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteReceiptsPermanentlyArgs = {
  receiptIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteReceivableArgs = {
  receivableIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteReceivableInvoiceLineItemsArgs = {
  invoiceLineItemIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteReportScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteRoleV2Args = {
  roleId: Scalars['ID']['input'];
  roleIdToAssign?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationdeleteRuleArgs = {
  ruleId: Scalars['ID']['input'];
};


export type MutationdeleteSettleInboxMessagesArgs = {
  settleInboxMessageIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteTeamMemberArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  teamMemberId: Scalars['ID']['input'];
};


export type MutationdeleteVendorCreditArgs = {
  vendorCreditId: Scalars['ID']['input'];
};


export type MutationdeleteVendorLeadTimeArgs = {
  localBusinessId?: InputMaybe<Scalars['ID']['input']>;
  purchaseOrderId?: InputMaybe<Scalars['ID']['input']>;
  vendorLeadTimeIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteVendorTermOptionArgs = {
  vendorTermOptionIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteW9Args = {
  localBusinessId: Scalars['ID']['input'];
};


export type MutationdeleteWorkOrderAdditionalExpenseArgs = {
  additionalExpenseId: Scalars['ID']['input'];
};


export type MutationdeleteWorkOrderLineItemArgs = {
  workOrderLineItemId: Scalars['ID']['input'];
};


export type MutationdeleteWorkOrdersPermanentlyArgs = {
  workOrderIds: Array<Scalars['ID']['input']>;
};


export type MutationdisablePhoneFactorArgs = {
  mfaToken: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};


export type MutationdisablePhoneFactorWithRecoveryCodeArgs = {
  mfaToken: Scalars['String']['input'];
  recoveryCode: Scalars['String']['input'];
};


export type MutationdisableTotpArgs = {
  mfaToken: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};


export type MutationdisableTotpWithRecoveryCodeArgs = {
  mfaToken: Scalars['String']['input'];
  recoveryCode: Scalars['String']['input'];
};


export type MutationdiscardDocumentOcrChangesArgs = {
  documentId: Scalars['ID']['input'];
  ocrRecordId: Scalars['ID']['input'];
};


export type MutationdismissBannerArgs = {
  bannerId: Scalars['String']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationdismissSuggestedPaymentArgs = {
  suggestedPaymentId: Scalars['ID']['input'];
};


export type MutationdownloadBillingStatementArgs = {
  billingInvoiceId: Scalars['ID']['input'];
};


export type MutationdownloadClientBillingStatementArgs = {
  billingInvoiceId: Scalars['ID']['input'];
};


export type MutationdownloadClientUpcomingBillingStatementArgs = {
  clientBusinessId: Scalars['ID']['input'];
};


export type MutationdownloadOutboundOrderPackingSlipArgs = {
  outboundOrderId: Scalars['ID']['input'];
};


export type MutationduplicateInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationduplicatePurchaseOrderArgs = {
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationexcludeFromSyncArgs = {
  excludeFromSync: Scalars['Boolean']['input'];
  syncObjectIds: Array<Scalars['ID']['input']>;
  syncObjectType: SyncObjectTypeEnum;
};


export type Mutationexport1099CsvArgs = {
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationexportApAgingDetailsArgs = {
  asOfDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  includeVendorCredits?: InputMaybe<Scalars['Boolean']['input']>;
  invoicesFilter?: InputMaybe<InvoicesFilteringInputObject>;
};


export type MutationexportApAgingSummaryArgs = {
  asOfDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  invoicesFilter?: InputMaybe<InvoicesFilteringInputObject>;
};


export type MutationexportCashOutflowArgs = {
  apForecastEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  unscheduledBills?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationexportFactoringAgreementsArgs = {
  dateRange?: InputMaybe<DateFilteringInputObject>;
  receivableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationexportInvoicesV2Args = {
  invoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoicesFilter?: InputMaybe<InvoicesFilteringInputObject>;
  sorting?: InputMaybe<InvoiceSortingInputObject>;
};


export type MutationexportLockboxTransactionsArgs = {
  dateRange?: InputMaybe<DateFilteringInputObject>;
};


export type MutationexportMvcTransactionsArgs = {
  dateRange?: InputMaybe<DateFilteringInputObject>;
};


export type MutationexportMyInvoicesArgs = {
  dateRange?: InputMaybe<DateFilteringInputObject>;
};


export type MutationexportOutstandingLoansArgs = {
  asOfDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type MutationexportOwedToSettleArgs = {
  asOfDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type MutationexportPaymentConfirmationsV2Args = {
  dateRange?: InputMaybe<DateFilteringInputObject>;
  invoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoicesFilter?: InputMaybe<InvoicesFilteringInputObject>;
};


export type MutationexportPurchaseOrdersArgs = {
  purchaseOrderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  purchaseOrdersFilter?: InputMaybe<PurchaseOrdersFilteringInputObject>;
};


export type MutationexportPurchaseOrdersWithLineItemsArgs = {
  purchaseOrderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  purchaseOrdersFilter?: InputMaybe<PurchaseOrdersFilteringInputObject>;
};


export type MutationexportReceivablesArgs = {
  dateRange?: InputMaybe<DateFilteringInputObject>;
  receivableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationexportReconciliationItemsArgs = {
  reconciliationItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  reconciliationItemsFilter?: InputMaybe<ReconciliationItemsFilteringInputObject>;
  sorting?: InputMaybe<ReconciliationItemSortingInputObject>;
};


export type MutationexportSignedDocumentsV2Args = {
  dateRange?: InputMaybe<DateFilteringInputObject>;
  documentType: SignedDocumentTypesEnum;
  invoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoicesFilter?: InputMaybe<InvoicesFilteringInputObject>;
};


export type MutationexportVendorPaymentConfirmationsArgs = {
  dateRange?: InputMaybe<DateFilteringInputObject>;
};


export type MutationextendPaymentTermArgs = {
  offerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentId: Scalars['ID']['input'];
};


export type MutationfinanceInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationimportBillsArgs = {
  billIds: Array<Scalars['ID']['input']>;
};


export type MutationimportHistoricalBillsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
};


export type MutationimportPurchaseOrdersArgs = {
  purchaseOrderIds: Array<Scalars['ID']['input']>;
};


export type MutationinitiateVerificationArgs = {
  accountId: Scalars['ID']['input'];
  accountNumber: Scalars['String']['input'];
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  wireRoutingNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationinvitePayerArgs = {
  localBusinessId: Scalars['ID']['input'];
};


export type MutationinviteTeamMemberArgs = {
  accountingAccountIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email: Scalars['String']['input'];
  occupation?: InputMaybe<Scalars['String']['input']>;
  occupationType?: InputMaybe<OccupationEnum>;
  role?: InputMaybe<MembershipRolesEnum>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationinviteVendorArgs = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  localBusinessId: Scalars['ID']['input'];
};


export type MutationinvoicePreviewArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationissueMfaChallengeV2Args = {
  method?: InputMaybe<MfaMethod>;
};


export type MutationitemizeInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationitemizePurchaseOrderArgs = {
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationlinkAuthProviderArgs = {
  data: Scalars['String']['input'];
  provider: AuthProviderTypeEnum;
};


export type MutationlinkDocumentsArgs = {
  linkedDocumentIds: Array<Scalars['ID']['input']>;
  sourceDocumentId: Scalars['ID']['input'];
};


export type MutationlinkFinaloopArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationlinkNetsuiteArgs = {
  accountId: Scalars['String']['input'];
  apiTokenId: Scalars['String']['input'];
  apiTokenSecret: Scalars['String']['input'];
  businessId?: InputMaybe<Scalars['ID']['input']>;
  integrationKey: Scalars['String']['input'];
  integrationSecret: Scalars['String']['input'];
  subsidiaryId: Scalars['String']['input'];
};


export type MutationlinkPaymentToOrderDocumentArgs = {
  orderDocumentId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
};


export type MutationlinkPlaidArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  publicToken: Scalars['String']['input'];
  selectedAccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationlinkPurchaseOrderAdditionalExpenseToInvoiceItemArgs = {
  expenseId: Scalars['ID']['input'];
  invoiceLineItemId: Scalars['ID']['input'];
};


export type MutationlinkQuickBooksArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
};


export type MutationlinkShopifyArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  shopifyOauthArguments: Scalars['String']['input'];
};


export type MutationlinkWorkOrderAdditionalExpenseToInvoiceItemArgs = {
  additionalExpenseId: Scalars['ID']['input'];
  invoiceLineItemId: Scalars['ID']['input'];
};


export type MutationlinkXeroArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
};


export type MutationmanageAssignmentsArgs = {
  accountingAccountIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  accountingFirmId: Scalars['ID']['input'];
  assignments: Array<ClientManagerAssignmentInputObject>;
  clientId: Scalars['ID']['input'];
};


export type MutationmarkAsFixedArgs = {
  markAsFixed: Scalars['Boolean']['input'];
  syncErrorIds: Array<Scalars['ID']['input']>;
};


export type MutationmarkBomsAsReviewedArgs = {
  variationIds: Array<Scalars['ID']['input']>;
};


export type MutationmarkCommentsReadArgs = {
  commentIds: Array<Scalars['ID']['input']>;
};


export type MutationmarkInvoicePaidArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountingAccountId?: InputMaybe<Scalars['ID']['input']>;
  amountCents?: InputMaybe<Scalars['SafeInt']['input']>;
  amountCurrency?: InputMaybe<Scalars['String']['input']>;
  datePaid?: InputMaybe<Scalars['ISO8601Date']['input']>;
  invoiceId: Scalars['ID']['input'];
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
};


export type MutationmarkInvoiceUnpaidArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationmarkReceivableInvoicePaidArgs = {
  datePaid: Scalars['ISO8601Date']['input'];
  invoiceId: Scalars['ID']['input'];
  paymentMethod: PaymentMethodEnum;
};


export type MutationmarkReceivableInvoiceSentArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationmergeUnlinkedCatalogItemArgs = {
  matchedCatalogItems: Array<MatchedCatalogItemInputObject>;
};


export type MutationmergeUnlinkedLocationArgs = {
  matchedLocations: Array<MatchedLocationInputObject>;
};


export type MutationmergeWithPublicBusinessArgs = {
  localBusinessId: Scalars['ID']['input'];
  publicBusinessId: Scalars['ID']['input'];
};


export type MutationmigrateBusinessAccountArgs = {
  accountId: Scalars['ID']['input'];
  newAccountId: Scalars['ID']['input'];
};


export type MutationnewChangeBillingPlanArgs = {
  billingPlanId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationnewPasswordRequestArgs = {
  email: Scalars['String']['input'];
};


export type MutationnotifyEptRequestArgs = {
  invoiceId: Scalars['ID']['input'];
  reason?: InputMaybe<InvoicesEptReasonEnum>;
};


export type MutationnotifyWrongInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationopenPurchaseOrderArgs = {
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationpasswordUpdateArgs = {
  password: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
};


export type MutationpayNowPaymentArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationpreviewInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationpreviewReceiptArgs = {
  receiptId: Scalars['ID']['input'];
};


export type MutationprocessChatMessageFeedbackArgs = {
  parameters: ProcessChatFeedbackInput;
};


export type MutationprocessKybDataRequestArgs = {
  dataRequestInput: KybDataRequestInput;
};


export type MutationprocessNaturalLanguageMutationArgs = {
  parameters: ProcessNaturalLanguageInput;
};


export type MutationpublicApproveExternalRequestArgs = {
  token: Scalars['String']['input'];
};


export type MutationpublicDeleteLocalBusinessW9Args = {
  localBusinessId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type MutationpublicRevokeExternalRequestArgs = {
  token: Scalars['String']['input'];
};


export type MutationpublicUpdateLocalBusinessArgs = {
  address?: InputMaybe<AddressInputObject>;
  attachW9Form?: InputMaybe<Scalars['Boolean']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessStructure?: InputMaybe<BusinessStructureEnum>;
  businessStructureTaxClassification?: InputMaybe<BusinessStructureTaxClassificationEnum>;
  exemptFatcaReportingCode?: InputMaybe<Scalars['String']['input']>;
  exemptPayeeCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  is1099Eligible?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  localBusinessId: Scalars['ID']['input'];
  requestorSignature?: InputMaybe<Scalars['String']['input']>;
  taxpayerId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationpublicUploadLocalBusinessW9Args = {
  localBusinessId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
  uploadSignedId: Scalars['ID']['input'];
};


export type MutationpurchaseOrderPreviewArgs = {
  orientation?: InputMaybe<PdfOrientationEnum>;
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationrejectAllBusinessMatchArgs = {
  businessMatchIds: Array<Scalars['ID']['input']>;
};


export type MutationrejectInvoiceApprovalRequestArgs = {
  approvalOverride?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId: Scalars['ID']['input'];
  rejectionNote?: InputMaybe<Scalars['String']['input']>;
};


export type MutationrejectPaymentArgs = {
  approvalOverride?: InputMaybe<Scalars['Boolean']['input']>;
  paymentId: Scalars['ID']['input'];
  rejectionNote?: InputMaybe<Scalars['String']['input']>;
};


export type MutationrejectPurchaseOrderApprovalRequestArgs = {
  approvalOverride?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  rejectionNote?: InputMaybe<Scalars['String']['input']>;
};


export type MutationreleasePaymentArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationreleasePaymentsArgs = {
  paymentIds: Array<Scalars['ID']['input']>;
};


export type MutationremoveCatalogItemsLabelsArgs = {
  catalogItemIds: Array<Scalars['ID']['input']>;
  labelIds: Array<Scalars['ID']['input']>;
};


export type MutationremoveInvoicesLabelsArgs = {
  invoiceIds: Array<Scalars['ID']['input']>;
  labelIds: Array<Scalars['ID']['input']>;
};


export type MutationremoveLocalBusinessesLabelsArgs = {
  labelIds: Array<Scalars['ID']['input']>;
  localBusinessIds: Array<Scalars['ID']['input']>;
};


export type MutationremovePurchaseOrdersLabelsArgs = {
  labelIds: Array<Scalars['ID']['input']>;
  purchaseOrderIds: Array<Scalars['ID']['input']>;
};


export type MutationremoveVendorTermArgs = {
  id: Scalars['ID']['input'];
  localBusinessId: Scalars['ID']['input'];
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationrepayEarlyV2Args = {
  paymentId: Scalars['ID']['input'];
  repaymentAmount: MoneyInputObject;
  repaymentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type MutationreportLinkPlaidFailedArgs = {
  displayMessage?: InputMaybe<Scalars['String']['input']>;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorType?: InputMaybe<Scalars['String']['input']>;
  institutionId?: InputMaybe<Scalars['String']['input']>;
  linkSessionId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationrequestBillingInvoiceArgs = {
  billingInvoiceId: Scalars['ID']['input'];
};


export type MutationrequestClientBillingInvoiceArgs = {
  billingInvoiceId: Scalars['ID']['input'];
};


export type MutationrequestCustomReportArgs = {
  description: Scalars['String']['input'];
};


export type MutationrequestInvoiceApprovalArgs = {
  condition: RuleActionConditionEnum;
  invoiceIds: Array<Scalars['ID']['input']>;
  requestNote?: InputMaybe<Scalars['String']['input']>;
  values: Array<Scalars['String']['input']>;
};


export type MutationrequestPurchaseOrderApprovalArgs = {
  condition: RuleActionConditionEnum;
  ids: Array<Scalars['ID']['input']>;
  postApprovalWorkflow?: InputMaybe<PurchaseOrderPostApprovalWorkflow>;
  requestNote?: InputMaybe<Scalars['String']['input']>;
  values: Array<Scalars['String']['input']>;
};


export type MutationrequestPurchaseOrderRuleBasedApprovalArgs = {
  id: Scalars['ID']['input'];
  postApprovalWorkflow?: InputMaybe<PurchaseOrderPostApprovalWorkflow>;
  requestNote?: InputMaybe<Scalars['String']['input']>;
};


export type MutationrequestReceivableFactoringArgs = {
  receivableId: Scalars['ID']['input'];
};


export type MutationrequestRuleBasedApprovalArgs = {
  invoiceId: Scalars['ID']['input'];
  requestNote?: InputMaybe<Scalars['String']['input']>;
};


export type MutationreschedulePaymentArgs = {
  paymentId: Scalars['ID']['input'];
  processOn: Scalars['ISO8601Date']['input'];
};


export type MutationresendPhoneFactorCodeArgs = {
  channel?: InputMaybe<PhoneFactorChannel>;
  mfaToken: Scalars['String']['input'];
};


export type MutationresetMicrodepositsArgs = {
  accountId: Scalars['ID']['input'];
  businessId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationresolveSuggestedPaymentArgs = {
  paymentId?: InputMaybe<Scalars['ID']['input']>;
  suggestedPaymentId: Scalars['ID']['input'];
};


export type MutationrestoreBomLineItemArgs = {
  lineItemId: Scalars['ID']['input'];
};


export type MutationrestoreCatalogItemImagesArgs = {
  catalogItemIds: Array<Scalars['ID']['input']>;
};


export type MutationrestoreCatalogItemVariationImagesArgs = {
  variationIds: Array<Scalars['ID']['input']>;
};


export type MutationrestoreLocalBusinessArgs = {
  localBusinessId: Scalars['ID']['input'];
};


export type MutationrestoreLocalBusinessesArgs = {
  localBusinessIds: Array<Scalars['ID']['input']>;
};


export type MutationrestorePaymentDateArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationretryPaymentV2Args = {
  paymentId: Scalars['ID']['input'];
};


export type MutationrevokeInvitationArgs = {
  invitationId: Scalars['ID']['input'];
};


export type MutationrevokePaymentArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationrevokeReceivableFactoringArgs = {
  receivableId: Scalars['ID']['input'];
};


export type MutationrevokeRecurrentPaymentsArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type MutationscheduleReceivableFactoringArgs = {
  ccAddress?: InputMaybe<Scalars['String']['input']>;
  receivableId: Scalars['ID']['input'];
};


export type MutationsendInvoiceArgs = {
  emails: Array<Scalars['String']['input']>;
  includeAdditionalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsendPurchaseOrderEmailArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderId: Scalars['ID']['input'];
  receivingEmails: Array<Scalars['String']['input']>;
  replyToEmail?: InputMaybe<Scalars['String']['input']>;
  secondaryDocumentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationsendW9RequestEmailArgs = {
  data: Array<LocalBusinessEmailInputObject>;
};


export type MutationsendWorkOrderArgs = {
  changeStatusToOpen?: InputMaybe<Scalars['Boolean']['input']>;
  data: WorkOrderEmailInputObject;
  secondaryDocumentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workOrderId: Scalars['ID']['input'];
};


export type MutationsetBillingMethodDefaultArgs = {
  billingMethodId: Scalars['ID']['input'];
};


export type MutationsetDesiredWorkingCapitalArgs = {
  amount: MoneyInputObject;
};


export type MutationsetMfaEnforcementLevelArgs = {
  enforcementLevel?: InputMaybe<MfaEnforcementLevelEnum>;
  method?: InputMaybe<MfaMethod>;
  mfaToken: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};


export type MutationsetNextStepArgs = {
  flowType: FlowTypeEnum;
  nextStep?: InputMaybe<StepEnum>;
};


export type MutationsetPreviousStepArgs = {
  flowType: FlowTypeEnum;
};


export type MutationsetRoleV2Args = {
  accountingAccountIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  businessId?: InputMaybe<Scalars['ID']['input']>;
  roleId: Scalars['ID']['input'];
  teamMemberIds: Array<Scalars['ID']['input']>;
};


export type MutationsetVendorManufacturingLocationArgs = {
  manufacturingLocationId: Scalars['ID']['input'];
  vendorLocalBusinessId: Scalars['ID']['input'];
};


export type MutationsetupCashManagerInflowIntegrationArgs = {
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsignBulletEptExtensionAgreementArgs = {
  extensionAgreementId: Scalars['ID']['input'];
};


export type MutationsignInArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationsignInByTokenArgs = {
  signInToken: Scalars['String']['input'];
};


export type MutationsignInIssueMfaChallengeV2Args = {
  challengeGrant: Scalars['String']['input'];
  channel?: InputMaybe<PhoneFactorChannel>;
  method: MfaMethod;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsignInResendPhoneFactorCodeArgs = {
  channel?: InputMaybe<PhoneFactorChannel>;
  email?: InputMaybe<Scalars['String']['input']>;
  mfaToken: Scalars['String']['input'];
};


export type MutationsignInWithPhoneFactorArgs = {
  code: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  mfaToken: Scalars['String']['input'];
  rememberDevice?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsignInWithPhoneFactorRecoveryCodeArgs = {
  mfaToken: Scalars['ID']['input'];
  recoveryCode: Scalars['String']['input'];
  rememberDevice?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsignInWithTotpArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  mfaToken: Scalars['String']['input'];
  rememberDevice?: InputMaybe<Scalars['Boolean']['input']>;
  totpCode: Scalars['String']['input'];
};


export type MutationsignInWithTotpRecoveryCodeArgs = {
  mfaToken: Scalars['ID']['input'];
  recoveryCode: Scalars['String']['input'];
  rememberDevice?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsignUpArgs = {
  businessStructure?: InputMaybe<BusinessStructureEnum>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  invitationCode: Scalars['String']['input'];
  is1099Eligible?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  partnerDataAccessToken?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationskipMfaSetupArgs = {
  mfaToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsubmitSurveyArgs = {
  changeReason: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  type: SurveyTypeEnum;
};


export type MutationsyncReceivableInvoiceWithOutboundOrderArgs = {
  outboundOrderId: Scalars['ID']['input'];
};


export type MutationsyncWithPublicBusinessArgs = {
  localBusinessId: Scalars['ID']['input'];
  publicBusinessId: Scalars['ID']['input'];
};


export type MutationtestAutoEptSetArgs = {
  amortizedPeriod?: InputMaybe<Scalars['Int']['input']>;
  amortizedPeriods?: InputMaybe<Scalars['Int']['input']>;
  amortizedRate?: InputMaybe<Scalars['Float']['input']>;
  businessId?: InputMaybe<Scalars['ID']['input']>;
  creditLimitCents: Scalars['Int']['input'];
  eptLength?: InputMaybe<Scalars['Int']['input']>;
  eptRate?: InputMaybe<Scalars['Float']['input']>;
  numEptMax?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationtestBeneficialOwnersApproveArgs = {
  beneficialOwnerId: Scalars['ID']['input'];
};


export type MutationtestBeneficialOwnersDeclineArgs = {
  beneficialOwnerId: Scalars['ID']['input'];
};


export type MutationtestBeneficialOwnersStartReviewArgs = {
  beneficialOwnerId: Scalars['ID']['input'];
};


export type MutationtestCompleteJourneyStepArgs = {
  businessId: Scalars['ID']['input'];
  stepType: JourneyStepEnum;
};


export type MutationtestCreateBusinessArgs = {
  companyName: Scalars['String']['input'];
  traits?: InputMaybe<Array<BusinessTraitsEnum>>;
};


export type MutationtestCreateDocumentRequestItemArgs = {
  beneficialOwnerId?: InputMaybe<Scalars['ID']['input']>;
  category: DocumentCategoryEnum;
};


export type MutationtestCreateUserArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  businessIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  traits?: InputMaybe<Array<UserTraitsEnum>>;
};


export type MutationtestFraudBusinessReviewApproveArgs = {
  businessId: Scalars['ID']['input'];
};


export type MutationtestLinkPlaidArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationtestMicroDepositsCompletedArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationtestPayVendorArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationtestPayerKycOverrideArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationtestPaymentPaidArgs = {
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  paymentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationtestPaymentProcessedArgs = {
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  paymentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationtestSeedPendingOcrReviewArgs = {
  amount?: InputMaybe<MoneyInputObject>;
  documentId: Scalars['ID']['input'];
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  issueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationtestSeedSettleInboxMessagesArgs = {
  businessId: Scalars['ID']['input'];
  messages: Array<TestSettleInboxMessageInputObject>;
};


export type MutationtestSendPaymentArgs = {
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  paymentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationtestSendReportScheduleArgs = {
  input: ReportScheduleTestSendInput;
};


export type MutationtestSetCatalogItemShopifyImagesArgs = {
  catalogItemIds: Array<Scalars['ID']['input']>;
  imageManagedManually?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationtestSetCatalogItemVariationShopifyImagesArgs = {
  imageManagedManually?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  variationIds: Array<Scalars['ID']['input']>;
};


export type MutationtestSetupQuickBooksAccountingStateArgs = {
  accounts?: InputMaybe<Array<TestAccountingAccountInput>>;
  classes?: InputMaybe<Array<Scalars['String']['input']>>;
  customersAndProjects?: InputMaybe<Array<TestCustomerOrProjectInput>>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationtestVendorFinancingCreditLimitArgs = {
  businessId: Scalars['ID']['input'];
  creditLimitCents: Scalars['Int']['input'];
  expirationDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type MutationtriggerDocumentOcrArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationunapplyVendorCreditArgs = {
  invoiceId: Scalars['ID']['input'];
  vendorCreditId: Scalars['ID']['input'];
};


export type MutationunlinkDocumentsArgs = {
  sourceDocumentId: Scalars['ID']['input'];
  unlinkedDocumentIds: Array<Scalars['ID']['input']>;
};


export type MutationunlinkFinicityArgs = {
  finicityConnectionId: Scalars['ID']['input'];
};


export type MutationunlinkPaymentFromOrderDocumentArgs = {
  orderDocumentId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
};


export type MutationunlinkPlaidArgs = {
  plaidConnectionId: Scalars['ID']['input'];
};


export type MutationunlinkShopifyArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  clearRelatedData?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationupdateAccountArgs = {
  accountId: Scalars['ID']['input'];
  accountType?: InputMaybe<AccountTypeEnum>;
  accountingAccountId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  quickBooksAccountId?: InputMaybe<Scalars['ID']['input']>;
  wireFields?: InputMaybe<Array<InternationalWireFieldsDataFieldInputObject>>;
  xeroAccountId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationupdateAccountingAutoImportArgs = {
  autoImportBills?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationupdateAccountingDetailsRecurrentPaymentsArgs = {
  accountingDetails: PaymentAccountingDetailsInputObject;
  scheduleId: Scalars['ID']['input'];
};


export type MutationupdateAppliedVendorCreditsArgs = {
  invoiceId: Scalars['ID']['input'];
  scheduledFor?: InputMaybe<Scalars['ISO8601Date']['input']>;
  vendorCreditApplications: Array<VendorCreditApplicationInputObject>;
};


export type MutationupdateAttachmentArgs = {
  attachmentId: Scalars['ID']['input'];
  category?: InputMaybe<AttachmentCategoryEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationupdateAttachmentTemplateArgs = {
  appliedToPurchaseOrders?: InputMaybe<Scalars['Boolean']['input']>;
  appliedToWorkOrders?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  localBusinessIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  templateScope?: InputMaybe<AttachedDocumentTemplateScopeEnum>;
};


export type MutationupdateBomLineItemArgs = {
  catalogItemVariationId?: InputMaybe<Scalars['ID']['input']>;
  lineItemId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationupdateBomMaterialArgs = {
  defaultCatalogItemVariationId?: InputMaybe<Scalars['ID']['input']>;
  defaultQuantity?: InputMaybe<Scalars['Float']['input']>;
  materialId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationupdateBusinessDetailsArgs = {
  address?: InputMaybe<AddressInputObject>;
  attachW9Form?: InputMaybe<Scalars['Boolean']['input']>;
  bankAccount?: InputMaybe<LocalBusinessAccountInputObject>;
  businessStructure?: InputMaybe<BusinessStructureEnum>;
  businessStructureTaxClassification?: InputMaybe<BusinessStructureTaxClassificationEnum>;
  doingBusinessAsNames?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  exemptFatcaReportingCode?: InputMaybe<Scalars['String']['input']>;
  exemptPayeeCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<BusinessIndustryEnum>;
  inputStateOfFormation?: InputMaybe<Scalars['String']['input']>;
  is1099Eligible?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<AddressInputObject>;
  mainUboPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  mcc?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredPayingAccountId?: InputMaybe<Scalars['ID']['input']>;
  preferredReceivingAccountId?: InputMaybe<Scalars['ID']['input']>;
  prohibitedIndustryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  requestorSignature?: InputMaybe<Scalars['String']['input']>;
  taxpayerId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationupdateBusinessFeaturesArgs = {
  features: BusinessFeaturesInputObject;
};


export type MutationupdateBusinessLogoArgs = {
  uploadSignedId: Scalars['ID']['input'];
};


export type MutationupdateBusinessMailingAddressArgs = {
  mailingAddress: AddressInputObject;
};


export type MutationupdateBusinessW9Args = {
  exemptFatcaReportingCode?: InputMaybe<Scalars['String']['input']>;
  exemptPayeeCode?: InputMaybe<Scalars['String']['input']>;
  requestorSignature?: InputMaybe<Scalars['String']['input']>;
  uploadSignedId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationupdateCashAdvancePaymentReceivingAccountArgs = {
  accountId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
};


export type MutationupdateCatalogItemArgs = {
  attributes: CatalogItemInputObject;
  id: Scalars['ID']['input'];
};


export type MutationupdateCatalogItemPropertyArgs = {
  attributes: CatalogItemPropertyInputObject;
  propertyId: Scalars['ID']['input'];
};


export type MutationupdateCatalogItemPropertyTemplateArgs = {
  attributes: CatalogItemPropertyInputObject;
  propertyId: Scalars['ID']['input'];
};


export type MutationupdateCatalogItemVariationArgs = {
  attributes: CatalogItemVariationInputObject;
  variationId: Scalars['ID']['input'];
};


export type MutationupdateCatalogItemsArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  catalogItemIds: Array<Scalars['ID']['input']>;
};


export type MutationupdateDefaultVendorTermsArgs = {
  default: Scalars['Boolean']['input'];
  localBusinessId: Scalars['ID']['input'];
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationupdateDiscrepancyRuleArgs = {
  id: Scalars['ID']['input'];
  thresholds: Array<DiscrepancyThresholdInputObject>;
  vendorLocalBusinessId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationupdateDocumentReferenceArgs = {
  documentReferenceData: DocumentReferenceUpdateInputObject;
  documentReferenceId: Scalars['ID']['input'];
};


export type MutationupdateFinaloopPreferencesArgs = {
  pullFinancials: Scalars['Boolean']['input'];
};


export type MutationupdateInternationalDetailsRecurrentPaymentsArgs = {
  purposeCode?: InputMaybe<Scalars['String']['input']>;
  scheduleId: Scalars['ID']['input'];
};


export type MutationupdateInvoiceArgs = {
  invoiceData: InvoiceInputObject;
  invoiceId: Scalars['ID']['input'];
  paperCheckDetails?: InputMaybe<PaperCheckDetailsInputObject>;
};


export type MutationupdateInvoiceAmountArgs = {
  amount: MoneyInputObject;
  invoiceId: Scalars['ID']['input'];
};


export type MutationupdateInvoiceExternalAttributesArgs = {
  accountingCategoryClassId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryDepartmentId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryLocationId?: InputMaybe<Scalars['ID']['input']>;
  accountingMemo?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
  lineItems?: InputMaybe<Array<InvoiceLineItemInputObject>>;
  paymentAccountingAccountId?: InputMaybe<Scalars['ID']['input']>;
  quickbooksLocationId?: InputMaybe<Scalars['ID']['input']>;
  quickbooksMemo?: InputMaybe<Scalars['String']['input']>;
  quickbooksPaymentAccountId?: InputMaybe<Scalars['ID']['input']>;
  xeroPaymentAccountId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationupdateInvoiceLineItemArgs = {
  attributes: InvoiceLineItemInputObject;
  invoiceLineItemId: Scalars['ID']['input'];
};


export type MutationupdateInvoicePayableDataArgs = {
  invoiceId: Scalars['ID']['input'];
  payableData: InvoicePayableDataInputObject;
};


export type MutationupdateInvoicePaymentsForecastArgs = {
  data: PaymentsForecastTableInputObject;
  invoiceId: Scalars['ID']['input'];
};


export type MutationupdateInvoicesReadArgs = {
  invoiceIds: Array<Scalars['ID']['input']>;
  read: Scalars['Boolean']['input'];
};


export type MutationupdateLabelArgs = {
  attributes: LabelInputObject;
  labelId: Scalars['ID']['input'];
};


export type MutationupdateLocalBusinessArgs = {
  accountAttributes?: InputMaybe<LocalBusinessAccountInputObject>;
  attributes: LocalBusinessInputObject;
  localBusinessId: Scalars['ID']['input'];
};


export type MutationupdateLocalBusinessAccountArgs = {
  accountId: Scalars['ID']['input'];
  attributes: LocalBusinessAccountInputObject;
};


export type MutationupdateLocalBusinessShipmentLocationArgs = {
  attributes: LocalBusinessShipmentLocationInputObject;
  shipmentLocationId: Scalars['ID']['input'];
};


export type MutationupdateLocalBusinessVisibilityArgs = {
  localBusinessId: Scalars['ID']['input'];
  visible: Scalars['Boolean']['input'];
};


export type MutationupdateLocationArgs = {
  attributes: LocationInputObject;
  locationId: Scalars['ID']['input'];
};


export type MutationupdateLocationArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  locationIds: Array<Scalars['ID']['input']>;
};


export type MutationupdateLotArgs = {
  attributes: LotInputObject;
  id: Scalars['ID']['input'];
};


export type MutationupdateMarketingVirtualCardArgs = {
  data: MarketingVirtualCardInputObject;
};


export type MutationupdateMilestoneArgs = {
  attributes: MilestoneInputObject;
  milestoneId: Scalars['ID']['input'];
};


export type MutationupdateNetsuitePreferencesArgs = {
  accountMappings: Array<NetsuiteAccountMappingInputObject>;
  feeExpensesAccountId?: InputMaybe<Scalars['ID']['input']>;
  prepaymentsAccountId?: InputMaybe<Scalars['ID']['input']>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  receivableBankAccountId?: InputMaybe<Scalars['ID']['input']>;
  settleLiabilityAccountId?: InputMaybe<Scalars['ID']['input']>;
  standalonePaymentsExpensesAccountId?: InputMaybe<Scalars['ID']['input']>;
  syncAutomatically: Scalars['Boolean']['input'];
  syncStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  syncUncategorizedExpenses?: InputMaybe<Scalars['Boolean']['input']>;
  unallocatedExpensesAccountId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationupdateNotificationSettingsArgs = {
  notificationSettings: NotificationSettingsInputObject;
};


export type MutationupdateOrderDocumentLineItemsFromShipmentsArgs = {
  orderDocumentId: Scalars['ID']['input'];
};


export type MutationupdateOutboundOrderArgs = {
  attributes: OutboundOrdersInputObject;
  id: Scalars['ID']['input'];
};


export type MutationupdateOutboundOrderFulfillmentArgs = {
  attributes: OutboundOrderFulfillmentInputObject;
  id: Scalars['ID']['input'];
};


export type MutationupdateOutboundOrderLineItemArgs = {
  attributes: OutboundOrderLineItemInputObject;
  outboundOrderLineItemId: Scalars['ID']['input'];
};


export type MutationupdateOutboundOrdersArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  outboundOrderIds: Array<Scalars['ID']['input']>;
};


export type MutationupdatePayablesArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  invoiceIds: Array<Scalars['ID']['input']>;
};


export type MutationupdatePayerInvitationArgs = {
  approximateRevenue?: InputMaybe<Scalars['String']['input']>;
  bankAccountLocation?: InputMaybe<Scalars['String']['input']>;
  billingPromotionCodeId?: InputMaybe<Scalars['ID']['input']>;
  businessIndustry?: InputMaybe<BusinessIndustryEnum>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<BusinessTypeEnum>;
  countryOfRegistration?: InputMaybe<Scalars['String']['input']>;
  desiredWorkingCapitalCents?: InputMaybe<Scalars['SafeInt']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  interestedIn?: InputMaybe<Array<SignupInterestsEnum>>;
  invitationCode: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  prohibitedIndustryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  referredFrom?: InputMaybe<ReferralSourceEnum>;
  source?: InputMaybe<Scalars['String']['input']>;
  userOccupation?: InputMaybe<OccupationEnum>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationupdatePaymentAccountArgs = {
  accountId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
};


export type MutationupdatePaymentAccountingDetailsArgs = {
  accountingDetails: PaymentAccountingDetailsInputObject;
  paymentId: Scalars['ID']['input'];
};


export type MutationupdatePaymentInternationalDetailsArgs = {
  paymentId: Scalars['ID']['input'];
  purposeCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationupdatePaymentMethodArgs = {
  paymentId: Scalars['ID']['input'];
  paymentMethod: PaymentMethodEnum;
};


export type MutationupdatePaymentReceivingAccountArgs = {
  accountId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
};


export type MutationupdatePaymentsForecastArgs = {
  data: PaymentsForecastTableInputObject;
  purchaseOrderId: Scalars['ID']['input'];
  updateDefault?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationupdatePreferredAccountsArgs = {
  preferredPayingAccountId?: InputMaybe<Scalars['ID']['input']>;
  preferredReceivingAccountId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationupdatePurchaseDetailsArgs = {
  attributes: PurchaseDetailsInputObject;
  purchaseDetailsIds: Array<Scalars['ID']['input']>;
};


export type MutationupdatePurchaseOrderArgs = {
  purchaseOrderData?: InputMaybe<PurchaseOrderInputObject>;
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationupdatePurchaseOrderAdditionalExpenseArgs = {
  attributes: AdditionalExpenseInputObject;
  expenseId: Scalars['ID']['input'];
};


export type MutationupdatePurchaseOrderDiscountArgs = {
  discountAttributes: PurchaseOrderDiscountInputObject;
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationupdatePurchaseOrderLineItemArgs = {
  attributes: PurchaseOrderLineItemInputObject;
  purchaseOrderLineItemId: Scalars['ID']['input'];
};


export type MutationupdatePurchaseOrderLineItemsGroupArgs = {
  attributes: PurchaseOrderLineItemsGroupInputObject;
  purchaseOrderLineItemGroupId: Scalars['ID']['input'];
};


export type MutationupdatePurchaseOrderLineItemsGroupRowArgs = {
  data: Array<PurchaseOrderLineItemsGroupRowsUpdateInputObject>;
  purchaseOrderLineItemGroupId: Scalars['ID']['input'];
};


export type MutationupdatePurchaseOrdersArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  purchaseOrderIds: Array<Scalars['ID']['input']>;
};


export type MutationupdateQuickBooksPreferencesArgs = {
  accountMappings: Array<QuickBooksAccountMappingInputObject>;
  feeExpensesAccountId?: InputMaybe<Scalars['ID']['input']>;
  prepaymentsAccountId?: InputMaybe<Scalars['ID']['input']>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  receivableBankAccountId?: InputMaybe<Scalars['ID']['input']>;
  settleLiabilityAccountId?: InputMaybe<Scalars['ID']['input']>;
  standalonePaymentsExpensesAccountId?: InputMaybe<Scalars['ID']['input']>;
  syncAutomatically: Scalars['Boolean']['input'];
  syncStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  syncUncategorizedExpenses?: InputMaybe<Scalars['Boolean']['input']>;
  trackClasses: Scalars['Boolean']['input'];
  trackLocations: Scalars['Boolean']['input'];
  unallocatedExpensesAccountId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationupdateReceiptArgs = {
  receiptData?: InputMaybe<ReceiptInputObject>;
  receiptId: Scalars['ID']['input'];
};


export type MutationupdateReceiptLineItemArgs = {
  attributes: ReceiptLineItemInputObject;
  receiptLineItemId: Scalars['ID']['input'];
};


export type MutationupdateReceiptsArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  receiptIds: Array<Scalars['ID']['input']>;
};


export type MutationupdateReceivableArgs = {
  data: ReceivableInputObject;
  receivableId: Scalars['ID']['input'];
};


export type MutationupdateReceivableInvoiceArgs = {
  invoiceData: ReceivableInvoiceInputObject;
  invoiceId: Scalars['ID']['input'];
};


export type MutationupdateReceivableInvoiceDiscountArgs = {
  discountAttributes: PurchaseOrderDiscountInputObject;
  invoiceId: Scalars['ID']['input'];
};


export type MutationupdateReceivableInvoiceLineItemArgs = {
  attributes: ReceivableInvoiceLineItemInputObject;
  invoiceLineItemId: Scalars['ID']['input'];
};


export type MutationupdateReceivableInvoiceLineItemsArgs = {
  invoiceId: Scalars['ID']['input'];
  lineItems: Array<ReceivableLineItemInputObject>;
};


export type MutationupdateReceivablesArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  invoiceIds: Array<Scalars['ID']['input']>;
};


export type MutationupdateReportScheduleArgs = {
  id: Scalars['ID']['input'];
  input: ReportScheduleInput;
};


export type MutationupdateRoleArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissionSets?: InputMaybe<Array<PermissionSetInputObject>>;
  roleId: Scalars['ID']['input'];
};


export type MutationupdateRuleArgs = {
  actions?: InputMaybe<Array<RuleActionInputObject>>;
  conditions?: InputMaybe<Array<RuleConditionInputObject>>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  ruleId: Scalars['ID']['input'];
  targetType?: InputMaybe<RuleTypeEnum>;
};


export type MutationupdateSalesChannelArgs = {
  attributes: SalesChannelInputObject;
  salesChannelId: Scalars['ID']['input'];
};


export type MutationupdateSalesChannelConfigurationStatesArgs = {
  configurations: Array<SalesChannelConfigurationInputObject>;
};


export type MutationupdateSettleInboxMessagesArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  settleInboxMessageIds: Array<Scalars['ID']['input']>;
};


export type MutationupdateSettleInboxMessagesReadArgs = {
  read?: InputMaybe<Scalars['Boolean']['input']>;
  settleInboxMessageIds: Array<Scalars['ID']['input']>;
};


export type MutationupdateShipmentArgs = {
  attributes: ShipmentInputObject;
  shipmentId: Scalars['ID']['input'];
};


export type MutationupdateShipmentLineItemsArgs = {
  attributes?: InputMaybe<Array<ShipmentLineItemInputObject>>;
};


export type MutationupdateShopifyExportLandedCostsArgs = {
  businessId: Scalars['ID']['input'];
  exportLandedCosts: Scalars['Boolean']['input'];
};


export type MutationupdateShopifyExportableLocationsArgs = {
  locationIds: Array<Scalars['ID']['input']>;
};


export type MutationupdateShopifyIntegrationFeatureArgs = {
  featureId: Scalars['ID']['input'];
  permission: ShopifyFeaturePermissionEnum;
};


export type MutationupdateUserDetailsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationupdateVendorCreditArgs = {
  vendorCreditData: VendorCreditInputObject;
  vendorCreditId: Scalars['ID']['input'];
};


export type MutationupdateVendorLeadTimeArgs = {
  id: Scalars['ID']['input'];
  vendorLeadTime: VendorLeadTimeInputObject;
};


export type MutationupdateVendorTermArgs = {
  purchaseOrderId: Scalars['ID']['input'];
  vendorTerm: VendorTermInputObject;
};


export type MutationupdateWorkOrderArgs = {
  data: WorkOrderInputObject;
  workOrderId: Scalars['ID']['input'];
};


export type MutationupdateWorkOrderAdditionalExpenseArgs = {
  additionalExpenseId: Scalars['ID']['input'];
  attributes: AdditionalExpenseInputObject;
};


export type MutationupdateWorkOrderLineItemArgs = {
  data: WorkOrderLineItemInputObject;
  workOrderLineItemId: Scalars['ID']['input'];
};


export type MutationupdateWorkOrdersArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  workOrderIds: Array<Scalars['ID']['input']>;
};


export type MutationupdateXeroPreferencesArgs = {
  accountMappings: Array<XeroAccountMappingInputObject>;
  feeExpensesAccountId?: InputMaybe<Scalars['ID']['input']>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  settleLiabilityAccountId?: InputMaybe<Scalars['ID']['input']>;
  syncAutomatically: Scalars['Boolean']['input'];
  syncStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  syncUncategorizedExpenses?: InputMaybe<Scalars['Boolean']['input']>;
  unallocatedExpensesAccountId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationupsertAutopayableConfigArgs = {
  allowlistEmails: Array<Scalars['String']['input']>;
};


export type MutationupsertContactDetailsArgs = {
  attributes: ContactDetailsInputObject;
  contactDetailsId?: InputMaybe<Scalars['ID']['input']>;
  targetObjectId: Scalars['ID']['input'];
  targetObjectType: ContactDetailsTargetTypeEnum;
};


export type MutationupsertShipmentLineItemsArgs = {
  attributes?: InputMaybe<Array<ShipmentLineItemInputObject>>;
};


export type MutationvalidateInternationalWireFieldArgs = {
  wireField: InternationalWireFieldsDataFieldInputObject;
};


export type MutationvalidateRoutingNumberArgs = {
  routingNumber: Scalars['String']['input'];
};


export type MutationverificationConfirmArgs = {
  verificationToken: Scalars['String']['input'];
};


export type MutationverificationRequestArgs = {
  payerOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationverifyAccountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  amountCents1: Scalars['Int']['input'];
  amountCents2: Scalars['Int']['input'];
};


export type MutationviewInvoiceV2Args = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationviewPublicInvoiceV2Args = {
  uuid: Scalars['String']['input'];
};


export type MutationworkOrderPreviewArgs = {
  workOrderId: Scalars['ID']['input'];
};

export type NetsuiteAccountMapping = {
  accountId: Scalars['ID']['output'];
  externalAccountId: Maybe<Scalars['ID']['output']>;
  netsuiteAccountId: Maybe<Scalars['ID']['output']>;
};

export type NetsuiteAccountMappingInputObject = {
  accountId: Scalars['ID']['input'];
  externalAccountId?: InputMaybe<Scalars['ID']['input']>;
  netsuiteAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type NetsuiteState = {
  accountMappings: Array<NetsuiteAccountMapping>;
  accounts: Array<AccountingAccount>;
  analyticsConnected: Scalars['Boolean']['output'];
  apiConnected: Scalars['Boolean']['output'];
  autoImportBills: Scalars['Boolean']['output'];
  autoImportPurchaseOrders: Scalars['Boolean']['output'];
  bankAccounts: Array<AccountingAccount>;
  bookCloseDate: Maybe<Scalars['ISO8601Date']['output']>;
  creditCardAccounts: Array<AccountingAccount>;
  expenseAccounts: Array<AccountingAccount>;
  feeExpensesAccountId: Maybe<Scalars['ID']['output']>;
  filteredAccounts: Array<AccountingAccount>;
  liabilityAccounts: Array<AccountingAccount>;
  name: Scalars['String']['output'];
  prepaymentsAccountId: Maybe<Scalars['ID']['output']>;
  readOnly: Scalars['Boolean']['output'];
  receivableBankAccountId: Maybe<Scalars['ID']['output']>;
  settleLiabilityAccountId: Maybe<Scalars['ID']['output']>;
  standalonePaymentsExpensesAccountId: Maybe<Scalars['ID']['output']>;
  syncAutomatically: Scalars['Boolean']['output'];
  syncErrorMessage: Maybe<Scalars['String']['output']>;
  syncScheduledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  syncStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  syncStartedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  syncState: SyncStateEnum;
  syncUncategorizedExpenses: Scalars['Boolean']['output'];
  syncedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  unallocatedExpensesAccountId: Maybe<Scalars['ID']['output']>;
};

export type NetsuiteUnpaidBill = {
  amount: Maybe<Money>;
  balance: Maybe<Money>;
  dueDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  issueDate: Maybe<Scalars['ISO8601Date']['output']>;
  number: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  vendorName: Maybe<Scalars['String']['output']>;
};

export type NotificationSetting = {
  category: NotificationSettingCategoryTypeEnum;
  configurable: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  name: NotificationSettingNameTypeEnum;
};

export enum NotificationSettingCategoryTypeEnum {
  ACCOUNTS_RECEIVABLE = 'ACCOUNTS_RECEIVABLE',
  STANDARD = 'STANDARD',
  UNKNOWN = 'UNKNOWN'
}

export enum NotificationSettingNameTypeEnum {
  ANNOUNCEMENTS_EMAIL = 'ANNOUNCEMENTS_EMAIL',
  APPROVAL_REQUEST_STATUS_UPDATE_EMAIL = 'APPROVAL_REQUEST_STATUS_UPDATE_EMAIL',
  APPROVE_INVOICE_EMAIL = 'APPROVE_INVOICE_EMAIL',
  APPROVE_PAYMENT_EMAIL = 'APPROVE_PAYMENT_EMAIL',
  EXTEND_PAYMENT_EMAIL = 'EXTEND_PAYMENT_EMAIL',
  FAILED_PAYMENTS_DIGEST_EMAIL = 'FAILED_PAYMENTS_DIGEST_EMAIL',
  PAYMENT_CANCELED_EMAIL = 'PAYMENT_CANCELED_EMAIL',
  PAYMENT_LANDED_IN_ACCOUNT_EMAIL = 'PAYMENT_LANDED_IN_ACCOUNT_EMAIL',
  PAYMENT_ON_ITS_WAY_EMAIL = 'PAYMENT_ON_ITS_WAY_EMAIL',
  PAYMENT_SCHEDULED_EMAIL = 'PAYMENT_SCHEDULED_EMAIL',
  PENDING_INVOICE_EMAIL = 'PENDING_INVOICE_EMAIL',
  REMIND_APPROVERS_ABOUT_PENDING_APPROVAL_EMAIL = 'REMIND_APPROVERS_ABOUT_PENDING_APPROVAL_EMAIL',
  RULE_MODIFIED_EMAIL = 'RULE_MODIFIED_EMAIL',
  SETTLE_INBOX_WEEKLY_DIGEST_EMAIL = 'SETTLE_INBOX_WEEKLY_DIGEST_EMAIL',
  UPCOMING_PAYMENTS_DIGEST_EMAIL = 'UPCOMING_PAYMENTS_DIGEST_EMAIL'
}

export type NotificationSettings = {
  accountsReceivable: AccountsReceivableNotificationSettings;
  announcementsEmail: Scalars['Boolean']['output'];
  approvalRequestStatusUpdateEmail: Scalars['Boolean']['output'];
  approveInvoiceEmail: Scalars['Boolean']['output'];
  approvePaymentEmail: Scalars['Boolean']['output'];
  configurations: Array<NotificationSetting>;
  extendPaymentEmail: Scalars['Boolean']['output'];
  failedPaymentsDigestEmail: Scalars['Boolean']['output'];
  pendingInvoiceEmail: Scalars['Boolean']['output'];
  ruleModifiedEmail: Scalars['Boolean']['output'];
  settleInboxWeeklyDigestEmail: Scalars['Boolean']['output'];
  upcomingPaymentsDigestEmail: Scalars['Boolean']['output'];
};

export type NotificationSettingsInputObject = {
  accountsReceivable?: InputMaybe<AccountsReceivableNotificationSettingsInputObject>;
  announcementsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  approvalRequestStatusUpdateEmail?: InputMaybe<Scalars['Boolean']['input']>;
  approveInvoiceEmail?: InputMaybe<Scalars['Boolean']['input']>;
  approvePaymentEmail?: InputMaybe<Scalars['Boolean']['input']>;
  extendPaymentEmail?: InputMaybe<Scalars['Boolean']['input']>;
  failedPaymentsDigestEmail?: InputMaybe<Scalars['Boolean']['input']>;
  pendingInvoiceEmail?: InputMaybe<Scalars['Boolean']['input']>;
  ruleModifiedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  settleInboxWeeklyDigestEmail?: InputMaybe<Scalars['Boolean']['input']>;
  upcomingPaymentsDigestEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OauthClientIntegrationEnum {
  A2X = 'A2X',
  ESCALON = 'ESCALON',
  FINALOOP = 'FINALOOP',
  UNKNOWN = 'UNKNOWN'
}

export enum ObjectSyncStatusEnum {
  EXCLUDED_BY_BOOK_CLOSE_DATE = 'EXCLUDED_BY_BOOK_CLOSE_DATE',
  EXCLUDED_BY_STATUS = 'EXCLUDED_BY_STATUS',
  EXCLUDED_BY_SYNC_START_DATE = 'EXCLUDED_BY_SYNC_START_DATE',
  EXCLUDED_BY_USER = 'EXCLUDED_BY_USER',
  SYNCED = 'SYNCED',
  SYNCED_WITH_ERROR = 'SYNCED_WITH_ERROR',
  UNSYNCED = 'UNSYNCED'
}

export enum OccupationEnum {
  ACCOUNTANT_CPA = 'ACCOUNTANT_CPA',
  BOOKKEEPER = 'BOOKKEEPER',
  COO = 'COO',
  CSUITE = 'CSUITE',
  EXTERNAL_ACCOUNTANT = 'EXTERNAL_ACCOUNTANT',
  EXTERNAL_CFO = 'EXTERNAL_CFO',
  FINANCE = 'FINANCE',
  FOUNDER_OR_CEO = 'FOUNDER_OR_CEO',
  FRACTCAL_CFO = 'FRACTCAL_CFO',
  INTERNAL_ACCOUNTANT = 'INTERNAL_ACCOUNTANT',
  INTERNAL_CFO = 'INTERNAL_CFO',
  INVESTOR = 'INVESTOR',
  INVESTOR_OR_CONSULTANT = 'INVESTOR_OR_CONSULTANT',
  MARKETING = 'MARKETING',
  MARKETING_OR_SALES = 'MARKETING_OR_SALES',
  OPERATIONS = 'OPERATIONS',
  OTHER = 'OTHER',
  OWNER = 'OWNER',
  PROCUREMENT = 'PROCUREMENT'
}

export type OcrDocument = Invoice | PurchaseOrder;

export enum OfferStatusEnum {
  ACTIVATED = 'ACTIVATED',
  AVAILABLE = 'AVAILABLE'
}

export enum OnboardingStatusEnum {
  MICRO_DEPOSITS_SENT = 'MICRO_DEPOSITS_SENT',
  MICRO_DEPOSITS_WAITING = 'MICRO_DEPOSITS_WAITING',
  UNVERIFIED = 'UNVERIFIED'
}

export type OrderDocument = PurchaseOrder | WorkOrder;

export enum OrderDocumentTypeEnum {
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  WORK_ORDER = 'WORK_ORDER'
}

export enum OrderFulfillmentStatusEnum {
  CANCELED = 'CANCELED',
  OPEN = 'OPEN',
  OTHER = 'OTHER',
  SHIPPED = 'SHIPPED'
}

export type OutboundOrder = {
  archiveDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  archived: Scalars['Boolean']['output'];
  attachment: Maybe<Attachment>;
  attachments: Array<Attachment>;
  cancelDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  channel: Maybe<OutboundOrderChannel>;
  contactDetails: Maybe<ContactDetails>;
  currency: Scalars['String']['output'];
  customerLocalBusiness: Maybe<LocalBusiness>;
  deleteDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  deleted: Scalars['Boolean']['output'];
  discountAmount: Maybe<Money>;
  dutyAmount: Maybe<Money>;
  financialStatus: Maybe<OutboundOrderFinancialStatusEnum>;
  fulfillmentStatus: Maybe<OutboundOrderFulfillmentStatusEnum>;
  id: Scalars['ID']['output'];
  importDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  lineItems: Array<OutboundOrderLineItem>;
  location: Maybe<Location>;
  memo: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['String']['output']>;
  orderDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  orderFulfillments: Array<OutboundOrderFulfillment>;
  orderMarginPercentage: Maybe<Scalars['Float']['output']>;
  orderPageUrl: Maybe<Scalars['String']['output']>;
  orderSubtotal: Money;
  orderTotalAmount: Money;
  orderTotalMargin: Maybe<InfinitePrecisionMoney>;
  paymentPageUrl: Maybe<Scalars['String']['output']>;
  paymentTerms: Maybe<Scalars['String']['output']>;
  purchaseOrderNumber: Maybe<Scalars['String']['output']>;
  receivableInvoice: Maybe<ReceivableInvoice>;
  receivableInvoiceInSync: Maybe<Scalars['Boolean']['output']>;
  refundedAmount: Maybe<Money>;
  shippingAmount: Maybe<Money>;
  source: OutboundOrderSourceEnum;
  status: OutboundOrderStatusEnum;
  targetFulfillmentDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  taxAmount: Maybe<Money>;
  timelineEvents: Array<OutboundOrderTimelineEvent>;
  updateDate: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum OutboundOrderArchivedStatusEnum {
  ACTIVE_AND_ARCHIVED = 'ACTIVE_AND_ARCHIVED',
  ACTIVE_ONLY = 'ACTIVE_ONLY',
  ARCHIVED_ONLY = 'ARCHIVED_ONLY'
}

export type OutboundOrderChannel = {
  defaultFulfillmentLocationId: Maybe<Scalars['ID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  source: SalesChannelIntegrationEnum;
};

export enum OutboundOrderEventTypeEnum {
  OUTBOUND_ORDER_CREATED = 'OUTBOUND_ORDER_CREATED',
  OUTBOUND_ORDER_FULFILLED = 'OUTBOUND_ORDER_FULFILLED',
  OUTBOUND_ORDER_PAYMENT_CAPTURED = 'OUTBOUND_ORDER_PAYMENT_CAPTURED',
  OUTBOUND_ORDER_SHIPPED = 'OUTBOUND_ORDER_SHIPPED'
}

export enum OutboundOrderFinancialStatusEnum {
  DUE = 'DUE',
  PAID = 'PAID',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  PENDING = 'PENDING',
  REFUNDED = 'REFUNDED',
  VOIDED = 'VOIDED'
}

export type OutboundOrderFulfillment = {
  fulfillByDate: Maybe<Scalars['ISO8601Date']['output']>;
  fulfillmentDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  fulfillmentDestination: Maybe<LocalBusinessShipmentLocation>;
  fulfillmentInstructions: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location: Maybe<Location>;
  number: Maybe<Scalars['String']['output']>;
  outboundOrder: OutboundOrder;
  shippingMethod: Maybe<Scalars['String']['output']>;
  shippingVendorsLocalBusinesses: Array<LocalBusiness>;
  sourceIntegration: Maybe<OutboundOrderSourceIntegration>;
  status: OrderFulfillmentStatusEnum;
  targetFulfillmentDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  trackingNumber: Maybe<Scalars['String']['output']>;
};

export type OutboundOrderFulfillmentInputObject = {
  fulfillByDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  fulfillmentDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  fulfillmentDestinationId?: InputMaybe<Scalars['ID']['input']>;
  fulfillmentInstructions?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
  shippingVendorsLocalBusinessesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<OrderFulfillmentStatusEnum>;
  targetFulfillmentDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum OutboundOrderFulfillmentStatusEnum {
  FULFILLED = 'FULFILLED',
  ON_HOLD = 'ON_HOLD',
  PARTIALLY_FULFILLED = 'PARTIALLY_FULFILLED',
  SCHEDULED = 'SCHEDULED',
  UNFULFILLED = 'UNFULFILLED'
}

export type OutboundOrderLineItem = {
  catalogItemVariation: CatalogItemVariation;
  discountPrice: Money;
  id: Scalars['ID']['output'];
  outboundOrder: OutboundOrder;
  quantity: Scalars['Float']['output'];
  salesChannelSku: Scalars['String']['output'];
  taxPrice: Money;
  total: Money;
  unitPrice: Money;
};

export type OutboundOrderLineItemInputObject = {
  catalogItemId: Scalars['ID']['input'];
  discountPriceCents?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Float']['input'];
  salesChannelSku?: InputMaybe<Scalars['String']['input']>;
  taxPriceCents?: InputMaybe<Scalars['Int']['input']>;
  unitPriceCents?: InputMaybe<Scalars['Int']['input']>;
};

export enum OutboundOrderPermissionsEnum {
  ATTACH_OUTBOUND_ORDER_DOCUMENT = 'ATTACH_OUTBOUND_ORDER_DOCUMENT',
  CREATE_OUTBOUND_ORDER = 'CREATE_OUTBOUND_ORDER',
  DELETE_OUTBOUND_ORDER = 'DELETE_OUTBOUND_ORDER',
  UPDATE_OUTBOUND_ORDER = 'UPDATE_OUTBOUND_ORDER',
  UPDATE_OUTBOUND_ORDER_ARCHIVED = 'UPDATE_OUTBOUND_ORDER_ARCHIVED',
  VIEW_OUTBOUND_ORDER = 'VIEW_OUTBOUND_ORDER'
}

export enum OutboundOrderSortableFieldEnum {
  CUSTOMER_NAME = 'CUSTOMER_NAME',
  NUMBER = 'NUMBER',
  ORDER_DATE = 'ORDER_DATE',
  ORDER_TOTAL_AMOUNT = 'ORDER_TOTAL_AMOUNT'
}

export enum OutboundOrderSortingDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum OutboundOrderSourceEnum {
  MANUAL = 'MANUAL',
  SHOPIFY = 'SHOPIFY',
  TRACKSTAR = 'TRACKSTAR'
}

export type OutboundOrderSourceIntegration = ShopifyState;

export enum OutboundOrderStatusEnum {
  CANCELED = 'CANCELED',
  CREATED = 'CREATED',
  FULFILLED = 'FULFILLED',
  PAYMENT_CAPTURED = 'PAYMENT_CAPTURED'
}

export type OutboundOrderTimelineEvent = TimelineEventInterface & {
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayText: Scalars['String']['output'];
  eventType: OutboundOrderEventTypeEnum;
  icon: IconEnum;
  occurredAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  user: Maybe<Approver>;
};

export type OutboundOrdersFilteringInputObject = {
  archivedStatus?: InputMaybe<OutboundOrderArchivedStatusEnum>;
  channel?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  financialStatuses?: InputMaybe<Array<OutboundOrderFinancialStatusEnum>>;
  fulfillmentStatuses?: InputMaybe<Array<OutboundOrderFulfillmentStatusEnum>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<OutboundOrderStatusEnum>>;
};

export type OutboundOrdersInputObject = {
  customerLocalBusinessId?: InputMaybe<Scalars['ID']['input']>;
  dutyAmountCents?: InputMaybe<Scalars['SafeInt']['input']>;
  financialStatus?: InputMaybe<OutboundOrderFinancialStatusEnum>;
  fulfillmentStatus?: InputMaybe<OutboundOrderFulfillmentStatusEnum>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  orderDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  refundAmountCents?: InputMaybe<Scalars['SafeInt']['input']>;
  salesChannelId?: InputMaybe<Scalars['ID']['input']>;
  shippingAmountCents?: InputMaybe<Scalars['SafeInt']['input']>;
  targetFulfillmentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  uploadSignedId?: InputMaybe<Scalars['ID']['input']>;
};

export type OutboundOrdersSortingInputObject = {
  direction: OutboundOrderSortingDirectionEnum;
  field: OutboundOrderSortableFieldEnum;
};

export type OverrideStepInput = {
  approvingUserIds: Array<Scalars['ID']['input']>;
  stepNumber: Scalars['Int']['input'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export enum PagePermissionsEnum {
  ACCOUNTING_FIRM_DASHBOARD_PAGE = 'ACCOUNTING_FIRM_DASHBOARD_PAGE',
  BILLS_PAGE = 'BILLS_PAGE',
  BILLS_PROMO_PAGE = 'BILLS_PROMO_PAGE',
  CATALOG_PAGE = 'CATALOG_PAGE',
  DASHBOARD_PAGE = 'DASHBOARD_PAGE',
  INBOX_PAGE = 'INBOX_PAGE',
  INVENTORY_TRANSFERS_PAGE = 'INVENTORY_TRANSFERS_PAGE',
  LOCATIONS_PAGE = 'LOCATIONS_PAGE',
  MY_INVOICES_PAGE = 'MY_INVOICES_PAGE',
  PAYMENTS_PAGE = 'PAYMENTS_PAGE',
  PURCHASERS_PAGE = 'PURCHASERS_PAGE',
  PURCHASE_ORDERS_PAGE = 'PURCHASE_ORDERS_PAGE',
  RECEIPTS_PAGE = 'RECEIPTS_PAGE',
  RECEIVABLES_PAGE = 'RECEIVABLES_PAGE',
  VENDORS_PAGE = 'VENDORS_PAGE',
  WORK_ORDERS_PAGE = 'WORK_ORDERS_PAGE'
}

export type PagedCatalogItemBatchLandedCostDetails = {
  data: Array<CatalogItemBatchLandedCostDetails>;
  pagination: Pagination;
};

export type PagedCatalogItemLandedCostDetails = {
  data: Maybe<Array<CatalogItemLandedCostDetails>>;
  pagination: Maybe<Pagination>;
};

export type PagedLinkableCatalogItems = {
  data: Array<LinkableCatalogItem>;
  pagination: Pagination;
};

export type PagedLinkableLocations = {
  data: Array<LinkableLocation>;
  pagination: Pagination;
};

export type PagedLocalBusinessShipmentLocations = {
  data: Array<LocalBusinessShipmentLocation>;
  pagination: Pagination;
};

export type PagedLocations = {
  data: Array<Location>;
  pagination: Pagination;
};

export type PagedOrderDocuments = {
  data: Array<OrderDocument>;
  pagination: Pagination;
};

export type PagedOrderDocumentsFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PagedOutboundOrders = {
  data: Array<OutboundOrder>;
  pagination: Pagination;
};

export type PagedSalesChannelConfigurations = {
  data: Array<SalesChannelConfiguration>;
  pagination: Pagination;
};

export type PagedWorkOrders = {
  data: Maybe<Array<WorkOrder>>;
  pagination: Maybe<Pagination>;
};

export type Pagination = {
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaperCheckDetails = {
  address: Maybe<Address>;
  email: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type PaperCheckDetailsInputObject = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum PayableActionIndicatorEnum {
  INCOMPLETE = 'INCOMPLETE',
  READY = 'READY'
}

export type PayableInvoiceInputObject = {
  amountCents?: InputMaybe<Scalars['SafeInt']['input']>;
  amountCurrency?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  issueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  lineItems?: InputMaybe<Array<BaseExternalPayableLineItemInputObject>>;
  number?: InputMaybe<Scalars['String']['input']>;
  vendorLocalBusinessId?: InputMaybe<Scalars['ID']['input']>;
};

export type PayableInvoicePreview = {
  amount: Maybe<Money>;
  dueDate: Maybe<Scalars['ISO8601Date']['output']>;
  issueDate: Maybe<Scalars['ISO8601Date']['output']>;
  number: Maybe<Scalars['String']['output']>;
  vendor: Maybe<LocalBusiness>;
};

export enum PayerEnum {
  accounting_firm = 'accounting_firm',
  client = 'client'
}

export type PayerInvitation = {
  businessName: Maybe<Scalars['String']['output']>;
  demoAvailable: Scalars['Boolean']['output'];
  valid: Scalars['Boolean']['output'];
};

export type PayerInvitationV2 = {
  approximateRevenue: Maybe<Scalars['String']['output']>;
  bankAccountLocation: Maybe<Scalars['String']['output']>;
  businessIndustry: Maybe<BusinessIndustryEnum>;
  businessName: Maybe<Scalars['String']['output']>;
  businessType: Maybe<BusinessTypeEnum>;
  countryOfRegistration: Maybe<Scalars['String']['output']>;
  demoAvailable: Maybe<Scalars['Boolean']['output']>;
  desiredWorkingCapitalCents: Maybe<Scalars['SafeInt']['output']>;
  email: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  interestedIn: Array<SignupInterestsEnum>;
  invitationCode: Scalars['String']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  prohibitedIndustryConfirmation: Maybe<Scalars['Boolean']['output']>;
  promotionCode: Maybe<BillingPromotionCodeType>;
  /** @deprecated Use referrer instead */
  referralCode: Maybe<Scalars['String']['output']>;
  referredFrom: Maybe<ReferralSourceEnum>;
  referrer: Maybe<Referral>;
  source: Maybe<Scalars['String']['output']>;
  userOccupation: Maybe<OccupationEnum>;
  website: Maybe<Scalars['String']['output']>;
};

export type Payment = {
  accountingDetails: Maybe<PaymentAccountingDetailsType>;
  accountingUrl: Maybe<Scalars['String']['output']>;
  actions: PaymentActions;
  agreementSignRequired: Scalars['Boolean']['output'];
  allocations: Maybe<Array<Allocation>>;
  allowAccountChange: Scalars['Boolean']['output'];
  allowReschedule: Scalars['Boolean']['output'];
  allowRestorePaymentDate: Scalars['Boolean']['output'];
  allowedDeferralDays: Maybe<Scalars['Int']['output']>;
  amortizedLoan: Maybe<AmortizedLoan>;
  amount: Money;
  anyEarlyRepayments: Scalars['Boolean']['output'];
  approval: Maybe<Approval>;
  auditTrailEvents: Array<AuditTrailEvents>;
  balanceDueToSettle: Money;
  bulletEpt: Maybe<BulletEpt>;
  canChangeExtendedPaymentTerms: Maybe<Scalars['Boolean']['output']>;
  cancelledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  cancelledBy: Maybe<Approver>;
  consolidated: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Maybe<Approver>;
  currentExtendedPaymentTermConfirmation: Maybe<InvoiceExtendedPaymentTermConfirmation>;
  debitDate: Maybe<Scalars['ISO8601Date']['output']>;
  errorCode: Maybe<Scalars['String']['output']>;
  errorDirection: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  etaFromPayer: Maybe<Scalars['ISO8601Date']['output']>;
  etaToVendor: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  extendedPaymentTermAdditionalDays: Maybe<Scalars['Int']['output']>;
  extendedTermPayerPaymentDate: Maybe<Scalars['ISO8601Date']['output']>;
  extendedTermUnrefundedFee: Maybe<Money>;
  external: Scalars['Boolean']['output'];
  failedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  feeInvoices: Maybe<Array<Invoice>>;
  financed: Scalars['Boolean']['output'];
  friendlyId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  importedFromAccounting: Scalars['Boolean']['output'];
  invoices: Array<Invoice>;
  isCashAdvance: Scalars['Boolean']['output'];
  isDailyInterestAccrual: Scalars['Boolean']['output'];
  isDomestic: Scalars['Boolean']['output'];
  lendingLicense: Maybe<LendingLicenseEnum>;
  loanAgreementDocumentUrl: Maybe<Scalars['String']['output']>;
  mainReconciliationItem: Maybe<ReconciliationItem>;
  onHold: Scalars['Boolean']['output'];
  originalInvoice: Maybe<Invoice>;
  otherReasonNote: Maybe<Scalars['String']['output']>;
  paidWithLink: Scalars['Boolean']['output'];
  paidWithMethod: Maybe<PaymentMethodEnum>;
  payFromAccount: Maybe<Account>;
  payToAccount: Maybe<LocalBusinessAccount>;
  payerAmount: Money;
  payerCharged: Scalars['Boolean']['output'];
  payerPaymentDate: Scalars['ISO8601Date']['output'];
  payerPaymentStatus: PaymentStatusEnum;
  payerTransferDetails: Maybe<TransferDetails>;
  payerTransfersDetails: Maybe<Array<TransferDetails>>;
  paymentConfirmationDocumentUrl: Maybe<Scalars['String']['output']>;
  paymentDescription: Maybe<Scalars['String']['output']>;
  paymentMethod: Maybe<PaymentMethodEnum>;
  paymentNumber: Maybe<Scalars['Int']['output']>;
  paymentRestoreDate: Maybe<Scalars['ISO8601Date']['output']>;
  paymentRestoreDay: Maybe<Scalars['Int']['output']>;
  paymentType: Maybe<PaymentTypeEnum>;
  purchaseOrders: Array<PurchaseOrder>;
  purposeCode: Maybe<Scalars['String']['output']>;
  reasonCode: Maybe<PaymentReasonEnum>;
  receiverBusiness: Maybe<Business>;
  reconciliationItems: Array<ReconciliationItem>;
  recurrentPaymentsSchedule: Maybe<RecurrentPaymentsSchedule>;
  refundItems: Array<ReconciliationItem>;
  releasedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  repaidCompletely: Scalars['Boolean']['output'];
  revokable: Scalars['Boolean']['output'];
  scheduledConfirmationAvailable: Scalars['Boolean']['output'];
  scheduledOn: Scalars['ISO8601Date']['output'];
  secondaryStatusDescription: Maybe<Scalars['String']['output']>;
  sentDate: Maybe<Scalars['ISO8601Date']['output']>;
  standalone: Scalars['Boolean']['output'];
  status: PaymentStatusEnum;
  statusDescription: Maybe<Scalars['String']['output']>;
  statusDescriptions: Maybe<Array<Scalars['String']['output']>>;
  statuses: Array<InvoiceStatusEnum>;
  suggestedPayment: Maybe<SuggestedPayment>;
  syncError: Maybe<SyncError>;
  syncObjectStatus: Maybe<SyncObjectStatus>;
  timelineEvents: Maybe<Array<TimelineEvent>>;
  usedDeferralDays: Maybe<Scalars['Int']['output']>;
  vendorAmount: Money;
  vendorLocalBusiness: LocalBusiness;
  vendorPaid: Scalars['Boolean']['output'];
  vendorPaymentDate: Scalars['ISO8601Date']['output'];
  vendorPaymentStatus: PaymentStatusEnum;
  vendorReceivedOn: Maybe<Scalars['ISO8601Date']['output']>;
  vendorTransferDetails: Maybe<TransferDetails>;
  w9FormHoldSubmittedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  w9FormHoldSubmittedByName: Maybe<Scalars['String']['output']>;
  warningMessages: Maybe<Array<WarningMessage>>;
  withWarningMessage: Scalars['Boolean']['output'];
  workOrders: Array<WorkOrder>;
};

export type PaymentAccountingDetailsInputObject = {
  accountingAccountId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryClassId?: InputMaybe<Scalars['ID']['input']>;
  accountingMemo?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentAccountingDetailsType = {
  accountingAccount: Maybe<AccountingAccount>;
  accountingCategoryClass: Maybe<AccountingDictionary>;
  accountingMemo: Maybe<Scalars['String']['output']>;
};

export type PaymentActions = {
  amortizedRepayEarly: Action;
  eptRepayEarly: Action;
  overrideApproval: Action;
  releasePayment: Action;
  retryPayment: Action;
  vendorAccountChange: Action;
};

export type PaymentAttributesForEstimatesInputObject = {
  payerBusinessId: Scalars['ID']['input'];
  receivingAccountId?: InputMaybe<Scalars['ID']['input']>;
  vendorAmount: MoneyInputObject;
};

export type PaymentCard = {
  default: Scalars['Boolean']['output'];
  expirationMonth: Scalars['Int']['output'];
  expirationYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  maskedNumber: Scalars['String']['output'];
  paymentSystem: Maybe<Scalars['String']['output']>;
};

export type PaymentInputObject = {
  accountId: Scalars['ID']['input'];
  amount: MoneyInputObject;
  paymentDescription?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethodEnum;
  processDate: Scalars['ISO8601Date']['input'];
};

export enum PaymentMethodEnum {
  ACH = 'ACH',
  OTHER = 'OTHER',
  PAPER_CHECK = 'PAPER_CHECK',
  PAYMENT_CARD = 'PAYMENT_CARD',
  SLOW_ACH = 'SLOW_ACH',
  WIRE = 'WIRE'
}

export type PaymentOptions = {
  billpayPaymentMethods: Array<PaymentMethodEnum>;
  financingPaymentMethods: Array<PaymentMethodEnum>;
};

export enum PaymentReasonEnum {
  EXPENSE_REIMBURSEMENT = 'EXPENSE_REIMBURSEMENT',
  INVENTORY_DEPOSIT = 'INVENTORY_DEPOSIT',
  MARKETING = 'MARKETING',
  MATERIALS_AND_SUPPLIES = 'MATERIALS_AND_SUPPLIES',
  MONTHLY_FEE = 'MONTHLY_FEE',
  OTHER = 'OTHER',
  PAYROLL_AND_COMMISSION = 'PAYROLL_AND_COMMISSION',
  PROPERTY = 'PROPERTY'
}

export enum PaymentStatusEnum {
  APPROVAL_PENDING = 'APPROVAL_PENDING',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  FULLY_REVERSED = 'FULLY_REVERSED',
  ON_HOLD = 'ON_HOLD',
  PAID = 'PAID',
  PARTIALLY_REPAID = 'PARTIALLY_REPAID',
  PAYMENT_PLAN = 'PAYMENT_PLAN',
  PROCESSED = 'PROCESSED',
  SCHEDULED = 'SCHEDULED',
  SENT = 'SENT'
}

export enum PaymentTypeEnum {
  AMORTIZED_LOAN = 'AMORTIZED_LOAN',
  BULLET_EPT = 'BULLET_EPT',
  DIRECT = 'DIRECT',
  EPT = 'EPT',
  EPT_FEE = 'EPT_FEE'
}

export type PaymentsForecast = {
  amount: Money;
  days: Maybe<Scalars['Int']['output']>;
  expectedPaymentDate: Maybe<Scalars['ISO8601Date']['output']>;
  percentage: Scalars['Int']['output'];
  termType: Scalars['String']['output'];
};

export type PaymentsForecastItem = {
  amount: Money;
  days: Maybe<Scalars['Int']['output']>;
  expectedPaymentDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  percentage: Scalars['Int']['output'];
  suggestedPayment: Maybe<SuggestedPayment>;
  termType: Scalars['String']['output'];
  vendorTermOption: Maybe<VendorTermOption>;
};

export type PaymentsForecastItemInputObject = {
  id?: InputMaybe<Scalars['ID']['input']>;
  paymentDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  vendorTermOptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type PaymentsForecastTable = {
  default: Scalars['Boolean']['output'];
  deletedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  deletedBy: Maybe<Profile>;
  id: Scalars['ID']['output'];
  paymentsForecastItems: Array<PaymentsForecastItem>;
  triggerDays: Maybe<Scalars['Int']['output']>;
  triggerEvent: Maybe<VendorLeadTimeEventEnum>;
  vendorLocalBusiness: Maybe<LocalBusiness>;
};

export type PaymentsForecastTableInputObject = {
  paymentsForecastItems?: InputMaybe<Array<PaymentsForecastItemInputObject>>;
  triggerDays?: InputMaybe<Scalars['Int']['input']>;
  triggerEvent?: InputMaybe<VendorLeadTimeEventEnum>;
};

export enum PaymentsPermissionsEnum {
  ALLOCATE_PAYMENT_TO_INVOICE = 'ALLOCATE_PAYMENT_TO_INVOICE',
  CREATE_AMORTIZED_LOAN_PAYMENT = 'CREATE_AMORTIZED_LOAN_PAYMENT',
  CREATE_EXTENDED_TERM_PAYMENT = 'CREATE_EXTENDED_TERM_PAYMENT',
  CREATE_PAYMENT = 'CREATE_PAYMENT',
  CREATE_PRELIMINARY_AMORTIZED_LOAN_AGREEMENT = 'CREATE_PRELIMINARY_AMORTIZED_LOAN_AGREEMENT',
  CREATE_PRELIMINARY_EPT_AGREEMENT = 'CREATE_PRELIMINARY_EPT_AGREEMENT',
  DECLINE_TERM_EXTENSIONS = 'DECLINE_TERM_EXTENSIONS',
  EXTEND_PAYMENT_TERM = 'EXTEND_PAYMENT_TERM',
  PAY_NOW_PAYMENT = 'PAY_NOW_PAYMENT',
  RELEASE_PAYMENT = 'RELEASE_PAYMENT',
  REPAY_EARLY = 'REPAY_EARLY',
  RESCHEDULE_PAYMENT = 'RESCHEDULE_PAYMENT',
  REVOKE_PAYMENT = 'REVOKE_PAYMENT',
  UPDATE_PAYMENT_ACCOUNT = 'UPDATE_PAYMENT_ACCOUNT',
  UPDATE_PAYMENT_ACCOUNTING_DETAILS = 'UPDATE_PAYMENT_ACCOUNTING_DETAILS'
}

export type PaymentsSummary = {
  failedCount: Scalars['Int']['output'];
  rejectedCount: Scalars['Int']['output'];
};

export enum PdfOrientationEnum {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT'
}

export type PermissionSet = {
  availableLevels: Maybe<Array<AccessLevelEnum>>;
  availableOptions: Maybe<Array<PermissionSetOptionEnum>>;
  grantedLevel: Maybe<AccessLevelEnum>;
  grantedOptions: Maybe<Array<PermissionSetOptionEnum>>;
  name: PermissionSetEnum;
};

export enum PermissionSetEnum {
  ACCOUNTING_SYNC = 'ACCOUNTING_SYNC',
  APPROVAL_RULES = 'APPROVAL_RULES',
  BILLS = 'BILLS',
  BUSINESS_DETAILS = 'BUSINESS_DETAILS',
  CLIENT_MANAGER = 'CLIENT_MANAGER',
  CONNECTIONS = 'CONNECTIONS',
  COSTING_METHOD_SELECTION = 'COSTING_METHOD_SELECTION',
  DASHBOARD = 'DASHBOARD',
  DISCREPANCY_RULES = 'DISCREPANCY_RULES',
  INBOX = 'INBOX',
  INVENTORY = 'INVENTORY',
  INVENTORY_TRANSFERS = 'INVENTORY_TRANSFERS',
  OUTBOUND_ORDERS = 'OUTBOUND_ORDERS',
  PAYMENTS = 'PAYMENTS',
  PURCHASE_ORDERS_AND_RECEIPTS = 'PURCHASE_ORDERS_AND_RECEIPTS',
  SALES_CHANNELS = 'SALES_CHANNELS',
  TEAM_MEMBERS = 'TEAM_MEMBERS',
  VENDORS = 'VENDORS'
}

export type PermissionSetInputObject = {
  grantedLevel?: InputMaybe<AccessLevelEnum>;
  grantedOptions?: InputMaybe<Array<PermissionSetOptionEnum>>;
  name: PermissionSetEnum;
};

export enum PermissionSetOptionEnum {
  APPLY_VENDOR_CREDITS = 'APPLY_VENDOR_CREDITS',
  CLIENT_MANAGER = 'CLIENT_MANAGER',
  CUSTOM_ROLES = 'CUSTOM_ROLES',
  EXPORT_REPORTS = 'EXPORT_REPORTS',
  LABEL_INVOICES_AS_PAID_OUTSIDE_SETTLE = 'LABEL_INVOICES_AS_PAID_OUTSIDE_SETTLE',
  LINK_RECEIPTS_TO_PURCHASE_ORDERS_AND_INVOICES = 'LINK_RECEIPTS_TO_PURCHASE_ORDERS_AND_INVOICES',
  MANAGE_BANK_ACCOUNTS = 'MANAGE_BANK_ACCOUNTS',
  MARKETING_VIRTUAL_CARD = 'MARKETING_VIRTUAL_CARD'
}

export type Permissions = {
  accountingPermissions: Array<AccountingPermissionsEnum>;
  attachmentDocumentTemplatePermissions: Array<AttachmentDocumentTemplatePermissionsEnum>;
  bankAccountsPermissions: Array<BankAccountsPermissionsEnum>;
  billingPlanPermissions: Array<BillingPlanPermissionsEnum>;
  businessDetailsPermissions: Array<BusinessDetailsPermissionsEnum>;
  businessFeaturesPermissions: Array<BusinessFeaturesPermissionsEnum>;
  catalogPermissions: Array<CatalogPermissionsEnum>;
  clientManagerPermissions: Array<ClientManagerPermissionsEnum>;
  dashboardPermissions: Array<DashboardPermissionsEnum>;
  discrepancyRulePermissions: Array<DiscrepancyRulePermissionsEnum>;
  inventoryPermissions: Array<InventoryPermissionsEnum>;
  inventoryTransferPermissions: Array<InventoryTransferPermissionsEnum>;
  invoicesPermissions: Array<InvoicesPermissionsEnum>;
  localBusinessesPermissions: Array<LocalBusinessesPermissionsEnum>;
  outboundOrderPermissions: Array<OutboundOrderPermissionsEnum>;
  pagePermissions: Array<PagePermissionsEnum>;
  paymentsPermissions: Array<PaymentsPermissionsEnum>;
  purchaseOrderPermissions: Array<PurchaseOrderPermissionsEnum>;
  receiptPermissions: Array<ReceiptPermissionsEnum>;
  receivablesPermissions: Array<ReceivablesPermissionsEnum>;
  reconciliationItemsPermissions: Array<ReconciliationItemsPermissionsEnum>;
  rulesPermissions: Array<RulesPermissionsEnum>;
  salesChannelConfigurationPermissions: Array<SalesChannelConfigurationPermissionsEnum>;
  settleInboxConfigPermissions: Array<SettleInboxConfigPermissionsEnum>;
  settleInboxPermissions: Array<SettleInboxPermissionsEnum>;
  teamPermissions: Array<TeamPermissionsEnum>;
  vendorCreditsPermissions: Array<VendorCreditsPermissionsEnum>;
  workOrderPermissions: Array<WorkOrderPermissionsEnum>;
};

export type Phone = {
  country: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  e164: Scalars['String']['output'];
  national: Scalars['String']['output'];
  rawNational: Scalars['String']['output'];
};

export type PhoneFactor = {
  activatedAt: Scalars['ISO8601DateTime']['output'];
  maskedPhoneNumber: Scalars['String']['output'];
};

export type PhoneFactorChallenge = {
  mfaToken: Scalars['ID']['output'];
  phoneFactorChallengeInfo: PhoneFactorChallengeInfo;
};

export type PhoneFactorChallengeInfo = {
  attemptsLeft: Scalars['Int']['output'];
  maskedPhoneNumber: Scalars['String']['output'];
  nextRetryAvailableAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  resendsLeft: Scalars['Int']['output'];
};

export enum PhoneFactorChannel {
  CALL = 'CALL',
  SMS = 'SMS'
}

export type PhysicalAttributes = {
  dimensionsUnitOfMeasure: Maybe<DimensionsUnitEnum>;
  height: Maybe<Scalars['Float']['output']>;
  length: Maybe<Scalars['Float']['output']>;
  weight: Maybe<Scalars['Float']['output']>;
  weightUnitOfMeasure: Maybe<WeightUnitEnum>;
  width: Maybe<Scalars['Float']['output']>;
};

export type PlaidLink = BankLink & {
  deleted: Scalars['Boolean']['output'];
  fixAvailable: Maybe<BankLinkFixEnum>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PreliminaryConsolidatedInvoicesGroupType = {
  invoices: Array<Invoice>;
  position: Scalars['Int']['output'];
};

export type ProcessChatFeedbackInput = {
  /** Categories of feedback issues */
  categories?: InputMaybe<Array<AiFeedbackCategoryEnum>>;
  /** Optional comment about the chat response */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the conversation */
  conversationId: Scalars['String']['input'];
  /** Whether the feedback is positive (true) or negative (false) */
  rating: Scalars['Boolean']['input'];
};

export type ProcessDateForArrivalEstimate = {
  achievable: Scalars['Boolean']['output'];
  processDate: Scalars['ISO8601Date']['output'];
  vendorCreditEta: Array<Scalars['ISO8601Date']['output']>;
};

export type ProcessDateForArrivalResult = {
  direct: ProcessDateForArrivalEstimate;
  financed: ProcessDateForArrivalEstimate;
};

export type ProcessNaturalLanguageInput = {
  /** Optional conversation ID for context */
  conversationId?: InputMaybe<Scalars['String']['input']>;
  /** The natural language text to process */
  text: Scalars['String']['input'];
  /** Optional array of signed IDs for uploaded files to provide context */
  uploadSignedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProcessingEstimate = {
  nearestProcessingDate: Scalars['ISO8601Date']['output'];
  nearestProcessingTime: Maybe<Scalars['ISO8601DateTime']['output']>;
  payerDebitEta: Array<Scalars['ISO8601Date']['output']>;
  processingDate: Scalars['ISO8601Date']['output'];
  vendorCreditEta: Array<Scalars['ISO8601Date']['output']>;
};

export type ProcessingEstimates = {
  direct: ProcessingEstimate;
  financed: ProcessingEstimate;
};

export type Profile = {
  accountingFirms: Maybe<Array<Business>>;
  actions: UserActions;
  applicationTheme: ApplicationThemeEnum;
  authProvider: Maybe<AuthProviderTypeEnum>;
  clients: Maybe<Array<UserClient>>;
  company: Scalars['String']['output'];
  country: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  emailConfirmationPending: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  internalEmail: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  loginEmail: Maybe<Scalars['String']['output']>;
  membership: Membership;
  memberships: Array<Membership>;
  multiBusiness: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  operational: Scalars['Boolean']['output'];
  phone: Maybe<Phone>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  timezone: Maybe<Scalars['String']['output']>;
  totp: Maybe<Totp>;
};

export enum ProviderEnum {
  FINALOOP = 'FINALOOP',
  NETSUITE = 'NETSUITE',
  QUICK_BOOKS = 'QUICK_BOOKS',
  XERO = 'XERO'
}

export type PublicBusiness = {
  /** @deprecated Use preferredReceivingAccount instead */
  account: Maybe<PublicLocalBusinessAccount>;
  address: Maybe<Address>;
  businessStructure: Maybe<BusinessStructureEnum>;
  companyName: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  emailDomains: Array<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  is1099Eligible: Maybe<Scalars['Boolean']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  officialName: Scalars['String']['output'];
  preferredReceivingAccount: Maybe<PublicLocalBusinessAccount>;
  /** Active verified accounts connected by the business */
  receivingAccounts: Array<PublicLocalBusinessAccount>;
  taxpayerId: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
  /** W9 form uploaded by the business */
  w9Form: Maybe<Attachment>;
  website: Maybe<Scalars['String']['output']>;
};

export type PublicInvoice = {
  account: Maybe<Account>;
  actions: PublicInvoiceActions;
  amount: Maybe<Money>;
  attachments: Array<Attachment>;
  dueDate: Maybe<Scalars['ISO8601Date']['output']>;
  issueDate: Maybe<Scalars['ISO8601Date']['output']>;
  memo: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['String']['output']>;
  paidOn: Maybe<Scalars['ISO8601Date']['output']>;
  payableUrl: Maybe<Scalars['String']['output']>;
  payerBusiness: Maybe<PublicBusiness>;
  payerLocalBusiness: Maybe<LocalBusiness>;
  payerNotificationsEmail: Maybe<Scalars['String']['output']>;
  scheduledOn: Maybe<Scalars['ISO8601Date']['output']>;
  sentAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: InvoiceStatusEnum;
  uuid: Maybe<Scalars['String']['output']>;
  vendorAccount: Maybe<LocalBusinessAccount>;
  vendorBusiness: Maybe<PublicBusiness>;
};

export type PublicInvoiceActions = {
  createPayment: Action;
  createPublicLinkToken: Action;
  link: Action;
  removePayerAccount: Action;
  revokePayment: Action;
  updateBusinessDetails: Action;
  verifyAccount: Action;
};

export type PublicLocalBusiness = {
  address: Maybe<Address>;
  business: Maybe<PublicBusiness>;
  businessName: Maybe<Scalars['String']['output']>;
  businessStructure: Maybe<BusinessStructureEnum>;
  businessStructureTaxClassification: Maybe<BusinessStructureTaxClassificationEnum>;
  exemptFatcaReportingCode: Maybe<Scalars['String']['output']>;
  exemptPayeeCode: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  is1099Eligible: Maybe<Scalars['Boolean']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  taxpayerId: Maybe<Scalars['String']['output']>;
  w9Form: Maybe<Attachment>;
};

export type PublicLocalBusinessAccount = {
  accountNumberType: Maybe<VendorAccountNumberTypeEnum>;
  bankAddress: Maybe<Address>;
  bankName: Maybe<Scalars['String']['output']>;
  bicSwift: Maybe<Scalars['String']['output']>;
  destinationCountry: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastUsedOn: Maybe<Scalars['ISO8601Date']['output']>;
  maskedAccountNumber: Scalars['String']['output'];
  maskedRoutingNumber: Maybe<Scalars['String']['output']>;
  maskedWireRoutingNumber: Maybe<Scalars['String']['output']>;
  preferredReceivingAccount: Scalars['Boolean']['output'];
};

export type PurchaseDetailsInputObject = {
  amount?: InputMaybe<FractionalMoneyInputObject>;
  costTiers?: InputMaybe<Array<CostTierInputObject>>;
  leadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasureConversion?: InputMaybe<Scalars['Float']['input']>;
  vendorLocalBusinessId: Scalars['ID']['input'];
};

export type PurchaseDetailsType = {
  costTiers: Maybe<Array<CostTierType>>;
  id: Scalars['ID']['output'];
  leadTimeDays: Maybe<Scalars['Int']['output']>;
  sku: Maybe<Scalars['String']['output']>;
  unitCost: Maybe<InfinitePrecisionMoney>;
  unitOfMeasure: Maybe<Scalars['String']['output']>;
  unitOfMeasureConversion: Maybe<Scalars['Float']['output']>;
  vendorLocalBusiness: Maybe<LocalBusiness>;
};

export type PurchaseOrder = {
  accountingSyncEvents: Maybe<Array<SyncEvent>>;
  accountingUrl: Maybe<Scalars['String']['output']>;
  actions: PurchaseOrderActions;
  additionalExpenses: Array<AdditionalExpense>;
  additionalExpensesTotal: Money;
  allowedShippingTerms: Array<Scalars['String']['output']>;
  amount: Maybe<Money>;
  approval: Maybe<Approval>;
  archived: Scalars['Boolean']['output'];
  attachment: Maybe<Attachment>;
  attachments: Array<Attachment>;
  auditTrailEvents: Array<AuditTrailEvents>;
  balanceSet: Maybe<PurchaseOrderBalanceSet>;
  contactDetails: Maybe<ContactDetails>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentMilestone: Maybe<Milestone>;
  discountAmount: Maybe<Money>;
  discountPercentage: Maybe<Scalars['Float']['output']>;
  discountType: Maybe<PurchaseOrderDiscountTypeEnum>;
  documentDisplaySettings: DocumentDisplaySettings;
  fullyReceivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  hasFinancingOffer: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated use linkedDocuments instead */
  invoices: Array<Invoice>;
  issueDate: Maybe<Scalars['ISO8601Date']['output']>;
  labels: Array<Label>;
  lineItems: Array<PurchaseOrderLineItem>;
  lineItemsGroups: Array<Maybe<PurchaseOrderLineItemsGroup>>;
  lineItemsMatchOcr: Scalars['Boolean']['output'];
  lineItemsSubtotal: Money;
  lineItemsSubtotalAfterDiscount: Money;
  lineItemsTotal: Money;
  lineItemsViewSettings: PurchaseOrderLineItemsViewSettings;
  linkedDocuments: Array<LinkedDocument>;
  location: Maybe<Location>;
  memo: Maybe<Scalars['String']['output']>;
  milestones: Array<Milestone>;
  number: Maybe<Scalars['String']['output']>;
  ocrStatus: DocumentOcrStatus;
  orientation: PdfOrientationEnum;
  payments: Array<Payment>;
  /** @deprecated Use paymentsForecastTable instead */
  paymentsForecast: Maybe<Array<PaymentsForecast>>;
  paymentsForecastTable: Maybe<PaymentsForecastTable>;
  paymentsOfLinkedInvoices: Array<Payment>;
  pendingOcrChanges: Maybe<DocumentPendingOcrChanges>;
  possibleDuplicates: Array<PurchaseOrder>;
  /** @deprecated use linkedDocuments instead */
  receipts: Array<Receipt>;
  receiveByDate: Maybe<Scalars['ISO8601Date']['output']>;
  shipByDate: Maybe<Scalars['ISO8601Date']['output']>;
  shipments: Array<Shipment>;
  shippingMethod: Maybe<Scalars['String']['output']>;
  shippingTerms: Maybe<Scalars['String']['output']>;
  shippingVendors: Array<LocalBusiness>;
  showPaymentTermsOnAttachment: Scalars['Boolean']['output'];
  showSyncHistory: Maybe<Scalars['Boolean']['output']>;
  source: PurchaseOrderSourceEnum;
  status: PurchaseOrderStatusEnum;
  suggestedPayments: Array<SuggestedPayment>;
  syncError: Maybe<SyncError>;
  syncObjectStatus: Maybe<SyncObjectStatus>;
  taxAmount: Money;
  taxPercentage: Maybe<Scalars['Float']['output']>;
  timelineEvents: Maybe<Array<PurchaseOrderTimelineEvent>>;
  vendorAddress: Maybe<Address>;
  vendorAddressType: Maybe<VendorAddressTypeEnum>;
  /** @deprecated Use paymentsForecastTable instead */
  vendorLeadTimes: Array<VendorLeadTime>;
  vendorLocalBusiness: Maybe<LocalBusiness>;
  /** @deprecated Use paymentsForecastTable instead */
  vendorPaymentTerms: Array<VendorPaymentTerm>;
  /** @deprecated Use paymentsForecastTable instead */
  vendorTerm: Maybe<VendorTerms>;
  viewFormat: PurchaseOrderViewFormatEnum;
};

export type PurchaseOrderActions = {
  addNewPayment: Action;
  attachDocumentPurchaseOrder: Action;
  cancelApprovalRequest: Action;
  createPurchaseOrder: Action;
  overrideApproval: Action;
  requestRuleBasedApproval: Action;
  updatePurchaseOrder: Action;
  updateVendor: Action;
};

export enum PurchaseOrderArchivedStatusEnum {
  ACTIVE_AND_ARCHIVED = 'ACTIVE_AND_ARCHIVED',
  ACTIVE_ONLY = 'ACTIVE_ONLY',
  ARCHIVED_ONLY = 'ARCHIVED_ONLY'
}

export type PurchaseOrderBalanceSet = {
  /** Due to Settle */
  dueToSettleAmount: Maybe<Money>;
  /** Due To Vendor */
  dueToVendorAmount: Maybe<Money>;
  /** PO amount */
  totalAmount: Maybe<Money>;
  /** Remaining balance */
  unscheduledAmount: Maybe<Money>;
  /** Vendor received */
  vendorReceivedAmount: Maybe<Money>;
};

export type PurchaseOrderDiscountInputObject = {
  discountAmount?: InputMaybe<MoneyInputObject>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<PurchaseOrderDiscountTypeEnum>;
};

export enum PurchaseOrderDiscountTypeEnum {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE'
}

export enum PurchaseOrderEventTypeEnum {
  PO_ACKNOWLEDGED = 'PO_ACKNOWLEDGED',
  PO_ADDED = 'PO_ADDED',
  PO_ADDED_AUTOMATICALLY = 'PO_ADDED_AUTOMATICALLY',
  PO_APPROVAL_CANCELLED = 'PO_APPROVAL_CANCELLED',
  PO_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT = 'PO_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT',
  PO_APPROVAL_CANCELLED_PLAN_CHANGE = 'PO_APPROVAL_CANCELLED_PLAN_CHANGE',
  PO_APPROVAL_OVERRIDE_APPROVED = 'PO_APPROVAL_OVERRIDE_APPROVED',
  PO_APPROVAL_OVERRIDE_REJECTED = 'PO_APPROVAL_OVERRIDE_REJECTED',
  PO_APPROVAL_REQUESTED = 'PO_APPROVAL_REQUESTED',
  PO_APPROVED = 'PO_APPROVED',
  PO_AUTO_APPROVED = 'PO_AUTO_APPROVED',
  PO_CANCELED = 'PO_CANCELED',
  PO_CLOSED = 'PO_CLOSED',
  PO_CREATED = 'PO_CREATED',
  PO_OPENED = 'PO_OPENED',
  PO_REJECTED = 'PO_REJECTED',
  PO_SENT_TO_VENDOR = 'PO_SENT_TO_VENDOR',
  PO_SYNCED_FROM_ACCOUNTING = 'PO_SYNCED_FROM_ACCOUNTING'
}

export type PurchaseOrderInputObject = {
  amountCents?: InputMaybe<Scalars['SafeInt']['input']>;
  amountCurrency?: InputMaybe<Scalars['String']['input']>;
  documentDisplaySettings?: InputMaybe<DocumentDisplaySettingsInputObject>;
  issueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  lineItemsViewSettings?: InputMaybe<PurchaseOrderLineItemsViewSettingsInputObject>;
  location?: InputMaybe<LocationInputObject>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  receiveByDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  shipByDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
  shippingTerms?: InputMaybe<Scalars['String']['input']>;
  shippingVendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  showPaymentTermsOnAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PurchaseOrderStatusEnum>;
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
  vendorAddressType?: InputMaybe<VendorAddressTypeEnum>;
  vendorLocalBusinessId?: InputMaybe<Scalars['ID']['input']>;
  /** (Deprecated) Use `paymentsForecast` instead */
  vendorPaymentTerms?: InputMaybe<Array<VendorPaymentTermInputObject>>;
  viewFormat?: InputMaybe<PurchaseOrderViewFormatEnum>;
};

export type PurchaseOrderLineItem = {
  accountingAccount: Maybe<AccountingAccount>;
  accountingCustomerOrProject: Maybe<AccountingDictionary>;
  amountCents: Maybe<Scalars['Float']['output']>;
  amountCurrency: Maybe<Scalars['String']['output']>;
  catalogItemVariation: Maybe<CatalogItemVariation>;
  currentCostTier: Maybe<CostTierType>;
  fractionalLandedCost: Maybe<InfinitePrecisionMoney>;
  hasSimilarCatalogItem: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inventoryQuantity: Maybe<Scalars['Float']['output']>;
  itemName: Maybe<Scalars['String']['output']>;
  lineItemsGroup: Maybe<PurchaseOrderLineItemsGroup>;
  position: Maybe<Scalars['Int']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  shipmentLineItems: Array<ShipmentLineItem>;
  unitOfMeasure: Maybe<Scalars['String']['output']>;
  vendorSku: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrderLineItemInputObject = {
  accountingAccountId?: InputMaybe<Scalars['ID']['input']>;
  accountingCustomerOrProjectId?: InputMaybe<Scalars['ID']['input']>;
  amountCents?: InputMaybe<Scalars['Float']['input']>;
  amountCurrency?: InputMaybe<Scalars['String']['input']>;
  catalogItemVariationId?: InputMaybe<Scalars['ID']['input']>;
  itemName?: InputMaybe<Scalars['String']['input']>;
  lineItemsGroupId?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderLineItemsGroup = {
  accountingAccount: Maybe<AccountingAccount>;
  accountingCustomerOrProject: Maybe<AccountingDictionary>;
  catalogItem: CatalogItem;
  catalogItemPropertyValues: Array<Maybe<CatalogItemPropertyValue>>;
  catalogItemVariation: CatalogItemVariation;
  groupByProperty: Maybe<CatalogItemProperty>;
  id: Scalars['ID']['output'];
  lineItemColumns: Array<Maybe<CatalogItemPropertyValue>>;
  lineItemRows: Array<PurchaseOrderLineItemsGroupRow>;
};

export type PurchaseOrderLineItemsGroupInputObject = {
  accountingAccountId?: InputMaybe<Scalars['ID']['input']>;
  accountingCustomerOrProjectId?: InputMaybe<Scalars['ID']['input']>;
  catalogItemOrVariationId?: InputMaybe<Scalars['ID']['input']>;
  catalogItemPropertyValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupByPropertyId?: InputMaybe<Scalars['ID']['input']>;
};

export type PurchaseOrderLineItemsGroupRow = {
  cost: Array<InfinitePrecisionMoney>;
  fractionalLandedCostRange: Array<InfinitePrecisionMoney>;
  image: Maybe<Blob>;
  imageUrl: Maybe<Scalars['String']['output']>;
  lineItemCells: Array<PurchaseOrderLineItemsGroupRowCell>;
  name: Scalars['String']['output'];
  unitOfMeasure: Array<Scalars['String']['output']>;
};

export type PurchaseOrderLineItemsGroupRowCell = {
  catalogItemVariation: Maybe<CatalogItemVariation>;
  lineItem: Maybe<PurchaseOrderLineItem>;
};

export enum PurchaseOrderLineItemsGroupRowsUpdateActionEnum {
  /** Create a new PurchaseOrder LineItem */
  CREATE = 'CREATE',
  /** Delete the PurchaseOrder LineItem */
  DELETE = 'DELETE',
  /** Update the PurchaseOrder LineItem */
  UPDATE = 'UPDATE'
}

export type PurchaseOrderLineItemsGroupRowsUpdateInputObject = {
  lineItemAction: PurchaseOrderLineItemsGroupRowsUpdateActionEnum;
  lineItemAttributes?: InputMaybe<PurchaseOrderLineItemInputObject>;
  lineItemId?: InputMaybe<Scalars['ID']['input']>;
};

export enum PurchaseOrderLineItemsThumbnailsSize {
  LARGE = 'LARGE',
  SMALL = 'SMALL'
}

export type PurchaseOrderLineItemsViewSettings = {
  itemThumbnailsSize: PurchaseOrderLineItemsThumbnailsSize;
  showItemThumbnails: Scalars['Boolean']['output'];
  showProductDescription: Scalars['Boolean']['output'];
  showUnitCostPerVariation: Scalars['Boolean']['output'];
  showVariantSku: Scalars['Boolean']['output'];
  showVariantVendorSku: Scalars['Boolean']['output'];
};

export type PurchaseOrderLineItemsViewSettingsInputObject = {
  itemThumbnailsSize?: InputMaybe<PurchaseOrderLineItemsThumbnailsSize>;
  showItemThumbnails?: InputMaybe<Scalars['Boolean']['input']>;
  showProductDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showUnitCostPerVariation?: InputMaybe<Scalars['Boolean']['input']>;
  showVariantSku?: InputMaybe<Scalars['Boolean']['input']>;
  showVariantVendorSku?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PurchaseOrderOcr = {
  ocrRecordLineItems: Array<PurchaseOrderOcrLineItem>;
};

export type PurchaseOrderOcrLineItem = {
  amount: Maybe<Money>;
  id: Scalars['ID']['output'];
  matchingCatalogItem: Maybe<CatalogItem>;
  productName: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  sku: Maybe<Scalars['String']['output']>;
  unitAmount: Maybe<Money>;
};

export type PurchaseOrderPaymentInputObject = {
  accountId: Scalars['ID']['input'];
  accountingDetails?: InputMaybe<PaymentAccountingDetailsInputObject>;
  amount: MoneyInputObject;
  localBusinessId: Scalars['ID']['input'];
  paymentDescription?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethodEnum;
  processDate: Scalars['ISO8601Date']['input'];
  purchaseOrderId: Scalars['ID']['input'];
  receivingAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export enum PurchaseOrderPermissionsEnum {
  ATTACH_PURCHASE_ORDER_DOCUMENT = 'ATTACH_PURCHASE_ORDER_DOCUMENT',
  CREATE_PAYMENT_ON_PURCHASE_ORDER = 'CREATE_PAYMENT_ON_PURCHASE_ORDER',
  CREATE_PURCHASE_ORDER = 'CREATE_PURCHASE_ORDER',
  DELETE_PURCHASE_ORDER = 'DELETE_PURCHASE_ORDER',
  LINK_DOCUMENTS_TO_PURCHASE_ORDER = 'LINK_DOCUMENTS_TO_PURCHASE_ORDER',
  READ_PURCHASE_ORDER = 'READ_PURCHASE_ORDER',
  REQUEST_PURCHASE_ORDER_APPROVAL = 'REQUEST_PURCHASE_ORDER_APPROVAL',
  UPDATE_PURCHASE_ORDER = 'UPDATE_PURCHASE_ORDER',
  UPDATE_PURCHASE_ORDER_ARCHIVED = 'UPDATE_PURCHASE_ORDER_ARCHIVED',
  UPDATE_PURCHASE_ORDER_LABELS = 'UPDATE_PURCHASE_ORDER_LABELS'
}

export type PurchaseOrderPostApprovalWorkflow = {
  body?: InputMaybe<Scalars['String']['input']>;
  openPostApproval?: InputMaybe<Scalars['Boolean']['input']>;
  receivingEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  replyToEmail?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderPreliminaryAgreementInput = {
  accountId: Scalars['ID']['input'];
  amount: MoneyInputObject;
  paymentMethod: PaymentMethodEnum;
  processDate: Scalars['ISO8601Date']['input'];
  purchaseOrderId: Scalars['ID']['input'];
};

export enum PurchaseOrderSortableFieldEnum {
  CREATED_AT = 'CREATED_AT',
  ISSUE_DATE = 'ISSUE_DATE',
  NUMBER = 'NUMBER',
  RECEIVE_BY_DATE = 'RECEIVE_BY_DATE'
}

export enum PurchaseOrderSortingDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type PurchaseOrderSortingInputObject = {
  direction: PurchaseOrderSortingDirectionEnum;
  field: PurchaseOrderSortableFieldEnum;
};

export enum PurchaseOrderSourceEnum {
  AI_GENERATED = 'AI_GENERATED',
  GENERATED = 'GENERATED',
  UPLOADED = 'UPLOADED'
}

export enum PurchaseOrderStatusEnum {
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  IN_REVIEW = 'IN_REVIEW',
  OPEN = 'OPEN',
  REJECTED = 'REJECTED'
}

export type PurchaseOrderTimelineEvent = TimelineEventInterface & {
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayText: Scalars['String']['output'];
  eventType: PurchaseOrderEventTypeEnum;
  icon: IconEnum;
  user: Maybe<Approver>;
};

export enum PurchaseOrderViewFormatEnum {
  APPAREL = 'APPAREL',
  DEFAULT = 'DEFAULT'
}

export type PurchaseOrders = {
  data: Array<PurchaseOrder>;
  pagination: Pagination;
};

export type PurchaseOrdersFilteringInputObject = {
  acknowledgedDate?: InputMaybe<DateFilteringInputObject>;
  approverIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  archivedStatus?: InputMaybe<PurchaseOrderArchivedStatusEnum>;
  createdAt?: InputMaybe<DateFilteringInputObject>;
  expectedPayments?: InputMaybe<DateFilteringInputObject>;
  hasFinancedPayments?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<DateFilteringInputObject>;
  labelIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  labelOperator?: InputMaybe<LabelOperatorEnum>;
  milestoneTypes?: InputMaybe<Array<MilestoneTypeEnum>>;
  number?: InputMaybe<Scalars['String']['input']>;
  paymentFriendlyId?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  shippingVendorLocalBusinessIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<PurchaseOrderStatusEnum>>;
  vendorLocalBusinessIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
  withSyncError?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PurposeCode = {
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type PurposeCodesPayload = {
  codes: Array<PurposeCode>;
  required: Scalars['Boolean']['output'];
};

export type Query = {
  account: Account;
  accountantDashboard: AccountantDashboard;
  accountingCounters: AccountingCounters;
  accountingObjectsWithError: SyncObjects;
  accountingState: Maybe<AccountingState>;
  accountingSyncErrorSummaries: SyncErrorSummaries;
  accountingSyncEvents: Maybe<SyncEvents>;
  accounts: Array<Account>;
  accountsForBilling: Array<Account>;
  addressValidation: AddressValidation;
  /** @deprecated Deprecated feature, will be removed after FE cleanup */
  amortizedEarlyRepaymentInterestSavings: Money;
  amortizedLoanEarlyRepaymentPreview: AmortizedLoanEarlyRepaymentPreview;
  apAgingSummary: Array<ApAgingBucketSummary>;
  approvalRuleByInvoiceId: Maybe<Rule>;
  approvalRuleByPurchaseOrderId: Maybe<Rule>;
  attachment: Maybe<Attachment>;
  auditTrailEvents: Array<AuditTrailEvents>;
  banners: Banners;
  beneficialOwnerDataFields: BeneficialOwnersDataFields;
  beneficialOwners: Array<BeneficialOwner>;
  /** @deprecated Use pagedBillingInvoices instead */
  billingInvoices: Array<BillingInvoiceType>;
  billingMethods: Array<BillingMethod>;
  billingPlanFeatures: Array<BillingPlanFeatures>;
  bulletEptEarlyRepaymentPreview: BulletEptEarlyRepaymentPreview;
  business: Maybe<Business>;
  businessFeatures: BusinessFeaturesType;
  businessesForSwitcher: Array<Business>;
  cashAdvanceFinancingOptions: FinancingOptions;
  cashOutflows: Array<CashOutflow>;
  /** @deprecated Use pagedCatalogItemLandedCostDetails instead */
  catalogItemLandedCostDetails: Array<CatalogItemLandedCostDetails>;
  catalogItemPropertyTemplates: Array<CatalogItemProperty>;
  catalogItemVariations: CatalogItemVariations;
  catalogItems: CatalogItems;
  catalogItemsWaitingForSync: Maybe<CatalogItems>;
  checkBillingPlanUpgrade: BillingPlanUpgrade;
  checkEmail: EmailTypeEnum;
  checkInvitation: Maybe<Invitation>;
  checkPayerInvitation: PayerInvitation;
  checkSkuUniqueness: ValidationResult;
  clientApplication: ClientApplication;
  clientBillingDashboard: ClientBillingDashboardType;
  clientBillingInvoices: ClientBillingInvoicesType;
  clientManagerDashboard: ClientManagerDashboard;
  clientPlans: Array<BillingPlanType>;
  consolidatedPaymentFinancingOptions: FinancingOptions;
  counters: Counters;
  countries: Array<Country>;
  /** Get all the statuses of the csv imports */
  csvImportStatuses: Array<CsvImportStatus>;
  currencies: Array<Currency>;
  dashboard: Dashboard;
  deactivatedBusinesses: Array<PublicBusiness>;
  deepLinkedDocuments: Array<LinkedDocument>;
  defaultInterestSummary: Maybe<DefaultInterestSummary>;
  disclosures: Disclosures;
  discounts: Array<BillingDiscountType>;
  discrepancyRules: Array<DiscrepancyRule>;
  dueDatesForConsolidatedGroups: Array<ConsolidatedPaymentGroupWithDueDateType>;
  earlyRepaymentBalance: RepaymentBalance;
  /** @deprecated Use pagedEarlyRepaymentPayments instead */
  earlyRepaymentPayments: Array<ReconciliationItem>;
  eptMetrics: EptMetrics;
  estimateRecurrentPaymentsTimelines: Array<RecurrentPaymentsEstimatedTimeline>;
  exchangeFeeData: ExchangeFeeData;
  excludedFromSync: Array<SyncObject>;
  extendedDowngradeDetails: Maybe<Array<BillingExtendedDowngradeDetailsType>>;
  externalApprovalRequest: Maybe<ExternalApprovalRequest>;
  fetchUnauthenticatedShopifyRedirect: Scalars['String']['output'];
  finaloopState: Maybe<FinaloopState>;
  finicityConnectUrlV2: ConnectUrl;
  finicityConnections: Array<FinicityLink>;
  fullRepaymentBalance: FullRepaymentBalance;
  holidays: Array<Holiday>;
  informationRequest: Maybe<InformationRequest>;
  integrationsState: IntegrationsState;
  internationalWireFields: Array<InternationalWireFieldsDataFieldType>;
  invoice: Invoice;
  invoiceOcrData: Maybe<InvoiceOcr>;
  invoiceStatusCounts: InvoiceStatusCounts;
  invoices: Array<Invoice>;
  invoicesAddressesValidation: Maybe<Array<InvoiceAddressValidationType>>;
  invoicesFilteringOptions: InvoiceFilteringOptions;
  invoicesPossibleForAllocation: Maybe<Invoices>;
  invoicesWaitingForSync: Maybe<Invoices>;
  journeys: Array<Journey>;
  kybDataRequest: KybDataRequest;
  labels: Array<Label>;
  linkableCatalogItems: PagedLinkableCatalogItems;
  linkableLocations: PagedLinkableLocations;
  linkedDocuments: Array<LinkedDocument>;
  listReports: Maybe<Reports>;
  localBusinessAccounts: Array<LocalBusinessAccount>;
  localBusinesses: LocalBusinesses;
  locations: Array<Location>;
  marketingVirtualCard: Maybe<MarketingVirtualCard>;
  marketingVirtualCardAuthorizations: AuthorizationPaginated;
  marketingVirtualCardSecure: Maybe<MarketingVirtualCardSecure>;
  marketingVirtualCardTransactions: TransactionPaginated;
  matchDocuments: DocumentsMatchingData;
  metabaseCreateEmbedToken: MetabaseEmbedToken;
  middeskSearch: MiddeskSearch;
  netsuiteState: Maybe<NetsuiteState>;
  /** @deprecated Use generic unpaid_bills instead. */
  netsuiteUnpaidBills: Maybe<Array<NetsuiteUnpaidBill>>;
  newBillingPlans: Array<BillingPlanType>;
  newCashAdvanceEptGrandTotal: Maybe<Money>;
  newEptGrandTotal: Maybe<Money>;
  newPaymentFinancingOptions: FinancingOptions;
  notificationSettings: NotificationSettings;
  /** Get all onboarding flows for the current business */
  onboardingFlows: Array<FlowUnion>;
  orderProfitabilityBatchLandedCost: Array<BatchLandedCostProfitability>;
  orderProfitabilityWeightedAverageCost: Array<WeightedAverageCostProfitability>;
  pagedBillingInvoices: BillingInvoicesType;
  pagedCatalogItemBatchLandedCostDetails: PagedCatalogItemBatchLandedCostDetails;
  pagedCatalogItemLandedCostDetails: PagedCatalogItemLandedCostDetails;
  pagedEarlyRepaymentPayments: ReconciliationItems;
  pagedInvoices: Invoices;
  pagedLocalBusinessShipmentLocations: PagedLocalBusinessShipmentLocations;
  pagedLocations: PagedLocations;
  pagedOutboundOrders: PagedOutboundOrders;
  pagedReconciliationItems: ReconciliationItems;
  pagedRecurrentPaymentsSchedules: RecurrentPaymentsPagedSchedules;
  pagedSalesChannelConfigurations: PagedSalesChannelConfigurations;
  pagedWorkOrders: PagedWorkOrders;
  payerInvitation: PayerInvitationV2;
  paymentsPageCutoffWarning: Maybe<Scalars['String']['output']>;
  permissionSets: Array<PermissionSet>;
  permissions: Permissions;
  phoneFactor: Maybe<PhoneFactor>;
  plaidConnections: Array<PlaidLink>;
  plaidCreateLinkToken: Scalars['String']['output'];
  preliminaryConsolidatedInvoicesGroups: Array<PreliminaryConsolidatedInvoicesGroupType>;
  previewAsPayableInvoice: PayableInvoicePreview;
  processDateForArrival: ProcessDateForArrivalResult;
  processDatesToArriveOnDueDateForConsolidatedGroups: Array<ConsolidatedPaymentGroupWithProcessDateType>;
  processingEstimates: ProcessingEstimates;
  profile: Profile;
  promotionCodes: Array<BillingPromotionCodeType>;
  publicBusinesses: Array<PublicBusiness>;
  publicInvoice: PublicInvoice;
  purchaseOrderFinancingOptions: FinancingOptions;
  purchaseOrderOcrData: Maybe<PurchaseOrderOcr>;
  purchaseOrders: PurchaseOrders;
  purchaseOrdersWaitingForSync: Maybe<PurchaseOrders>;
  /** @deprecated use purposeCodesV2 instead */
  purposeCodes: Array<PurposeCode>;
  purposeCodesV2: PurposeCodesPayload;
  quickBooksLoginUrl: Scalars['String']['output'];
  quickBooksState: Maybe<QuickBooksState>;
  /** @deprecated Use generic unpaid_bills instead. */
  quickBooksUnpaidBills: Maybe<Array<QuickBooksUnpaidBill>>;
  rateLimits: Array<RateLimit>;
  receipts: Receipts;
  receivableInvoices: ReceivableInvoices;
  receivableReconciliationItem: ReceivableReconciliationItem;
  receivables: Receivables;
  recentReports: Array<Report>;
  reconciliationItem: ReconciliationItem;
  reconciliationItemsFilteringOptions: ReconciliationItemFilteringOptions;
  reconciliationItemsPossibleForAllocation: ReconciliationItems;
  recurrentPaymentsSchedule: RecurrentPaymentsSchedule;
  referralCodeV2: Maybe<CodeTypeV2>;
  report: Maybe<Report>;
  report1099Years: Array<ReportYear>;
  reportSchedules: Array<ReportSchedule>;
  reportsFilteringOptions: ReportFilteringOptions;
  ruleMetadata: RuleMetadata;
  rules: Array<Rule>;
  salesChannels: Array<OutboundOrderChannel>;
  searchOrderDocuments: PagedOrderDocuments;
  semanticSearchCatalogItems: Array<CatalogItemSemanticSearchResult>;
  settleInboxAutopayableConfig: Maybe<SettleInboxAutopayableConfigType>;
  settleInboxMessages: SettleInboxMessages;
  /** Gets products based on title or sku from customer's Shopify API */
  shopifyProducts: Array<ShopifyProduct>;
  shopifyState: Maybe<ShopifyState>;
  signIns: Array<SignIn>;
  subscriptionFreezingDetails: Maybe<Message>;
  suggestedVendorAccounts: Maybe<Array<InvoiceSuggestedVendorAccount>>;
  /** @deprecated use teamMembersV2 instead */
  teamMember: TeamMember;
  teamMemberV2: Maybe<TeamMember>;
  teamMembers: TeamMembers;
  testingMicroDeposits: TestingMicroDeposits;
  testingTokens: TestingTokens;
  totalDebits: TotalDebits;
  totp: Maybe<Totp>;
  transactionalTodoListSummary: Array<TransactionalTodoListSummary>;
  unimportedPurchaseOrders: Maybe<UnimportedPurchaseOrders>;
  unitsOfMeasure: Array<Scalars['String']['output']>;
  unpaidBills: Maybe<Array<UnpaidBill>>;
  unpaidBillsPaginated: Maybe<UnpaidBillsPaginated>;
  upcomingBillingInvoiceV2: Maybe<BillingInvoiceType>;
  userRole: Maybe<UserRole>;
  userRoles: Array<UserRole>;
  validateReferralCode: ValidateReferralCode;
  vendorCredit: VendorCredit;
  vendorCreditsWaitingForSync: Maybe<VendorCredits>;
  vendorFinancingOffer: VendorFinancingOffer;
  vendorInvitation: VendorInvitation;
  vendorLeadTimes: Array<VendorLeadTime>;
  vendorTermOptions: Array<VendorTermOption>;
  workingCapitalUtilization: WorkingCapitalUtilization;
  xeroLoginUrl: Scalars['String']['output'];
  xeroState: Maybe<XeroState>;
  /** @deprecated Use generic unpaid_bills instead. */
  xeroUnpaidBills: Maybe<Array<XeroUnpaidBill>>;
};


export type QueryaccountArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryaccountingObjectsWithErrorArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  syncErrorMessage: Scalars['String']['input'];
  syncObjectType: SyncObjectTypeEnum;
};


export type QueryaccountingSyncErrorSummariesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryaccountingSyncEventsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  syncObjectType: SyncObjectTypeEnum;
};


export type QueryaccountsArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  lockbox?: InputMaybe<Scalars['Boolean']['input']>;
  paying?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryaddressValidationArgs = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  inputAddress?: InputMaybe<AddressInputObject>;
};


export type QueryamortizedEarlyRepaymentInterestSavingsArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  paymentId: Scalars['ID']['input'];
};


export type QueryamortizedLoanEarlyRepaymentPreviewArgs = {
  paymentId: Scalars['ID']['input'];
  repaymentAmount: MoneyInputObject;
  repaymentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryapAgingSummaryArgs = {
  includedLocalBusinessIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  numDistinctVendors?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryapprovalRuleByInvoiceIdArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type QueryapprovalRuleByPurchaseOrderIdArgs = {
  purchaseOrderId: Scalars['ID']['input'];
};


export type QueryattachmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryauditTrailEventsArgs = {
  entityId: Scalars['ID']['input'];
};


export type QuerybannersArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerybeneficialOwnerDataFieldsArgs = {
  countryCode: Scalars['String']['input'];
};


export type QuerybillingInvoicesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerybulletEptEarlyRepaymentPreviewArgs = {
  paymentId: Scalars['ID']['input'];
  repaymentAmount: MoneyInputObject;
  repaymentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QuerybusinessArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerybusinessesForSwitcherArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerycashAdvanceFinancingOptionsArgs = {
  amount: MoneyInputObject;
};


export type QuerycashOutflowsArgs = {
  apForecastEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  unscheduledBills?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerycatalogItemLandedCostDetailsArgs = {
  catalogItemOrVariationId: Scalars['ID']['input'];
  filterLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerycatalogItemVariationsArgs = {
  catalogItemVariationsFilter?: InputMaybe<CatalogItemVariationsFilteringInputObject>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<CatalogItemVariationsSortingInputObject>;
};


export type QuerycatalogItemsArgs = {
  catalogItemsFilter?: InputMaybe<CatalogItemsFilteringInputObject>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerycatalogItemsWaitingForSyncArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerycheckBillingPlanUpgradeArgs = {
  billingPlanId: Scalars['ID']['input'];
};


export type QuerycheckEmailArgs = {
  email: Scalars['String']['input'];
};


export type QuerycheckInvitationArgs = {
  invitationToken: Scalars['String']['input'];
};


export type QuerycheckPayerInvitationArgs = {
  invitationCode: Scalars['String']['input'];
};


export type QuerycheckSkuUniquenessArgs = {
  catalogItemVariationId: Scalars['ID']['input'];
  sku: Scalars['String']['input'];
};


export type QueryclientApplicationArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryclientBillingDashboardArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryclientBillingInvoicesArgs = {
  clientBusinessId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryclientManagerDashboardArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryconsolidatedPaymentFinancingOptionsArgs = {
  members: Array<ConsolidatedPaymentMemberInputObject>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  vendorPaymentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QuerydeactivatedBusinessesArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerydeepLinkedDocumentsArgs = {
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  purchaseOrderId?: InputMaybe<Scalars['ID']['input']>;
  receiptId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerydisclosuresArgs = {
  template?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerydueDatesForConsolidatedGroupsArgs = {
  groups: Array<ConsolidatePaymentDueDateForGroupInputObject>;
  paymentMethod: PaymentMethodEnum;
};


export type QueryearlyRepaymentBalanceArgs = {
  amount: MoneyInputObject;
  paymentId: Scalars['ID']['input'];
  repaymentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryestimateRecurrentPaymentsTimelinesArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  interval: RecurrentPaymentsIntervalEnum;
  paymentAttributes: PaymentAttributesForEstimatesInputObject;
  paymentMethod: PaymentMethodEnum;
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryexchangeFeeDataArgs = {
  amount: MoneyInputObject;
};


export type QueryextendedDowngradeDetailsArgs = {
  planFromId: Scalars['ID']['input'];
  planToId: Scalars['ID']['input'];
};


export type QueryexternalApprovalRequestArgs = {
  token: Scalars['String']['input'];
};


export type QueryfetchUnauthenticatedShopifyRedirectArgs = {
  shopifyOauthArguments?: InputMaybe<Scalars['String']['input']>;
};


export type QueryfinicityConnectUrlV2Args = {
  finicityConnectionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryfullRepaymentBalanceArgs = {
  paymentId: Scalars['ID']['input'];
  repaymentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryholidaysArgs = {
  beforeDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryinformationRequestArgs = {
  token: Scalars['String']['input'];
};


export type QueryinternationalWireFieldsArgs = {
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  targetType: InternationalWireTargetTypeEnum;
};


export type QueryinvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type QueryinvoiceOcrDataArgs = {
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  receivableId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryinvoicesArgs = {
  invoiceIds: Array<Scalars['ID']['input']>;
};


export type QueryinvoicesAddressesValidationArgs = {
  invoiceIds: Array<Scalars['ID']['input']>;
  paymentMethod: PaymentMethodEnum;
};


export type QueryinvoicesFilteringOptionsArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryinvoicesPossibleForAllocationArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  paymentId: Scalars['ID']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryinvoicesWaitingForSyncArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryjourneysArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerykybDataRequestArgs = {
  dataRequestId: Scalars['ID']['input'];
};


export type QuerylabelsArgs = {
  filter?: InputMaybe<LabelsFilteringInputObject>;
  labelId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerylinkableCatalogItemsArgs = {
  linkableCatalogItemsFilter?: InputMaybe<LinkableCatalogItemsFilteringInputObject>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerylinkableLocationsArgs = {
  linkableLocationsFilter?: InputMaybe<LinkableLocationsFilteringInputObject>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerylinkedDocumentsArgs = {
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  purchaseOrderId?: InputMaybe<Scalars['ID']['input']>;
  receiptId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistReportsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<StatusEnum>>;
};


export type QuerylocalBusinessAccountsArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  destinationCountry?: InputMaybe<Scalars['String']['input']>;
  localBusinessId: Scalars['ID']['input'];
};


export type QuerylocalBusinessesArgs = {
  fulltext?: InputMaybe<Scalars['Boolean']['input']>;
  invited?: InputMaybe<Scalars['Boolean']['input']>;
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  labelOperator?: InputMaybe<LabelOperatorEnum>;
  localBusinessId?: InputMaybe<Scalars['ID']['input']>;
  localBusinessIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<LocalBusinessRoleEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<LocalBusinessSortingInputObject>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  withEmptyName?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withLocation?: InputMaybe<Scalars['Boolean']['input']>;
  withW8OrW9FormMissing?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerylocationsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerymarketingVirtualCardAuthorizationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerymarketingVirtualCardTransactionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerymatchDocumentsArgs = {
  linkedDocumentIds: Array<Scalars['ID']['input']>;
  recordUsage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerymetabaseCreateEmbedTokenArgs = {
  dashboard?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerymiddeskSearchArgs = {
  businessId: Scalars['ID']['input'];
  legalName: Scalars['String']['input'];
  stateOfFormation: Scalars['String']['input'];
};


export type QuerynewCashAdvanceEptGrandTotalArgs = {
  amount?: InputMaybe<MoneyInputObject>;
  offerIds: Array<Scalars['ID']['input']>;
  paymentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerynewEptGrandTotalArgs = {
  amount: MoneyInputObject;
  invoiceId: Scalars['ID']['input'];
  offerIds: Array<Scalars['ID']['input']>;
};


export type QuerynewPaymentFinancingOptionsArgs = {
  amount: MoneyInputObject;
  invoiceId: Scalars['ID']['input'];
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  vendorPaymentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryonboardingFlowsArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryorderProfitabilityBatchLandedCostArgs = {
  outboundOrderId: Scalars['ID']['input'];
};


export type QueryorderProfitabilityWeightedAverageCostArgs = {
  outboundOrderId: Scalars['ID']['input'];
};


export type QuerypagedBillingInvoicesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerypagedCatalogItemBatchLandedCostDetailsArgs = {
  catalogItemVariationId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerypagedCatalogItemLandedCostDetailsArgs = {
  catalogItemVariationId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerypagedEarlyRepaymentPaymentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerypagedInvoicesArgs = {
  invoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoicesFilter?: InputMaybe<InvoicesFilteringInputObject>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<InvoiceSortingInputObject>;
};


export type QuerypagedLocalBusinessShipmentLocationsArgs = {
  localBusinessId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypagedLocationsArgs = {
  locationFilter?: InputMaybe<LocationFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerypagedOutboundOrdersArgs = {
  filter?: InputMaybe<OutboundOrdersFilteringInputObject>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<OutboundOrdersSortingInputObject>;
};


export type QuerypagedReconciliationItemsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  reconciliationItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  reconciliationItemsFilter?: InputMaybe<ReconciliationItemsFilteringInputObject>;
  sorting?: InputMaybe<ReconciliationItemSortingInputObject>;
};


export type QuerypagedRecurrentPaymentsSchedulesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerypagedSalesChannelConfigurationsArgs = {
  filter?: InputMaybe<SalesChannelConfigurationsFilteringInputObject>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerypagedWorkOrdersArgs = {
  filter?: InputMaybe<WorkOrdersFilteringInputObject>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerypayerInvitationArgs = {
  invitationCode: Scalars['String']['input'];
};


export type QueryplaidCreateLinkTokenArgs = {
  plaidItemId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerypreliminaryConsolidatedInvoicesGroupsArgs = {
  requestsData: Array<ConsolidatePaymentPreliminaryGroupRequestInputObject>;
};


export type QuerypreviewAsPayableInvoiceArgs = {
  settleInboxAttachmentId: Scalars['ID']['input'];
};


export type QueryprocessDateForArrivalArgs = {
  financingDays?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  paymentAttributes?: InputMaybe<PaymentAttributesForEstimatesInputObject>;
  paymentMethod: PaymentMethodEnum;
  targetArrivalDate: Scalars['ISO8601Date']['input'];
};


export type QueryprocessDatesToArriveOnDueDateForConsolidatedGroupsArgs = {
  groups: Array<ConsolidatePaymentDueDateForGroupInputObject>;
  paymentMethod: PaymentMethodEnum;
};


export type QueryprocessingEstimatesArgs = {
  financingDays?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  paymentAttributes?: InputMaybe<PaymentAttributesForEstimatesInputObject>;
  paymentMethod: PaymentMethodEnum;
  scheduledFor?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QuerypromotionCodesArgs = {
  code: Scalars['String']['input'];
};


export type QuerypublicBusinessesArgs = {
  publicBusinessIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypublicInvoiceArgs = {
  uuid: Scalars['String']['input'];
};


export type QuerypurchaseOrderFinancingOptionsArgs = {
  amount: MoneyInputObject;
  paymentMethod: PaymentMethodEnum;
  purchaseOrderId: Scalars['ID']['input'];
};


export type QuerypurchaseOrderOcrDataArgs = {
  purchaseOrderId: Scalars['ID']['input'];
};


export type QuerypurchaseOrdersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrdersFilter?: InputMaybe<PurchaseOrdersFilteringInputObject>;
  purchaseOrdersSorting?: InputMaybe<PurchaseOrderSortingInputObject>;
};


export type QuerypurchaseOrdersWaitingForSyncArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerypurposeCodesArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  destinationCountry?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypurposeCodesV2Args = {
  currency?: InputMaybe<Scalars['String']['input']>;
  destinationCountry?: InputMaybe<Scalars['String']['input']>;
};


export type QueryreceiptsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  receiptsFilter?: InputMaybe<ReceiptsFilteringInputObject>;
};


export type QueryreceivableInvoicesArgs = {
  invoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoicesFilter?: InputMaybe<InvoicesFilteringInputObject>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<ReceivableInvoicesSortingInputObject>;
};


export type QueryreceivableReconciliationItemArgs = {
  reconciliationItemId: Scalars['ID']['input'];
};


export type QueryreceivablesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  receivableId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryreconciliationItemArgs = {
  reconciliationItemId: Scalars['ID']['input'];
};


export type QueryreconciliationItemsPossibleForAllocationArgs = {
  includesVendor?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryrecurrentPaymentsScheduleArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type QueryreportArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryrulesArgs = {
  ruleId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerysearchOrderDocumentsArgs = {
  filter?: InputMaybe<PagedOrderDocumentsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerysemanticSearchCatalogItemsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  minSimilarity?: InputMaybe<Scalars['Float']['input']>;
  query: Scalars['String']['input'];
};


export type QuerysettleInboxMessagesArgs = {
  archived: Scalars['Boolean']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryshopifyProductsArgs = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QuerysuggestedVendorAccountsArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type QueryteamMemberArgs = {
  teamMemberId: Scalars['ID']['input'];
};


export type QueryteamMemberV2Args = {
  teamMemberId: Scalars['ID']['input'];
};


export type QueryteamMembersArgs = {
  teamMemberStatus?: InputMaybe<TeamMemberStatusEnum>;
  userRoleGroup?: InputMaybe<UserRoleGroupEnum>;
};


export type QuerytestingMicroDepositsArgs = {
  email: Scalars['String']['input'];
};


export type QuerytestingTokensArgs = {
  email: Scalars['String']['input'];
};


export type QuerytotalDebitsArgs = {
  reconciliationItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  reconciliationItemsFilter?: InputMaybe<ReconciliationItemsFilteringInputObject>;
};


export type QueryunimportedPurchaseOrdersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryunpaidBillsPaginatedArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryuserRoleArgs = {
  roleId: Scalars['ID']['input'];
};


export type QueryuserRolesArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  userRoleGroup?: InputMaybe<UserRoleGroupEnum>;
};


export type QueryvalidateReferralCodeArgs = {
  medium?: InputMaybe<Scalars['String']['input']>;
  referralCode: Scalars['String']['input'];
};


export type QueryvendorCreditArgs = {
  vendorCreditId: Scalars['ID']['input'];
};


export type QueryvendorCreditsWaitingForSyncArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryvendorFinancingOfferArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type QueryvendorInvitationArgs = {
  invitationToken: Scalars['String']['input'];
};


export type QueryvendorLeadTimesArgs = {
  localBusinessId: Scalars['ID']['input'];
  purchaseOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryvendorTermOptionsArgs = {
  localBusinessId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryworkingCapitalUtilizationArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuickBooksAccount = {
  accountSubType: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  children: Array<QuickBooksAccount>;
  classification: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  number: Maybe<Scalars['String']['output']>;
  subAccount: Scalars['Boolean']['output'];
};

export type QuickBooksAccountMapping = {
  accountId: Scalars['ID']['output'];
  accountingAccountId: Maybe<Scalars['ID']['output']>;
  externalAccountId: Maybe<Scalars['ID']['output']>;
  quickBooksAccountId: Maybe<Scalars['ID']['output']>;
};

export type QuickBooksAccountMappingInputObject = {
  accountId: Scalars['ID']['input'];
  externalAccountId?: InputMaybe<Scalars['ID']['input']>;
  quickBooksAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuickBooksDictionary = {
  children: Array<QuickBooksDictionary>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type QuickBooksState = {
  accountMappings: Array<QuickBooksAccountMapping>;
  accounts: Array<QuickBooksAccount>;
  autoImportBills: Scalars['Boolean']['output'];
  autoImportPurchaseOrders: Scalars['Boolean']['output'];
  bankAccounts: Array<QuickBooksAccount>;
  bookCloseDate: Maybe<Scalars['ISO8601Date']['output']>;
  classes: Array<QuickBooksDictionary>;
  classesAvailable: Scalars['Boolean']['output'];
  connected: Scalars['Boolean']['output'];
  creditCardAccounts: Array<QuickBooksAccount>;
  expenseAccounts: Array<QuickBooksAccount>;
  feeExpensesAccountId: Maybe<Scalars['ID']['output']>;
  filteredAccounts: Array<QuickBooksAccount>;
  liabilityAccounts: Array<QuickBooksAccount>;
  locations: Array<QuickBooksDictionary>;
  locationsAvailable: Scalars['Boolean']['output'];
  multiCurrency: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  prepaymentsAccountId: Maybe<Scalars['ID']['output']>;
  readOnly: Scalars['Boolean']['output'];
  receivableBankAccountId: Maybe<Scalars['ID']['output']>;
  settleLiabilityAccountId: Maybe<Scalars['ID']['output']>;
  standalonePaymentsExpensesAccountId: Maybe<Scalars['ID']['output']>;
  syncAutomatically: Scalars['Boolean']['output'];
  syncErrorMessage: Maybe<Scalars['String']['output']>;
  syncScheduledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  syncStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  syncStartedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  syncState: SyncStateEnum;
  syncUncategorizedExpenses: Scalars['Boolean']['output'];
  syncedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  trackClasses: Scalars['Boolean']['output'];
  trackLocations: Scalars['Boolean']['output'];
  unallocatedExpensesAccountId: Maybe<Scalars['ID']['output']>;
};

export type QuickBooksUnpaidBill = {
  amount: Maybe<Money>;
  balance: Maybe<Money>;
  dueDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  issueDate: Maybe<Scalars['ISO8601Date']['output']>;
  number: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  vendorName: Maybe<Scalars['String']['output']>;
};

export type RateLimit = {
  expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  resource: ResourceEnum;
};

export enum ReasonEnum {
  BLOCKED = 'BLOCKED',
  DORMANT = 'DORMANT',
  IN_REVIEW = 'IN_REVIEW',
  NEED_BENEFICIAL_OWNER = 'NEED_BENEFICIAL_OWNER',
  NEED_BUSINESS_INFO = 'NEED_BUSINESS_INFO',
  NEED_SIGNIFICANT_CONTROL = 'NEED_SIGNIFICANT_CONTROL'
}

export type Receipt = {
  actions: ReceiptActions;
  archived: Scalars['Boolean']['output'];
  attachment: Maybe<Attachment>;
  attachments: Array<Attachment>;
  auditTrailEvents: Array<AuditTrailEvents>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  documentDisplaySettings: DocumentDisplaySettings;
  id: Scalars['ID']['output'];
  issueDate: Maybe<Scalars['ISO8601Date']['output']>;
  lineItems: Array<ReceiptLineItem>;
  linkedDocuments: Array<LinkedDocument>;
  location: Maybe<Location>;
  memo: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['String']['output']>;
  receivedOn: Maybe<Scalars['ISO8601Date']['output']>;
  shipment: Maybe<Shipment>;
  shippingVendors: Array<LocalBusiness>;
  vendorLocalBusiness: Maybe<LocalBusiness>;
};

export type ReceiptActions = {
  archive: Action;
  createReceipt: Action;
  delete: Action;
  updateReceipt: Action;
};

export enum ReceiptArchivedStatusEnum {
  ACTIVE_AND_ARCHIVED = 'ACTIVE_AND_ARCHIVED',
  ACTIVE_ONLY = 'ACTIVE_ONLY',
  ARCHIVED_ONLY = 'ARCHIVED_ONLY'
}

export type ReceiptCreateInputObject = {
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderId?: InputMaybe<Scalars['ID']['input']>;
  shipmentId?: InputMaybe<Scalars['ID']['input']>;
  uploadSignedId?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type ReceiptInputObject = {
  documentDisplaySettings?: InputMaybe<DocumentDisplaySettingsInputObject>;
  issueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  receivedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  shippingVendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vendorLocalBusinessId?: InputMaybe<Scalars['ID']['input']>;
};

export type ReceiptLineItem = {
  catalogItemVariation: Maybe<CatalogItemVariation>;
  hasInventory: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  itemName: Maybe<Scalars['String']['output']>;
  lotCode: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  previousReceivedQuantity: Maybe<Scalars['Float']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  quantityOrdered: Maybe<Scalars['Float']['output']>;
  receipt: Receipt;
  shipmentQuantity: Maybe<Scalars['Float']['output']>;
  unitOfMeasure: Maybe<Scalars['String']['output']>;
};

export type ReceiptLineItemInputObject = {
  catalogItemVariationId?: InputMaybe<Scalars['ID']['input']>;
  lotCode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
};

export enum ReceiptPermissionsEnum {
  ATTACH_RECEIPT_DOCUMENT = 'ATTACH_RECEIPT_DOCUMENT',
  CREATE_RECEIPT = 'CREATE_RECEIPT',
  DELETE_RECEIPT = 'DELETE_RECEIPT',
  LINK_DOCUMENTS_TO_RECEIPT = 'LINK_DOCUMENTS_TO_RECEIPT',
  READ_RECEIPT = 'READ_RECEIPT',
  UPDATE_RECEIPT = 'UPDATE_RECEIPT',
  UPDATE_RECEIPT_ARCHIVED = 'UPDATE_RECEIPT_ARCHIVED'
}

export type Receipts = {
  data: Array<Receipt>;
  pagination: Pagination;
};

export type ReceiptsFilteringInputObject = {
  archivedStatus?: InputMaybe<ReceiptArchivedStatusEnum>;
  number?: InputMaybe<Scalars['String']['input']>;
  receiptIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vendorLocalBusinessIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type Receivable = {
  account: Maybe<Account>;
  accountNumber: Maybe<Scalars['String']['output']>;
  agreement: Maybe<Scalars['String']['output']>;
  amount: Maybe<Money>;
  attachments: Array<Attachment>;
  balancePaymentAmount: Maybe<Money>;
  balancePaymentDate: Maybe<Scalars['ISO8601Date']['output']>;
  balancePaymentStatus: Maybe<BalancePaymentStatusEnum>;
  ccAddress: Maybe<Scalars['String']['output']>;
  collectionDate: Maybe<Scalars['ISO8601Date']['output']>;
  collectionMethod: Maybe<ReceivableCollectionMethodEnum>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated use 'payer.first_name'/'payer.last_name' instead */
  customerContactName: Maybe<Scalars['String']['output']>;
  /** @deprecated use 'payer.notifications_email' instead */
  customerEmail: Maybe<Scalars['String']['output']>;
  /** @deprecated use 'payer.name' instead */
  customerName: Maybe<Scalars['String']['output']>;
  debitApproved: Maybe<Scalars['Boolean']['output']>;
  deletable: Scalars['Boolean']['output'];
  depositDate: Scalars['ISO8601Date']['output'];
  dueDate: Maybe<Scalars['ISO8601Date']['output']>;
  expectedRepaymentDate: Maybe<Scalars['ISO8601Date']['output']>;
  feeAmount: Maybe<Money>;
  feePercent: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  initialDepositAmount: Maybe<Money>;
  issueDate: Maybe<Scalars['ISO8601Date']['output']>;
  labels: Array<Label>;
  number: Maybe<Scalars['String']['output']>;
  payerBusiness: Maybe<LocalBusiness>;
  payment: Maybe<Payment>;
  paymentMethod: Maybe<PaymentMethodEnum>;
  receivableAmount: Maybe<Money>;
  requestedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  revokable: Scalars['Boolean']['output'];
  routingNumber: Maybe<Scalars['String']['output']>;
  settleRepaymentAmount: Maybe<Money>;
  showsDetails: Scalars['Boolean']['output'];
  signedDocuments: Array<SignedDocument>;
  status: ReceivableStatusEnum;
};

export type ReceivableAllocation = {
  amount: Maybe<Money>;
  id: Scalars['ID']['output'];
  includedInConsolidatedPayment: Scalars['Boolean']['output'];
  invoice: Maybe<ReceivableInvoice>;
  payment: Maybe<ReceivablePayment>;
  reconciliationItems: Array<ReconciliationItem>;
  status: InvoiceStatusEnum;
  statuses: Array<InvoiceStatusEnum>;
};

export enum ReceivableCollectionMethodEnum {
  SETTLE_DEBITS_MY_BUSINESS = 'SETTLE_DEBITS_MY_BUSINESS',
  SETTLE_INVOICES_CUSTOMER = 'SETTLE_INVOICES_CUSTOMER'
}

export type ReceivableInputObject = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  amountCents?: InputMaybe<Scalars['SafeInt']['input']>;
  amountCurrency?: InputMaybe<Scalars['String']['input']>;
  collectionMethod?: InputMaybe<ReceivableCollectionMethodEnum>;
  customerContactName?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  expectedRepaymentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  issueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  payerBusinessId?: InputMaybe<Scalars['ID']['input']>;
};

export type ReceivableInvoice = {
  actions: InvoiceActions;
  allocations: Maybe<Array<ReceivableAllocation>>;
  amount: Maybe<Money>;
  archived: Scalars['Boolean']['output'];
  attachment: Maybe<Attachment>;
  attachments: Array<Attachment>;
  balanceDue: Maybe<Money>;
  contactDetails: Maybe<ContactDetails>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  discountAmount: Maybe<Money>;
  discountPercentage: Maybe<Scalars['Float']['output']>;
  discountType: Maybe<PurchaseOrderDiscountTypeEnum>;
  dueDate: Maybe<Scalars['ISO8601Date']['output']>;
  dueDays: Maybe<Scalars['Int']['output']>;
  dueToVendorAmount: Maybe<Money>;
  externalReceivableReconciliationItems: Maybe<Array<ReceivableReconciliationItem>>;
  id: Scalars['ID']['output'];
  issueDate: Maybe<Scalars['ISO8601Date']['output']>;
  liabilityAmount: Money;
  lineItems: Array<ReceivableInvoiceLineItem>;
  lineItemsMatchOcr: Scalars['Boolean']['output'];
  lineItemsSubtotalAfterDiscount: Maybe<Money>;
  markedAsPaid: Scalars['Boolean']['output'];
  mdrFeeTotal: Maybe<Money>;
  memo: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['String']['output']>;
  ocrStatus: DocumentOcrStatus;
  outboundOrder: Maybe<OutboundOrder>;
  paidOn: Maybe<Scalars['ISO8601Date']['output']>;
  paidWithMethod: Maybe<PaymentMethodEnum>;
  paperCheckDetails: Maybe<PaperCheckDetails>;
  payWithLink: Scalars['Boolean']['output'];
  payerBusiness: Maybe<PublicBusiness>;
  payerLocalBusiness: Maybe<LocalBusiness>;
  paymentLinkUrl: Maybe<Scalars['String']['output']>;
  payments: Array<ReceivablePayment>;
  paymentsForecast: Maybe<PaymentsForecastTable>;
  paymentsNetTotalAmount: Money;
  paymentsTotalAmount: Money;
  payoutReceivableReconciliationItems: Maybe<Array<ReceivableReconciliationItem>>;
  possibleDuplicates: Array<ReceivableInvoice>;
  purchaseOrderNumber: Maybe<Scalars['String']['output']>;
  purposeCode: Maybe<Scalars['String']['output']>;
  sentAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  showPaymentTermsOnAttachment: Scalars['Boolean']['output'];
  source: Maybe<InvoiceSourceEnum>;
  status: InvoiceStatusEnum;
  statuses: Array<InvoiceStatusEnum>;
  statusesForBadge: Array<InvoiceStatusEnum>;
  timelineEvents: Maybe<Array<TimelineEvent>>;
  totalAmount: Maybe<Money>;
  totalUsdAmount: Maybe<Money>;
  unscheduledAmount: Maybe<Money>;
  uploadedByCurrentBusiness: Scalars['Boolean']['output'];
  url: Maybe<Scalars['String']['output']>;
  vendorAccount: Maybe<LocalBusinessAccount>;
  vendorAmount: Maybe<Money>;
  vendorBusiness: Maybe<PublicBusiness>;
  vendorCreditApplications: Array<VendorCreditApplication>;
  vendorCreditAppliedTotal: Money;
  vendorCurrency: Maybe<Currency>;
  vendorFinancingConfirmation: Maybe<VendorFinancingConfirmation>;
  vendorLocalBusiness: Maybe<LocalBusiness>;
  vendorReceivedAmount: Money;
};

export type ReceivableInvoiceInputObject = {
  amountCents?: InputMaybe<Scalars['SafeInt']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmountCents?: InputMaybe<Scalars['SafeInt']['input']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  issueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  payWithLink?: InputMaybe<Scalars['Boolean']['input']>;
  payerLocalBusinessId?: InputMaybe<Scalars['ID']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  showPaymentTermsOnAttachment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReceivableInvoiceLineItem = {
  amount: Money;
  description: Maybe<Scalars['String']['output']>;
  fractionalUnitAmount: Maybe<InfinitePrecisionMoney>;
  id: Scalars['ID']['output'];
  quantity: Maybe<Scalars['Float']['output']>;
  tax: Scalars['Boolean']['output'];
  unitAmount: Maybe<Money>;
};

export type ReceivableInvoiceLineItemInputObject = {
  description?: InputMaybe<Scalars['String']['input']>;
  fractionalUnitAmountCents?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Float']['input'];
};

export type ReceivableInvoices = {
  data: Array<ReceivableInvoice>;
  pagination: Pagination;
};

export enum ReceivableInvoicesSortingDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ReceivableInvoicesSortingInputObject = {
  direction: ReceivableInvoicesSortingDirectionEnum;
  field: ReceivableSortableFieldEnum;
};

export type ReceivableLineItemInputObject = {
  lineItemDetails: InvoiceLineItemDetailsInputObject;
};

export type ReceivablePayment = {
  allocations: Maybe<Array<ReceivableAllocation>>;
  cancelledBy: Maybe<Approver>;
  consolidated: Scalars['Boolean']['output'];
  errorDirection: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  eta: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  etaFromPayer: Maybe<Scalars['ISO8601Date']['output']>;
  external: Scalars['Boolean']['output'];
  failedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoices: Array<ReceivableInvoice>;
  mdrFeeAmount: Maybe<Money>;
  netVendorAmount: Money;
  paidWithLink: Scalars['Boolean']['output'];
  paidWithMethod: Maybe<PaymentMethodEnum>;
  paymentConfirmationDocumentUrl: Maybe<Scalars['String']['output']>;
  processedOn: Maybe<Scalars['ISO8601Date']['output']>;
  purposeCode: Maybe<Scalars['String']['output']>;
  receivedOn: Maybe<Scalars['ISO8601Date']['output']>;
  revokable: Scalars['Boolean']['output'];
  scheduledOn: Scalars['ISO8601Date']['output'];
  secondaryStatusDescription: Maybe<Scalars['String']['output']>;
  status: PaymentStatusEnum;
  statusDescription: Maybe<Scalars['String']['output']>;
  stripeDashboardUrl: Maybe<Scalars['String']['output']>;
  vendorAmount: Money;
  vendorPaymentDate: Scalars['ISO8601Date']['output'];
};

export type ReceivableReconciliationItem = {
  amount: Money;
  arrivedOn: Maybe<Scalars['ISO8601Date']['output']>;
  creditConfirmationNumber: Maybe<Scalars['String']['output']>;
  debitConfirmationNumber: Maybe<Scalars['String']['output']>;
  direction: ReconciliationItemDirectionEnum;
  etaRange: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  failedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  paidToAccount: Maybe<Scalars['String']['output']>;
  paidToAccountObject: Maybe<LocalBusinessAccount>;
  payToBankAccount: Maybe<BankAccountInfo>;
  payment: ReceivablePayment;
  paymentMethod: PaymentMethodEnum;
  refundForItem: Maybe<ReceivableReconciliationItem>;
  refundItem: Maybe<ReceivableReconciliationItem>;
  scheduledFor: Scalars['ISO8601Date']['output'];
  sentAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: ReconciliationItemStatusEnum;
  type: ReconciliationItemTypeEnum;
  vendorLocalBusiness: Maybe<LocalBusiness>;
};

export enum ReceivableSortableFieldEnum {
  AMOUNT = 'AMOUNT',
  AMOUNT_CURRENCY = 'AMOUNT_CURRENCY',
  CREATED_AT = 'CREATED_AT',
  DUE_DATE = 'DUE_DATE',
  INVOICE_NUMBER = 'INVOICE_NUMBER',
  ISSUE_DATE = 'ISSUE_DATE',
  PAYMENT_METHOD = 'PAYMENT_METHOD'
}

export enum ReceivableStatusEnum {
  APPROVED = 'APPROVED',
  DEBIT_APPROVAL_REQUESTED = 'DEBIT_APPROVAL_REQUESTED',
  DEBIT_PROCESSED = 'DEBIT_PROCESSED',
  DEBIT_SCHEDULED = 'DEBIT_SCHEDULED',
  DENIED = 'DENIED',
  DEPOSIT_PAID = 'DEPOSIT_PAID',
  DEPOSIT_PROCESSED = 'DEPOSIT_PROCESSED',
  DEPOSIT_SCHEDULED = 'DEPOSIT_SCHEDULED',
  DRAFT = 'DRAFT',
  OVERDUE = 'OVERDUE',
  OVERPAID = 'OVERPAID',
  REPAID = 'REPAID',
  REPAID_PARTIAL = 'REPAID_PARTIAL',
  WAITING = 'WAITING'
}

export type Receivables = {
  data: Array<Receivable>;
  pagination: Pagination;
};

export enum ReceivablesPermissionsEnum {
  RECEIVABLES = 'RECEIVABLES'
}

export type ReconciliationItem = {
  additionalDescription: Maybe<Scalars['String']['output']>;
  allowAccountChange: Scalars['Boolean']['output'];
  amount: Money;
  approvers: Array<Approver>;
  arrivedOn: Maybe<Scalars['ISO8601Date']['output']>;
  canceledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  creditConfirmationNumber: Maybe<Scalars['String']['output']>;
  debitConfirmationNumber: Maybe<Scalars['String']['output']>;
  debitedOn: Maybe<Scalars['ISO8601Date']['output']>;
  defaultInterestDetails: Maybe<DefaultInterestDetails>;
  direction: ReconciliationItemDirectionEnum;
  earlyRepaidOn: Maybe<Scalars['ISO8601Date']['output']>;
  earlyRepayment: Scalars['Boolean']['output'];
  etaRange: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  failedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  friendlyId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  interest: Maybe<Money>;
  onHold: Scalars['Boolean']['output'];
  paidFromAccount: Maybe<Scalars['String']['output']>;
  paidFromAccountObject: Maybe<Account>;
  paidToAccount: Maybe<Scalars['String']['output']>;
  paidToAccountObject: Maybe<LocalBusinessAccount>;
  /** Only set for refund items, in which case this field returns the business' name */
  paidToBusinessName: Maybe<Scalars['String']['output']>;
  payFromBankAccount: Maybe<BankAccountInfo>;
  payToBankAccount: Maybe<BankAccountInfo>;
  payment: Payment;
  paymentMethod: PaymentMethodEnum;
  principal: Maybe<Money>;
  refundForItem: Maybe<ReconciliationItem>;
  refundItem: Maybe<ReconciliationItem>;
  releasedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  retriedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  retriedBy: Maybe<Approver>;
  scheduledFor: Scalars['ISO8601Date']['output'];
  sentAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: ReconciliationItemStatusEnum;
  type: ReconciliationItemTypeEnum;
  usdAmount: Money;
  vendorLocalBusiness: Maybe<LocalBusiness>;
  warningMessages: Array<WarningMessage>;
};

export type ReconciliationItemDateFilteringOption = {
  code: Maybe<Scalars['String']['output']>;
  empty: Scalars['Boolean']['output'];
  from: Maybe<Scalars['ISO8601Date']['output']>;
  name: Maybe<Scalars['String']['output']>;
  to: Maybe<Scalars['ISO8601Date']['output']>;
};

export type ReconciliationItemDateFilteringOptions = {
  field: ReconciliationItemSortableFieldEnum;
  presets: Array<ReconciliationItemDateFilteringOption>;
};

export enum ReconciliationItemDirectionEnum {
  COMBINED = 'COMBINED',
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT'
}

export type ReconciliationItemFilteringOptions = {
  dates: Array<ReconciliationItemDateFilteringOptions>;
  epts: Maybe<Array<EptFilterEnum>>;
};

export enum ReconciliationItemSortableFieldEnum {
  AMOUNT = 'AMOUNT',
  ARRIVED_AT = 'ARRIVED_AT',
  DEBITED_ON = 'DEBITED_ON',
  SCHEDULED_FOR = 'SCHEDULED_FOR',
  SENT_AT = 'SENT_AT',
  STATUS = 'STATUS',
  VENDOR_NAME = 'VENDOR_NAME'
}

export enum ReconciliationItemSortingDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ReconciliationItemSortingInputObject = {
  direction: ReconciliationItemSortingDirectionEnum;
  field: ReconciliationItemSortableFieldEnum;
};

export enum ReconciliationItemStatusEnum {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  INITIATED = 'INITIATED',
  ON_HOLD = 'ON_HOLD',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  REFUNDED = 'REFUNDED',
  RETURNED = 'RETURNED',
  SCHEDULED = 'SCHEDULED'
}

export enum ReconciliationItemTypeEnum {
  AMORTIZED_INSTALLMENT = 'AMORTIZED_INSTALLMENT',
  AMORTIZED_VENDOR_PAYMENT = 'AMORTIZED_VENDOR_PAYMENT',
  CASH_ADVANCE = 'CASH_ADVANCE',
  CASH_ADVANCE_REPAYMENT = 'CASH_ADVANCE_REPAYMENT',
  DEFAULT_INTEREST = 'DEFAULT_INTEREST',
  DIRECT = 'DIRECT',
  EPT_FEE = 'EPT_FEE',
  EPT_REPAYMENT = 'EPT_REPAYMENT',
  EPT_VENDOR_PAYMENT = 'EPT_VENDOR_PAYMENT',
  EXTERNAL = 'EXTERNAL',
  REFUND = 'REFUND'
}

export type ReconciliationItems = {
  data: Array<ReconciliationItem>;
  pagination: Pagination;
};

export type ReconciliationItemsFilteringInputObject = {
  amountCents?: InputMaybe<InvoiceAmountFilteringInputObject>;
  amountCurrencies?: InputMaybe<Array<Scalars['String']['input']>>;
  approverIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  approverName?: InputMaybe<Scalars['String']['input']>;
  confirmationNumber?: InputMaybe<Scalars['String']['input']>;
  confirmationNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  debitedOn?: InputMaybe<DateFilteringInputObject>;
  extensionAvailableDueSoon?: InputMaybe<Scalars['Boolean']['input']>;
  extensionFees?: InputMaybe<Scalars['Boolean']['input']>;
  financingPeriod?: InputMaybe<Array<EptFilterEnum>>;
  fromPayerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  fromSettleAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountWithIssue?: InputMaybe<Scalars['Boolean']['input']>;
  includeOverdueApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  installments?: InputMaybe<Scalars['Boolean']['input']>;
  itemType?: InputMaybe<Array<ReconciliationItemTypeEnum>>;
  notLinkedToOrderDocuments?: InputMaybe<Array<Scalars['ID']['input']>>;
  payFromAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  payToSettle?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<PaymentMethodEnum>>;
  scheduledByIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  scheduledByName?: InputMaybe<Scalars['String']['input']>;
  scheduledFor?: InputMaybe<DateFilteringInputObject>;
  /** (Deprecated) Use `settlePaymentIds` instead */
  settlePaymentId?: InputMaybe<Scalars['String']['input']>;
  settlePaymentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<ReconciliationItemStatusEnum>>;
  suitableForDeferral?: InputMaybe<Scalars['Boolean']['input']>;
  vendorLocalBusinessIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
  withSyncError?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ReconciliationItemsPermissionsEnum {
  PAGED_RECONCILIATION_ITEMS = 'PAGED_RECONCILIATION_ITEMS',
  RECONCILIATION_ITEM = 'RECONCILIATION_ITEM'
}

/** Autogenerated return type of RecurrentPaymentScheduleCreated. */
export type RecurrentPaymentScheduleCreatedPayload = {
  schedule: RecurrentPaymentsSchedule;
};

export type RecurrentPaymentsEstimatedTimeline = {
  dateIsShifted: Scalars['Boolean']['output'];
  processingEstimates: ProcessingEstimate;
  scheduledFor: Scalars['ISO8601Date']['output'];
};

export enum RecurrentPaymentsIntervalEnum {
  BIMONTHLY = 'BIMONTHLY',
  BIWEEKLY = 'BIWEEKLY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export type RecurrentPaymentsPagedSchedules = {
  data: Array<RecurrentPaymentsSchedule>;
  pagination: Pagination;
};

export type RecurrentPaymentsSchedule = {
  actions: RecurrentPaymentsScheduleActions;
  endDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  interval: RecurrentPaymentsIntervalEnum;
  lastPaymentDate: Maybe<Scalars['ISO8601Date']['output']>;
  nextPaymentDate: Maybe<Scalars['ISO8601Date']['output']>;
  paidPaymentsCount: Scalars['Int']['output'];
  paymentTemplate: RecurrentPaymentsTemplate;
  payments: Array<Payment>;
  startDate: Scalars['ISO8601Date']['output'];
  totalPaymentsCount: Scalars['Int']['output'];
};

export type RecurrentPaymentsScheduleActions = {
  changePayFromAccount: Action;
  changePayToAccount: Action;
  revokePayments: Action;
  updateInternationalDetails: Action;
};

export type RecurrentPaymentsScheduleInputObject = {
  endDate: Scalars['ISO8601Date']['input'];
  interval: RecurrentPaymentsIntervalEnum;
  paymentData: RecurrentPaymentsTemplateInputObject;
  startDate: Scalars['ISO8601Date']['input'];
};

export type RecurrentPaymentsTemplate = {
  accountingAccount: Maybe<AccountingAccount>;
  accountingCategoryClass: Maybe<AccountingDictionary>;
  accountingMemo: Maybe<Scalars['String']['output']>;
  otherReasonNote: Maybe<Scalars['String']['output']>;
  payerAccount: Maybe<Account>;
  paymentDescription: Maybe<Scalars['String']['output']>;
  paymentMethod: PaymentMethodEnum;
  purposeCode: Maybe<Scalars['String']['output']>;
  reasonCode: Maybe<PaymentReasonEnum>;
  vendorAccount: Maybe<LocalBusinessAccount>;
  vendorAmount: Money;
  vendorLocalBusiness: LocalBusiness;
};

export type RecurrentPaymentsTemplateInputObject = {
  accountingDetails?: InputMaybe<PaymentAccountingDetailsInputObject>;
  otherReasonNote?: InputMaybe<Scalars['String']['input']>;
  payerAccountId: Scalars['ID']['input'];
  paymentDescription?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethodEnum;
  purposeCode?: InputMaybe<Scalars['String']['input']>;
  reasonCode?: InputMaybe<PaymentReasonEnum>;
  vendorAccountId?: InputMaybe<Scalars['ID']['input']>;
  vendorAmount: MoneyInputObject;
  vendorLocalBusinessId: Scalars['ID']['input'];
};

/** Referral data for new business that was referred */
export type Referral = {
  affiliateName: Maybe<Scalars['String']['output']>;
  referralCode: Scalars['String']['output'];
  type: ReferralTypeEnum;
};

export enum ReferralSourceEnum {
  ACCOUNTANT = 'ACCOUNTANT',
  COMMUNITY_GROUP = 'COMMUNITY_GROUP',
  EVENT = 'EVENT',
  FRIEND = 'FRIEND',
  INVESTORS = 'INVESTORS',
  LINKEDIN = 'LINKEDIN',
  META = 'META',
  NEWS_ARTICLE = 'NEWS_ARTICLE',
  OTHER = 'OTHER',
  OUTREACH = 'OUTREACH',
  PODCAST = 'PODCAST',
  SEARCH_ENGINE = 'SEARCH_ENGINE'
}

export enum ReferralTypeEnum {
  AFFILIATE = 'AFFILIATE',
  REFERRAL = 'REFERRAL'
}

export type RepaymentBalance = {
  currentAccruedInterest: Money;
  currentInterestPaid: Money;
  currentPrincipalBalance: Money;
  daysOfPeriodPaid: Scalars['Int']['output'];
  defaultInterest: Money;
  defaultInterestAsOfDate: Maybe<Scalars['ISO8601Date']['output']>;
  outstandingBalance: Money;
  outstandingInterest: Money;
  outstandingPrincipal: Money;
  paymentId: Scalars['ID']['output'];
  periodDays: Scalars['Int']['output'];
  postRepaymentInterestPaid: Money;
  principalPaid: Money;
  repaymentAmount: Money;
  repaymentDate: Scalars['ISO8601Date']['output'];
};

export type Report = {
  attachedReports: Array<AttachedReport>;
  category: CategoryEnum;
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayName: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastAttachedReport: Maybe<AttachedReport>;
  status: StatusEnum;
};

export type ReportDateFilteringOption = {
  code: Maybe<Scalars['String']['output']>;
  from: Maybe<Scalars['ISO8601Date']['output']>;
  name: Maybe<Scalars['String']['output']>;
  to: Maybe<Scalars['ISO8601Date']['output']>;
};

export type ReportFilteringOptions = {
  reportInputDateRanges: Array<ReportDateFilteringOption>;
};

export type ReportSchedule = {
  dayOfMonth: Maybe<ReportScheduleDayOfMonth>;
  /** 0 (Sunday) to 6 (Saturday). */
  dayOfWeek: Maybe<Scalars['Int']['output']>;
  frequency: ReportScheduleFrequency;
  id: Scalars['ID']['output'];
  lastOccurrence: Maybe<ReportScheduleOccurrence>;
  nextRunAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  recipients: Array<TeamMember>;
  reportType: ScheduledReportType;
  status: ReportScheduleStatus;
  summary: Scalars['String']['output'];
};

export enum ReportScheduleDayOfMonth {
  FIRST = 'FIRST',
  LAST = 'LAST'
}

export enum ReportScheduleFrequency {
  BIWEEKLY = 'BIWEEKLY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export type ReportScheduleInput = {
  dayOfMonth?: InputMaybe<ReportScheduleDayOfMonth>;
  /** 0 (Sunday) to 6 (Saturday). */
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  frequency: ReportScheduleFrequency;
  recipientUserIds: Array<Scalars['ID']['input']>;
  reportType: ScheduledReportType;
};

export type ReportScheduleOccurrence = {
  executedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  report: Maybe<Report>;
  scheduledFor: Scalars['ISO8601DateTime']['output'];
  status: Scalars['String']['output'];
};

export enum ReportScheduleStatus {
  ACTIVE = 'ACTIVE',
  NO_RECIPIENTS = 'NO_RECIPIENTS'
}

export type ReportScheduleTestSendInput = {
  dayOfMonth?: InputMaybe<ReportScheduleDayOfMonth>;
  /** 0 (Sunday) to 6 (Saturday). */
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<ReportScheduleFrequency>;
  recipientUserIds: Array<Scalars['ID']['input']>;
  reportType: ScheduledReportType;
};

/** Autogenerated return type of ReportStatusChanged. */
export type ReportStatusChangedPayload = {
  attachedReports: Array<AttachedReport>;
  category: CategoryEnum;
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  error: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: StatusEnum;
};

export type ReportYear = {
  historical: Scalars['Boolean']['output'];
  preliminary: Scalars['Boolean']['output'];
  year: Scalars['Int']['output'];
};

export type Reports = {
  data: Array<Report>;
  pagination: Pagination;
};

export type ResendPhoneFactorCodeResponse = {
  attemptsLeft: Scalars['Int']['output'];
  mfaToken: Maybe<Scalars['ID']['output']>;
  nextRetryAvailableAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  resendsLeft: Scalars['Int']['output'];
};

export enum ResourceEnum {
  FINICITY_CONNECT = 'FINICITY_CONNECT'
}

export enum RoutingNumberTypeEnum {
  ABA = 'ABA',
  OTHER = 'OTHER',
  SWIFT = 'SWIFT'
}

export type RoutingNumberValidation = {
  bankName: Maybe<Scalars['String']['output']>;
  validationMessage: Maybe<Scalars['String']['output']>;
  validationStatus: RoutingNumberValidationStatusEnum;
};

export enum RoutingNumberValidationStatusEnum {
  ACH_AND_WIRE = 'ACH_AND_WIRE',
  ACH_ONLY = 'ACH_ONLY',
  INVALID = 'INVALID',
  WIRE_ONLY = 'WIRE_ONLY'
}

export type Rule = {
  accountingRelated: Scalars['Boolean']['output'];
  actions: Array<RuleAction>;
  conditions: Array<RuleCondition>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  status: RuleStatusEnum;
  targetType: Maybe<RuleTypeEnum>;
};

export type RuleAction = {
  action: RuleActionEnum;
  condition: Maybe<RuleActionConditionEnum>;
  values: Maybe<Array<Scalars['String']['output']>>;
};

export enum RuleActionConditionEnum {
  ALL_OF_THESE_COWORKERS = 'ALL_OF_THESE_COWORKERS',
  ANY_OF_THESE_COWORKERS = 'ANY_OF_THESE_COWORKERS'
}

export enum RuleActionEnum {
  REQUIRE_APPROVAL = 'REQUIRE_APPROVAL'
}

export type RuleActionInputObject = {
  action: RuleActionEnum;
  condition?: InputMaybe<RuleActionConditionEnum>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RuleCondition = {
  attributeName: RuleConditionAttributeNameEnum;
  condition: RuleConditionEnum;
  value: Maybe<Scalars['String']['output']>;
  values: Maybe<Array<RuleConditionValueType>>;
};

export enum RuleConditionAttributeNameEnum {
  ACCOUNT = 'ACCOUNT',
  AMOUNT = 'AMOUNT',
  CLASS = 'CLASS',
  DEPARTMENT = 'DEPARTMENT',
  LOCAL_BUSINESS = 'LOCAL_BUSINESS',
  LOCATION = 'LOCATION',
  TRACKING_CATEGORY_ONE = 'TRACKING_CATEGORY_ONE',
  TRACKING_CATEGORY_TWO = 'TRACKING_CATEGORY_TWO',
  USER = 'USER'
}

export enum RuleConditionEnum {
  ANY_IN = 'ANY_IN',
  EQUALS = 'EQUALS',
  IN = 'IN',
  IS_GREATER_THAN = 'IS_GREATER_THAN',
  IS_GREATER_THAN_OR_EQUAL = 'IS_GREATER_THAN_OR_EQUAL',
  IS_LESS_THAN = 'IS_LESS_THAN',
  IS_LESS_THAN_OR_EQUAL = 'IS_LESS_THAN_OR_EQUAL',
  NOT_IN = 'NOT_IN'
}

export type RuleConditionInputObject = {
  attributeName: RuleConditionAttributeNameEnum;
  condition: RuleConditionEnum;
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RuleConditionValueType = AccountingAccount | AccountingCategoryType | LocalBusiness | Profile;

export type RuleMetadata = {
  actions: Array<RuleMetadataAction>;
  conditions: Array<RuleMetadataCondition>;
  defaultAction: RuleActionEnum;
  defaultCondition: RuleConditionAttributeNameEnum;
  defaultName: Scalars['String']['output'];
};

export type RuleMetadataAction = {
  code: RuleActionEnum;
  conditionLabel: Maybe<Scalars['String']['output']>;
  conditions: Maybe<Array<RuleMetadataActionCondition>>;
  defaultCondition: Maybe<RuleActionConditionEnum>;
  name: Scalars['String']['output'];
  values: Maybe<Array<SelectItem>>;
};

export type RuleMetadataActionCondition = {
  code: RuleActionConditionEnum;
  name: Scalars['String']['output'];
};

export type RuleMetadataCondition = {
  code: RuleConditionAttributeNameEnum;
  conditions: Array<RuleMetadataConditionCondition>;
  defaultCondition: RuleConditionEnum;
  defaultValue: Maybe<Scalars['String']['output']>;
  multipleValues: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type RuleMetadataConditionCondition = {
  code: RuleConditionEnum;
  name: Scalars['String']['output'];
};

export enum RuleStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum RuleTypeEnum {
  INVOICE = 'INVOICE',
  PAYMENT = 'PAYMENT',
  PURCHASEORDER = 'PURCHASEORDER'
}

export enum RulesPermissionsEnum {
  ACTIVATE_RULE = 'ACTIVATE_RULE',
  CREATE_RULE = 'CREATE_RULE',
  DEACTIVATE_RULE = 'DEACTIVATE_RULE',
  DELETE_RULE = 'DELETE_RULE',
  RULES = 'RULES',
  UPDATE_RULE = 'UPDATE_RULE'
}

export type SalesChannelConfiguration = {
  channel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integrationOneType: SalesChannelIntegrationEnum;
  integrationTwoType: SalesChannelIntegrationEnum;
  state: SalesChannelConfigurationStateEnum;
};

export type SalesChannelConfigurationInputObject = {
  id: Scalars['ID']['input'];
  state: SalesChannelConfigurationStateEnum;
};

export enum SalesChannelConfigurationPermissionsEnum {
  UPDATE_SALES_CHANNEL_CONFIGURATION = 'UPDATE_SALES_CHANNEL_CONFIGURATION',
  VIEW_SALES_CHANNEL_CONFIGURATION = 'VIEW_SALES_CHANNEL_CONFIGURATION'
}

export enum SalesChannelConfigurationStateEnum {
  DO_NOT_MERGE = 'DO_NOT_MERGE',
  MERGE = 'MERGE',
  NEEDS_REVIEW = 'NEEDS_REVIEW'
}

export type SalesChannelConfigurationsFilteringInputObject = {
  state: SalesChannelConfigurationStateEnum;
};

export type SalesChannelInputObject = {
  defaultFulfillmentLocationId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export enum SalesChannelIntegrationEnum {
  MANUAL = 'MANUAL',
  SHOPIFY = 'SHOPIFY',
  TRACKSTAR = 'TRACKSTAR'
}

export type SalesDetailType = {
  amount: Maybe<Money>;
  dataSource: CatalogItemSalesDataSourceEnum;
  id: Scalars['ID']['output'];
  sku: Maybe<Scalars['String']['output']>;
};

export enum ScheduledReportType {
  AP_AGING_DETAILS = 'AP_AGING_DETAILS',
  AP_AGING_SUMMARY = 'AP_AGING_SUMMARY',
  CASH_OUTFLOW = 'CASH_OUTFLOW',
  INVOICES_EXPORT = 'INVOICES_EXPORT',
  OUTSTANDING_LOANS = 'OUTSTANDING_LOANS',
  OWED_TO_SETTLE = 'OWED_TO_SETTLE',
  PAYMENTS_EXPORT = 'PAYMENTS_EXPORT',
  PRODUCT_COST = 'PRODUCT_COST',
  PURCHASE_ORDERS = 'PURCHASE_ORDERS'
}

export type SectionFieldsInput = {
  additionalFields?: InputMaybe<Array<SectionFieldsInput>>;
  intValue?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SeedPendingOcrReview. */
export type SeedPendingOcrReviewPayload = {
  ocrRecordId: Scalars['ID']['output'];
};

/** Autogenerated return type of SeedSettleInboxMessages. */
export type SeedSettleInboxMessagesPayload = {
  messages: Array<SettleInboxMessage>;
};

export type SelectItem = {
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SettleInboxAttachment = {
  attachment: Attachment;
  convertedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdDocument: Maybe<CreatedDocument>;
  id: Scalars['ID']['output'];
  payableAutocreated: Maybe<Scalars['Boolean']['output']>;
  possibleInvoiceDuplicates: Array<Invoice>;
};

export type SettleInboxAutopayableConfigType = {
  allowlistCount: Scalars['Int']['output'];
  allowlistEmails: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
};

export enum SettleInboxConfigPermissionsEnum {
  UPSERT_SETTLE_INBOX_AUTOPAYABLE_CONFIG = 'UPSERT_SETTLE_INBOX_AUTOPAYABLE_CONFIG'
}

export enum SettleInboxEventTypeEnum {
  CONVERTED_TO_PAYABLE = 'CONVERTED_TO_PAYABLE',
  CONVERTED_TO_RECEIVABLE = 'CONVERTED_TO_RECEIVABLE',
  SWITCH_TO_PRO = 'SWITCH_TO_PRO'
}

export type SettleInboxMessage = {
  archived: Scalars['Boolean']['output'];
  attachments: Array<SettleInboxAttachment>;
  body: Maybe<Scalars['String']['output']>;
  createdInvoices: Array<Invoice>;
  createdReceivableInvoices: Array<ReceivableInvoice>;
  id: Scalars['ID']['output'];
  read: Scalars['Boolean']['output'];
  receivedAt: Scalars['ISO8601DateTime']['output'];
  senderEmail: Scalars['String']['output'];
  senderName: Maybe<Scalars['String']['output']>;
  subject: Maybe<Scalars['String']['output']>;
  timelineEvents: Array<SettleInboxTimelineEvent>;
};

export type SettleInboxMessages = {
  data: Array<SettleInboxMessage>;
  pagination: Pagination;
};

export enum SettleInboxPermissionsEnum {
  CREATE_PAYABLE_FROM_SETTLE_INBOX = 'CREATE_PAYABLE_FROM_SETTLE_INBOX',
  CREATE_RECEIVABLE_FROM_SETTLE_INBOX = 'CREATE_RECEIVABLE_FROM_SETTLE_INBOX',
  CREATE_VENDOR_CREDIT_FROM_SETTLE_INBOX = 'CREATE_VENDOR_CREDIT_FROM_SETTLE_INBOX',
  CREATE_W9_FROM_SETTLE_INBOX = 'CREATE_W9_FROM_SETTLE_INBOX',
  DELETE_SETTLE_INBOX_MESSAGES = 'DELETE_SETTLE_INBOX_MESSAGES',
  READ_SETTLE_INBOX_AUTOPAYABLE_CONFIG = 'READ_SETTLE_INBOX_AUTOPAYABLE_CONFIG',
  UPDATE_SETTLE_INBOX_MESSAGE_ARCHIVED = 'UPDATE_SETTLE_INBOX_MESSAGE_ARCHIVED',
  UPDATE_SETTLE_INBOX_MESSAGE_READ = 'UPDATE_SETTLE_INBOX_MESSAGE_READ'
}

export type SettleInboxTimelineEvent = {
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayText: Scalars['String']['output'];
  eventType: SettleInboxEventTypeEnum;
  icon: IconEnum;
  user: Maybe<Approver>;
};

/** Autogenerated return type of SetupQuickBooksAccountingState. */
export type SetupQuickBooksAccountingStatePayload = {
  accounts: Array<AccountingAccount>;
  classes: Array<AccountingDictionary>;
  customersAndProjects: Array<AccountingDictionary>;
  locations: Array<AccountingDictionary>;
};

export type Shipment = {
  arriveByDate: Maybe<Scalars['ISO8601Date']['output']>;
  cargoReadyDate: Maybe<Scalars['ISO8601Date']['output']>;
  destination: Maybe<Location>;
  id: Scalars['ID']['output'];
  lineItems: Array<ShipmentLineItem>;
  number: Maybe<Scalars['String']['output']>;
  productionStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  receipt: Maybe<Receipt>;
  shipByDate: Maybe<Scalars['ISO8601Date']['output']>;
  shippingMethod: Maybe<Scalars['String']['output']>;
  shippingTerms: Maybe<Scalars['String']['output']>;
  shippingVendors: Array<LocalBusiness>;
  status: ShipmentStatusEnum;
  trackingNumber: Maybe<Scalars['String']['output']>;
};

export type ShipmentInputObject = {
  arriveByDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  cargoReadyDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  productionStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  shipByDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
  shippingTerms?: InputMaybe<Scalars['String']['input']>;
  shippingVendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<ShipmentStatusEnum>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ShipmentLineItem = {
  catalogItemVariation: Maybe<CatalogItemVariation>;
  documentLineItemId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  inventoryQuantity: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  shipment: Shipment;
  unitOfMeasure: Maybe<Scalars['String']['output']>;
};

export type ShipmentLineItemInputObject = {
  orderingDocumentLineItemId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  shipmentId: Scalars['ID']['input'];
};

export enum ShipmentStatusEnum {
  IN_TRANSIT = 'IN_TRANSIT',
  ON_TRACK = 'ON_TRACK',
  RECEIVED = 'RECEIVED'
}

export enum ShopifyFeaturePermissionEnum {
  NO_SYNC = 'NO_SYNC',
  READ = 'READ'
}

export enum ShopifyFeatureTypeEnum {
  CATALOG = 'CATALOG',
  LOCATIONS = 'LOCATIONS'
}

export type ShopifyIntegrationFeature = {
  featureType: ShopifyFeatureTypeEnum;
  id: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
  permission: ShopifyFeaturePermissionEnum;
  title: Scalars['String']['output'];
};

export type ShopifyProduct = {
  /** Shopify id that we use as our external id */
  externalId: Scalars['String']['output'];
  /** Every variant will point to a shopify product id */
  parentExternalId: Maybe<Scalars['String']['output']>;
  /** Needed to give the variant a description of the product itself */
  parentTitle: Maybe<Scalars['String']['output']>;
  /** Variant sku */
  sku: Maybe<Scalars['String']['output']>;
  /** Variant title e.g. (small, 20oz, etc) */
  title: Scalars['String']['output'];
  /** Unit cost pulled from shopify */
  unitCost: Maybe<InfinitePrecisionMoney>;
};

export type ShopifyState = {
  connected: Scalars['Boolean']['output'];
  domain: Scalars['String']['output'];
  exportLandedCosts: Scalars['Boolean']['output'];
  exportableLocations: Array<Location>;
  features: Array<ShopifyIntegrationFeature>;
  id: Scalars['ID']['output'];
  lastSyncedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  name: Scalars['String']['output'];
  syncScheduledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  syncStartedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  syncState: ShopifySyncStateEnum;
};

export enum ShopifySyncStateEnum {
  NOT_SYNCED = 'NOT_SYNCED',
  READY_TO_SYNC = 'READY_TO_SYNC',
  SYNCED = 'SYNCED',
  SYNC_FAILED = 'SYNC_FAILED',
  SYNC_IN_PROGRESS = 'SYNC_IN_PROGRESS'
}

/** Autogenerated return type of ShopifySyncStatusChanged. */
export type ShopifySyncStatusChangedPayload = {
  shopifyState: ShopifyState;
};

export type SignIn = {
  active: Scalars['Boolean']['output'];
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  current: Scalars['Boolean']['output'];
  ip: Scalars['String']['output'];
  jwtId: Scalars['String']['output'];
  revoked: Scalars['Boolean']['output'];
  revokedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type SignedDocument = {
  byteSize: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export enum SignedDocumentTypesEnum {
  AMORTIZED_LOAN_AGREEMENT = 'AMORTIZED_LOAN_AGREEMENT',
  BULLET_EPT_AGREEMENT = 'BULLET_EPT_AGREEMENT',
  EXTENDED_PAYMENT_TERM_AGREEMENT = 'EXTENDED_PAYMENT_TERM_AGREEMENT',
  FACTORING_AGREEMENT = 'FACTORING_AGREEMENT',
  FACTORING_AGREEMENT_V2 = 'FACTORING_AGREEMENT_V2',
  PAYEE_AGENT_DISCLOSURE = 'PAYEE_AGENT_DISCLOSURE'
}

export enum SignupInterestsEnum {
  BILL_PAY = 'BILL_PAY',
  LANDED_COSTS = 'LANDED_COSTS',
  PURCHASING = 'PURCHASING',
  WORKING_CAPITAL = 'WORKING_CAPITAL'
}

/** Autogenerated return type of SkipMfaSetup. */
export type SkipMfaSetupPayload = {
  success: Scalars['Boolean']['output'];
};

export type StandalonePaymentInputObject = {
  accountId: Scalars['ID']['input'];
  accountingDetails?: InputMaybe<PaymentAccountingDetailsInputObject>;
  amount: MoneyInputObject;
  localBusinessId: Scalars['ID']['input'];
  orderDocumentId?: InputMaybe<Scalars['ID']['input']>;
  otherReasonNote?: InputMaybe<Scalars['String']['input']>;
  paymentDescription?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethodEnum;
  processDate: Scalars['ISO8601Date']['input'];
  purposeCode?: InputMaybe<Scalars['String']['input']>;
  reasonCode?: InputMaybe<PaymentReasonEnum>;
  receivingAccountId?: InputMaybe<Scalars['ID']['input']>;
  suggestedPaymentId?: InputMaybe<Scalars['ID']['input']>;
};

export enum StatusEnum {
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  STARTED = 'STARTED',
  WAITING = 'WAITING'
}

export enum StepEnum {
  CONNECT_SHOPIFY = 'CONNECT_SHOPIFY',
  SET_BASELINE_COSTS = 'SET_BASELINE_COSTS',
  SYNC_LANDED_COSTS = 'SYNC_LANDED_COSTS',
  UPLOAD_CSV = 'UPLOAD_CSV'
}

export enum StripeOnboardingStatusEnum {
  COMPLETED = 'COMPLETED',
  CONNECTED_ACCOUNT_CREATION = 'CONNECTED_ACCOUNT_CREATION',
  CONNECTED_ACCOUNT_CREATION_FAILED = 'CONNECTED_ACCOUNT_CREATION_FAILED',
  MISSING_REQUIREMENTS = 'MISSING_REQUIREMENTS',
  PENDING = 'PENDING',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  REPRESENTATIVES_CREATION = 'REPRESENTATIVES_CREATION'
}

export type SubmitSubscriptionSurveyResponseType = {
  /** List of errors that occurred while creating the survey */
  errors: Array<Scalars['String']['output']>;
  /** Whether the survey was successfully created */
  success: Scalars['Boolean']['output'];
};

export type Subscription = {
  accountingImportStateChanged: AccountingImportStateChangedPayload;
  accountingSyncStateChanged: AccountingSyncStateChangedPayload;
  attachmentPreviewStatusChanged: AttachmentPreviewStatusChangedPayload;
  countersChanged: CountersChangedPayload;
  csvImportChanged: CsvImportChangedPayload;
  documentAttachmentUpdated: DocumentAttachmentUpdatedPayload;
  documentOcrCompleted: DocumentOcrCompletedPayload;
  journeyChanged: JourneyChangedPayload;
  recurrentPaymentScheduleCreated: RecurrentPaymentScheduleCreatedPayload;
  reportStatusChanged: ReportStatusChangedPayload;
  shopifySyncStatusChanged: ShopifySyncStatusChangedPayload;
};


export type SubscriptionaccountingImportStateChangedArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptionaccountingSyncStateChangedArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptionattachmentPreviewStatusChangedArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptioncountersChangedArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptioncsvImportChangedArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptiondocumentAttachmentUpdatedArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptiondocumentOcrCompletedArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptionjourneyChangedArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptionrecurrentPaymentScheduleCreatedArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptionreportStatusChangedArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptionshopifySyncStatusChangedArgs = {
  businessId: Scalars['ID']['input'];
};

export type SuggestedPayment = {
  accountingAccount: Maybe<AccountingAccount>;
  accountingCategoryClass: Maybe<AccountingDictionary>;
  accountingMemo: Maybe<Scalars['String']['output']>;
  amount: Maybe<Money>;
  id: Scalars['ID']['output'];
  otherReasonNote: Maybe<Scalars['String']['output']>;
  payerAccount: Maybe<Account>;
  payment: Maybe<Payment>;
  paymentDate: Maybe<Scalars['ISO8601Date']['output']>;
  paymentDescription: Maybe<Scalars['String']['output']>;
  paymentMethod: Maybe<PaymentMethodEnum>;
  paymentsForecastItem: Maybe<PaymentsForecastItem>;
  purposeCode: Maybe<Scalars['String']['output']>;
  reasonCode: Maybe<PaymentReasonEnum>;
  status: SuggestedPaymentStatusEnum;
  vendorAccount: Maybe<LocalBusinessAccount>;
  vendorLocalBusiness: LocalBusiness;
};

export enum SuggestedPaymentStatusEnum {
  DISMISSED = 'DISMISSED',
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED'
}

export enum SuggestedVendorAccountTypeEnum {
  EMAIL = 'EMAIL',
  OCR = 'OCR'
}

export enum SurveyTypeEnum {
  /** Subscription cancellation survey */
  CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION',
  /** Subscription downgrade survey */
  DOWNGRADE_SUBSCRIPTION = 'DOWNGRADE_SUBSCRIPTION',
  /** Subscription upgrade survey */
  UPGRADE_SUBSCRIPTION = 'UPGRADE_SUBSCRIPTION'
}

export type SyncError = {
  date: Maybe<Scalars['ISO8601Date']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  fixClaimed: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

export type SyncErrorSummaries = {
  data: Array<SyncErrorSummary>;
  pagination: Pagination;
};

export type SyncErrorSummary = {
  count: Scalars['Int']['output'];
  syncErrorMessage: Scalars['String']['output'];
  syncObjectType: SyncObjectTypeEnum;
};

export type SyncEvent = {
  displaySubtext: Maybe<Scalars['String']['output']>;
  displayText: Scalars['String']['output'];
  eventType: SyncEventTypeEnum;
  icon: SyncEventIconEnum;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['ISO8601DateTime']['output'];
  syncObject: Maybe<SyncObject>;
  syncObjectType: Maybe<SyncObjectTypeEnum>;
};

export enum SyncEventIconEnum {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  ERRORED = 'ERRORED',
  SYNCED = 'SYNCED'
}

export enum SyncEventTypeEnum {
  CREATED_EXTERNALLY = 'CREATED_EXTERNALLY',
  DELETED_EXTERNALLY = 'DELETED_EXTERNALLY',
  DELETED_LOCALLY = 'DELETED_LOCALLY',
  EXCLUDED_FROM_SYNC = 'EXCLUDED_FROM_SYNC',
  FIX_CLAIMED = 'FIX_CLAIMED',
  FIX_UNCLAIMED = 'FIX_UNCLAIMED',
  INCLUDED_IN_SYNC = 'INCLUDED_IN_SYNC',
  JOURNAL_ENTRY_EXPORTED = 'JOURNAL_ENTRY_EXPORTED',
  MARKED_AS_PAID = 'MARKED_AS_PAID',
  PAYMENT_DELETED = 'PAYMENT_DELETED',
  PAYMENT_EXPORTED = 'PAYMENT_EXPORTED',
  PAYMENT_IMPORTED = 'PAYMENT_IMPORTED',
  PAYMENT_REVERSAL_EXPORTED = 'PAYMENT_REVERSAL_EXPORTED',
  SYNC_ERRORED = 'SYNC_ERRORED',
  SYNC_INITIATED = 'SYNC_INITIATED',
  UPDATED_EXTERNALLY = 'UPDATED_EXTERNALLY',
  UPDATED_LOCALLY = 'UPDATED_LOCALLY'
}

export type SyncEvents = {
  data: Array<SyncEvent>;
  pagination: Pagination;
};

export type SyncObject = CatalogItem | Invoice | Payment | PurchaseOrder | VendorCredit;

export type SyncObjectStatus = {
  excludedFromSync: Scalars['Boolean']['output'];
  objectSyncStatusEnum: ObjectSyncStatusEnum;
  syncDisabledBy: Maybe<Scalars['String']['output']>;
};

export enum SyncObjectTypeEnum {
  CATALOG_ITEM = 'CATALOG_ITEM',
  INVOICE = 'INVOICE',
  PAYMENT = 'PAYMENT',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  VENDOR_CREDIT = 'VENDOR_CREDIT'
}

export type SyncObjects = {
  data: Array<SyncObject>;
  pagination: Pagination;
};

export enum SyncStateEnum {
  NOT_SYNCED = 'NOT_SYNCED',
  READY_TO_SYNC = 'READY_TO_SYNC',
  SYNCED = 'SYNCED',
  SYNCED_WITH_ERRORS = 'SYNCED_WITH_ERRORS',
  SYNC_IN_PROGRESS = 'SYNC_IN_PROGRESS'
}

export type TeamMember = {
  clients: Maybe<Array<UserClient>>;
  deactivated: Scalars['Boolean']['output'];
  deletable: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  lastSignedInAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  membership: Membership;
  mfaStatus: TeamMemberMfaStatusEnum;
  name: Maybe<Scalars['String']['output']>;
  reactivateable: Scalars['Boolean']['output'];
  totp: Maybe<Totp>;
};

export enum TeamMemberMfaStatusEnum {
  ENABLED = 'ENABLED',
  NONE = 'NONE',
  OPTIONAL = 'OPTIONAL',
  REQUIRED = 'REQUIRED'
}

export enum TeamMemberStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type TeamMembers = {
  invitations: Array<Invitation>;
  users: Array<TeamMember>;
};

export enum TeamPermissionsEnum {
  ACTIVATE_TEAM_MEMBER = 'ACTIVATE_TEAM_MEMBER',
  CUSTOM_ROLES = 'CUSTOM_ROLES',
  DELETE_TEAM_MEMBER = 'DELETE_TEAM_MEMBER',
  INVITE_TEAM_MEMBER = 'INVITE_TEAM_MEMBER',
  REQUIRE_MFA = 'REQUIRE_MFA',
  REVOKE_INVITATION = 'REVOKE_INVITATION',
  SET_OWN_ROLE = 'SET_OWN_ROLE',
  SET_TEAM_MEMBER_ROLE = 'SET_TEAM_MEMBER_ROLE',
  TEAM_MEMBERS = 'TEAM_MEMBERS'
}

export type TestAccountingAccountInput = {
  accountType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TestCustomerOrProjectInput = {
  isProject?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type TestSettleInboxMessageInputObject = {
  attachmentCount?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  senderEmail: Scalars['String']['input'];
  senderName?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type TestingMicroDeposits = {
  amount1: Maybe<Scalars['Int']['output']>;
  amount2: Maybe<Scalars['Int']['output']>;
};

export type TestingTokens = {
  emailVerificationToken: Maybe<Scalars['String']['output']>;
  lastLocalBusinessInvitationToken: Maybe<Scalars['String']['output']>;
  lastPaymentConfirmationToken: Maybe<Scalars['String']['output']>;
  lastTeamInvitationToken: Maybe<Scalars['String']['output']>;
  lastVendorInvitationToken: Maybe<Scalars['String']['output']>;
  passwordResetToken: Maybe<Scalars['String']['output']>;
};

export type TimelineEvent = TimelineEventInterface & {
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayText: Scalars['String']['output'];
  eventType: TimelineEventTypeEnum;
  icon: IconEnum;
  invoiceEventType: InvoiceEventTypeEnum;
  user: Maybe<Approver>;
};

export type TimelineEventInterface = {
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayText: Scalars['String']['output'];
  icon: IconEnum;
  user: Maybe<Approver>;
};

export enum TimelineEventTypeEnum {
  APPLIED_VENDOR_CREDITS_CLOSED = 'APPLIED_VENDOR_CREDITS_CLOSED',
  APPLIED_VENDOR_CREDITS_REOPENED = 'APPLIED_VENDOR_CREDITS_REOPENED',
  APPLIED_VENDOR_CREDITS_UPDATED = 'APPLIED_VENDOR_CREDITS_UPDATED',
  COLLECTION_EMAIL_SENT = 'COLLECTION_EMAIL_SENT',
  DEFAULT_INTEREST_ACCRUAL_RESUMED = 'DEFAULT_INTEREST_ACCRUAL_RESUMED',
  DEFAULT_INTEREST_ACCRUAL_STARTED = 'DEFAULT_INTEREST_ACCRUAL_STARTED',
  DEFAULT_INTEREST_COLLECTION_CANCELED = 'DEFAULT_INTEREST_COLLECTION_CANCELED',
  DEFAULT_INTEREST_COLLECTION_SCHEDULED = 'DEFAULT_INTEREST_COLLECTION_SCHEDULED',
  DEFAULT_INTEREST_WAIVED_BY_SETTLE = 'DEFAULT_INTEREST_WAIVED_BY_SETTLE',
  DEFAULT_INTEREST_WAIVED_WITHIN_GRACE = 'DEFAULT_INTEREST_WAIVED_WITHIN_GRACE',
  EPT_AGREEMENT_SIGNED = 'EPT_AGREEMENT_SIGNED',
  EPT_TERMS_CHANGED = 'EPT_TERMS_CHANGED',
  INVOICE_APPROVAL_CANCELLED = 'INVOICE_APPROVAL_CANCELLED',
  INVOICE_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT = 'INVOICE_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT',
  INVOICE_APPROVAL_CANCELLED_PLAN_CHANGE = 'INVOICE_APPROVAL_CANCELLED_PLAN_CHANGE',
  INVOICE_APPROVAL_OVERRIDE_APPROVED = 'INVOICE_APPROVAL_OVERRIDE_APPROVED',
  INVOICE_APPROVAL_OVERRIDE_REJECTED = 'INVOICE_APPROVAL_OVERRIDE_REJECTED',
  INVOICE_APPROVAL_REQUESTED = 'INVOICE_APPROVAL_REQUESTED',
  INVOICE_APPROVED = 'INVOICE_APPROVED',
  INVOICE_ARCHIVED = 'INVOICE_ARCHIVED',
  INVOICE_AUTO_APPROVED = 'INVOICE_AUTO_APPROVED',
  INVOICE_CREATED_BY_EMAIL = 'INVOICE_CREATED_BY_EMAIL',
  INVOICE_CREATED_BY_IMPORT = 'INVOICE_CREATED_BY_IMPORT',
  INVOICE_CREATED_BY_USER = 'INVOICE_CREATED_BY_USER',
  INVOICE_CREATED_BY_VENDOR = 'INVOICE_CREATED_BY_VENDOR',
  INVOICE_CREATED_FROM_SETTLE_INBOX = 'INVOICE_CREATED_FROM_SETTLE_INBOX',
  INVOICE_MARKED_AS_PAID = 'INVOICE_MARKED_AS_PAID',
  INVOICE_MARKED_AS_UNPAID = 'INVOICE_MARKED_AS_UNPAID',
  INVOICE_RECEIVED_IN_SETTLE_INBOX = 'INVOICE_RECEIVED_IN_SETTLE_INBOX',
  INVOICE_REJECTED = 'INVOICE_REJECTED',
  INVOICE_SENT = 'INVOICE_SENT',
  INVOICE_VIEWED_BY_PAYER = 'INVOICE_VIEWED_BY_PAYER',
  PAYMENT_APPROVAL_CANCELLED = 'PAYMENT_APPROVAL_CANCELLED',
  PAYMENT_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT = 'PAYMENT_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT',
  PAYMENT_APPROVAL_CANCELLED_PLAN_CHANGE = 'PAYMENT_APPROVAL_CANCELLED_PLAN_CHANGE',
  PAYMENT_APPROVAL_OVERRIDE_APPROVED = 'PAYMENT_APPROVAL_OVERRIDE_APPROVED',
  PAYMENT_APPROVAL_OVERRIDE_REJECTED = 'PAYMENT_APPROVAL_OVERRIDE_REJECTED',
  PAYMENT_APPROVAL_REQUESTED = 'PAYMENT_APPROVAL_REQUESTED',
  PAYMENT_APPROVED = 'PAYMENT_APPROVED',
  PAYMENT_AUTO_APPROVED = 'PAYMENT_AUTO_APPROVED',
  PAYMENT_CANCELLED = 'PAYMENT_CANCELLED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_FROM_PAYER_PAID = 'PAYMENT_FROM_PAYER_PAID',
  PAYMENT_FROM_PAYER_PROCESSED = 'PAYMENT_FROM_PAYER_PROCESSED',
  PAYMENT_FULLY_REVERSED = 'PAYMENT_FULLY_REVERSED',
  PAYMENT_ON_HOLD = 'PAYMENT_ON_HOLD',
  PAYMENT_PAID_EXTERNALLY = 'PAYMENT_PAID_EXTERNALLY',
  PAYMENT_PARTIALLY_REPAID_EARLY = 'PAYMENT_PARTIALLY_REPAID_EARLY',
  PAYMENT_REFUND_COMPLETED = 'PAYMENT_REFUND_COMPLETED',
  PAYMENT_REFUND_INITIATED = 'PAYMENT_REFUND_INITIATED',
  PAYMENT_REJECTED = 'PAYMENT_REJECTED',
  PAYMENT_RELEASED = 'PAYMENT_RELEASED',
  PAYMENT_REPAID_EARLY = 'PAYMENT_REPAID_EARLY',
  PAYMENT_RESCHEDULED = 'PAYMENT_RESCHEDULED',
  PAYMENT_RETRIED = 'PAYMENT_RETRIED',
  PAYMENT_SCHEDULED = 'PAYMENT_SCHEDULED',
  PAYMENT_TO_VENDOR_PAID = 'PAYMENT_TO_VENDOR_PAID',
  PAYMENT_TO_VENDOR_PAPER_CHECK_CASHED = 'PAYMENT_TO_VENDOR_PAPER_CHECK_CASHED',
  PAYMENT_TO_VENDOR_PROCESSED = 'PAYMENT_TO_VENDOR_PROCESSED',
  RECEIVABLE_CREATED_FROM_SETTLE_INBOX = 'RECEIVABLE_CREATED_FROM_SETTLE_INBOX',
  RECEIVABLE_PURCHASED = 'RECEIVABLE_PURCHASED',
  RECEIVABLE_PURCHASE_CANCELED = 'RECEIVABLE_PURCHASE_CANCELED',
  SWITCH_TO_PRO = 'SWITCH_TO_PRO',
  VENDOR_CREDIT_ADDED = 'VENDOR_CREDIT_ADDED',
  VENDOR_CREDIT_APPLIED = 'VENDOR_CREDIT_APPLIED',
  VENDOR_CREDIT_CLOSED = 'VENDOR_CREDIT_CLOSED',
  VENDOR_CREDIT_CREATED = 'VENDOR_CREDIT_CREATED',
  VENDOR_CREDIT_DELETED = 'VENDOR_CREDIT_DELETED',
  VENDOR_CREDIT_REOPENED = 'VENDOR_CREDIT_REOPENED',
  VENDOR_CREDIT_UNAPPLIED = 'VENDOR_CREDIT_UNAPPLIED',
  W8_OR_W9_EMAIL_REQUEST_SENT = 'W8_OR_W9_EMAIL_REQUEST_SENT',
  W8_OR_W9_SUBMITTED = 'W8_OR_W9_SUBMITTED'
}

export enum TimelineEventTypeEnumV2 {
  APPLIED_VENDOR_CREDITS_CLOSED = 'APPLIED_VENDOR_CREDITS_CLOSED',
  APPLIED_VENDOR_CREDITS_REOPENED = 'APPLIED_VENDOR_CREDITS_REOPENED',
  APPLIED_VENDOR_CREDITS_UPDATED = 'APPLIED_VENDOR_CREDITS_UPDATED',
  ARCHIVE = 'ARCHIVE',
  COLLECTION_EMAIL_SENT = 'COLLECTION_EMAIL_SENT',
  CONVERTED_TO_PAYABLE = 'CONVERTED_TO_PAYABLE',
  CONVERTED_TO_RECEIVABLE = 'CONVERTED_TO_RECEIVABLE',
  CREATE = 'CREATE',
  DEFAULT_INTEREST_ACCRUAL_RESUMED = 'DEFAULT_INTEREST_ACCRUAL_RESUMED',
  DEFAULT_INTEREST_ACCRUAL_STARTED = 'DEFAULT_INTEREST_ACCRUAL_STARTED',
  DEFAULT_INTEREST_COLLECTION_CANCELED = 'DEFAULT_INTEREST_COLLECTION_CANCELED',
  DEFAULT_INTEREST_COLLECTION_SCHEDULED = 'DEFAULT_INTEREST_COLLECTION_SCHEDULED',
  DEFAULT_INTEREST_WAIVED_BY_SETTLE = 'DEFAULT_INTEREST_WAIVED_BY_SETTLE',
  DEFAULT_INTEREST_WAIVED_WITHIN_GRACE = 'DEFAULT_INTEREST_WAIVED_WITHIN_GRACE',
  EPT_AGREEMENT_SIGNED = 'EPT_AGREEMENT_SIGNED',
  EPT_TERMS_CHANGED = 'EPT_TERMS_CHANGED',
  INVOICE_APPROVAL_CANCELLED = 'INVOICE_APPROVAL_CANCELLED',
  INVOICE_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT = 'INVOICE_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT',
  INVOICE_APPROVAL_CANCELLED_PLAN_CHANGE = 'INVOICE_APPROVAL_CANCELLED_PLAN_CHANGE',
  INVOICE_APPROVAL_OVERRIDE_APPROVED = 'INVOICE_APPROVAL_OVERRIDE_APPROVED',
  INVOICE_APPROVAL_OVERRIDE_REJECTED = 'INVOICE_APPROVAL_OVERRIDE_REJECTED',
  INVOICE_APPROVAL_REQUESTED = 'INVOICE_APPROVAL_REQUESTED',
  INVOICE_APPROVED = 'INVOICE_APPROVED',
  INVOICE_ARCHIVED = 'INVOICE_ARCHIVED',
  INVOICE_AUTO_APPROVED = 'INVOICE_AUTO_APPROVED',
  INVOICE_CREATED_BY_EMAIL = 'INVOICE_CREATED_BY_EMAIL',
  INVOICE_CREATED_BY_IMPORT = 'INVOICE_CREATED_BY_IMPORT',
  INVOICE_CREATED_BY_USER = 'INVOICE_CREATED_BY_USER',
  INVOICE_CREATED_BY_VENDOR = 'INVOICE_CREATED_BY_VENDOR',
  INVOICE_CREATED_FROM_SETTLE_INBOX = 'INVOICE_CREATED_FROM_SETTLE_INBOX',
  INVOICE_MARKED_AS_PAID = 'INVOICE_MARKED_AS_PAID',
  INVOICE_MARKED_AS_UNPAID = 'INVOICE_MARKED_AS_UNPAID',
  INVOICE_RECEIVED_IN_SETTLE_INBOX = 'INVOICE_RECEIVED_IN_SETTLE_INBOX',
  INVOICE_REJECTED = 'INVOICE_REJECTED',
  INVOICE_SENT = 'INVOICE_SENT',
  INVOICE_VIEWED_BY_PAYER = 'INVOICE_VIEWED_BY_PAYER',
  MERGE = 'MERGE',
  OUTBOUND_ORDER_CREATED = 'OUTBOUND_ORDER_CREATED',
  OUTBOUND_ORDER_FULFILLED = 'OUTBOUND_ORDER_FULFILLED',
  OUTBOUND_ORDER_PAYMENT_CAPTURED = 'OUTBOUND_ORDER_PAYMENT_CAPTURED',
  OUTBOUND_ORDER_SHIPPED = 'OUTBOUND_ORDER_SHIPPED',
  PAYMENT_APPROVAL_CANCELLED = 'PAYMENT_APPROVAL_CANCELLED',
  PAYMENT_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT = 'PAYMENT_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT',
  PAYMENT_APPROVAL_CANCELLED_PLAN_CHANGE = 'PAYMENT_APPROVAL_CANCELLED_PLAN_CHANGE',
  PAYMENT_APPROVAL_OVERRIDE_APPROVED = 'PAYMENT_APPROVAL_OVERRIDE_APPROVED',
  PAYMENT_APPROVAL_OVERRIDE_REJECTED = 'PAYMENT_APPROVAL_OVERRIDE_REJECTED',
  PAYMENT_APPROVAL_REQUESTED = 'PAYMENT_APPROVAL_REQUESTED',
  PAYMENT_APPROVED = 'PAYMENT_APPROVED',
  PAYMENT_AUTO_APPROVED = 'PAYMENT_AUTO_APPROVED',
  PAYMENT_CANCELLED = 'PAYMENT_CANCELLED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_FROM_PAYER_PAID = 'PAYMENT_FROM_PAYER_PAID',
  PAYMENT_FROM_PAYER_PROCESSED = 'PAYMENT_FROM_PAYER_PROCESSED',
  PAYMENT_FULLY_REVERSED = 'PAYMENT_FULLY_REVERSED',
  PAYMENT_ON_HOLD = 'PAYMENT_ON_HOLD',
  PAYMENT_PAID_EXTERNALLY = 'PAYMENT_PAID_EXTERNALLY',
  PAYMENT_PARTIALLY_REPAID_EARLY = 'PAYMENT_PARTIALLY_REPAID_EARLY',
  PAYMENT_REFUND_COMPLETED = 'PAYMENT_REFUND_COMPLETED',
  PAYMENT_REFUND_INITIATED = 'PAYMENT_REFUND_INITIATED',
  PAYMENT_REJECTED = 'PAYMENT_REJECTED',
  PAYMENT_RELEASED = 'PAYMENT_RELEASED',
  PAYMENT_REPAID_EARLY = 'PAYMENT_REPAID_EARLY',
  PAYMENT_RESCHEDULED = 'PAYMENT_RESCHEDULED',
  PAYMENT_RETRIED = 'PAYMENT_RETRIED',
  PAYMENT_SCHEDULED = 'PAYMENT_SCHEDULED',
  PAYMENT_TO_VENDOR_PAID = 'PAYMENT_TO_VENDOR_PAID',
  PAYMENT_TO_VENDOR_PAPER_CHECK_CASHED = 'PAYMENT_TO_VENDOR_PAPER_CHECK_CASHED',
  PAYMENT_TO_VENDOR_PROCESSED = 'PAYMENT_TO_VENDOR_PROCESSED',
  PO_ACKNOWLEDGED = 'PO_ACKNOWLEDGED',
  PO_ADDED = 'PO_ADDED',
  PO_ADDED_AUTOMATICALLY = 'PO_ADDED_AUTOMATICALLY',
  PO_APPROVAL_CANCELLED = 'PO_APPROVAL_CANCELLED',
  PO_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT = 'PO_APPROVAL_CANCELLED_BY_ACCOUNTING_EXTERNAL_PAYMENT',
  PO_APPROVAL_CANCELLED_PLAN_CHANGE = 'PO_APPROVAL_CANCELLED_PLAN_CHANGE',
  PO_APPROVAL_OVERRIDE_APPROVED = 'PO_APPROVAL_OVERRIDE_APPROVED',
  PO_APPROVAL_OVERRIDE_REJECTED = 'PO_APPROVAL_OVERRIDE_REJECTED',
  PO_APPROVAL_REQUESTED = 'PO_APPROVAL_REQUESTED',
  PO_APPROVED = 'PO_APPROVED',
  PO_AUTO_APPROVED = 'PO_AUTO_APPROVED',
  PO_CANCELED = 'PO_CANCELED',
  PO_CLOSED = 'PO_CLOSED',
  PO_CREATED = 'PO_CREATED',
  PO_OPENED = 'PO_OPENED',
  PO_REJECTED = 'PO_REJECTED',
  PO_SENT_TO_VENDOR = 'PO_SENT_TO_VENDOR',
  PO_SYNCED_FROM_ACCOUNTING = 'PO_SYNCED_FROM_ACCOUNTING',
  RECEIVABLE_CREATED_FROM_SETTLE_INBOX = 'RECEIVABLE_CREATED_FROM_SETTLE_INBOX',
  RECEIVABLE_PURCHASED = 'RECEIVABLE_PURCHASED',
  RECEIVABLE_PURCHASE_CANCELED = 'RECEIVABLE_PURCHASE_CANCELED',
  SWITCH_TO_PRO = 'SWITCH_TO_PRO',
  UNARCHIVE = 'UNARCHIVE',
  VENDOR_CREDIT_ADDED = 'VENDOR_CREDIT_ADDED',
  VENDOR_CREDIT_APPLIED = 'VENDOR_CREDIT_APPLIED',
  VENDOR_CREDIT_CLOSED = 'VENDOR_CREDIT_CLOSED',
  VENDOR_CREDIT_CREATED = 'VENDOR_CREDIT_CREATED',
  VENDOR_CREDIT_DELETED = 'VENDOR_CREDIT_DELETED',
  VENDOR_CREDIT_REOPENED = 'VENDOR_CREDIT_REOPENED',
  VENDOR_CREDIT_UNAPPLIED = 'VENDOR_CREDIT_UNAPPLIED',
  W8_OR_W9_EMAIL_REQUEST_SENT = 'W8_OR_W9_EMAIL_REQUEST_SENT',
  W8_OR_W9_SUBMITTED = 'W8_OR_W9_SUBMITTED'
}

export type TimelineEventV2 = TimelineEventInterface & {
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayText: Scalars['String']['output'];
  eventType: TimelineEventTypeEnumV2;
  icon: IconEnum;
  user: Maybe<Approver>;
};

export type TotalDebits = {
  cashAdvanceCreditsToBusinessAccounts: Array<Money>;
  creditsToBusinessAccounts: Array<Money>;
  debitsFromBusinessAccounts: Array<Money>;
  debitsFromSettleAccounts: Array<Money>;
  paymentsToVendorAccounts: Array<Money>;
  repaymentsToSettle: Array<Money>;
};

export type Totp = {
  activatedAt: Scalars['ISO8601DateTime']['output'];
};

export type TotpChallenge = {
  mfaToken: Scalars['ID']['output'];
  totpSetupInfo: Maybe<TotpSetupInfo>;
};

export type TotpSetupInfo = {
  qrCodeUri: Scalars['String']['output'];
  /** @deprecated Use recoveryCodes on activation */
  recoveryCodes: Array<Scalars['String']['output']>;
  secret: Scalars['String']['output'];
  skippable: Scalars['Boolean']['output'];
};

export type TransactionPaginated = {
  data: Array<MarketingVirtualCardTransaction>;
  pagination: Pagination;
};

export type TransactionalTodoListSummary = {
  count: Scalars['Int']['output'];
  reason: DashboardActionableItemReasonEnum;
};

export type TransferActionableItem = {
  allocation: Maybe<Allocation>;
  reason: DashboardActionableItemReasonEnum;
};

export type TransferActions = {
  retryPayment: Action;
};

export type TransferDetails = {
  achTraceNumber: Maybe<Scalars['String']['output']>;
  amount: Money;
  checkNumber: Maybe<Scalars['String']['output']>;
  confirmationNumber: Maybe<Scalars['String']['output']>;
  earlyRepayment: Scalars['Boolean']['output'];
  /** @deprecated Use payment.etaToVendor or payment.etaFromPayer instead */
  estimatedArrivalDate: Scalars['ISO8601Date']['output'];
  memo: Maybe<Scalars['String']['output']>;
  paidFrom: Maybe<Scalars['String']['output']>;
  paidTo: Maybe<Scalars['String']['output']>;
  paymentMethod: Maybe<PaymentMethodEnum>;
  processedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: PaymentStatusEnum;
  swiftUetrNumber: Maybe<Scalars['String']['output']>;
  userInitiated: Scalars['Boolean']['output'];
};

export type UnimportedPurchaseOrder = {
  amount: Maybe<Money>;
  id: Scalars['ID']['output'];
  issueDate: Maybe<Scalars['ISO8601Date']['output']>;
  number: Maybe<Scalars['String']['output']>;
  vendorName: Maybe<Scalars['String']['output']>;
};

export type UnimportedPurchaseOrders = {
  data: Maybe<Array<UnimportedPurchaseOrder>>;
  pagination: Maybe<Pagination>;
};

export type UnmatchedLine = {
  invoiceLine: Maybe<LineItemDetails>;
  purchaseOrderLine: Maybe<LineItemDetails>;
  receiptLine: Maybe<LineItemDetails>;
};

export type UnpaidBill = {
  amount: Maybe<Money>;
  balance: Maybe<Money>;
  dueDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  issueDate: Maybe<Scalars['ISO8601Date']['output']>;
  number: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  vendorName: Maybe<Scalars['String']['output']>;
};

export type UnpaidBillsPaginated = {
  data: Maybe<Array<UnpaidBill>>;
  pagination: Maybe<Pagination>;
};

/** Leading window at its own rate, applied before the regular rate */
export type UpfrontWindow = {
  /** The window's rate annualized, comparable with the loan's interestRate */
  annualRate: Scalars['Float']['output'];
  /** Whether any amount falls due while the window runs; a window that charges nothing is not counted in repaymentCount */
  charges: Scalars['Boolean']['output'];
  /** Calendar length of the window */
  days: Scalars['Int']['output'];
  /** Payment behavior during the window */
  mode: UpfrontWindowModeEnum;
  /** Percentage of principal charged as interest during the window */
  periodRate: Scalars['Float']['output'];
};

/** Payment behavior during the upfront window */
export enum UpfrontWindowModeEnum {
  /** Principal installments fall due during the window */
  AMORTIZING = 'AMORTIZING',
  /** Only accrued interest falls due during the window, no principal */
  INTEREST_ONLY = 'INTEREST_ONLY'
}

export type UploadedDocument = {
  documentRequest: Maybe<Scalars['ID']['output']>;
  documents: Maybe<Array<Scalars['ID']['output']>>;
};

export type UserActions = {
  addBusiness: Action;
  viewAccountantDashboard: Action;
};

export type UserClient = {
  business: PublicBusiness;
  /** @deprecated Use user_role instead */
  role: MembershipRolesEnum;
  user: TeamMember;
  userRole: UserRole;
};

export type UserRole = {
  available: Scalars['Boolean']['output'];
  business: Maybe<Business>;
  clientManager: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissionSets: Array<PermissionSet>;
  roleType: MembershipRolesEnum;
};

export enum UserRoleGroupEnum {
  BUSINESS = 'BUSINESS',
  CLIENT_MANAGER = 'CLIENT_MANAGER'
}

export enum UserTraitsEnum {
  APPROVER = 'APPROVER',
  CLERK = 'CLERK',
  CLIENT_MANAGER_ADMIN = 'CLIENT_MANAGER_ADMIN',
  CLIENT_MANAGER_TEAM_MEMBER = 'CLIENT_MANAGER_TEAM_MEMBER',
  MULTI_BUSINESS = 'MULTI_BUSINESS',
  PROCUREMENT = 'PROCUREMENT',
  REGULAR_MEMBER = 'REGULAR_MEMBER',
  SIGN_IN_LOCKED = 'SIGN_IN_LOCKED',
  VIEWER = 'VIEWER',
  WITH_MFA = 'WITH_MFA'
}

/** Validates referral codes passed to sign up flow */
export type ValidateReferralCode = {
  promoCode: Maybe<BillingPromotionCodeType>;
  referral: Maybe<Referral>;
  utms: Maybe<LongLinkUtms>;
  valid: Scalars['Boolean']['output'];
};

export type ValidationResult = {
  message: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export enum VendorAccountNumberTypeEnum {
  ACH = 'ACH',
  CLABE = 'CLABE',
  IBAN = 'IBAN',
  OTHER = 'OTHER'
}

export enum VendorAddressTypeEnum {
  BUSINESS = 'BUSINESS',
  OPERATIONS = 'OPERATIONS'
}

export type VendorAmount = {
  amount: Money;
  vendor: LocalBusiness;
};

export type VendorCredit = {
  accountingCategoryClassId: Maybe<Scalars['ID']['output']>;
  accountingCategoryDepartmentId: Maybe<Scalars['ID']['output']>;
  accountingCategoryLocationId: Maybe<Scalars['ID']['output']>;
  accountingSyncEvents: Maybe<Array<SyncEvent>>;
  accountingUrl: Maybe<Scalars['String']['output']>;
  actions: VendorCreditActions;
  amount: Maybe<Money>;
  amountRemaining: Maybe<Money>;
  amountUsed: Maybe<Money>;
  associatedInvoice: Maybe<Invoice>;
  attachment: Maybe<Attachment>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Maybe<TeamMember>;
  /** @deprecated Use sync_object_status instead */
  excludedFromSync: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  issueDate: Maybe<Scalars['ISO8601Date']['output']>;
  lineItem: VendorCreditLineItem;
  number: Maybe<Scalars['String']['output']>;
  quickbooksLocationId: Maybe<Scalars['ID']['output']>;
  showSyncHistory: Maybe<Scalars['Boolean']['output']>;
  status: VendorCreditStatusEnum;
  syncError: Maybe<SyncError>;
  syncObjectStatus: Maybe<SyncObjectStatus>;
  vendorCreditApplications: Array<VendorCreditApplication>;
  vendorLocalBusiness: Maybe<LocalBusiness>;
};

export type VendorCreditActions = {
  add: Action;
  delete: Action;
};

export type VendorCreditApplication = {
  amount: Maybe<Money>;
  appliedBy: Maybe<Approver>;
  appliedOn: Scalars['ISO8601DateTime']['output'];
  closed: Scalars['Boolean']['output'];
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoice: Maybe<Invoice>;
  scheduledFor: Maybe<Scalars['ISO8601Date']['output']>;
  vendorCredit: VendorCredit;
};

export type VendorCreditApplicationInputObject = {
  amountCents: Scalars['SafeInt']['input'];
  amountCurrency: Scalars['String']['input'];
  vendorCreditId: Scalars['ID']['input'];
};

export type VendorCreditInputObject = {
  accountingAccountId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryClassId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryDepartmentId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryLocationId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryOneId?: InputMaybe<Scalars['ID']['input']>;
  accountingCategoryTwoId?: InputMaybe<Scalars['ID']['input']>;
  amountCents?: InputMaybe<Scalars['SafeInt']['input']>;
  amountCurrency?: InputMaybe<Scalars['String']['input']>;
  associatedInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  quickBooksAccountId?: InputMaybe<Scalars['ID']['input']>;
  quickBooksClassId?: InputMaybe<Scalars['ID']['input']>;
  quickBooksLocationId?: InputMaybe<Scalars['ID']['input']>;
  trackingCategoryOneId?: InputMaybe<Scalars['ID']['input']>;
  trackingCategoryTwoId?: InputMaybe<Scalars['ID']['input']>;
  vendorLocalBusinessId?: InputMaybe<Scalars['ID']['input']>;
  xeroAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type VendorCreditLineItem = {
  accountingAccount: Maybe<AccountingAccount>;
  accountingAccountId: Maybe<Scalars['ID']['output']>;
  accountingCategoryClassId: Maybe<Scalars['ID']['output']>;
  accountingCategoryDepartmentId: Maybe<Scalars['ID']['output']>;
  accountingCategoryLocationId: Maybe<Scalars['ID']['output']>;
  accountingCategoryOneId: Maybe<Scalars['ID']['output']>;
  accountingCategoryTwoId: Maybe<Scalars['ID']['output']>;
  amount: Money;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  quantity: Maybe<Scalars['Float']['output']>;
  quickbooksCategory: Maybe<AccountingAccount>;
  quickbooksCategoryId: Maybe<Scalars['ID']['output']>;
  quickbooksClass: Maybe<QuickBooksDictionary>;
  quickbooksClassId: Maybe<Scalars['ID']['output']>;
  trackingCategoryOne: Maybe<AccountingDictionary>;
  trackingCategoryOneId: Maybe<Scalars['ID']['output']>;
  trackingCategoryTwo: Maybe<AccountingDictionary>;
  trackingCategoryTwoId: Maybe<Scalars['ID']['output']>;
  unitAmount: Maybe<Money>;
  xeroCategory: Maybe<AccountingAccount>;
  xeroCategoryId: Maybe<Scalars['String']['output']>;
};

export enum VendorCreditStatusEnum {
  APPLIED = 'APPLIED',
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  PARTIALLY_APPLIED = 'PARTIALLY_APPLIED',
  UNAPPLIED = 'UNAPPLIED'
}

export type VendorCredits = {
  data: Array<VendorCredit>;
  pagination: Pagination;
};

export enum VendorCreditsPermissionsEnum {
  ADD_VENDOR_CREDIT = 'ADD_VENDOR_CREDIT',
  APPLY_VENDOR_CREDIT = 'APPLY_VENDOR_CREDIT',
  CREATE_VENDOR_CREDIT = 'CREATE_VENDOR_CREDIT',
  DELETE_VENDOR_CREDIT = 'DELETE_VENDOR_CREDIT',
  UNAPPLY_VENDOR_CREDIT = 'UNAPPLY_VENDOR_CREDIT',
  UPDATE_VENDOR_CREDIT = 'UPDATE_VENDOR_CREDIT',
  VENDOR_CREDIT = 'VENDOR_CREDIT'
}

export type VendorFinancingConfirmation = {
  agreementDocument: SignedDocument;
  feeAmount: Money;
  feePercent: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  originalInvoiceAmount: Money;
  payment: ReceivablePayment;
};

export type VendorFinancingOffer = {
  feeAmount: Money;
  feePercent: Scalars['Float']['output'];
  invoiceId: Scalars['ID']['output'];
  vendorAmount: Money;
  vendorPaymentDate: Scalars['ISO8601Date']['output'];
  vendorPaymentEta: Maybe<Array<Scalars['ISO8601Date']['output']>>;
};

export type VendorInvitation = {
  address: Maybe<Address>;
  businessName: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  hasSettleUser: Scalars['Boolean']['output'];
  invitedBy: Maybe<VendorInviter>;
  name: Maybe<Scalars['String']['output']>;
  receivableInvoice: Maybe<ReceivableInvoice>;
  senderName: Maybe<Scalars['String']['output']>;
  status: Maybe<VendorInvitationStatusEnum>;
  vendorHasBusiness: Scalars['Boolean']['output'];
};

export enum VendorInvitationStatusEnum {
  ACCEPTED = 'ACCEPTED',
  REVOKED = 'REVOKED',
  SENT = 'SENT'
}

export type VendorInviter = {
  businessName: Scalars['String']['output'];
  senderName: Scalars['String']['output'];
};

export type VendorLeadTime = {
  days: Maybe<Scalars['Int']['output']>;
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  localBusinessId: Maybe<Scalars['ID']['output']>;
  purchaseOrderId: Maybe<Scalars['ID']['output']>;
};

export enum VendorLeadTimeEventEnum {
  BILLING = 'BILLING',
  PRODUCTION = 'PRODUCTION',
  RECEIVING = 'RECEIVING',
  SHIPPING = 'SHIPPING'
}

export type VendorLeadTimeInputObject = {
  days: Scalars['Int']['input'];
  event: VendorLeadTimeEventEnum;
  id?: InputMaybe<Scalars['ID']['input']>;
  localBusinessId?: InputMaybe<Scalars['ID']['input']>;
  purchaseOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type VendorPaymentTerm = {
  id: Scalars['ID']['output'];
  localBusinessId: Scalars['ID']['output'];
  /** @deprecated Use `paymentDate` of `paymentsForecastItem` instead */
  paymentDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  percentage: Scalars['Int']['output'];
  vendorTermOption: Maybe<VendorTermOption>;
};

export type VendorPaymentTermInputObject = {
  id?: InputMaybe<Scalars['ID']['input']>;
  localBusinessId?: InputMaybe<Scalars['ID']['input']>;
  /** (Deprecated) Use `paymentDate` of `paymentsForecastItem` instead */
  paymentDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  vendorTermOptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type VendorTermInputObject = {
  /** (Deprecated) Set on `paymentsForecast` instead */
  default?: InputMaybe<Scalars['Boolean']['input']>;
  /** (Deprecated) Use `triggerDays` and `triggerEvent` instead */
  leadTimes?: InputMaybe<Array<VendorLeadTimeInputObject>>;
  paymentTerms?: InputMaybe<Array<VendorPaymentTermInputObject>>;
  triggerDays?: InputMaybe<Scalars['Int']['input']>;
  triggerEvent?: InputMaybe<VendorLeadTimeEventEnum>;
  vendorTermId?: InputMaybe<Scalars['ID']['input']>;
};

export type VendorTermOption = {
  days: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  localBusinessId: Maybe<Scalars['ID']['output']>;
  termType: Scalars['String']['output'];
};

export type VendorTermOptionInputObject = {
  days?: InputMaybe<Scalars['Int']['input']>;
  localBusinessId: Scalars['ID']['input'];
  termType: Scalars['String']['input'];
};

export type VendorTerms = {
  deletedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  deletedBy: Maybe<Profile>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  localBusinessId: Maybe<Scalars['ID']['output']>;
  purchaseOrderId: Maybe<Scalars['ID']['output']>;
  triggerDays: Maybe<Scalars['Int']['output']>;
  triggerEvent: Maybe<VendorLeadTimeEventEnum>;
  /** @deprecated Use `triggerDays` and `triggerEvent` instead */
  vendorLeadTimes: Maybe<Array<VendorLeadTime>>;
  vendorPaymentTerms: Maybe<Array<VendorPaymentTerm>>;
};

export enum VerificationSourceEnum {
  FINICITY = 'FINICITY',
  MODERN_TREASURY = 'MODERN_TREASURY',
  OTHER = 'OTHER',
  PLAID = 'PLAID'
}

export type WarningMessage = {
  actions: Array<WarningMessageAction>;
  kind: WarningMessageKindEnum;
  message: Scalars['String']['output'];
  name: WarningMessageNameEnum;
};

export type WarningMessageAction = {
  label: Scalars['String']['output'];
  relatedEntities: Array<WarningMessageActionEntity>;
  type: WarningMessageActionTypeEnum;
  variant: WarningMessageActionVariantEnum;
};

export type WarningMessageActionEntity = ReconciliationItem;

export enum WarningMessageActionTypeEnum {
  ADD_OR_REQUEST_W8_OR_W9 = 'ADD_OR_REQUEST_W8_OR_W9',
  OPEN_PAYMENT_HOLD_SETTINGS = 'OPEN_PAYMENT_HOLD_SETTINGS',
  OPEN_RELATED_ITEM = 'OPEN_RELATED_ITEM',
  RELEASE_PAYMENT_ON_W8_OR_W9_HOLD = 'RELEASE_PAYMENT_ON_W8_OR_W9_HOLD'
}

export enum WarningMessageActionVariantEnum {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export enum WarningMessageKindEnum {
  ERROR = 'ERROR',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING'
}

export enum WarningMessageNameEnum {
  LATE_PAYMENT_INTEREST_BUILDING = 'LATE_PAYMENT_INTEREST_BUILDING',
  LATE_PAYMENT_INTEREST_BUILDING_AFTER_MATURITY_DATE = 'LATE_PAYMENT_INTEREST_BUILDING_AFTER_MATURITY_DATE',
  LATE_PAYMENT_INTEREST_BUILDING_PAST_GRACE = 'LATE_PAYMENT_INTEREST_BUILDING_PAST_GRACE',
  LATE_PAYMENT_INTEREST_BUILDING_WITHIN_GRACE = 'LATE_PAYMENT_INTEREST_BUILDING_WITHIN_GRACE',
  LATE_PAYMENT_INTEREST_CHARGED = 'LATE_PAYMENT_INTEREST_CHARGED',
  LATE_PAYMENT_INTEREST_COLLECTION_FAILED_PRINCIPAL_OUTSTANDING = 'LATE_PAYMENT_INTEREST_COLLECTION_FAILED_PRINCIPAL_OUTSTANDING',
  LATE_PAYMENT_INTEREST_COLLECTION_FAILED_PRINCIPAL_REPAID = 'LATE_PAYMENT_INTEREST_COLLECTION_FAILED_PRINCIPAL_REPAID',
  LATE_PAYMENT_INTEREST_TO_BE_COLLECTED = 'LATE_PAYMENT_INTEREST_TO_BE_COLLECTED',
  LATE_PAYMENT_INTEREST_WAIVED = 'LATE_PAYMENT_INTEREST_WAIVED',
  PAYMENT_ACCOUNT_PROCESSING_AT_RISK = 'PAYMENT_ACCOUNT_PROCESSING_AT_RISK',
  PAYMENT_ELIGIBLE_FOR_W8_OR_W9_HOLD = 'PAYMENT_ELIGIBLE_FOR_W8_OR_W9_HOLD',
  PAYMENT_ON_W8_OR_W9_HOLD = 'PAYMENT_ON_W8_OR_W9_HOLD',
  PAYMENT_PENDING_APPROVAL = 'PAYMENT_PENDING_APPROVAL'
}

export enum WeightUnitEnum {
  GRAMS = 'GRAMS',
  KG = 'KG',
  OZ = 'OZ',
  POUNDS = 'POUNDS'
}

export type WeightedAverageCostProfitability = {
  catalogItemVariation: CatalogItemVariation;
  margin: Maybe<InfinitePrecisionMoney>;
  marginPercentage: Maybe<Scalars['Float']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  totalMargin: Maybe<InfinitePrecisionMoney>;
  totalWeightedAverageCost: Maybe<InfinitePrecisionMoney>;
  weightedAverageCost: Maybe<InfinitePrecisionMoney>;
};

export type WorkOrder = {
  actions: WorkOrderActions;
  additionalExpenses: Array<AdditionalExpense>;
  allowedShippingTerms: Array<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  attachment: Maybe<Attachment>;
  contactDetails: Maybe<ContactDetails>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentMilestone: Maybe<Milestone>;
  deleted: Scalars['Boolean']['output'];
  documentDisplaySettings: DocumentDisplaySettings;
  fullyReceivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  issueDate: Maybe<Scalars['ISO8601Date']['output']>;
  lineItems: Array<WorkOrderLineItem>;
  linkedDocuments: Array<LinkedDocument>;
  location: Maybe<Location>;
  locationEmail: Maybe<Scalars['String']['output']>;
  locationEmailDate: Maybe<Scalars['ISO8601Date']['output']>;
  locationEmailMessage: Maybe<Scalars['String']['output']>;
  locationEmailScheduledDate: Maybe<Scalars['ISO8601Date']['output']>;
  manufacturingVendor: Maybe<LocalBusiness>;
  manufacturingVendorEmailDate: Maybe<Scalars['ISO8601Date']['output']>;
  memo: Maybe<Scalars['String']['output']>;
  milestones: Array<Milestone>;
  number: Maybe<Scalars['String']['output']>;
  payments: Array<Payment>;
  paymentsOfLinkedInvoices: Array<Payment>;
  receiveByDate: Maybe<Scalars['ISO8601Date']['output']>;
  secondaryAttachments: Array<Attachment>;
  shipByDate: Maybe<Scalars['ISO8601Date']['output']>;
  shipmentMethod: Maybe<Scalars['String']['output']>;
  shipments: Array<Shipment>;
  shippingVendor: Maybe<LocalBusiness>;
  status: WorkOrderStatusEnum;
};

export type WorkOrderActions = {
  archive: Action;
  cancel: Action;
  close: Action;
  delete: Action;
  edit: Action;
  open: Action;
  revertToDraft: Action;
};

export enum WorkOrderArchivedStatusEnum {
  ACTIVE_AND_ARCHIVED = 'ACTIVE_AND_ARCHIVED',
  ACTIVE_ONLY = 'ACTIVE_ONLY',
  ARCHIVED_ONLY = 'ARCHIVED_ONLY'
}

export type WorkOrderEmailInputObject = {
  locationEmail?: InputMaybe<Scalars['String']['input']>;
  locationEmailScheduledDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  locationMessage?: InputMaybe<Scalars['String']['input']>;
  manufacturingVendorEmail: Scalars['String']['input'];
  manufacturingVendorMessage: Scalars['String']['input'];
  replyToEmail?: InputMaybe<Scalars['String']['input']>;
};

export type WorkOrderInputObject = {
  documentDisplaySettings?: InputMaybe<DocumentDisplaySettingsInputObject>;
  issueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  locationEmailMessage?: InputMaybe<Scalars['String']['input']>;
  locationEmailScheduledDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  manufacturingVendorId?: InputMaybe<Scalars['ID']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  receiveByDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  shipByDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  shipmentMethod?: InputMaybe<Scalars['String']['input']>;
  shippingVendorId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<WorkOrderStatusEnum>;
};

export type WorkOrderLineItem = {
  amount: Maybe<InfinitePrecisionMoney>;
  /** The timestamp of the BOM snapshot, formatted for display in the BOM table. */
  bomSnapshotTimestamp: Maybe<Scalars['String']['output']>;
  bomTableRows: Array<BomTableRowType>;
  /** @deprecated Use 'catalogItemVariation' instead */
  catalogItem: Maybe<CatalogItemVariation>;
  catalogItemVariation: Maybe<CatalogItemVariation>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentCostTier: Maybe<CostTierType>;
  fractionalLandedCost: Maybe<InfinitePrecisionMoney>;
  id: Scalars['ID']['output'];
  inventoryQuantity: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
  position: Maybe<Scalars['Int']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  shipmentLineItems: Array<ShipmentLineItem>;
  sku: Maybe<Scalars['String']['output']>;
  unitOfMeasure: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrder;
};

export type WorkOrderLineItemInputObject = {
  amount?: InputMaybe<FractionalMoneyInputObject>;
  catalogItemId?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkOrderPermissionsEnum {
  CREATE_PAYMENT_ON_WORK_ORDER = 'CREATE_PAYMENT_ON_WORK_ORDER',
  CREATE_WORK_ORDER = 'CREATE_WORK_ORDER',
  DELETE_WORK_ORDER = 'DELETE_WORK_ORDER',
  READ_WORK_ORDER = 'READ_WORK_ORDER',
  UPDATE_WORK_ORDER = 'UPDATE_WORK_ORDER',
  UPDATE_WORK_ORDER_ARCHIVED = 'UPDATE_WORK_ORDER_ARCHIVED'
}

export enum WorkOrderStatusEnum {
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  OPEN = 'OPEN'
}

export type WorkOrdersFilteringInputObject = {
  acknowledgedDate?: InputMaybe<DateFilteringInputObject>;
  archivedStatus?: InputMaybe<WorkOrderArchivedStatusEnum>;
  createdAt?: InputMaybe<DateFilteringInputObject>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  issueDate?: InputMaybe<DateFilteringInputObject>;
  milestoneTypes?: InputMaybe<Array<MilestoneTypeEnum>>;
  number?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shippingVendorLocalBusinessIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<WorkOrderStatusEnum>>;
  vendorLocalBusinessIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type WorkingCapitalUtilization = {
  underUtilized: Scalars['Boolean']['output'];
  workingCapitalAdvanceLastUsedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  workingCapitalLastUsedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type XeroAccount = {
  accountSubType: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  children: Array<XeroAccount>;
  classification: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  number: Maybe<Scalars['String']['output']>;
  subAccount: Scalars['Boolean']['output'];
};

export type XeroAccountMapping = {
  accountId: Scalars['ID']['output'];
  accountingAccountId: Maybe<Scalars['ID']['output']>;
  externalAccountId: Maybe<Scalars['ID']['output']>;
  xeroAccountId: Maybe<Scalars['ID']['output']>;
};

export type XeroAccountMappingInputObject = {
  accountId: Scalars['ID']['input'];
  externalAccountId?: InputMaybe<Scalars['ID']['input']>;
  xeroAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type XeroState = {
  accountMappings: Array<XeroAccountMapping>;
  accounts: Array<XeroAccount>;
  bankAccounts: Array<XeroAccount>;
  bookCloseDate: Maybe<Scalars['ISO8601Date']['output']>;
  connected: Scalars['Boolean']['output'];
  creditCardAccounts: Array<XeroAccount>;
  expenseAccounts: Array<XeroAccount>;
  feeExpensesAccountId: Maybe<Scalars['ID']['output']>;
  filteredAccounts: Array<XeroAccount>;
  liabilityAccounts: Array<XeroAccount>;
  name: Scalars['String']['output'];
  readOnly: Scalars['Boolean']['output'];
  settleLiabilityAccountId: Maybe<Scalars['ID']['output']>;
  syncAutomatically: Scalars['Boolean']['output'];
  syncErrorMessage: Maybe<Scalars['String']['output']>;
  syncScheduledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  syncStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  syncStartedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  syncState: SyncStateEnum;
  syncUncategorizedExpenses: Scalars['Boolean']['output'];
  syncedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  unallocatedExpensesAccountId: Maybe<Scalars['ID']['output']>;
};

export type XeroUnpaidBill = {
  amount: Maybe<Money>;
  balance: Maybe<Money>;
  dueDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  issueDate: Maybe<Scalars['ISO8601Date']['output']>;
  number: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  vendorName: Maybe<Scalars['String']['output']>;
};
